/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.login',
    'BlurAdmin.pages.advertisers',
    'BlurAdmin.pages.insertionorders',
    'BlurAdmin.pages.todos',
    'BlurAdmin.pages.ads',
    'BlurAdmin.pages.pixels',
    'BlurAdmin.pages.users',
    'BlurAdmin.pages.targetings',
    'BlurAdmin.pages.forecast',
    'BlurAdmin.pages.tools',
    'BlurAdmin.pages.settings',
    'BlurAdmin.pages.statistics',
    'BlurAdmin.pages.productfeeds'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider, $stateProvider) {
    $urlRouterProvider.otherwise('/dashboard');

    $stateProvider
      .state('private', {
        abstract: true,
        data: {
          roles: [2]
        },
        resolve: {
          authorize: ['authorization',
            function(authorization) {
              return authorization.authorize();
            }
          ],
          user: ['principal',
            function(principal) {
              return principal.identity();
            }
          ],
        },
        views: {
          layout: {
            templateUrl: 'private.html',
          }
        }
      })
      .state('public', {
        abstract: true,
        views: {
          layout: {
            templateUrl: 'public.html',
          }
        }
      })
      .state('accessdenied', {
        template: '<h1 class="al-title">You are not allowed to view this page.</h1>',
        url: '/accessdenied',
        title: 'ACCESS DENIED',
        parent: 'public'
      })
      .state('loggedin', {
        template: '<h1 class="al-title">You are not allowed to view this page.</h1>',
        url: '/loggedin',
        parent: 'private'
      })
      .state('adops-tool', {
        title: 'ADOPS TOOL',
        tooltip: 'All campaigning services will be moved here. Login credentials are the same as here.',
        url: 'https://adops.adup.tech/',
        external: true,
        data: {
          roles: [
            0
          ]
        },
        sidebarMeta: {
          img: 'icon_adup.png',
          order: -1,
        },
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
    'toastr',
    'BlurAdmin.theme.components'
  ]);

})();

/**
 * Created by frank on 18.08.17.
 */


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.advertisers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('advertisers', {
        url: '/advertisers',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'ADVERTISERS',
        parent: 'private',
        data: {
          roles: [
            16
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-briefcase',
          order: 6,
        },
      }).state('advertisers.all', {
        url: '/',
        templateUrl: 'app/pages/advertisers/all/list.html',
        title: 'LIST ALL ADVERTISERS',
        controller: 'AdvertisersListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('advertisers.detail', {
        url: '/:id',
        templateUrl: 'app/pages/advertisers/detail/detail.html',
        title: 'ADVERTISER DETAIL',
        controller: 'AdvertisersDetailController',
      })
      .state('advertisers.new', {
        url: '/new',
        templateUrl: 'app/pages/advertisers/detail/detail.html',
        title: 'ADVERTISER DETAIL',
        controller: 'AdvertisersDetailController',
      });
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'DASHBOARD',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        parent: 'private'
      });
  }

})();

/**
 * Created by frank on 18.08.17.
 */


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.insertionorders', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('insertionorders', {
        url: '/insertionorders',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'INSERTION ORDERS',
        parent: 'private',
        data: {
          roles: [
            16
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-file',
          order: 7,
        },
      }).state('insertionorders.all', {
        url: '/',
        templateUrl: 'app/pages/insertionorders/all/list.html',
        title: 'LIST ALL INSERTION ORDERS',
        controller: 'InsertionordersListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('insertionorders.detail', {
        url: '/detail/:id',
        templateUrl: 'app/pages/insertionorders/detail/detail.html',
        title: 'INSERTION ORDER DETAIL',
        controller: 'InsertionordersDetailController',
      })
      .state('insertionorders.new', {
        url: '/new',
        params: {
          advertiser_id: null
        },
        templateUrl: 'app/pages/insertionorders/detail/detail.html',
        title: 'INSERTION ORDER DETAIL',
        controller: 'InsertionordersDetailController',
      });
  }

})();


/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.login', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        resolve: {
          authorize: ['authorization',
            function(authorization) {
              return authorization.authorize();
            }
          ]
        },
        data: {
          roles: []
        },
        templateUrl: 'app/pages/login/login.html',
        title: 'LOGIN',
        parent: 'public'
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('ads', {
        url: '/ads',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'CAMPAIGNS',
        parent: 'private',
        data: {
          roles: [
            16
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-folder-open',
          order: 8
        }
      })
      .state('ads.all', {
        url: '/',
        templateUrl: 'app/pages/ads/all/AdsList.html',
        title: 'LIST ALL CAMPAIGNS',
        controller: 'AdsListController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('ads.detail', {
        url: '/:id',
        params: {
          insertionorder: null
        },
        templateUrl: 'app/pages/ads/detail/AdsDetail.html',
        title: 'AD DETAILS',
        controller: 'AdsDetailController'
      })
      .state('ads.clone', {
        url: '/clone/:id',
        templateUrl: 'app/pages/ads/cloneAd/cloneAd.html',
        title: 'CLONE CAMPAIGN',
        controller: 'CloneAdController',
        sidebarMeta: {
          order: 1

        }
      })
      .state('ads.history', {
        url: '/history/:id',
        templateUrl: 'app/pages/ads/history/history.html',
        title: 'AD HISTORY',
        controller: 'HistoryController'
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.forecast', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('forecast', {
        url: '/forecast',
        title: 'FORECAST',
        parent: 'private',
        tooltip: 'This feature will be moved to the new ADOPS Tool as of KW30/2020',
        data: {
          roles: [
            8
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-binoculars',
          order: 5,
        },
        templateUrl: 'app/pages/forecast/forecast/index.html',
        controller: 'ForecastController',
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.pixels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('pixels', {
        url: '/pixels',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'PIXELS',
        parent: 'private',
        data: {
          roles: [
            64
          ]
        },
        sidebarMeta: {
          icon: 'ion-bookmark',
          order: 9,
        },
      }).state('pixels.all', {
        url: '/',
        templateUrl: 'app/pages/pixels/all/list.html',
        title: 'LIST ALL PIXELS',
        controller: 'PixelsListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('pixels.detail', {
        url: '/:hash',
        templateUrl: 'app/pages/pixels/detail/detail.html',
        title: 'NEW PIXEL',
        controller: 'PixelsDetailController',
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.productfeeds', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('productfeeds', {
        url: '/productfeeds',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'PRODUCTFEEDS',
        parent: 'private',
        data: {
          roles: [
            16
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-list',
          order: 8
        }
      }).state('productfeeds.all', {
        url: '/',
        templateUrl: 'app/pages/productfeeds/all/ProductFeedsList.html',
        title: 'LIST ALL PRODUCTFEEDS',
        controller: 'ProductFeedsListController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('productfeeds.detail', {
        url: '/:id',
        templateUrl: 'app/pages/productfeeds/detail/ProductFeedsDetail.html',
        title: 'PRODUCTFEED DETAILS',
        controller: 'ProductFeedsDetailController'
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageController',
        parent: 'private',
      })
      .state('profile.tab', {
        url: '/profile/:tab',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageController',
        parent: 'private'
      });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('statistics', {
        url: '/statistics',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'STATISTICS',
        parent: 'private',
        data: {
          roles: [
            128
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-bar-chart',
          order: 5
        }
      })
      .state('statistics.adsitemedia', {
        url: '/adSitemedia?ads',
        reloadOnSearch: false,
        template: '<statistics show-chart="false" extra-columns="true" extra-ad-information="true" statistics-type="adSitemediaStatistics" first-column-type="NAME"></statistics>',
        title: 'CAMPAIGN',
        sidebarMeta: {
          order: 0
        }
      })
      .state('statistics.dailyadsitemedia', {
        url: '/dailyAdSitemedia?ads&kind&subkind&from&to',
        reloadOnSearch: false,
        template: '<statistics show-chart="true" extra-columns="true" extra-ad-information="false" statistics-type="dailyAdSitemediaStatistics" first-column-type="DATE"></statistics>',
        title: 'DAY/CAMPAIGN',
        sidebarMeta: {
          order: 1
        }
      })
      .state('statistics.monthlyadsitemedia', {
        url: '/monthlyAdSitemedia?ads&kind&subkind&from&to',
        reloadOnSearch: false,
        template: '<statistics show-chart="true" extra-columns="true" extra-ad-information="false" statistics-type="monthlyAdSitemediaStatistics" first-column-type="DATE"></statistics>',
        title: 'MONTH/CAMPAIGN',
        sidebarMeta: {
          order: 1
        }
      })
      .state('statistics.admediasitemedia', {
        url: '/admediaSitemedia?ads',
        reloadOnSearch: false,
        template: '<statistics show-chart="false" extra-columns="false" extra-ad-information="true" statistics-type="admediaSitemediaStatistics" first-column-type="NAME"></statistics>',
        title: 'ADMEDIA',
        sidebarMeta: {
          order: 2
        }
      })
      .state('statistics.dailyadmediasitemedia', {
        url: '/dailyAdmediaSitemedia?ads',
        reloadOnSearch: false,
        template: '<statistics show-chart="true" extra-columns="false" extra-ad-information="false" statistics-type="dailyAdmediaSitemediaStatistics" first-column-type="DATE"></statistics>',
        title: 'DAY/ADMEDIA',
        sidebarMeta: {
          order: 3
        }
      })
      .state('statistics.actionreport', {
        url: '/actionReport',
        templateUrl: 'app/pages/statistics/actionReport/index.html',
        title: 'ACTION REPORTING',
        controller: 'ActionReportController',
        sidebarMeta: {
          order: 4,
        },
      });
  }
})();


/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.targetings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('targetings', {
        title: 'TARGETINGS',
        url: '/targetings',
        parent: 'private',
        template: '<ui-view></ui-view>',
        abstract: true,
        tooltip: 'This feature was moved to the new ADOPS Tool and will be removed here as of KW29/2020',
        // url: 'https://adops.adup.tech/',
        // external: true,
        data: {
          roles: [
            32
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-bullseye',
          order: 2,
        },
      })
      .state('targetings.all', {
        url: '/',
        templateUrl: 'app/pages/targetings/all/list.html',
        title: 'LIST ALL TARGETINGS',
        controller: 'TargetingsListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('targetings.detail', {
        url: '/detail/:id',
        templateUrl: 'app/pages/targetings/detail/detail.html',
        title: 'TARGETING DETAILS',
        controller: 'TargetingsDetailController',
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('settings', {
        url: '/settings',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'SETTINGS',
        data: {
          roles: [
            2048
          ]
        },
        parent: 'private',
        sidebarMeta: {
          icon: 'ion-settings',
          order: 15
        }
      }).state('settings.templates', {
        url: '/templates',
        templateUrl: 'app/pages/settings/templates/index.html',
        title: 'TEMPLATES',
        controller: 'SettingsTemplatesController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.adsizes', {
        url: '/adsizes',
        templateUrl: 'app/pages/settings/adsizes/all/index.html',
        title: 'ADSIZES',
        controller: 'AdsizesController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.adsizes-detail', {
        url: '/adsizes/detail/:id',
        templateUrl: 'app/pages/settings/adsizes/detail/index.html',
        title: 'ADSIZES DETAILS',
        controller: 'AdsizesDetailController'
      })
      .state('settings.locations', {
        url: '/locations',
        templateUrl: 'app/pages/settings/locations/index.html',
        title: 'LOCATIONS',
        controller: 'LocationsController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.publishers', {
        url: '/publishers',
        templateUrl: 'app/pages/settings/publishers/all/list.html',
        title: 'PUBLISHERS',
        controller: 'PublishersListController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.publishers-detail', {
        url: '/publishers/detail/:id',
        templateUrl: 'app/pages/settings/publishers/detail/index.html',
        title: 'PUBLISHER DETAILS',
        controller: 'PublishersDetailController'
      })
      .state('settings.networks', {
        url: '/networks',
        templateUrl: 'app/pages/settings/networks/all/list.html',
        title: 'NETWORKS',
        controller: 'NetworksListController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.networks-detail', {
        url: '/networks/detail/:id',
        templateUrl: 'app/pages/settings/networks/detail/index.html',
        title: 'NETWORK DETAILS',
        controller: 'NetworksDetailController'
      })
      .state('settings.requestcategories', {
        url: '/requestcategories',
        templateUrl: 'app/pages/settings/requestcategories/index.html',
        title: 'REQUEST CATEGORIES',
        controller: 'RequestCategoriesController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.matchers', {
        url: '/matchers',
        templateUrl: 'app/pages/settings/matchers/all/index.html',
        title: 'MATCHERS',
        controller: 'MatchersController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.matchers-detail', {
        url: '/matchers/detail/:id',
        templateUrl: 'app/pages/settings/matchers/detail/index.html',
        title: 'MATCHERS DETAILS',
        controller: 'MatchersDetailController'
      })
      .state('settings.sites', {
        url: '/sites',
        templateUrl: 'app/pages/settings/sites/all/list.html',
        title: 'SITES',
        controller: 'SitesController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.sites-detail', {
        url: '/sites/detail/:id',
        templateUrl: 'app/pages/settings/sites/detail/index.html',
        title: 'SITES DETAILS',
        controller: 'SitesDetailController'
      })
      .state('settings.sitemedias', {
        url: '/sitemedias',
        templateUrl: 'app/pages/settings/sitemedias/all/index.html',
        title: 'SITEMEDIAS',
        controller: 'SitemediasController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.sitemedias-detail', {
        url: '/sitemedias/detail/:id',
        templateUrl: 'app/pages/settings/sitemedias/detail/index.html',
        title: 'SITEMEDIAS DETAILS',
        controller: 'SitemediasDetailController'
      })
      .state('settings.adchecker', {
        url: '/adchecker',
        templateUrl: 'app/pages/settings/adchecker/index.html',
        title: 'AD CHECKER',
        controller: 'AdcheckerController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.inventories', {
        url: '/inventories',
        templateUrl: 'app/pages/settings/inventories/index.html',
        title: 'INVENTORIES',
        controller: 'InventoriesController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.placementgroups', {
        url: '/placementgroups',
        templateUrl: 'app/pages/settings/placementgroups/index.html',
        title: 'PLACEMENTGROUPS',
        controller: 'PlacementGroupsController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.events', {
        url: '/events',
        templateUrl: 'app/pages/settings/events/index.html',
        title: 'EVENTS',
        controller: 'EventsController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.todoTypes', {
        url: '/todoTypes',
        templateUrl: 'app/pages/settings/todoTypes/all/list.html',
        title: 'TODOTYPES',
        controller: 'TodoTypesListController',
        sidebarMeta: {
          order: 0
        }
      })
      .state('settings.todoTypes-detail', {
        url: '/todoTypes/detail/:id',
        templateUrl: 'app/pages/settings/todoTypes/detail/index.html',
        title: 'TODOTYPES DETAILS',
        controller: 'TodoTypesDetailController'
      })
      .state('settings.groups', {
        url: '/groups',
        templateUrl: 'app/pages/settings/groups/all/list.html',
        title: 'GROUPS',
        controller: 'GroupsListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('settings.groups-detail', {
        url: '/groups/detail/:id',
        templateUrl: 'app/pages/settings/groups/detail/detail.html',
        title: 'GROUP DETAILS',
        controller: 'GroupsDetailController',
      })
      .state('settings.tasks', {
        url: '/tasks',
        templateUrl: 'app/pages/settings/tasks/manage/all/list.html',
        title: 'MANAGE TASKS',
        controller: 'TasksListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('settings.tasks-detail', {
        url: '/tasks/detail/:id',
        templateUrl: 'app/pages/settings/tasks/manage/detail/detail.html',
        title: 'TASKS DETAIL',
        controller: 'TasksDetailController',
      })
      .state('settings.tasks-new', {
        url: '/tasks/new',
        templateUrl: 'app/pages/settings/tasks/manage/detail/detail.html',
        title: 'TASKS NEW',
        controller: 'TasksDetailController',
      })
      .state('settings.run-tasks', {
        url: '/runtasks',
        templateUrl: 'app/pages/settings/tasks/run/all/list.html',
        title: 'RUN TASKS',
        controller: 'RunTasksListController',
        sidebarMeta: {
          order: 0,
        },
      });
  }

})();

/**
 * Created by frank on 18.08.17.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.todos', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('todos', {
        url: '/todos',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'TODOS',
        parent: 'private',
        data: {
          roles: [
            16
          ]
        },
        sidebarMeta: {
          icon: 'fa fa-list-ol',
          order: 7,
        },
      }).state('todos.all', {
        url: '/',
        templateUrl: 'app/pages/todos/all/list.html',
        title: 'LIST ALL TODOS',
        controller: 'TodosListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('todos.detail', {
        url: '/detail/:id',
        templateUrl: 'app/pages/todos/detail/detail.html',
        title: 'TODOS DETAIL',
        controller: 'TodosDetailController',
      });
  }
})();


/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tools', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('tools', {
        url: '/tools',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'TOOLS',
        data: {
          roles: [
            2
          ]
        },
        parent: 'private',
        sidebarMeta: {
          icon: 'ion-hammer',
          order: 10,
        },
      })
      .state('tools.upload', {
        url: '/upload',
        templateUrl: 'app/pages/tools/upload/index.html',
        title: 'UPLOAD',
        controller: 'ToolsUploadController',
        sidebarMeta: {
          order: 1,
        },
      })
      .state('tools.beautify', {
        url: '/beautify',
        templateUrl: 'app/pages/tools/beautify/index.html',
        title: 'BEAUTIFY HTML/JS',
        controller: 'ToolsBeautifyController',
        sidebarMeta: {
          order: 2,
        },
      })
      .state('tools.taggen', {
        url: '/taggen/:hash',
        templateUrl: 'app/pages/tools/taggen/index.html',
        title: 'TAG GENERATOR',
        controller: 'ToolsTaggenController',
        sidebarMeta: {
          order: 3,
        },
      });
  }

})();

/**
 * @author m.ermer
 * created on 18.07.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.users', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('users', {
        url: '/users',
        template: '<ui-view></ui-view>',
        abstract: true,
        title: 'USERS',
        data: {
          roles: [
            4
          ]
        },
        parent: 'private',
        sidebarMeta: {
          icon: 'ion-person-stalker',
          order: 11,
        },
      }).state('users.list', {
        url: '/',
        templateUrl: 'app/pages/users/all/list.html',
        title: 'LIST ALL USERS',
        controller: 'UsersListController',
        sidebarMeta: {
          order: 0,
        },
      })
      .state('users.detail', {
        url: '/detail/:id',
        templateUrl: 'app/pages/users/detail/detail.html',
        title: 'USER DETAILS',
        controller: 'UsersDetailController',
      });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.router',
  'ui.tree',
  'ngTouch',
  'ngLodash',
  'toastr',
  'smart-table',
  'xeditable',
  'ui.slimscroll',
  'ui.gravatar',
  'angular-progress-button-styles',
  'ngFeathers',
  'pascalprecht.translate',
  'cfp.hotkeys',
  'angular-clockpicker',
  'ng.jsoneditor',
  'angular-clipboard',
  'ui.select',
  'ngSanitize',
  'ui.ace',
  'moment-picker',
  'jsonFormatter',
  'uix-multiselect',
  'thatisuday.dropzone',
  // disabled & bower uninstalled, styles still present:
  // 'leaflet-directive',
  // preserve these at the end
  'BlurAdmin.theme',
  'BlurAdmin.pages'
]);


/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config)
    .config(['uiSelectConfig', function(uiSelectConfig) {
      uiSelectConfig.resetSearchInput = false;
    }])
    .config(['$translateProvider', 'translations', function ($translateProvider, translations) {
      // add translation table
      $translateProvider
        .translations('en_GB', translations.en)
        .translations('de_DE', translations.de)
        .translations('de', translations.de)
        .translations('en', translations.en)
        .useMissingTranslationHandlerLog()
        // .useCookieStorage()
        // .useLocalStorage()
        .useSanitizeValueStrategy('sanitizeParameters')
        .determinePreferredLanguage()
        .fallbackLanguage('de');
    }]);

  /** @ngInject */
  function config(baConfigProvider, $feathersProvider, feathersSettings) {
    $feathersProvider.setEndpoint(feathersSettings.endpointUrl);

    // true is default; set to false if you like to use REST
    $feathersProvider.useSocket(feathersSettings.useSocket);

    // $locationProvider.html5Mode(true);

    baConfigProvider.changeColors({
      default: '#4e4e55',
      defaultText: '#e2e2e2',
      primary: '#e30613'
    });
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // chart colors for charts
  var chartColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        chart: chartColors
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme);
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors);
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';
  if (location.hostname.indexOf('localhost') !== -1
      && document.cookie.indexOf('liveapi') === -1
      && document.cookie.indexOf('api=dev') === -1
      && document.cookie.indexOf('api=live') === -1) {
    angular.module('BlurAdmin.theme')
      .constant('feathersSettings', {
        endpointUrl: 'http://localhost:3030', // DO NOT CHANGE THIS ADD YOUR SPECIAL CASE BELOW
        useSocket: true
      });
    // eslint-disable-next-line angular/document-service
  } else if (location.hostname !== 'admin.df-srv.de' && document.cookie.indexOf('liveapi') === -1 && document.cookie.indexOf('api=live') === -1) {
    angular.module('BlurAdmin.theme')
      .constant('feathersSettings', {
        endpointUrl: 'https://api-dev.df-srv.de', // DO NOT CHANGE THIS ADD YOUR SPECIAL CASE BELOW
        useSocket: true
      });
  } else {
    angular.module('BlurAdmin.theme')
      .constant('feathersSettings', {
        endpointUrl: 'https://api.df-srv.de',
        useSocket: true
      });
  }
  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('adKinds', {
      performance: ['display', 'retargeting', 'directorder', 'regiotool', 'regiosales', 'other'],
      regio: [],
      old: []
    })
    .constant('networkTypes', [
      'adcell',
      'affilinet',
      'awin',
      'belboon',
      'tradedoubler',
      'webgains',
      'zanox',
      'verticaladsgroup',
      'leadalliance',
      'medialead',
      'admitat'
    ])
    .constant('inventoryKinds', [
      'publisher',
      'domain',
      'network',
      'placement'
    ])
    .constant('forecastSites', {
      'Bild.de': 'bild',
      'Autobild.de': 'autobild',
      'Welt.de': 'welt',
      'Welt.de NEU': 'berlin',
      'Finanzen.net': 'finanzen',
      'Transfermarkt': 'transfermarkt',
      'Idealo': 'idealo',
      'Computerbild': 'computerbild',
      'Sportbild': 'sportbild',
      'Meinestadt': 'meinestadt',
      'gofeminin': 'gofeminin',
      'bildderfrau': 'bildderfrau',
      'businessinsider': 'businessinsider',
      'kaufda': 'kaufda',
      'stylebook.de': 'stylebook',
      'hoerzu': 'hoerzu',
      'tvdigital': 'tvdigital',
      'funketv (tvdirekt.de)': 'funketv'
    })
    .constant('revenueTypes', [
      'CPM',
      'CPC',
      'CPX',
      'eCPC',
      'eCPM',
      'OTHER'
    ])
    .constant('adoverwrites', [
      {
        value: 'targetCpm',
        text: 'targetCpm'
      },
      {
        value: 'targetCpmOffset',
        text: 'targetCpmOffset'
      },
      {
        value: 'targetCpmMultiplier',
        text: 'targetCpmMultiplier'
      },
      {
        value: 'last_presentation_days',
        text: 'lastPresentationDays'
      },
      {
        value: 'max_presentation_days',
        text: 'maxPresentationDays'
      },
      {
        value: 'multiSlot',
        text: 'multiSlot'
      },
      {
        value: 'bidCpmDoNotUseThis',
        text: 'bidCpmDoNotUseThis'
      }
    ])
    .constant('adOverwritesAutoComplete', {
      'type': 'object',
      'value': {
        'targetCpm': true,
        'targetCpmOffset': true,
        'targetCpmMultiplier': true,
        'last_presentation_days': true,
        'max_presentation_days': true,
        'multiSlot': true,
        'bidCpmDoNotUseThis': true
      }
    })
    .constant('distributions', [
      {
        value: 'daily',
        text: 'DAILY'
      },
      {
        value: 'weekly',
        text: 'WEEKLY'
      },
      {
        value: 'monthly',
        text: 'MONTHLY'
      },
      {
        value: 'spread',
        text: 'SPREAD'
      }
    ])
    .constant('targetTypes', [
      {
        value: 'guaranteed',
        text: 'GUARANTEED'
      },
      {
        value: 'capped',
        text: 'CAPPED'
      }
    ])
    .constant('contentTypes', [
      {
        id: 1,
        type: 'js'
      },
      {
        id: 2,
        type: 'html'
      },
      {
        id: 3,
        type: 'redirecthtml'
      },
      {
        id: 4,
        type: 'redirectjs'
      },
      {
        id: 5,
        type: 'template'
      }
    ])
    .constant('wizardTypes', [
      {
        value: null,
        text: 'Standard'
      },
      {
        value: 'coupon',
        text: 'Coupon'
      },
      {
        value: 'catalog',
        text: 'Catalog'
      }
    ])
    .constant('volumeTypes', [
      {
        value: 'clicks',
        text: 'CLICKS'
      },
      {
        value: 'impressions',
        text: 'IMPRESSIONS'
      }
    ])
    .constant('pixelTypes', [
      {
        name: 'Kategorie',
        type: 'C',
        recommended: true,
        params: {
          value: '[[KATEGORIE ID]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Produkt',
        type: 'P',
        recommended: true,
        params: {
          value: '[[PRODUKT ID]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Warenkorb',
        type: 'B',
        recommended: true,
        params: {
          value: '[[PRODUKT IDs, "," separated]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Checkout',
        type: 'SOLD',
        recommended: true,
        params: {
          value: '[[PRODUKT IDs, "," separated]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Suche',
        type: 'S',
        params: {
          value: '[[SUCHBEGRIFF]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Spezial',
        type: 'SP',
        params: {
          value: '[[WERT]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'LandingPage',
        type: 'L',
        params: {
          value: '[[LandingPage ID or -1]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      },
      {
        name: 'Block',
        type: 'BLOCK',
        description: 'Used to block a user from being retargeted, eg. for loggedin users',
        params: {
          days: '[[Number of days or -1 (=default) for unlimited time]]',
          gdpr_required: '[[Optional, 1 or 0 if TCF applies]]',
          gdpr_string: '[[Optional, TCF Consent String https://iabeurope.eu/transparency-consent-framework/]]'
        }
      }
    ])
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      }
    })
    .constant('adOptionsAutoComplete', {
      'type': 'object',
      'value': {
        'easing': {
          'type': 'string', 'value': true
        },
        'minROI': {
          'type': 'string', 'value': true
        },
        'baseCpm': {
          'type': 'string', 'value': true
        },
        'damping': {
          'type': 'string', 'value': true
        },
        'sinceLastActionSoldDays': {
          'type': 'string', 'value': true
        },
        'sinceSoldDays': {
          'type': 'string', 'value': true
        },
        'maxRetargetingDays': {
          'type': 'string', 'value': true
        },
        'lastPresentationDays': {
          'type': 'string', 'value': true
        },
        'lastPresentationDaysInsertionorder': {
          'type': 'string', 'value': true
        },
        'lastPresentationDaysAdvertiser': {
          'type': 'string', 'value': true
        },
        'maxPresentationDays': {
          'type': 'string', 'value': true
        },
        'maxPresentationDaysInsertionorder': {
          'type': 'string', 'value': true
        },
        'maxPresentationDaysAdvertiser': {
          'type': 'string', 'value': true
        },
        'sizeidDesktop': {
          'type': 'string', 'value': true
        },
        'sizeidMobile': {
          'type': 'string', 'value': true
        },
        'hbKeyword': {
          'type': 'string', 'value': true
        },
        'multiscreen': {
          'type': 'string', 'value': true
        },
        'allowedSlots': {
          'type': 'array', 'value': true
        },
        'target':
            {
              'type': 'object',
              'value': {
                'siteName': {
                  'type': 'string', 'value': true
                }, 'pageName': {
                  'type': 'string', 'value': true
                }
              }
            },
        'rtbPage': {
          'type': 'string', 'value': true
        },
        'rtbName': {
          'type': 'string', 'value': true
        },
        'multiSlot': {
          'type': 'string', 'value': true
        },
        'targetCpm': {
          'type': 'string', 'value': true
        },
        'attributeClicks': {
          'type': 'string', 'value': true
        },
        'confirmAnyConversion': {
          'type': 'string', 'value': true
        },
        'retargetingRequiredActions': {
          'type': 'string', 'value': true
        },
        'retarget': {
          'type': 'object', 'value': {
            'fl': {
              'type': 'array', 'value': true
            },
            'qf': {
              'type': 'object', 'value': true
            },
            'sort': {
              'type': 'array', 'value': true
            },
            'config': {
              'type': 'object', 'value': true
            },
            'maxProducts': {
              'type': 'object', 'value': {
                'test': {
                  'type': 'array', 'value': {
                    'neu': {
                      'type': 'string', 'value': true
                    },
                    'alt': {
                      'type': 'string', 'value': true
                    },
                    'array': {
                      'type': 'object', 'value': true
                    }
                  }
                }
              }
            },
            'minProducts': {
              'type': 'string', 'value': true
            },
            'clickTracking': {
              'type': 'string', 'value': true
            },
            'noDefaultStyle': {
              'type': 'string', 'value': true
            },
            'noDefaultScript': {
              'type': 'string', 'value': true
            },
          }
        },
        'skipChecks': {
          'type': 'string', 'value': true
        },
      }
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  // SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }

    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = '#';
    for (var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($window, $timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings, authorization, principal, $feathers) {
    var userLang = navigator.language;
    if ( userLang.includes('de') ) {
      moment.locale('de');
    } else {
      moment.locale('en');
    }

    window.ermi = $feathers;
    $rootScope.$on('$stateChangeStart',
      function(event, toState, toStateParams) {
        // track the state the user wants to go to;
        // authorization service needs this
        $rootScope.toState = toState;
        $rootScope.toStateParams = toStateParams;
        // if the principal is resolved, do an
        // authorization check immediately. otherwise,
        // it'll be done when the state it resolved.
        if (principal.isIdentityResolved()) {
          authorization.authorize();
        }
        if (toState.external) {
          event.preventDefault();
          $window.open(toState.url, '_blank');
        }
      });

    $rootScope.whatToWait = [
      preloader.loadAmCharts(),
      $timeout(2000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        $rootScope.whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        $rootScope.whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        $rootScope.whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all($rootScope.whatToWait).then(function () {
      if (!$rootScope.$pageLoadingController) {
        $rootScope.$pageFinishedLoading = true;
      }
    });

    $rootScope.$pageFinishedLoading = false;

    /*$timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 750);*/

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass)
      .addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .constant('translations', {
      en: {
        'IS REQUIRED': 'is required',
        CREATE: 'Create',
        'ADOPS TOOL': 'ADOPS TOOL',
        'with_date': 'English: {{date|date:\'medium\'}}',
        DAILY: 'daily',
        WEEKLY: 'weekly',
        MONTHLY: 'monthly',
        SPREAD: 'spread',
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday',
        AVERAGE: 'Average',
        EBAY: 'Ebay',
        MODIFIED: 'Modified',
        DECAY: 'Decay',
        ALL: 'All',
        HOME: 'Home',
        SEARCH: 'Search',
        PROFILE: 'Profile',
        SIGNOUT: 'Log out',
        ID: 'ID',
        NAME: 'Name',
        ACTIVE: 'Activ',
        DOWNLOAD_TOKEN: 'Download Token',
        LOADING: 'Loading',
        TOKEN: 'Token',
        SETTINGS: 'Settings',
        ZIPS: 'Zip code',
        SAVE: 'Save',
        REMOVE: 'Delete',
        NEW: 'New',
        PERMANENT: 'Permanent',
        FROM: 'from',
        TO: 'to',
        DURATION: 'duration',
        WIZARD_TYPE: 'Wizard Type',
        PRECISION: 'precision',
        DISTANCE: 'distance',
        INVENTORY: 'inventory',
        SITES: 'sites',
        CHANNELS: 'channels',
        RESULT: 'result',
        QUERY: 'query',
        INPUT: 'input',
        OUTPUT: 'output',
        STATUS: 'Status',
        AVAILABILITY: 'availability',
        UNIQUE_USERS: 'unique users',
        CAMPAIGNS: 'campaigns',
        FORECAST: 'forecast',
        PIXELS: 'pixels',
        TOOLS: 'tools',
        ADSIZES: 'Adsizes',
        DASHBOARD: 'Dashboard',
        COMMENT: 'comment',
        ADVERTISER: 'advertiser',
        WEIGHT: 'weight',
        DEFAULTWEIGHT: 'defaultweight',
        ALTWEIGHT: 'altweight',
        DOWNLOADTOKEN: 'Downloadtoken',
        RETARGETINGTOKEN: 'Retargetingtoken',
        VOUCHERS: 'Coupons',
        VOUCHER: 'Coupon',
        USED_VOUCHERS: 'Used Coupons',
        UNUSED_VOUCHERS: 'Unused Coupons',
        TIMESLOT: 'timeslot',
        TIMESLOTS: 'Timeslots',
        CONTENT: 'content',
        MEDIA: 'media',
        TYPE: 'type',
        SIZE: 'size',
        SIZES: 'sizes',
        PREVIEW: 'preview',
        TAG: 'tag',
        TAGS: 'tags',
        PARENT: 'parent',
        ACTION: 'action',
        ADD: 'add',
        DELETE: 'delete',
        DELETED: 'Deleted',
        DUMP: 'dump',
        HASH: 'hash',
        ADMEDIA: 'creative',
        ADMEDIAS: 'creatives',
        SITEMEDIA: 'sitemedia',
        AD: 'campaign',
        PRESENTATION: 'presentation',
        USERS: 'users',
        USER: 'user',
        ROLES: 'roles',
        ADMEDIASIZES: 'admediasizes',
        TOGGLE: 'toggle',
        LOCATIONS: 'locations',
        IP: 'IP',
        GEOGRAPHY: 'Geography',
        TARGET: 'target',
        CONFIG: 'configuration',
        OPTIONS: 'options',
        CREATED: 'created',
        BACK: 'back',
        USERNAME: 'username',
        PASSWORD: 'password',
        LOGIN: 'login',
        PAGE: 'Page',
        OF: 'of',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        TIMEOUT: 'Timeout',
        TARGETINGS: 'targetings',
        TARGETING: 'targeting',
        INFORMATION: 'information',
        ZIP: 'ZIP',
        RANDOM: 'Random',
        CODE: 'Code',
        STATISTICS: 'Statistics',
        COPY: 'Copy',
        DOWNLOAD: 'Download',
        NETWORK: 'Network',
        DATEFILTER: 'Datefilter',
        TODAY: 'Today',
        SUM: 'Sum',
        MEDIAS: 'Medias',
        KIND: 'Kind',
        FIRSTNAME: 'Firstname',
        LASTNAME: 'Lastname',
        EMAIL: 'Email',
        PERMISSIONS: 'Permissions',
        PUBLISHERS: 'Publishers',
        WIDTH: 'Width',
        HEIGHT: 'Height',
        NETWORKS: 'Networks',
        CREDENTIALS: 'Credentials',
        YIELD: 'Yield',
        CTR: 'CTR',
        CLONE: 'Clone',
        SELECT: 'select',
        DESELECT: 'deselect',
        SERVICE: 'Service',
        HISTORY: 'History',
        METHOD: 'Methode',
        RELATED: 'Related',
        SALES: 'Sales',
        DISTRIBUTION: 'Distribution',
        PACING: 'Pacing',
        OVERWRITES: 'Overwrites',
        OVERWRITE: 'Overwrite',
        CAPPED: 'Capped',
        GUARANTEED: 'Guaranteed',
        CPC: 'CPC',
        SELECTED: 'Selected',
        'EXTERNAL AID WAS SET': 'External aid was set',
        'YIELD PENDING': ' Yield pending',
        'YIELD CONFIRMED': 'Yield confirmed',
        'YIELD REJECTED': 'Yield rejected',
        'SALES PENDING': 'Sales pending',
        'SALES CONFIRMED': 'Sales confirmed',
        'SALES REJECTED': 'Sales rejected',
        PLACEMENTGROUPS: 'Placementgroups',
        TEMPLATES: 'Templates',
        'PLACEMENTGROUP SUCCESSFULLY CREATED': 'Placementgroup successfully created',
        'PLACEMENTGROUP NOT CREATED': 'Placementgroup not created',
        'PLACE NODES HERE': 'Place nodes here:',
        'NEW PLACEMENTGROUP': 'New Placementgroup',
        'CREATE PLACEMENTGROUP': 'Create Placementgroup',
        'PLEASE SELECT KIND': 'Please select kind',
        'INVENTORY SUCCESSFULLY CREATED': 'Inventory successfully created',
        'NEW INVENTORY': 'New inventory',
        'CREATE INVENTORY': 'create inventory',
        'ADMEDIA NAME': 'Creative name',
        'TYPE TO SEARCH CATEGORY': 'Type to search category',
        'RESET CATEGORY SEARCH': 'Reset category search',
        'ADD TARGETING': 'Add targeting',
        'EDIT TARGETING': 'Edit targeting',
        'OVERWRITES CANNOT BE EMPTY': 'Overwrites cannot be empty!',
        'EVERY OPTION NEEDS A VALUE': 'Every option needs a value',
        'TYPE TO SELECT': 'Type to select...',
        'SELECT OPTIONS': 'Select options',
        'EDIT OPTIONS': 'Edit options',
        'NEW OVERWRITE CREATED': 'New overwrite created',
        'ADD OVERWRITE': 'Add overwrite',
        'EDIT OVERWRITE': 'Edit overwrite',
        'OVERWRITE ACTIVATED': 'Overwrite activated',
        'OVERWRITE DEACTIVATED': 'Overwrite deactivated',
        'TARGET ACTIVATED': 'Target activated',
        'TARGET DEACTIVATED': 'Target deactivated',
        'RESET DATE': 'Reset date',
        'ONLY ONE TIMESLOT CAN BE ACTIVE': 'Only one timeslot can be active',
        'EDIT TIMESLOT': 'Edit timeslot',
        'AD NAME': 'Campaign Name',
        'DAY/ADMEDIA': 'Day/Admedia',
        'DAY/CAMPAIGN': 'Day/Campaign',
        'MONTH/CAMPAIGN': 'Month/Campaign',
        'CAMPAIGN': 'Campaign',
        'CLONE CAMPAGIN': 'Clone campaign',
        'CLONE AD': 'Clone ad',
        'YIELD CPM': 'Yield CPM',
        'SELECT COLUMNS': 'Select columns...',
        'CHOOSE COLUMNS TO BE DISPLAYED': 'Choose columns to be displayed',
        'RESET STATISTIC': 'Reset statistic',
        'NETWORK SUCCESSFULLY CREATED': 'Network successfully created',
        'NETWORK NOT CREATED': 'Network not created',
        'NETWORK DETAILS': 'Network details',
        'CREATE NETWORK': 'Create network',
        'NEW NETWORK': 'New network',
        'PUBLISHER SUCCESSFULLY CREATED': 'Publisher successfully created!',
        'PUBLISHER NOT CREATED': 'Publisher not created!',
        'NEW PUBLISHER': 'New Publisher',
        'CREATE PUBLISHER': 'Create Publisher',
        'CREATE USER': 'Create user',
        'NEW USER': 'New user',
        'USER SUCCESSFULLY CREATED': 'User successfully created',
        'COUPON SUCCESSFULLY CREATED': 'Coupon successfully created',
        'COUPON NOT CREATED': 'Coupon not created',
        'COUPON SUCCESSFULLY PATCHED': 'Coupon successfully patched',
        'COUPON NOT PATCHED': 'Coupon not patched',
        'CATALOG SUCCESSFULLY CREATED': 'Catalog successfully created',
        'CATALOG NOT CREATED': 'Catalog not created',
        'CATALOG SUCCESSFULLY PATCHED': 'Catalog successfully patched',
        'CATALOG NOT PATCHED': 'Catalog not patched',
        'USER NOT CREATED': 'User not created',
        'ADMEDIASIZE SUCCESSFULLY DELETED': 'Admediasize successfully deleted',
        'ADMEDIASIZE SUCCESSFULLY CREATED': 'Admediasize successfully created',
        'HOLD CTRL FOR MULTIPLE SELECT': 'Hold ctrl for multiple select',
        'THIS WEEK': 'This week',
        'LAST WEEK': 'Last week',
        'LAST MONTH': 'Last month',
        'THIS MONTH': 'This month',
        'LAST YEAR': 'Last year',
        'THIS YEAR': 'This year',
        'GO TO ADVERTISER': 'Go to advertiser',
        'GO TO INSERTION ORDER': 'Go to insertion order',
        'COPY ALL': 'Copy all',
        'CHOOSE SIZE': 'Choose size: ',
        'CHOOSE NETWORK': 'Choose network: ',
        'PLEASE PASTE IN THE CODE': 'Please paste in the code:',
        'IMPORT': 'Import',
        'ADD CREATIVE': 'New creative',
        'IMPORT CREATIVE': 'Import creative',
        'EXPORT STATISTIC': 'Export statistic',
        'LAST 7 DAYS': 'Last 7 days',
        'LAST 30 DAYS': 'Last 30 days',
        'LAST 365 DAYS': 'Last 365 days',
        'CHOOSE DATEFILTER': 'Choose datefilter',
        'SELECT SITEMEDIA': 'Select sitemedias',
        'NO STATISTICS AVAILABLE': 'No statistics available',
        'NO RESULT FOUND': 'No result found',
        'TAG COPIED TO CLIPBOARD': 'Tag copied to clipboard!',
        'TAG NOT COPIED': 'Tag not copied',
        'DOWNLOAD ALL': 'Download all',
        'ADCODE COPIED TO CLIPBOARD': 'Adcode copied to clipboard',
        'ADCODE NOT COPIED': 'Adcode not copied',
        'ADCODES SUCCESSFULLY DOWNLOADED': 'Adcodes successfully downloaded',
        'ADCODE SUCCESSFULLY DOWNLOADED': 'Adcode successfully downloaded',
        'EXPORT ADTAGS': 'Export adtags',
        'ADD COUPON': 'Add coupon',
        'ADD CATALOG': 'Add catalog',
        'GET STATISTIC': 'Get statistic',
        'CHOOSE DATE FROM': 'Choose "Date from"',
        'CHOOSE DATE TO': 'Choose "Date to"',
        'IMPRESSIONS': 'Impressions',
        'CLICKS': 'Clicks',
        'SPENT': 'Spent',
        'DATE': 'Date',
        'CPM': 'CPM',
        'OMIT AD': 'Omit campaign',
        'SELECT ADS': 'Select campaigns...',
        'SELECT ADMEDIAS': 'Select admedias',
        'CHOOSE AD': 'Choose ad:',
        'SELECT ALL': 'Select all',
        'DESELECT ALL': 'Deselect all',
        'CHOOSE ALL': 'Choose all',
        'CHOOSE OPTIONS': 'Choose options',
        'CHOOSE NEW AD NAME': 'Choose new ad name',
        'CHOOSE TIMESLOTS': 'Choose timeslots: ',
        'CHOOSE ADMEDIAS': 'Choose admedias: ',
        'CHOOSE TARGETS': 'Choose targetings: ',
        'NEW PIXEL': 'New pixel',
        'THEME PREVIEWS': 'Theme preview',
        'SMART TARGET': 'SMART Target',
        'SEARCH FOR': 'Search for',
        'SEARCH_FOR': 'Search for',
        'UPDATED BY': 'Updated by',
        'NEW CAMPAIGN': 'New campaign',
        'NEW TARGETING': 'New targeting',
        'BACK WITHOUT SAVING': 'Back without saving',
        'SAVE NEW CAMPAIGN': 'Save new campaign',
        '# ZIPS': '# Zips',
        'CREATED BY': 'Created by',
        'FORGOT PASSWORD?': 'Forgot password?',
        'UPDATED AT': 'Updated at',
        'SEGMENT INFO': 'Segment info',
        'RESULTING TARGETING': 'Resulting targeting',
        'You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.': 'You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.',
        'Hint: Leave this empty and it is auto generated for you. Do not use special characters like &!? in the token, keep them as short as possible. Use dfx_* for all REGIO Campaigns. Use dfv_* for REGIO Prerolls.': 'Hint: Leave this empty and it is auto generated for you. Do not use special characters like &!? in the token, keep them as short as possible. Use dfx_* for all REGIO Campaigns. Use dfv_* for REGIO Prerolls.',
        'This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.': 'This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.',
        'ROWS ON PAGE': 'Rows on page',
        'THE TARGETING YOU REQUESTED DOES NOT EXIST': 'The targeting you requested does not exist',
        'THE NETWORK YOU REQUESTED DOES NOT EXIST': 'The network you requested does not exist',
        'THE PUBLISHER YOU REQUESTED DOES NOT EXIST': 'The publisher you requested does not exist',
        'NOT FOUND': 'Not found',
        'THE TARGETING YOU VIEWED GOT REMOVED': 'The targeting you viewed got removed',
        'REMOVED': 'Removed!',
        'NOT DELETED': 'Not removed!',
        'THIS TARGETING IS NOT SAVED YET': 'This targeting is not saved yet',
        'PLEASE CLICK HERE TO CONFIRM REMOVAL': 'Please click here to confirm removal!',
        'DELETION WITHOUT CONFIRMATION NOT POSSIBLE': 'Deletion without confirmation not possible',
        'REMOVE TARGETING?': 'Remove targeting?',
        'REMOVE TARGET?': 'Remove Target?',
        'REMOVE LOCATION?': 'Remove Location?',
        'REMOVE ADMEDIASIZE?': 'Remove Admediasize?',
        'NOT SAVED': 'Not saved',
        'PLEASE ENTER A NAME': 'Please enter a name',
        'PLEASE ENTER A KEY': 'Please enter a key',
        'PLEASE FILL ALL INPUTS': 'Please fill all inputs',
        'PLEASE SELECT FROM & TO OR PERMANENT': 'Please select FROM & TO or PERMANENT',
        'NO ZIPS SELECTED?!': 'No Zips selected?!',
        'PLEASE USE A SMART TARGET NOT LONGER THAN 20 CHARACTERS': 'Please use a smart target not longer than 20 characters',
        'SAVED': 'Saved',
        'SMARTTARGET IS ALREADY DEFINED': 'Smart target is already defined',
        'NO SELECTION = RUN ON PORTFOLIO': 'No selection = Run on portfolio',
        'HOW MANY DAYS?': 'How many days?',
        'DEVICE TYPE': 'device type',
        'A BLOCK OF HELP TEXT THAT BREAKS ONTO A NEW LINE AND MAY EXTEND BEYOND ONE LINE': 'A block of help text thats breaks onto a new line and may extend beyond one line',
        'TIME FROM-TO': 'Time FROM-TO',
        'TIME FROM': 'Time from',
        'TIME TO': 'Time to',
        'RESET TIME': 'Reset time',
        'RESET PASSWORD': 'Reset password',
        'CHANGE PASSWORD': 'Change password',
        'CURRENT PASSWORD': 'Current password',
        'NEW PASSWORD': 'New passwort',
        'CONFIRM PASSWORD': 'Confirm password',
        'UPDATE PROFILE': 'Update profile',
        'QUERY AVAILABILITY': 'QUERY AVAILABILITY',
        'SHOW/HIDE OUTPUT': 'Show/Hide output',
        'ADVERTISERS': 'Advertiser',
        'NEW ADVERTISER': 'New Advertiser',
        'NEW ADVERTISER CREATED': 'New Advertiser created',
        'SAVE CONFIG': 'Save config',
        'CREATE ADVERTISER': 'Create Advertiser',
        'LIST ALL ADVERTISERS': 'All Advertiser',
        'LIST ALL TARGETINGS': 'All Targetings',
        'LIST ALL CAMPAIGNS': 'All Campaigns',
        'LIST ALL PIXELS': 'All Pixels',
        'CHANGES SAVED': 'Changes saved',
        'CHANGES NOT SAVED': 'Changes not saved',
        'NO ID AVAILABLE FOR UPDATE': 'No ID available for update',
        'ADD OPTION': 'Add option',
        'ADD TIMESLOT': 'Add timeslot',
        'SAVE CHANGES': 'Save changes',
        'LIVE PREVIEW': 'Live Preview',
        'ADD ADMEDIA': 'Werbemittel hinzufügen',
        'SEARCH REQUESTCATEGORY': 'Search requestcategory',
        'REQUESTCATEGORY SUCCESSFULLY CREATED': 'Requestcategory successfully created',
        'REQUESTCATEGORY SUCCESSFULLY REMOVED': 'Requestcategory successfully removed',
        'REQUESTCATEGORY NOT CREATED': 'Requestcategory not created',
        'ADMEDIA SUCCESSFULLY REMOVED': 'Admedia successfully removed',
        'CATEGORY NOT ADDED': 'Category not added',
        'NEW ADMEDIA CREATED': 'New admedia created',
        'REQUESTCATEGORY NOT REMOVED': 'Requestcategory not removed',
        'DELETION WITHOUT ID NOT POSSIBLE': 'Deletion without ID not possible',
        'NEW TIMESLOT CREATED': 'New timeslot created',
        'CREATING ADVERTISER FAILED': 'Creating advertiser failed',
        'PLEASE FILL NAME, ADVERTISER AND ALTWEIGHT': 'Please fill name, advertiser and altweight',
        'THE PIXEL YOU REQUESTED DOES NOT EXIST': 'The requested pixel does not exist',
        'THE AD YOU REQUESTED DOES NOT EXIST': 'The requested ad does not exist',
        'THE ADVERTISER YOU REQUESTED DOES NOT EXIST': 'The requested advertiser does not exist',
        'THE USER YOU REQUESTED DOES NOT EXIST': 'The requested user does not exist',
        'UGLY HTML/JS': 'Ugly HTML/JS',
        'NICE HTML/JS': 'Nice HTML/JS',
        'BEAUTIFY HTML/JS': 'Beautify HTML/JS',
        'CREATE TAG': 'Create tag',
        'DECODE HASH': 'Decode hash',
        'ENCODE IDs': 'Encode IDs',
        'RESULTING TAGS': 'Resulting tags',
        'TAG GENERATOR': 'Tag generator',
        'LIST ALL USERS': 'All users',
        'USER SETTINGS': 'User setttings',
        'CREATE ADMEDIASIZE': 'Create admediasize',
        'CREATE SIZE': 'Create size',
        'CREATE LOCATION': 'Create location',
        'LOCATION DELETED': 'Location deleted',
        'LOCATION SUCCESSFULLY CREATED': 'Location successfully created',
        'PLEASE ENTER A NAME, ZIP AND IP': 'Please enter a name, zip and ip',
        'WELCOME BACK ': 'Welcome back ',
        'LOGIN SUCCESSFULL': 'Login successful',
        'CREATE HASH': 'Create hash',
        'RANDOM HASH SUCCESSFULLY CREATED': 'Random hash successfully created',
        'HASH SUCCESSFULLY CREATED': 'Hash successfully created',
        'CREATE PIXEL': 'Create pixel',
        'PLEASE FILL ONE OF THE FOLLOWING INPUTS (IF YOU WANT A RANDOM HASH, PLEASE CHECK RANDOM):': 'Please fill ONE of the following inputs (if you want a random hash, please check random):',
        'HASH NOT CREATED': 'Hash not created',
        'TYPE IN HASH': 'Type in hash',
        'CONTACT IMPACT AD ID': 'Contact Impact AD ID',
        'AFFILINET PID': 'Affilinet PID',
        'AWIN PID': 'Awin PID',
        'WEBGAINS PID': 'Webgains PID',
        'OPENS MODAL TO CREATE NEW HASH': 'Opens modal to create new hash',
        'PLEASE ENTER NAME AND A VALID HASH (20 CHARACTERS)': 'Please enter name and a VALID hash (20 characters)',
        'PIXEL SUCCESSFULLY CREATED': 'Pixel successfully created',
        'PIXEL SUCCESSFULLY UPDATED': 'Pixel successfully updated',
        'PIXEL SUCCESSFULLY DELETED': 'Pixel successfully deleted',
        'THIS PIXEL IS NOT SAVED YET': 'This pixel is not saved yet',
        'REMOVE PIXEL?': 'Remove pixel?',
        'AD DETAILS': 'Campaign details',
        'PRODUCTS': 'Products',
        'RAW': 'RAW Data',
        'TARGET IMPRESSIONS': 'Impression Target',
        'REQUEST CATEGORIES': 'Request Categories',
        'CREATE REQUEST CATEGORY': 'Create Request Category',
        'REQUEST CATEGORY SUCCESSFULLY CREATED': 'Request Category successfully created',
        'PLEASE ENTER ALL': 'Please enter all',
        'REMOVE REQUEST CATEGORY?': 'Remove request category?',
        'REQUEST CATEGORY DELETED': 'Request Category deleted',
        'RESET': 'Reset',
        'EMPTY': 'empty',
        'MATCH': 'Match',
        'EVENTS': 'Events',
        'MATCHER DELETED': 'Matcher deleted',
        'MATCHER NOT DELETED': 'Matcher not deleted',
        'REMOVE MATCHER?': 'Remove Matcher?',
        'CREATE MATCHER': 'Create Matcher',
        'THE MATCHER YOU REQUESTED DOES NOT EXIST': 'The Matcher you requested does not exist',
        'MATCHER SUCCESSFULLY CREATED': 'Matcher successfully created',
        'MATCHER NOT CREATED': 'Matcher not created',
        'MATCHERS': 'Matchers',
        'NEW MATCHER': 'New Matcher',
        'AMOUNT': 'Amount',
        'CHART': 'Chart',
        'PROFIT': 'Profit',
        'PROFIT CPM': 'Profit CPM',
        'SUBKIND': 'Subkind',
        'AUTO ACCEPT ADVERTISER': 'Auto accept advertiser',
        'SHARE': 'Share',
        'NEW SITE': 'New Site',
        'PUBLISHER': 'Publisher',
        'SITE SUCCESSFULLY CREATED': 'Site successfully created',
        'SITE NOT CREATED': 'Site not created',
        'THE SITE YOU REQUESTED DOES NOT EXIST': 'The site you requested does not exist',
        'SITE NOT DELETED, PLEASE REMOVE FIRST ALL SITEMEDIAS OF THIS SITE': 'Site not deleted, please remove first all Sitemedias of this site',
        'SITE NOT DELETED': 'Site not deleted',
        'REMOVE SITE?': 'Remove Site?',
        'SITE DELETED': 'Site deleted',
        'SITEMEDIAS': 'Sitemedias',
        'SITE': 'Site',
        'NEW SITEMEDIAS': 'new Sitemedias',
        'SITEMEDIAS DETAILS': 'Sitemedias Details',
        'CREATE SITEMEDIA': 'Create Sitemedia',
        'REMOVE SITEMEDIA?': 'Remove Sitemedia?',
        'SITEMEDIA DELETED': 'Sitemedia deleted',
        'SITEMEDIA NOT CREATED': 'Sitemedia not created',
        'SITEMEDIAS SUCCESSFULLY CREATED': 'Sitemedias successfully created',
        'SHOW SITEMEDIAS': 'Show Sitemedias',
        'AD STATISTICS': 'Ad statistics',
        'ADMEDIA STATISTICS': 'Admedia statistics',
        'GET HISTORY': 'Get history',
        'AD HISTORY': 'Ad history',
        'NO HISTORY AVAILABLE': 'No history available',
        'LIST ALL INSERTION ORDERS': 'All Insertion Orders',
        'INSERTION ORDER DETAIL': 'Insertion Order Details',
        'INSERTION ORDER': 'Insertion Order',
        'INSERTION ORDERS': 'Insertion Orders',
        'NEW INSERTION ORDER': 'New Insertion Order',
        'CREATE INSERTION ORDER': 'Create Insertion Order',
        'CONFIGURE TARGET': 'Configure target',
        'EDIT TARGET': 'Edit target',
        'ADD TARGET': 'Add target',
        'VOLUME TYPE': 'Volume Type',
        'TARGET VOLUME': 'Target Volume',
        'PRODUCTFEEDS': 'Productfeeds',
        'LIST ALL PRODUCTFEEDS': 'All Productfeeds',
        'NEW PRODUCTFEED': 'New productfeed',
        'PARSER': 'Parser',
        'IMPORT STATUS': 'Import status',
        'IMPORT DATE': 'Import date',
        'IMPORTED': 'Imported',
        'EXTERNAL IMAGES': 'External images',
        'CREATE PRODUCTFEED': 'Create productfeed',
        'IMPORT STARTED': 'Import started',
        'START IMPORT': 'Start import',
        'SELECT INSERTION ORDERS': 'Select insertion orders...',
        'SELECT ADVERTISER': 'Select advertiser...',
        'AD CHECKER': 'Ad checker',
        'NEXT CHECK': 'Next check',
        'PIXELTYPE WITH PIXELVALUE ALREADY THERE': 'Pixeltype with pixelvalue already there',
        'PIXELTYPE WITH CODE ALREADY THERE': 'Pixeltype with code already there',
        'FIELDS ARE NOT FILLED': 'Fields are not filled',
        'ADD ROW': 'Add row',
        'CANCEL': 'Cancel',
        'CODES': 'CODES',
        'REVENUE SHARE': 'Revenue Share',
        'CHOOSE PLACEMENTGROUPS': 'Choose Placementgroups:',
        'CHOOSE INVENTORIES': 'Choose Inventories:',
        'CHOOSE NAME': 'Choose name:',
        'INVENTORIES': 'Inventories',
        'INVENTORY DEACTIVATED': 'Inventory deactivated',
        'INVENTORY ACTIVATED': 'Inventory activated',
        'PLACEMENT GROUP DEACTIVATED': 'Placement Group deactivated',
        'PLACEMENT GROUP ACTIVATED': 'Placement Group activated',
        'CONFIGURE DIRECT TARGETING': 'Configure direct Targeting',
        'DIRECT TARGETING': 'Direct Targeting',
        'SELECT SUBKINDS': 'Select subkinds...',
        'CHOOSE FILTERS': 'Choose filters',
        'YIELD CPC': 'Yield CPC',
        'PROFIT CPC': 'Profit CPC',
        'INVENTORY ITEM SUCCESSFULLY DELETED': 'Inventory item successfully deleted',
        'NEW PARENT_ID SAVED': 'New parent ID saved',
        'SAVE NEW PARENT_ID DID NOT WORK': 'New parent_id not saved',
        'LOAD ALL': 'Load all',
        'ADD INVENTORIES': 'Add Inventories',
        'PLACEMENTGROUP SUCCESSFULLY CHANGED': 'Placementgroup successfully changed',
        'SEARCH RESULT IS TOO BIG. HIDING ALL ITEMS OF KIND PLACEMENT': 'Search result is too big. Hiding all items of kind placement',
        'SEARCH RESULT IS STILL TOO BIG. RESTRICT YOUR SEARCH': 'Search result is still too big. Restrict your search.',
        'CHOOSE TYPE': 'Choose Type',
        'EDIT REQUESTCATEGORY': 'Edit Requestcategory',
        'REMOVING FAILED': 'Removing failed',
        'REMOVING SUCCESSFULL': 'Removing successfull',
        'NEW REQUESTCATEGORY': 'New requestcategory',
        'REMOVE REQUESTCATEGORY?': 'Remove Requestcategory?',
        'CHOOSE TEMPLATE': 'Choose Template',
        'SHOW CODE': 'Show code',
        'EDIT CODE': 'Edit code',
        'CODE SUCCESSFULLY PATCHED': 'Code successfully patched!',
        'CODE NOT PATCHED': 'Code not patched',
        'PAGE SETTINGS': 'Page settings',
        'EXCLUDE HOME': 'Exclude home',
        'ONLY HOME': 'Only Home',
        'INCLUDE RECENT LOCATION': 'Use Recent Location',
        'REFRESH': 'Refresh',
        'BIDDER RELOAD': 'Bidder reload',
        'BIDDER RELOAD SUCCESSFUL': 'Bidder reload successful',
        'BIDDER RELOAD FAILED': 'Bidder reload failed',
        'EXTERNAL STATISTICS': 'External Statistics',
        'CREATE ADVERTISER FAILED': 'Create Advertiser failed',
        'NEW ADMEDIASIZE': 'New Admediasize',
        'CREATE ADMEDIASIZE FAILED': 'Create Admediasize failed',
        'THE ADMEDIASIZE YOU REQUESTED DOES NOT EXIST': 'The Admediasize you requested does not exist',
        'ADMEDIASIZE NOT DELETED': 'Admediasize not deleted',
        'PLEASE FILL TARGET VOLUME WHEN TARGET IS ACTIVE': 'Please fill Target Volume when Target should be active',
        'FOR SPREAD, PLEASE FILL ALL VALUES': 'Please fill all value, for distribution Spread',
        'CHANGE EMAIL': 'Change Email',
        'CONFIRM EMAIL': 'Confirm Email',
        'TODOTYPES': 'Todo Types',
        'SERVICE NAME': 'Service Name',
        'TEXT': 'Text',
        'READ': 'Read',
        'TODO ID': 'Todo Id',
        'TEMPLATE TEXT': 'Template Text',
        'DESCRIPTION': 'Description',
        'CHANGE NOTIFICATIONS': 'Change Notifications',
        'NOTIFICATIONS': 'Notifications',
        'MARK ALL AS READ': 'Mark All as Read',
        'SEE ALL NOTIFICATIONS': 'See all Notifications',
        'NOTIFICATION': 'Notification',
        'TODOS': 'Todos',
        'LIST ALL TODOS': 'List all Todos',
        'NOTIFIER': 'Notifier',
        'TRIGGERFN': 'Trigger Function',
        'NEW TODOTYPE': 'New Todotype',
        'CREATE TODOTYPE': 'Create Todotype',
        'EDITING USER': 'Editing User',
        'BECOME EDITOR': 'Become editor',
        'FINISH TODO': 'Finish todo',
        'MARK AS READ': 'Mark as read',
        'GOTO TODO': 'Go to Todo',
        'GOTO': 'Go to',
        'TRIGGER OPTIONS': 'Trigger Options',
        'NOTIFICATION SETTINGS': 'Notification Settings',
        'ME': 'Me',
        'OPEN': 'Open',
        'DONE': 'Done',
        'PROGRESS': 'Progress',
        'CLOSED': 'Closed',
        'TRUE': 'True',
        'FALSE': 'False',
        'NOTIFICATION SETTINGS CHANGED': 'Notification Settings changed',
        'NOTIFICATION SETTINGS NOT CHANGED': 'Notification Settings not changed',
        'TODO STATUS CHANGED': 'Todo Status changed',
        'TODO STATUS FALSE': 'Todo Status false',
        'THE TODO YOU REQUESTED DOES NOT EXIST': 'The Todo you requested does not exist',
        'TODO COMMENT CHANGED': 'Todo Comment changed',
        'THE TODOTYPE YOU REQUESTED DOES NOT EXIST': 'The Todo Type you requested does not exist',
        'TODOTYPE SUCCESSFULLY CREATED': 'Todo Type successfully created',
        'TODOTYPE NOT CREATED': 'Todo Type not created',
        'TODOTYPE DESCRIPTION': 'Todo Type Description',
        'TODOTYPE SERVICE NAME': 'Todo Type Description',
        'TODOTYPE': 'Todo Type',
        'TODOTYPE NAME': 'Todo Type Name',
        'SHOW ONLY FOUND ITEMS': 'Show found & editable elements',
        'COLLAPSE ALL': 'Collapse All',
        'EXPAND ALL': 'Expand All',
        'IMPORT ALL': 'Import all',
        'REGIO TARGETING SUCCESSFULLY PATCHED': 'Regio Targeting successfully patched',
        'REGIO TARGETING NOT PATCHED': 'Regio Targeting not patched',
        'EDIT REGIO TARGETING': 'Edit Regio Targeting',
        'CREATE REGIO TARGETING': 'Create Regio Targeting',
        'NO REGIO TARGETING FOUND': 'No Regio Targeting found',
        'ALL ZIPS': 'All Zips',
        'PRESET': 'Preset',
        'RESTRICT ADMEDIA': 'Restrict to these Admedia',
        'PLEASE SELECT INSERTIONORDER': 'Please select an Insertionorder',
        'RESET FILTER': 'Reset Filter',
        'DOWNLOAD ACTION STATISTIC': 'Download Action Statistic',
        'NO ACTION STATISTIC AVAILABLE': 'No Action Statistic available',
        'RESTRICT DATE RANGE': 'Restrict Date Range',
        'TRY AGAIN LATER': 'Try again later',
        'ACTION REPORTING': 'Action Reporting',
        'ADVERTISER AND INSERTIONORDER MUST BE CREATED PREVIOUSLY': 'Advertiser and Insertionorder must be created before to be selected',
        'CREATE INSERTIONORDER': 'Create Insertionorder',
        'CHOOSE OR CREATE AN ADVERTISER': 'Choose an Advertiser',
        'CHOOSE OR CREATE AN INSERTIONORDER': 'Chose an Insertionorder',
        'PLEASE FILL NAME, ADVERTISER, INSERTIONORDER': 'Please fill Name, Advertiser and Insertionorder',
        'CHECK ALL': 'Check All',
        'UNCHECK ALL': 'Uncheck All',
        'PLEASE SELECT ADVERTISER': 'Please select Advertiser',
        'CHECK FROM AND TO DATE': 'To date is in the past compared to From date',
        'MANAGE TASKS': 'Manage Tasks',
        'RUN TASKS': 'Run Tasks',
        'TASKS': 'Tasks',
        'NEW TASK': 'New Task',
        'CRONTAB': 'Crontab',
        'PARENT TASK': 'Parent Task',
        'GO TO PARENT TASK': 'Go to Parent Task',
        'CREATE TASKS': 'Create Tasks',
        'SELECT PARENT TASK': 'Select Parent Task',
        'TASK ID': 'Task ID',
        'SUCCESS': 'Success',
        'DISABLED TARGET RUN WITHOUT LIMITATION': 'Caution! If disabled, the campaign will run without limitations. Check if really needed.',
        'PLEASE FILL DISTRIBUTION VALUE': 'Please fill Distribution Value',
        'PLEASE FILL TYPE VALUE': 'Please fill Distribution Type Value',
        'PLEASE FILL VOLUME VALUE': 'Please fill Volume Value',
        'PLEASE FILL VOLUME TYP VALUE': 'Please fill Volume Type Value',
        'FOR SPREAD, PLEASE FILL FROM AND TO DATE': 'Please fill From and To Date for Distribution Spread'
      },
      de: {
        'IS REQUIRED': 'wird benötigt',
        CREATE: 'Erstellen',
        'ADOPS TOOL': 'ADOPS TOOL',
        'CREATE GROUP': 'Gruppe anlegen',
        'NEW GROUP': 'Neue Gruppe',
        'LIST ALL GROUPS': 'Alle Gruppen anzeigen',
        GROUPS: 'Gruppen',
        GROUP: 'Gruppe',
        'with_date': '{{date|date:\'dd.MM.yyyy - HH:MM\'}}',
        AVERAGE: 'Average',
        MODIFIED: 'Zuletzt bearbeitet',
        DECAY: 'Decay',
        ALL: 'Alle',
        HOME: 'Start',
        SEARCH: 'Suchen',
        PROFILE: 'Profil',
        SIGNOUT: 'Ausloggen',
        ID: 'ID',
        NAME: 'Name',
        ACTIVE: 'Aktiv',
        DOWNLOAD_TOKEN: 'Download Token',
        LOADING: 'Wird geladen',
        TOKEN: 'Token',
        SETTINGS: 'Einstellungen',
        ZIPS: 'Postleitzahlen',
        SAVE: 'Speichern',
        REMOVE: 'Löschen',
        NEW: 'Neu',
        PERMANENT: 'Permanent',
        FROM: 'Von',
        TO: 'Bis',
        DURATION: 'Laufzeit',
        WIZARD_TYPE: 'Wizard Typ',
        PRECISION: 'Genauigkeit',
        DISTANCE: 'Umkreis',
        INVENTORY: 'Inventar',
        SITES: 'Seiten',
        CHANNELS: 'Channels',
        RESULT: 'Ergebnis',
        QUERY: 'Abfrage',
        INPUT: 'Eingabe',
        OUTPUT: 'Ausgabe',
        STATUS: 'Status',
        AVAILABILITY: 'Verfügbarkeit',
        UNIQUE_USERS: 'Unique Users',
        CAMPAIGNS: 'Kampagnen',
        FORECAST: 'Forecast',
        PIXELS: 'Pixel',
        TOOLS: 'Werkzeuge',
        ADSIZES: 'Adsizes',
        DASHBOARD: 'Dashboard',
        COMMENT: 'Kommentar',
        WEIGHT: 'Gewichtung',
        ALTWEIGHT: 'alternative Gewichtung',
        DOWNLOADTOKEN: 'Downloadtoken',
        RETARGETINGTOKEN: 'Retargetingtoken',
        VOUCHERS: 'Coupons',
        VOUCHER: 'Coupon',
        USED_VOUCHERS: 'Benutzte Coupons',
        UNUSED_VOUCHERS: 'Unbenutzte Coupons',
        TIMESLOT: 'Zeitraum',
        TIMESLOTS: 'Zeiträume',
        CONTENT: 'Inhalt',
        MEDIA: 'Medium',
        DELETED: 'Gelöscht',
        TYPE: 'Typ',
        SIZE: 'Größe',
        SIZES: 'Größen',
        PREVIEW: 'Vorschau',
        TAG: 'Tag',
        TAGS: 'Tags',
        PARENT: 'Parent',
        ACTION: 'Aktion',
        ADD: 'hinzufügen',
        DELETE: 'löschen',
        DUMP: 'Dump',
        HASH: 'Hash',
        ADMEDIA: 'Werbemittel',
        ADMEDIAS: 'Werbemittel',
        SITEMEDIA: 'Sitemedia',
        AD: 'Kampagne',
        PRESENTATION: 'Präsentation',
        USERS: 'Benutzer',
        USER: 'Benutzer',
        ROLES: 'Rollen',
        ADMEDIASIZES: 'Admediasizes',
        TOGGLE: 'toggle',
        LOCATIONS: 'Locations',
        IP: 'IP',
        GEOGRAPHY: 'Geodaten',
        TARGET: 'Target',
        CONFIG: 'Konfiguration',
        OPTIONS: 'Optionen',
        CREATED: 'Erstellzeitpunkt',
        BACK: 'Zurück',
        USERNAME: 'Benutzername',
        PASSWORD: 'Passwort',
        LOGIN: 'Anmelden',
        PAGE: 'Seite',
        OF: 'von',
        PREVIOUS: 'Zurück',
        NEXT: 'Nächste',
        TIMEOUT: 'Timeout',
        INFORMATION: 'Information',
        ZIP: 'PLZ',
        RANDOM: 'Zufall',
        CODE: 'Code',
        STATISTICS: 'Statistiken',
        REFERENCE: 'Referenz',
        DEFAULTWEIGHT: 'Standardgewichtung',
        COPY: 'Kopieren',
        DOWNLOAD: 'Herunterladen',
        NETWORK: 'Netzwerk',
        TODAY: 'Heute',
        SUM: 'Summe',
        MEDIAS: 'Werbemittel',
        KIND: 'Art',
        TARGETINGS: 'Targetings',
        TARGETING: 'Targeting',
        FIRSTNAME: 'Vorname',
        LASTNAME: 'Nachname',
        EMAIL: 'Email',
        PERMISSIONS: 'Rechte',
        PUBLISHERS: 'Publishers',
        WIDTH: 'Breite',
        HEIGHT: 'Höhe',
        NETWORKS: 'Netzwerke',
        CREDENTIALS: 'Zugangsdaten',
        YIELD: 'Ertrag',
        CTR: 'CTR',
        CLONE: 'Klonen',
        HISTORY: 'History',
        SERVICE: 'Service',
        METHOD: 'Methode',
        RELATED: 'Related',
        SALES: 'Verkäufe',
        DAILY: 'täglich',
        WEEKLY: 'wöchentlich',
        MONTHLY: 'monatlich',
        MONDAY: 'Montag',
        TUESDAY: 'Dienstag',
        WEDNESDAY: 'Mittwoch',
        THURSDAY: 'Donnerstag',
        FRIDAY: 'Freitag',
        SATURDAY: 'Samstag',
        SUNDAY: 'Sonntag',
        SPREAD: 'spread',
        DISTRIBUTION: 'Distribution',
        PACING: 'Pacing',
        OVERWRITES: 'Overwrites',
        OVERWRITE: 'Overwrite',
        GUARANTEED: 'Garantiert',
        CAPPED: 'Limitiert',
        PLACEMENTGROUPS: 'Placementgroups',
        TEMPLATES: 'Templates',
        SELECTED: 'Ausgewählt',
        'PLACE NODES HERE': 'Nodes hier ablegen:',
        'PLACEMENTGROUP SUCCESSFULLY CREATED': 'Placementgroup erfolgreich erstellt',
        'PLACEMENTGROUP NOT CREATED': 'Placementgroup nicht erstellt',
        'NEW PLACEMENTGROUP': 'Neue Placementgroup',
        'CREATE PLACEMENTGROUP': 'Placementgroup erstellen',
        'PLEASE SELECT KIND': 'Bitte Art auswählen',
        'INVENTORY SUCCESSFULLY CREATED': 'Inventory erfolgreich erstellt',
        'NEW INVENTORY': 'Neues Inventory',
        'CREATE INVENTORY': 'Inventory anlegen',
        'ADMEDIA NAME': 'Werbemittel Name',
        'TYPE TO SEARCH CATEGORY': 'Tippen um Kategorie zu suchen...',
        'RESET CATEGORY SEARCH': 'Kategoriesuche zurücksetzen',
        'ADD TARGETING': 'Targeting hinzufügen',
        'EDIT TARGETING': 'Targeting bearbeiten',
        'OVERWRITE ACTIVATED': 'Overwrite aktiviert',
        'OVERWRITE DEACTIVATED': 'Overwrite deaktiviert',
        'EVERY OPTION NEEDS A VALUE': 'Jede Option benötigt einen Wert',
        'OVERWRITES CANNOT BE EMPTY': 'Overwrites können nicht leer sein!',
        'SELECT OPTIONS': 'Optionen auswählen',
        'EDIT OPTIONS': 'Optionen bearbeiten',
        'TYPE TO SELECT': 'Tippen um auszuwählen...',
        'NEW OVERWRITE CREATED': 'Neues Overwrite erstellt',
        'ADD OVERWRITE': 'Overwrite hinzufügen',
        'EDIT OVERWRITE': 'Overwrite bearbeiten',
        'TARGET ACTIVATED': 'Target aktiviert',
        'TARGET DEACTIVATED': 'Target deaktiviert',
        'RESET DATE': 'Datum zurücksetzen',
        'ONLY ONE TIMESLOT CAN BE ACTIVE': 'Es kann gleichzeitig nur ein Zeitraum aktiv sein!',
        'EDIT TIMESLOT': 'Zeitraum ändern',
        'AD NAME': 'Kampagnen Name',
        'DAY/ADMEDIA': 'Tag/Werbemittel',
        'DAY/CAMPAIGN': 'Tag/Kampagne',
        'MONTH/CAMPAIGN': 'Monat/Kampagne',
        'CAMPAIGN': 'Kampagne',
        'CLONE CAMPAIGN': 'Kampagne klonen',
        'CLONE AD': 'Ad klonen',
        'TARGET IMPRESSIONS': 'Ziel Volumen',
        'YIELD CPM': 'Ertrag CPM',
        'CHOOSE COLUMNS TO BE DISPLAYED': 'Wähle anzuzeigende Spalten',
        'SELECT COLUMNS': 'Spalten auswählen...',
        'RESET STATISTIC': 'Statistik zurücksetzen',
        'NETWORK SUCCESSFULLY CREATED': 'Netzwerk erfolgreich erstellt!',
        'NETWORK NOT CREATED': 'Netzwerk nicht erstellt!',
        'NETWORK DETAILS': 'Netwerk Details',
        'CREATE NETWORK': 'Netzwerk erstellen',
        'NEW NETWORK': 'Neues Netzwerk',
        'PUBLISHER SUCCESSFULLY CREATED': 'Publisher erfolgreich erstellt!',
        'PUBLISHER NOT CREATED': 'Publisher nicht erstellt!',
        'NEW PUBLISHER': 'Neuer Publisher',
        'CREATE PUBLISHER': 'Publisher erstellen',
        'CHOOSE NEW AD NAME': 'Wähle neuen Ad Namen:',
        'CHOOSE TIMESLOTS': 'Wähle Zeiträume: ',
        'CHOOSE ADMEDIAS': 'Wähle Werbemittel: ',
        'CHOOSE TARGETS': 'Wähle Targetings: ',
        'CREATE USER': 'Benutzer erstellen',
        'NEW USER': 'Neuer Benutzer',
        'USER SUCCESSFULLY CREATED': 'Benutzer erfolgreich erstellt',
        'COUPON SUCCESSFULLY CREATED': 'Coupon erfolgreich erstellt',
        'COUPON NOT CREATED': 'Coupon nicht erstellt',
        'COUPON SUCCESSFULLY PATCHED': 'Coupon erfolgreich geändert',
        'COUPON NOT PATCHED': 'Coupon nicht geändert',
        'CATALOG SUCCESSFULLY CREATED': 'Katalog erfolgreich erstellt',
        'CATALOG NOT CREATED': 'Katalog nicht erstellt',
        'CATALOG SUCCESSFULLY PATCHED': 'Katalog erfolgreich geändert',
        'CATALOG NOT PATCHED': 'Katalog nicht geändert',
        'USER NOT CREATED': 'Benutzer nicht erstellt',
        'ADMEDIASIZE SUCCESSFULLY DELETED': 'Admediasize erfolgreich gelöscht',
        'ADMEDIASIZE SUCCESSFULLY CREATED': 'Admediasize erfolgreich erstellt',
        'HOLD CTRL FOR MULTIPLE SELECT': 'Mit STRG Mehrfachauswahl möglich',
        'LAST YEAR': 'Letztes Jahr',
        'THIS YEAR': 'Dieses Jahr',
        'THIS WEEK': 'Diese Woche',
        'LAST WEEK': 'Letzte Woche',
        'LAST MONTH': 'Letzter Monat',
        'THIS MONTH': 'Dieser Monat',
        'GO TO ADVERTISER': 'Zum Advertiser',
        'GO TO INSERTION ORDER': 'Zur Insertion Order',
        'COPY ALL': 'Alle kopieren',
        'CHOOSE SIZE': 'Größe wählen: ',
        'CHOOSE NETWORK': 'Netzwerk wählen: ',
        'PLEASE PASTE IN THE CODE': 'Bitte Code einfügen: ',
        'SELECT': 'auswählen',
        'DESELECT': 'abwählen',
        'IMPORT': 'Importieren',
        'ADD CREATIVE': 'Werbemittel hinzufügen',
        'IMPORT CREATIVE': 'Werbemittel importieren',
        'EXPORT STATISTIC': 'Statistik exportieren',
        'LAST 7 DAYS': 'Letzten 7 Tage',
        'LAST 30 DAYS': 'Letzten 30 Tage',
        'LAST 365 DAYS': 'Letzten 365 Tage',
        'DATEFILTER': 'Datumsfilter',
        'CHOOSE DATEFILTER': 'Wähle Datumsfilter',
        'SELECT SITEMEDIA': 'Wähle Sitemedias...',
        'NO STATISTICS AVAILABLE': 'Keine Statistiken verfügbar',
        'NO RESULT FOUND': 'Keine Ergebnisse gefunden',
        'TAG NOT COPIED': 'Tag konnte nicht kopiert werden!',
        'TAG COPIED TO CLIPBOARD': 'Tag wurde zur Zwischenablage hinzugefügt!',
        'DOWNLOAD ALL': 'Alle herunterladen',
        'ADCODE COPIED TO CLIPBOARD': 'Adcode wurde zur Zwischenablage hinzugefügt!',
        'ADCODE NOT COPIED': 'Adcode konnte nicht kopiert werden',
        'ADCODES SUCCESSFULLY DOWNLOADED': 'Adcodes erfolgreich heruntergeladen',
        'ADCODE SUCCESSFULLY DOWNLOADED': 'Adcode erfolgreich heruntergeladen',
        'EXPORT ADTAGS': 'Adtags exportieren',
        'ADD COUPON': 'Coupon hinzufügen',
        'ADD CATALOG': 'Katalog hinzufügen',
        'GET STATISTIC': 'Statistik erzeugen',
        'CHOOSE DATE FROM': 'Wähle "Datum von"',
        'CHOOSE DATE TO': 'Wähle "Datum bis"',
        'OMIT AD': 'Kampagne ausschließen',
        'SELECT ADS': 'Wähle Kampgnen...',
        'SELECT ADMEDIAS': 'Wähle Werbemittel',
        'CHOOSE AD': 'Wähle Kampagne',
        'CHOOSE OPTIONS': 'Wähle Parameter',
        'IMPRESSIONS': 'Einblendungen',
        'CLICKS': 'Klicks',
        'SPENT': 'Investiert',
        'SELECT ALL': 'Alle',
        'DESELECT ALL': 'Alle abwählen',
        'CHOOSE ALL': 'Alle auswählen',
        'DATE': 'Datum',
        'CPM': 'CPM',
        'NEW PIXEL': 'Neues Pixel',
        'THEME PREVIEWS': 'Theme Vorschau',
        'SMART TARGET': 'SMART Target',
        'SEARCH FOR': 'Suchen nach',
        'SEARCH_FOR': 'Suchen nach',
        'UPDATED BY': 'Aktualisiert von',
        'NEW CAMPAIGN': 'Neue Kampagne',
        'NEW TARGETING': 'Neues Targeting',
        'BACK WITHOUT SAVING': 'Zurück ohne Speichern',
        'SAVE NEW CAMPAIGN': 'Neue Kampagne speichern',
        '# ZIPS': '# PLZ',
        'CREATED BY': 'Erstellt von',
        'FORGOT PASSWORD?': 'Passwort vergessen?',
        'UPDATED AT': 'Update',
        'SEGMENT INFO': 'Segment Information',
        'RESULTING TARGETING': 'Resultierendes Targeting',
        'You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.': 'Bitte eine Postleitzahl pro Zeile, 93000-94000 oder mit Komma getrennte Postleitzahlen pro Zeile verwenden.',
        'Hint: Leave this empty and it is auto generated for you. Do not use special characters like &!? in the token, keep them as short as possible. Use dfx_* for all REGIO Campaigns. Use dfv_* for REGIO Prerolls.': 'Hinweis: Bei leerem Feld wird der Wert automatisch generiert. Bitte keine Sonderzeichen wie &!? im Token verwenden und sie so kurz wie möglich halten. Bitte dfx_* für alle REGIO Kampagnen oder dfv_* für REGIO Prerolls verwenden.',
        'This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.': 'Da dieses Targeting gesperrt ist, kann es nicht bearbeitet oder gelöscht werden. Bitte kontaktiere regio@contactimpact.de für Änderungen.',
        'ROWS ON PAGE': 'Einträge pro Seite',
        'THE TARGETING YOU REQUESTED DOES NOT EXIST': 'Das angefragte Targeting existiert nicht!',
        'NOT FOUND': 'Nicht gefunden!',
        'THE TARGETING YOU VIEWED GOT REMOVED': 'Das angezeigte Targeting wurde gelöscht!',
        'REMOVED': 'Gelöscht!',
        'NOT DELETED': 'Nicht gelöscht!',
        'THIS TARGETING IS NOT SAVED YET': 'Das Targeting wurde noch nicht gespeichert',
        'PLEASE CLICK HERE TO CONFIRM REMOVAL': 'Hier klicken um den Löschvorgang zu bestätigen!',
        'DELETION WITHOUT CONFIRMATION NOT POSSIBLE': 'Löschen ohne Bestätigung nicht möglich',
        'REMOVE TARGETING?': 'Targeting löschen?',
        'REMOVE TARGET?': 'Target löschen?',
        'REMOVE LOCATION?': 'Location löschen?',
        'REMOVE ADMEDIASIZE?': 'Admediasize löschen?',
        'NOT SAVED': 'Nicht gespeichert',
        'PLEASE ENTER A NAME': 'Bitte Name eingeben',
        'PLEASE ENTER A KEY': 'Bitte Key eingeben',
        'PLEASE FILL ALL INPUTS': 'Bitte alle Felder ausfüllen',
        'PLEASE SELECT FROM & TO OR PERMANENT': 'Bitte VON & BIS oder PERMANENT wählen',
        'NO ZIPS SELECTED?!': 'Keine Postleitzahlen ausgewählt?!',
        'PLEASE USE A SMART TARGET NOT LONGER THAN 20 CHARACTERS': 'Bitte ein SMART Target mit max. 20 Zeichen verwenden',
        'SAVED': 'Gespeichert',
        'SMARTTARGET IS ALREADY DEFINED': 'SmartTarget ist bereits definiert',
        'NO SELECTION = RUN ON PORTFOLIO': 'Keine Auswahl = Run on Portfolio',
        'HOW MANY DAYS?': 'Wie viele Tage?',
        'DEVICE TYPE': 'Gerätetyp',
        'A BLOCK OF HELP TEXT THAT BREAKS ONTO A NEW LINE AND MAY EXTEND BEYOND ONE LINE': 'Ein Hilfetextbereich, der einen Zeilenumbruch hat und über eine Zeile hinausgehen kann.',
        'TIME FROM-TO': 'Zeit VON - BIS',
        'TIME FROM': 'Zeit von',
        'TIME TO': 'Zeit bis',
        'RESET TIME': 'Zeit zurücksetzen',
        'RESET PASSWORD': 'Passwort zurücksetzen',
        'CHANGE PASSWORD': 'Passwort ändern',
        'CURRENT PASSWORD': 'Aktuelles Passwort',
        'NEW PASSWORD': 'Neues Passwort',
        'CONFIRM PASSWORD': 'Passwort bestätigen',
        'UPDATE PROFILE': 'Profil aktualisieren',
        'QUERY AVAILABILITY': 'Abfrage Verfügbarkeit',
        'SHOW/HIDE OUTPUT': 'Zeige/Verstecke Ausgabe',
        'ADVERTISERS': 'Advertiser',
        'NEW ADVERTISER': 'Neuer Advertiser',
        'NEW ADVERTISER CREATED': 'Neuer Advertiser erzeugt',
        'SAVE CONFIG': 'Konfiguration speichern',
        'CREATE ADVERTISER': 'Erstelle Advertiser',
        'LIST ALL ADVERTISERS': 'Alle Advertiser',
        'LIST ALL TARGETINGS': 'Alle Targetings',
        'LIST ALL CAMPAIGNS': 'Alle Kampagnen',
        'LIST ALL PIXELS': 'Alle Pixel',
        'CHANGES SAVED': 'Änderungen gespeichert',
        'CHANGES NOT SAVED': 'Änderungen nicht gespeichert',
        'NO ID AVAILABLE FOR UPDATE': 'Keine ID für ein Update verfügbar',
        'ADD OPTION': 'Option hinzufügen',
        'ADD TIMESLOT': 'Zeitraum hinzufügen',
        'SAVE CHANGES': 'Änderungen speichern',
        'LIVE PREVIEW': 'Live Vorschau',
        'ADD ADMEDIA': 'Admedia hinzufügen',
        'SEARCH REQUESTCATEGORY': 'Suche Requestkategorie',
        'REQUESTCATEGORY SUCCESSFULLY CREATED': 'Requestkategorie erfolgreich erstellt',
        'REQUESTCATEGORY SUCCESSFULLY REMOVED': 'Requestkategorie erfolgreich gelöscht',
        'REQUESTCATEGORY NOT CREATED': 'Requestkategorie nicht erstellt',
        'ADMEDIA SUCCESSFULLY REMOVED': 'Admedia erfolgreich gelöscht',
        'CATEGORY NOT ADDED': 'Kategorie nicht hinzugefügt',
        'NEW ADMEDIA CREATED': 'Neues Admedia erstellt',
        'REQUESTCATEGORY NOT REMOVED': 'Requestkategorie nicht gelöscht',
        'DELETION WITHOUT ID NOT POSSIBLE': 'Löschen ohne ID nicht möglich',
        'NEW TIMESLOT CREATED': 'Neuer Zeitraum erstellt',
        'CREATING ADVERTISER FAILED': 'Erstellen des Advertisers fehlgeschlagen',
        'PLEASE FILL NAME, ADVERTISER AND ALTWEIGHT': 'Bitte Name, Advertiser und alternative Gewichtung füllen',
        'THE PIXEL YOU REQUESTED DOES NOT EXIST': 'Das angeforderte Pixel existiert nicht',
        'THE AD YOU REQUESTED DOES NOT EXIST': 'Das angeforderte Ad existiert nicht',
        'THE ADVERTISER YOU REQUESTED DOES NOT EXIST': 'Der angeforderte Advertiser existiert nicht',
        'THE USER YOU REQUESTED DOES NOT EXIST': 'Der angeforderte Benutzer existiert nicht',
        'THE NETWORK YOU REQUESTED DOES NOT EXIST': 'Das angeforderte Netzwerk existiert nicht',
        'THE PUBLISHER YOU REQUESTED DOES NOT EXIST': 'Der angeforderte Publisher existiert nicht',
        'UGLY HTML/JS': 'Unformatiertes HTML/JS',
        'NICE HTML/JS': 'Formatiertes HTML/JS',
        'BEAUTIFY HTML/JS': 'Beautify HTML/JS',
        'CREATE TAG': 'Tag erstellen',
        'DECODE HASH': 'Hash decodieren',
        'ENCODE IDs': 'IDs kodieren',
        'RESULTING TAGS': 'Resultierende Tags',
        'TAG GENERATOR': 'Tag Generator',
        'LIST ALL USERS': 'Benutzerliste',
        'USER SETTINGS': 'Benutzereinstellungen',
        'CREATE ADMEDIASIZE': 'Admediasize erstellen',
        'CREATE SIZE': 'Größe erstellen',
        'CREATE LOCATION': 'Location erstellen',
        'LOCATION DELETED': 'Location gelöscht',
        'LOCATION SUCCESSFULLY CREATED': 'Location erfolgreich erstellt',
        'PLEASE ENTER A NAME, ZIP AND IP': 'Bitte Name, PLZ und IP ausfüllen',
        'WELCOME BACK': 'Willkommen zurück, ',
        'LOGIN SUCCESSFULL': 'Login erfolgreich',
        'CREATE HASH': 'Hash erzeugen',
        'RANDOM HASH SUCCESSFULLY CREATED': 'Zufälliger Hash erfolgreich erstellt',
        'HASH SUCCESSFULLY CREATED': 'Hash erfolgreich erstellt',
        'CREATE PIXEL': 'Pixel erstellen',
        'PLEASE FILL ONE OF THE FOLLOWING INPUTS (IF YOU WANT A RANDOM HASH, PLEASE CHECK RANDOM):': 'Bitte EINS der folgenden Inputs füllen (Für zufälligen Hash bitte Random markieren):',
        'HASH NOT CREATED': 'Hash nicht erstellt',
        'TYPE IN HASH': 'Existierenden Hash eintragen',
        'CONTACT IMPACT AD ID': 'Contact Impact AD ID',
        'AFFILINET PID': 'Affilinet PID',
        'AWIN PID': 'Awin PID',
        'WEBGAINS PID': 'Webgains PID',
        'OPENS MODAL TO CREATE NEW HASH': 'Öffnet Modal um neuen Hash zu erzeugen',
        'PLEASE ENTER NAME AND A VALID HASH (20 CHARACTERS)': 'Bitte Name und validen Hash (20 Zeichen) eingeben',
        'PIXEL SUCCESSFULLY CREATED': 'Pixel erfolgreich erstellt',
        'PIXEL SUCCESSFULLY UPDATED': 'Pixel erfolgreich aktualisiert',
        'PIXEL SUCCESSFULLY DELETED': 'Pixel erfolgreich gelöscht',
        'THIS PIXEL IS NOT SAVED YET': 'Dieses Pixel ist noch nicht gespeichert',
        'REMOVE PIXEL?': 'Pixel löschen?',
        'REMOVE ADMEDIA?': 'Admedia löschen?',
        'AD DETAILS': 'Kampagnen Details',
        'ADVERTISER': 'Advertiser',
        'PRODUCTS': 'Produkte',
        'RAW': 'Raw Daten',
        'REQUEST CATEGORIES': 'Request Kategorien',
        'CREATE REQUEST CATEGORY': 'Erstelle Request Kategorie',
        'REQUEST CATEGORY SUCCESSFULLY CREATED': 'Request Kategorie erfolgreich erstellt',
        'PLEASE ENTER ALL': 'Bitte alle Felder ausfüllen',
        'REMOVE REQUEST CATEGORY?': 'Request Kategorie entfernen?',
        'REQUEST CATEGORY DELETED': 'Request Kategorie entfernt',
        'RESET': 'zurücksetzen',
        'EMPTY': 'leer',
        'MATCHERS': 'Matchers',
        'MATCH': 'Match',
        'EVENTS': 'Events',
        'MATCHER DELETED': 'Matcher entfernt',
        'MATCHER NOT DELETED': 'Matcher nicht entfernt',
        'REMOVE MATCHER?': 'Matcher entfernen?',
        'CREATE MATCHER': 'Matcher erstellen',
        'THE MATCHER YOU REQUESTED DOES NOT EXIST': 'Der angeforderte Matcher existiert nicht',
        'MATCHER SUCCESSFULLY CREATED': 'Matcher erfolgreich erstellt',
        'MATCHER NOT CREATED': 'Matcher nicht erstellt',
        'NEW MATCHER': 'Neuer Matcher',
        'AMOUNT': 'Betrag',
        'CHART': 'Diagramm',
        'REVENUE TYPE': 'Ertragsmodell',
        'REVENUE VALUE': 'Ertragswert',
        'REVENUE SHARE': 'Ertagsshare',
        'CATEGORY NAME': 'Kategoriename',
        'CHOOSE PLACEMENTGROUPS': 'Wähle Placementgroups:',
        'CHOOSE INVENTORIES': 'Wähle Inventories:',
        'PROFIT': 'Profit',
        'PROFIT CPM': 'Profit CPM',
        'SUBKIND': 'Unterart',
        'SITEMEDIAS': 'Sitemedias',
        'SITE': 'Seite',
        'SHARE': 'Anteil',
        'NEW SITEMEDIAS': 'neue Sitemedias',
        'SITEMEDIAS DETAILS': 'Sitemedias Details',
        'CREATE SITEMEDIA': 'Erstelle Sitemedia',
        'REMOVE SITEMEDIA?': 'Sitemedia löschen?',
        'SITEMEDIA DELETED': 'Sitemedia gelöscht',
        'SITEMEDIA NOT CREATED': 'Sitemedia nicht erzeugt',
        'SITEMEDIAS SUCCESSFULLY CREATED': 'Sitemedias wurde erfolgreich erzeugt',
        'AUTO ACCEPT ADVERTISER': 'Auto accept advertiser',
        'NEW SITE': 'Neue Seite',
        'PUBLISHER': 'Publisher',
        'SITE SUCCESSFULLY CREATED': 'Seite erfolgreich erstellt',
        'SITE NOT CREATED': 'Seite nicht erstellt',
        'THE SITE YOU REQUESTED DOES NOT EXIST': 'Die angefragte Seite existiert nicht',
        'SITE NOT DELETED, PLEASE REMOVE FIRST ALL SITEMEDIAS OF THIS SITE': 'Seite nicht gelöscht, bitte zuerst alle Sitemedias dieser Seite löschen',
        'SITE NOT DELETED': 'Seite nicht gelöscht',
        'REMOVE SITE?': 'Seite löschen?',
        'SITE DELETED': 'Seite gelöscht',
        'SHOW SITEMEDIAS': 'Zeige Sitemedias',
        'AD STATISTICS': 'Ad Statistiken',
        'ADMEDIA STATISTICS': 'Admedia Statistiken',
        'GET HISTORY': 'History erzeugen',
        'AD HISTORY': 'Ad history',
        'NO HISTORY AVAILABLE': 'Keine History verfügbar',
        'LIST ALL INSERTION ORDERS': 'Alle Insertion Orders',
        'INSERTION ORDER DETAIL': 'Insertion Order Details',
        'INSERTION ORDER': 'Insertion Order',
        'INSERTION ORDERS': 'Insertion Orders',
        'NEW INSERTION ORDER': 'Neue Insertion Order',
        'CREATE INSERTION ORDER': 'Insertion Order anlegen',
        'CONFIGURE TARGET': 'Target konfigurieren',
        'EDIT TARGET': 'Target bearbeiten',
        'ADD TARGET': 'Target hinzufügen',
        'VOLUME TYPE': 'Volume Typ',
        'TARGET VOLUME': 'Ziel Volumen',
        'PRODUCTFEEDS': 'Productfeeds',
        'LIST ALL PRODUCTFEEDS': 'Alle Productfeeds',
        'NEW PRODUCTFEED': 'Neues Productfeed',
        'PARSER': 'Parser',
        'IMPORT STATUS': 'Import Status',
        'IMPORT DATE': 'Import Datum',
        'IMPORTED': 'Importiert',
        'EXTERNAL IMAGES': 'Externe Bilder',
        'CREATE PRODUCTFEED': 'Productfeed erstellen',
        'START IMPORT': 'Import starten',
        'IMPORT STARTED': 'Import gestarted',
        'SELECT INSERTION ORDERS': 'Wähle Insertion Orders...',
        'SELECT ADVERTISER': 'Wähle Advertiser...',
        'AD CHECKER': 'Ad Checker',
        'NEXT CHECK': 'Nächste Überprüfung',
        'PIXELTYPE WITH PIXELVALUE ALREADY THERE': 'Pixeltyp mit Pixelwert ist bereits vorhanden',
        'PIXELTYPE WITH CODE ALREADY THERE': 'Pixeltyp mit Code ist bereits vorhanden',
        'FIELDS ARE NOT FILLED': 'Nicht alle Felder sind befüllt',
        'ADD ROW': 'Zeile hinzufügen',
        'CANCEL': 'Abbrechen',
        'CODES': 'CODES',
        'CHOOSE NAME': 'Name wählen:',
        'INVENTORIES': 'Inventories',
        'INVENTORY DEACTIVATED': 'Inventory deaktiviert',
        'INVENTORY ACTIVATED': 'Inventory aktiviert',
        'PLACEMENT GROUP DEACTIVATED': 'Placement Group deaktiviert',
        'PLACEMENT GROUP ACTIVATED': 'Placement Group aktiviert',
        'CONFIGURE DIRECT TARGETING': 'Direct Targeting konfigurieren',
        'DIRECT TARGETING': 'Direct Targeting',
        'SELECT SUBKINDS': 'Wähle Unterarten...',
        'CHOOSE FILTERS': 'Filter wählen',
        'YIELD CPC': 'Ertrag CPC',
        'PROFIT CPC': 'Profit CPC',
        'INVENTORY ITEM SUCCESSFULLY DELETED': 'Inventory item erfolgreich gelöscht',
        'NEW PARENT_ID SAVED': 'Neue parent ID gespeichert',
        'SAVE NEW PARENT_ID DID NOT WORK': 'parent ID wurde nicht gespeichert',
        'LOAD ALL': 'Alle laden',
        'ADD INVENTORIES': 'Inventories hinzufügen',
        'PLACEMENTGROUP SUCCESSFULLY CHANGED': 'Placementgroup erfolgreich geändert',
        'SEARCH RESULT IS TOO BIG. HIDING ALL ITEMS OF KIND PLACEMENT': 'Suchergebnis ist zu lang, alle Ergebnisse der Art Placement wurden deshalb ausgeblendet.',
        'SEARCH RESULT IS STILL TOO BIG. RESTRICT YOUR SEARCH': 'Suchergebnis ist immer noch zu lang, grenzen Sie Ihre Suche weiter ein.',
        'CHOOSE TYPE': 'Typ wählen',
        'EDIT REQUESTCATEGORY': 'Requestcategory bearbeiten',
        'ADD REQUESTCATEGORY': 'Requestcategory hinzufügen',
        'REQUESTCATEGORY SUCCESSFULLY CHANGED': 'Requestcategory erfolgreich geändert',
        'REMOVING FAILED': 'Löschen fehlgeschlagen',
        'REMOVING SUCCESSFULL': 'Löschen erfolgreich',
        'REMOVE REQUESTCATEGORY?': 'Requesttcategory löschen?',
        'NEW REQUESTCATEGORY': 'Neue Requestcategory',
        'CHOOSE TEMPLATE': 'Template wählen',
        'SHOW CODE': 'Code anzeigen',
        'EDIT CODE': 'Code bearbeiten',
        'CODE SUCCESSFULLY PATCHED': 'Code erfolgreich bearbeitet',
        'CODE NOT PATCHED': 'Code nicht bearbeitet!',
        'PAGE SETTINGS': 'Seiten Einstellung',
        'EXCLUDE HOME': 'Home ausschließen',
        'ONLY HOME': 'Nur Home',
        'INCLUDE RECENT LOCATION': 'Recent Location verwenden',
        'REFRESH': 'Aktualisieren',
        'BIDDER RELOAD': 'Bidder neu laden',
        'BIDDER RELOAD SUCCESSFUL': 'Bidder neu laden erfolgreich',
        'BIDDER RELOAD FAILED': 'Bidder neu laden fehlgeschlagen',
        'EXTERNAL STATISTICS': 'Externe Statistiken',
        'CREATE ADVERTISER FAILED': 'Erzeugung eines Advertisers fehlgeschlagen',
        'NEW ADMEDIASIZE': 'Neuer Admediasize',
        'CREATE ADMEDIASIZE FAILED': 'Erzeugung eines Admediasize fehlgeschlagen',
        'THE ADMEDIASIZE YOU REQUESTED DOES NOT EXIST': 'Die angeforderte Admediasize existiert nicht',
        'ADMEDIASIZE NOT DELETED': 'Admediasize nicht gelöscht',
        'PLEASE FILL TARGET VOLUME WHEN TARGET IS ACTIVE': 'Bitte das Feld Target Volume befüllen, wenn das Target aktiv sein soll',
        'FOR SPREAD, PLEASE FILL ALL VALUES': 'Bitte alle Werte befüllen, für die Distribution Spread',
        'CHANGE EMAIL': 'Email ändern',
        'CONFIRM EMAIL': 'Email bestätigen',
        'TODOTYPES': 'Todo Typen',
        'SERVICE NAME': 'Service Name',
        'TEXT': 'Text',
        'READ': 'Gelesen',
        'TODO ID': 'Todo Id',
        'TEMPLATE TEXT': 'Vorlagentext',
        'DESCRIPTION': 'Beschreibung',
        'CHANGE NOTIFICATIONS': 'Benachrichtigung ändern',
        'NOTIFICATIONS': 'Benachrichtigungen',
        'NOTIFICATION': 'Benachrichtigung',
        'MARK ALL AS READ': 'Makiere alle als gelesen',
        'SEE ALL NOTIFICATIONS': 'Zeige alle Benachrichtigungen an',
        'TODOS': 'Todos',
        'LIST ALL TODOS': 'Alle Todos',
        'NOTIFIER': 'Benachrichtiger',
        'TRIGGERFN': 'Auslösefunktion',
        'NEW TODOTYPE': 'Neuer Todotyp',
        'CREATE TODOTYPE': 'Todotyp anlegen',
        'EDITING USER': 'Bearbeiter',
        'BECOME EDITOR': 'Bearbeiter werden',
        'FINISH TODO': 'Todo abschließen',
        'MARK AS READ': 'Als gelesen makieren',
        'GOTO TODO': 'Gehe zum Todo',
        'GOTO': 'Gehe zu',
        'TRIGGER OPTIONS': 'Auslösefunktionsoptionen',
        'NOTIFICATION SETTINGS': 'Benachrichtigungseinstellungen',
        'ME': 'Ich',
        'OPEN': 'Offen',
        'DONE': 'Erledigt',
        'PROGRESS': 'In Bearbeitung',
        'CLOSED': 'Geschlossen',
        'TRUE': 'Wahr',
        'FALSE': 'Falsch',
        'NOTIFICATION SETTINGS CHANGED': 'Benachrichtigungseinstellungen geändert',
        'NOTIFICATION SETTINGS NOT CHANGED': 'Benachrichtigungseinstellungen nicht geändert',
        'TODO STATUS CHANGED': 'Todo Status geändert',
        'TODO STATUS FALSE': 'Todo-Status falsch',
        'THE TODO YOU REQUESTED DOES NOT EXIST': 'Das von Ihnen angeforderte Todo existiert nicht',
        'TODO COMMENT CHANGED': 'Todo Kommentar geändert',
        'THE TODOTYPE YOU REQUESTED DOES NOT EXIST': 'Das von Ihnen angeforderte Todo-Type existiert nicht',
        'TODOTYPE SUCCESSFULLY CREATED': 'Todo Typ erfolgreich erstellt',
        'TODOTYPE NOT CREATED': 'Todo Typ nicht erstellt',
        'TODOTYPE DESCRIPTION': 'Todo Typ ',
        'TODOTYPE SERVICE NAME': 'Todo Typ Beschreibung',
        'TODOTYPE': 'Todo Typ',
        'TODOTYPE NAME': 'Todo Typ Name',
        'SHOW ONLY FOUND ITEMS': 'Zeige nur gefundene Elemente',
        'COLLAPSE ALL': 'Alle Einklappen',
        'EXPAND ALL': 'Alle Ausklappen',
        'TARGETING TREE': 'TARGETING',
        'UPLOAD': 'Hochladen (CDN)',
        'UPLOADS': 'Hochgeladene Dateien',
        'EDIT': 'Bearbeiten',
        'IMPORT ALL': 'Alle Importieren',
        'REGIO TARGETING SUCCESSFULLY PATCHED': 'Regio Targeting erfolgreich bearbeitet',
        'REGIO TARGETING NOT PATCHED': 'Regio Targeting nicht bearbeitet',
        'EDIT REGIO TARGETING': 'Regio Targeting bearbeiten',
        'CREATE REGIO TARGETING': 'Regio Targeting erstellen',
        'NO REGIO TARGETING FOUND': 'Kein Regio Targeting gefunden',
        'ALL ZIPS': 'Alle Postleitzahlen',
        'PRESET': 'Voreinstellung',
        'RESTRICT ADMEDIA': 'Auf diese Werbemittel einschränken',
        'PLEASE SELECT INSERTIONORDER': 'Bitte wählen Sie eine Insertionorder aus',
        'RESET FILTER': 'Filter zurücksetzen',
        'DOWNLOAD ACTION STATISTIC': 'Download Action Statistik',
        'NO ACTION STATISTIC AVAILABLE': 'Keine Action Statistik verfügbar',
        'RESTRICT DATE RANGE': 'Zeitraum begrenzen',
        'TRY AGAIN LATER': 'Versuchen Sie es später erneut',
        'ACTION REPORTING': 'Action Reporting',
        'ADVERTISER AND INSERTIONORDER MUST BE CREATED PREVIOUSLY': 'Advertiser und Insertion Order müssen zuvor angelegt werden um ausgewählt werden zu können',
        'CREATE INSERTIONORDER': 'Erstelle Insertion Order',
        'CHOOSE OR CREATE AN ADVERTISER': 'Wähle einen Advertiser aus',
        'CHOOSE OR CREATE AN INSERTIONORDER': 'Wähle eine Insertion Order aus',
        'PLEASE FILL NAME, ADVERTISER, INSERTIONORDER': 'Bitte die Werte Name, Advertiser und Insertion Order befüllen',
        'CHECK ALL': 'Alle Auswählen',
        'UNCHECK ALL': 'Alle Abwählen',
        'PLEASE SELECT ADVERTISER': 'Wählen Sie einen Advertiser aus',
        'CHECK FROM AND TO DATE': 'Bis Datum liegt gegenüber Von Datum in der Vergangenheit',
        'MANAGE TASKS': 'Tasks verwalten',
        'RUN TASKS': 'Ausgeführte Tasks',
        'TASKS': 'Aufgaben',
        'NEW TASK': 'Neue Aufgabe',
        'CRONTAB': 'Crontab',
        'PARENT TASK': 'Übergeordnete Aufgabe',
        'GO TO PARENT TASK': 'Gehe zu übergeordneter Aufgabe',
        'CREATE TASKS': 'Erstelle neue Aufgabe',
        'SELECT PARENT TASK': 'Wähle übergeordnete Aufgabe aus',
        'TASK ID': 'Task ID',
        'SUCCESS': 'Erfolg',
        'DISABLED TARGET RUN WITHOUT LIMITATION': 'Achtung! Bei Deaktivierung wird die Kampagne ohne Limitierung laufen. Prüfen Sie, ob das wirklich benötigt wird.',
        'PLEASE FILL DISTRIBUTION VALUE': 'Bitte den Wert Distribution ausfüllen',
        'PLEASE FILL TYPE VALUE': 'Bitte den Wert Distribution Typ ausfüllen',
        'PLEASE FILL VOLUME VALUE': 'Bitte den Wert Ziel Volumen ausfüllen',
        'PLEASE FILL VOLUME TYP VALUE': 'Bitte den Wert Volumen Typ ausfüllen',
        'FOR SPREAD, PLEASE FILL FROM AND TO DATE': 'Bitte den Von & Bis Datumswert für die Distribution Spread ausfüllen'
      }
    });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.login')
    .controller('LoginController', LoginController);

  function LoginController($rootScope, $location, $scope, baConfig, $filter, $state, $log, toastr, $feathers, principal, $window, $http, feathersSettings) {
    $scope.username = '';
    $scope.password = '';
    $window.f = $feathers;
    $scope.submit = function() {
      $feathers.authenticate({
        strategy: 'local',
        type: 'local',
        username: $scope.username,
        password: $scope.password
      }).then(function (result) {
        principal.authenticate(result.data);
        $log.log('Authenticated!', result);
        toastr.success($filter('translate')('WELCOME BACK ')+(result.data.firstname||result.data.username), $filter('translate')('LOGIN SUCCESSFULL'));
        if ($rootScope.returnToState && $rootScope.returnToStateQueryString) {
          $location.path($rootScope.returnToState.url).search($rootScope.returnToStateQueryString);
          delete $rootScope.returnToState;
          delete $rootScope.returnToStateQueryString;
          delete $rootScope.returnToStateParams;
        } else {
          if (principal.isInRole(32)) {
            $state.go('targetings.all');
          } else {
            $state.go('dashboard');
          }
        }
      })
        .catch(function (error) {
          toastr.error(error.message, 'Login Error');
          $log.error('Error authenticating!', error);
        });
    };

    $scope.appVersion = 'APP N/A';
    $scope.apiVersion = 'API N/A';
    $http.get('version.json').then((data) => {
      $scope.appVersion = 'APP ' +  data.data.raw;
    }, error => {
      console.log('error get appVersion: ', error);
    });

    $http.get(feathersSettings.endpointUrl + '/info').then((data) => {
      $scope.apiVersion = data.data.title + ' ' + data.data.version;
    }, error => {
      console.log('error get apiVersion: ', error);
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageController', ProfilePageController);

  /** @ngInject */
  function ProfilePageController($scope, $stateParams, fileReader, $filter, $state, $uibModal, $feathers, toastr, hotkeys) {

    $scope.$watch('user', function () {
      $scope.helperUser = $scope.user;
    });

    $scope.activeTabIndex = 0;

    if ($stateParams && $stateParams.tab) {
      let expression = $stateParams.tab;
      switch ($stateParams.tab) {
      case 'notifications':
        $scope.activeTabIndex = 0;
        break;
      case 'options':
        $scope.activeTabIndex = 1;
        break;
      default:
        break;
      }
    }

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.notifications = [];
    $scope.todoTypesNotificationSettings = [];
    $scope.userNotificationSettings = [];

    $state.current.title = $filter('translate')('PROFILE');

    $scope.profile = {
      password: '',
      confirmPassword: '',
      email: '',
      confirmEmail: ''
    };

    $scope.formatDateTime = function (dateTime){
      return moment(dateTime).format('LLL');
    };

    $scope.markAllNotificationsAsRead = async function (){
      let result =  await $feathers.service('notifications').patch(null, {
        'read': true
      }, {
        query: {
          read: false,
          $select: ['id', 'user_id']
        }
      });
      for (let item of result){
        await $scope.notificationViewedAll(item.id);
      }
      $scope.$apply();
    };

    $scope.notificationViewedAll = async function(id){
      try {
        const foundIndex = await $scope.notifications.findIndex( item => item.id === id);
        if (foundIndex >= 0) {
          $scope.notifications[foundIndex].read = true;
        }
        $scope.$apply();
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.notificationViewed = async function(id){
      try {
        let patched = await $feathers.service('notifications').patch(id, {
          read: true,
        });
        const foundIndex = await $scope.notifications.findIndex( item => item.id === id);
        if (foundIndex >= 0) {
          $scope.notifications[foundIndex] = patched;
        }
        $scope.$apply();
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.changePassword = function() {
      if ($scope.profile.password !== $scope.profile.confirmPassword) {
        return toastr.error('Passwords don\'t match!', 'Not Changed');
      }
      if ($scope.profile.password.length<8) {
        return toastr.error('Password needs to have least 8 characters', 'Not Changed');
      }
      $feathers.service('authManagement').create({
        action: 'passwordChange',
        value: {
          user: {
            email: $scope.helperUser.email
          },
          oldPassword: $scope.helperUser.currentPassword, // old password for verification
          password: $scope.profile.password, // new password
        },
      })
        .then(function() {
          toastr.success('Your new password is set.', 'Password Changed');
        });
      // $feathers.service('users').patch($scope.user.id, {
      //   password: $scope.profile.password
      // })

    };


    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.initNotificationIsActive = function(){
      for (let todoType of $scope.todoTypesNotificationSettings){
        todoType.notificationVisible = true;
      }

      if ($scope.userNotificationSettings && $scope.userNotificationSettings.notification_settings){
        let userNotificationSettingsKeys = Object.keys($scope.userNotificationSettings.notification_settings);
        for (let key of userNotificationSettingsKeys){
          const foundIndex = $scope.todoTypesNotificationSettings.findIndex(item => item.id === parseInt(key));
          if (foundIndex > -1){
            $scope.todoTypesNotificationSettings[foundIndex].notificationVisible = !$scope.userNotificationSettings.notification_settings[key].muted;
          }
        }
      }
    };

    $scope.createNotificationSettingsStructure = function () {
      let result = {
      };

      for (let todoType of $scope.todoTypesNotificationSettings){
        let idStr = todoType.id.toString();
        let mutedValue = !todoType.notificationVisible;
        let obj = {
        };
        obj[idStr] = {
          muted: mutedValue
        };
        Object.assign(result, obj);
      }

      return result;
    };

    $scope.changeNotificationIsActive = async function () {
      let notificationSettings = $scope.createNotificationSettingsStructure();
      try {
        await $feathers.service('users').patch($scope.user.id, {
          notification_settings: notificationSettings
        });
        return toastr.success($filter('translate')('NOTIFICATION SETTINGS CHANGED'));
      } catch (error){
        console.error(error);
        return toastr.error($filter('translate')('NOTIFICATION SETTINGS NOT CHANGED'));
      }
    };

    $scope.checkIfNotificationIsActive = function(todoTypeId){
      if ($scope.userNotificationSettings && $scope.userNotificationSettings.notification_settings){
        for (let item of $scope.userNotificationSettings.notification_settings){
          if (item.id === todoTypeId){
            return !item.muted;
          }
        }
      }
    };

    $scope.getNotificationSettings = async function(tableState){
      try {
        $scope.isLoading = true;
        $scope.todoTypesNotificationSettings = (await $feathers.service('todotypes').find()).data;
        $scope.userNotificationSettings = await $feathers.service('users').get($scope.user.id);
        $scope.isLoading = false;
        await $scope.initNotificationIsActive();
        $scope.$apply();
      } catch (error){
        console.error(error);
        $scope.isLoading = false;
        $scope.$apply();
      }
    };

    $scope.getNotifications = async function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }

      try {
        let result = await $feathers.service('notifications').find(query);
        $scope.notifications = result.data;
        tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
        $scope.isLoading = false;
        $scope.$apply();
      } catch (error) {
        console.error(error);
        $scope.isLoading = false;
        $scope.$apply();
      }
    };
  }

})();


/* (function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(feathersConfig);

  function feathersConfig($feathersProvider, feathersSettings) {
    $feathersProvider.setEndpoint(feathersSettings.endpointUrl)

    // true is default; set to false if you like to use REST
    $feathersProvider.useSocket(true)
  }
})();*/
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Autorization check
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .factory('authorization', ['$rootScope', '$state', 'principal', '$location',
      function($rootScope, $state, principal, $location) {
        return {
          authorize: function() {
            return principal.identity()
              .then(function() {
                var isAuthenticated = principal.isAuthenticated();
                if ($rootScope.toState.data.roles
                    && $rootScope.toState
                      .data.roles.length > 0
                    && !principal.isInAnyRole(
                      $rootScope.toState.data.roles)) {
                  if (isAuthenticated) {
                    // user is signed in but not
                    // authorized for desired state
                    $state.go('accessdenied');
                  } else {
                    // user is not authenticated. Stow
                    // the state they wanted before you
                    // send them to the sign-in state, so
                    // you can return them when you're done

                    // Fixing authorization.factory called twice
                    // which is overwriting params
                    if (!angular.equals($location.search(), {})){
                      $rootScope.returnToState = $rootScope.toState;
                      $rootScope.returnToStateParams = $rootScope.toStateParams;
                      $rootScope.returnToStateQueryString = $location.search();
                    }
                    // now, send them to the signin state
                    // so they can log in
                    $state.go('login');
                  }
                } else {
                    /*console.log('how', $rootScope.returnToState);
                    if ($rootScope.returnToState && $rootScope.returnToState.url && $rootScope.returnToStateQueryString) {
                        var url = $rootScope.returnToState.url;
                        var query = $rootScope.returnToStateQueryString;
                        //delete $rootScope.returnToState;
                        //delete $rootScope.returnToStateQueryString;
                        $location.path(url).search(query);
                    } else if ($rootScope.returnToState && principal.isInAnyRole([32])) {
                        $state.go('targetings.all');
                    }*/
                }
              });
          }
        };
      }
    ]);


})();

/**
 * Loggin factory
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .factory('principal', ['$q', '$http', '$timeout', '$feathers',
      function($q, $http, $timeout, $feathers) {
        var _identity = undefined,
          _authenticated = false;

        return {
          isIdentityResolved: function() {
            return angular.isDefined(_identity);
          },
          isAuthenticated: function() {
            return _authenticated;
          },
          isInRole: function(role) {
            if (!_authenticated || !_identity.roles) {
              return false;
            }
            return (_identity.roles & role) == role;
          },
          isInAnyRole: function(roles) {
            if (!_authenticated || !_identity.roles) {
              return false;
            }

            for (var i = 0; i < roles.length; i++) {
              if (this.isInRole(roles[i])) {
                return true;
              }
            }

            return false;
          },
          logout: function() {
            _identity = undefined;
            _authenticated = false;
            $feathers.logout();
            $feathers.io.io.off('reconnect', this._handleReconnect);
          },
          _handleReconnect: function() {
            $feathers.authenticate();
          },
          authenticate: function(identity) {
            _identity = identity;
            _authenticated = identity != null;
            // POSSIBLY BAD?
            $feathers.io.io.on('reconnect', this._handleReconnect);

          },
          identity: function(force) {
            var deferred = $q.defer();

            if (force === true) {
              _identity = undefined;
            }

            // check and see if we have retrieved the
            // identity data from the server. if we have,
            // reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
              deferred.resolve(_identity);

              return deferred.promise;
            }

            // otherwise, retrieve the identity data from the
            // server, update the identity object, and then
            // resolve.
            //           $http.get('/svc/account/identity',
            //                     { ignoreErrors: true })
            //                .success(function(data) {
            //                    _identity = data;
            //                    _authenticated = true;
            //                    deferred.resolve(_identity);
            //                })
            //                .error(function () {
            //                    _identity = null;
            //                    _authenticated = false;
            //                    deferred.resolve(_identity);
            //                });

            // for the sake of the demo, fake the lookup
            // by using a timeout to create a valid
            // fake identity. in reality,  you'll want
            // something more like the $http request
            // commented out above. in this example, we fake
            // looking up to find the user is
            // not logged in
            var self = this;
            $feathers.authenticate()
              .then(function (result) {
                self.authenticate(result.data);
                deferred.resolve(_identity);
              })
              .catch(function (error) {
                console.log('error', error);
                self.authenticate(null);
                deferred.resolve(_identity);
              });
            return deferred.promise;
          }
        };
      }
    ]);

})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1, 3), 16 );
      var g = parseInt( hex.slice(3, 5), 16 );
      var b = parseInt( hex.slice(5, 7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };
  }
})();

/**
 * Autorization check
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .provider('collection',
    	function() {
    		this.$get = [function() {
    		 	return function(init, options) {
    		 		if (!options && _.isObject(init)) {
    		 			options = init;
    		 			init = [];
    		 		}
    		 		options = options||{
            };
    		 		options = _.defaults(options, {
    		 			idField: '_id'
    		 		});
    		 		var collection = init||[];
    		 		return {
    		 			apply: function(data) {
    		 				collection = data;
    		 				return collection;
    		 			},
    		 			all: function() {
    		 				return this.find();
    		 			},
    		 			find: function(filter) {
    		 				if (filter) {
                  return _.filter(collection, filter);
                }
    		 				return collection;
    		 			},
    		 			get: function(id) {
    		 				var filter = {
                };
    		 				filter[options.idField] = id;
    		 				return _.first(this.find(filter));
    		 			},
		    			update: function (event, item) {
		    				switch (event) {
		    					case 'created':
		    						var l=this.get(item[options.idField]);
                  if (!l) {
                    collection.push(item);
                  }
                  break;
                case 'removed':
                  var l=this.get(item[options.idField]);
                  if (l) {
                    _.remove(collection, l);
                  }
                  break;
                case 'updated':
                  console.log('removed', item);
                  var l=this.get(item[options.idField]);
                  if (l) {
                    l=item;
                  }
                  break;
                case 'patched':
                  var l=this.get(item[options.idField]);
                  if (l) {
                    l=item;
                  }
                  break;
		    				}
		    			}
		    		};
	    		};
    		}];
    	}
    );
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
          {
            total: event.total,
            loaded: event.loaded
          });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts: function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) {
            interval.cancel(i);
          }
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) {
            interval.cancel(i);
          }
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .controller('JsonEditorToggleModeController', JsonEditorToggleModeController);

  function JsonEditorToggleModeController($scope, $element, $attrs) {
    let newElements;
    let old;

    $scope.editorOptions = {
      mode: 'tree', modes: ['tree', 'code'],
      autocomplete: {
        getOptions: function (string, path, input, editor) {
          try {
            if ($attrs.opts) {
              if (input === 'field') {
                $scope.editor = editor;
                let choices = {
                };
                choices.value = $scope.opts.value;
                if (path.length > 1) {
                  let valuePath = choices.value[path[0]]['value'];
                  for (let i = 1; i < path.length; i++) {
                    if (valuePath[path[i]]) {
                      valuePath = valuePath[path[i]].value;
                    }
                  }
                  return Object.keys(valuePath);
                } else {
                  return Object.keys(choices.value);
                }
              }
            }
          } catch (e){
            console.log('autocomplete error: ', e);
          }
          return Object.keys({
          });
        }
      },
      change: function(){
        newElements = $scope.editor ? $scope.editor.node.childs : null;
        if (old){
          $scope.checkChildren($scope.opts.value, newElements);
        }
        old = _.cloneDeep(newElements);
      }
    };
    $scope.checkChildren = function(opts, elements) {
      for (let item of elements) {
        if (opts[item.field] && item.type !== opts[item.field].type) {
          item.changeType(opts[item.field].type);
        }
        if ( item.childs && item.childs.length > 0) {
          if (opts[item.field] && opts[item.field].hasOwnProperty('value')) {
            $scope.checkChildren(opts[item.field].value, item.childs);
          }
        }
      }
    };

    if ('overwriteHeight' in $attrs && $attrs.overwriteHeight) {
      $scope.height = $attrs.overwriteHeight;
    } else {
      $scope.height = 475;
    }
  }
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i')
              .addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0);
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        ngModel: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
        $element.ionRangeSlider({
          min: $scope.min,
          max: $scope.max,
          type: $scope.type,
          prefix: $scope.prefix,
          maxPostfix: $scope.maxPostfix,
          prettify_enabled: $scope.prettify,
          prettify_separator: $scope.prettifySeparator,
          grid: $scope.grid,
          gridMargin: $scope.gridMargin,
          postfix: $scope.postfix,
          step: $scope.step,
          hideMinMax: $scope.hideMinMax,
          hideFromTo: $scope.hideFromTo,
          from: $scope.from,
          to: $scope.to,
          disable: $scope.disable,
          onChange: $scope.onChange,
          onFinish: $scope.onFinish,
          values: $scope.values
        });

        $scope.$watch('min', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({
              min: value
            });
          });
        }, true);
        $scope.$watch('max', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({
              max: value
            });
          });
        });
        $scope.$watch('from', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({
              from: value
            });
          });
        });
        $scope.$watch('to', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({
              to: value
            });
          });
        });
        $scope.$watch('disable', function (value) {
          $timeout(function () {
            $element.data('ionRangeSlider').update({
              disable: value
            });
          });
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('jsonEditorToggleMode', function (){
      return {
        restrict: 'E',
        scope: {
          source: '=source',
          opts: '=opts',
          overwrite: '=overwriteHeight'
        },
        templateUrl: 'app/theme/directives/jsonEditorToggleMode.html',
        controller: 'JsonEditorToggleModeController'
      };
    });
})();
/**
 * @author m.ermer
 * created on 26.04.2018
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('money', money);

  /** @ngInject */
  function money($filter) {
    return {
      restrict:'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelController) {
        ngModelController.$parsers.push(function(data) {
          //convert data from view format to model format

          data=$filter('comma2decimal')(data);

          return data;
        });

        ngModelController.$formatters.push(function(data) {
          //convert data from model format to view format

          data=$filter('decimal2comma')(data);

          return data;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        });
      }
    };
  }

})();
/**
 * @author m.ermer
 * created on 02.01.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('pageSelect', function() {
      return {
        restrict: 'E',
        template: '<input type="text" class="input-xs form-control select-page" ng-model="inputPage" ng-change="selectPage(inputPage)">',
        link: function(scope, element, attrs) {
          scope.$watch('currentPage', function(c) {
            scope.inputPage = c;
          });
        }
      };
    });
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
/**
 * @author f.gildner
 * created on 15.06.2017
 */
(function () {
  'use strict';

  /** @ngInject */
  angular.module('BlurAdmin.theme')
    .directive('stPersist', function () {
    return {
      require: '^stTable',
      link: function (scope, element, attr, ctrl) {
        var nameSpace = attr.stPersist;
        var initialLoad = true;
        // save the table state every time it changes
        scope.$watch(function () {
          return ctrl.tableState();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            if(initialLoad) {
              getSavedState();
              initialLoad = false;
              return;
            }
            if (newValue.search && newValue.search.predicateObject && (!newValue.search.predicateObject.kind || newValue.search.predicateObject.kind !== 'performance')) {
              delete newValue.search.predicateObject.subkind;
            }
            localStorage.setItem(nameSpace, JSON.stringify(newValue));
          }
        }, true);
        function getSavedState() {
          // fetch the table state when the directive is loaded
          if (localStorage.getItem(nameSpace)) {
            var savedState = JSON.parse(localStorage.getItem(nameSpace));
            var tableState = ctrl.tableState();
            if (savedState.search) {
              if (savedState.search.predicateObject) {
                scope.kind = savedState.search.predicateObject.kind || 'performance';
                scope.networkType = savedState.search.predicateObject.network || '';
                scope.active = savedState.search.predicateObject.active || '';
              }
            }
            if (savedState.pagination) {
              scope.smartTablePageSize = savedState.pagination.number;
            }
            _.merge(tableState, savedState);
            ctrl.pipe();
          }
        }
      }
    };
  });
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * Created by frank on 18.08.17.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.advertisers')
    .controller('AdvertisersListController', AdvertisersListController);

  /** @ngInject */
  function AdvertisersListController($rootScope, $state, $scope, $filter, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.advertisers = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getAdvertisers = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: {
            adrequestdesires: false,
            adbase: true
          }
          // kind: 'datafactor'
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('advertisers').find(query)
        .then(function(result) {
          $scope.advertisers = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };
    $scope.routeToNewAdvertiser = function(){
      $state.go('advertisers.new');
    };
  }

})();

/**
 * Created by frank on 18.08.17.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.advertisers')
    .controller('AdvertisersDetailController', AdvertisersDetailController);

  function AdvertisersDetailController($rootScope, $scope, $stateParams, $state, $feathers, $filter, $sce, editableOptions, editableThemes, toastr) {
    $scope.advertiser = {
    };
    $scope.insertionorders = {
    };
    $scope.campaigns = {
    };

    if ($stateParams.id && $stateParams.id !== 'new') {
      $feathers.service('advertisers').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          console.log('advertiser', result);
          $state.current.title = $filter('translate')('ADVERTISER') + ': ' + result.name;
          $scope.advertiser = result;
          $scope.debug=JSON.stringify($scope.ad, null, 2);
          $scope.$apply();
          $feathers.service('insertionorders').find({
            query: {
              advertiser_id: $scope.advertiser.id,
              $populate: false,
              $paginate: false
            }
          })
            .then(function(insertionorders){
              $scope.insertionorders = insertionorders;
              $scope.$apply();
            });
          $feathers.service('ads').find({
            query: {
              advertiser: $scope.advertiser.id,
              $populate: false,
              $paginate: false
            }
          })
            .then(function(campaigns){
              $scope.campaigns = campaigns;
              $scope.$apply();
            });
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE ADVERTISER YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('advertisers.all');
        });


      $feathers.service('advertisers').on('updated', function(updated){
        $scope.advertiser = updated;
        $scope.debug=JSON.stringify($scope.advertiser, null, 2);
        $scope.$apply();
      });
    } else {
      $state.current.title = $filter('translate')('NEW ADVERTISER');
      $stateParams.id = null;
      $scope.advertiser = {
      };
    }

    $scope.saveConfig = function(){
      if ($stateParams.id && $scope.advertiser.id) {
        $feathers.service('advertisers').patch($scope.advertiser.id, {
          name: $scope.advertiser.name,
          active: $scope.advertiser.active,
          comment: $scope.advertiser.comment,
          credentials: $scope.advertiser.credentials,
          options: $scope.advertiser.options
        })
          .then(function (result) {
            return toastr.success($filter('translate')('CHANGES SAVED'));
          })
          .catch(function (error) {
            console.log('error', error);
            return toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'), $filter('translate')('NO ID AVAILABLE FOR UPDATE'));
      }
    };

    $scope.createAdvertiser = function(){
      if ($stateParams.id){
        $feathers.service('advertisers').patch($stateParams.id, _.clone($scope.advertiser))
          .then(function (result) {
            return toastr.success($filter('translate')('CHANGES SAVED'));
          })
          .catch(function (error) {
            console.log('error', error);
            return toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      } else if ($scope.advertiser.name){
        $feathers.service('advertisers')
          .create($scope.advertiser)
          .then(function(result){
            toastr.success($filter('translate')('NEW ADVERTISER CREATED'));
            $state.go('advertisers.detail', {
              id: result.id
            });
          })
          .catch(function(error){
            toastr.error($filter('translate')('NOT SAVED'));
            console.log('error', error);
          });
      } else {
        return toastr.error($filter('translate')('PLEASE ENTER A NAME'));
      }
    };

    $scope.routeToNewInsertionorder = function(){
      $state.go('insertionorders.new', {
        advertiser_id: $scope.advertiser.id
      });
    };
  }
})();
/**
 * Created by frank on 18.08.17.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.insertionorders')
    .controller('InsertionordersListController', InsertionordersListController);

  /** @ngInject */
  function InsertionordersListController($rootScope, $state, $scope, $filter, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.insertionorders = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getInsertionorders = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('insertionorders').find(query)
        .then(function(result) {
          $scope.insertionorders = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };
    $scope.routeToNewInsertionorder = function(){
      $state.go('insertionorders.new');
    };
  }

})();

/**
 * Created by frank on 18.08.17.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.insertionorders')
    .controller('InsertionordersDetailController', InsertionordersDetailController);

  function InsertionordersDetailController($rootScope, $scope, $stateParams, $state, $feathers, $filter, $sce, editableOptions, editableThemes, toastr, $location) {
    $scope.insertionorder = {
      options: {
      },
      advertiser: {
      }
    };
    $scope.campaigns = {
    };
    let possibleAdvertiser = [];

    $scope.setAdvertiser = async function(advertiserId){
      $scope.insertionorder.advertiser_id = advertiserId;
      $scope.insertionorder.advertiser = await $feathers.service('advertisers').get($scope.insertionorder.advertiser_id)
        .catch( function (error) {
          console.error(error);
        });
    };

    if ($stateParams.id && $stateParams.id !== 'new') {
      $feathers.service('insertionorders').get($stateParams.id, {
        $populate: false
      })
        .then(async function(result) {
          $state.current.title = $filter('translate')('INSERTION ORDER') + ': ' + result.name;
          $scope.insertionorder = result;
          $scope.debug=JSON.stringify($scope.ad, null, 2);
          $scope.$apply();
          $scope.insertionorder.advertiser = await $feathers.service('advertisers').get($scope.insertionorder.advertiser_id);
          $feathers.service('ads').find({
            query: {
              insertionorder_id: $scope.insertionorder.id,
              $populate: false,
              $paginate: false
            }
          })
            .then(function(campaigns){
              $scope.campaigns = campaigns;
              $scope.$apply();
            });
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE INSERTIONORDER YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('insertionorders.all');
        });


      $feathers.service('insertionorders').on('updated', function(updated){
        $scope.insertionorder = updated;
        $scope.debug=JSON.stringify($scope.insertionorder, null, 2);
        $scope.$apply();
      });
    } else {
      $state.current.title = $filter('translate')('NEW INSERTIONORDER');
      $scope.insertionorder = {
        options: {
        }
      };
      if ($stateParams && $stateParams.advertiser_id) {
        $scope.setAdvertiser($stateParams.advertiser_id);
      } else {
        if ($location.search().advertiser_id) {
          $scope.setAdvertiser($location.search().advertiser_id);
        }
      }
    }

    $scope.showAdvertiser = function(){
      console.log($scope.insertionorder.advertiser);
    };

    $scope.searchAdvertiser = function(advertiser){
      let query = {
        name: {
          $ilike: '%'+advertiser+'%'
        }, $limit: 20
      };
      return $feathers.service('advertisers').find({
        query: query
      })
        .then(function(result){
          $scope.possibleAdvertiser = result.data;
          $scope.$apply();
        })
        .catch(function(err){
          console.log('searchAdvertiser Error', err);
        });
    };

    $scope.saveConfig = async function() {
      if ($stateParams.id && $scope.insertionorder.id && $scope.insertionorder.advertiser.id) {
        await $feathers.service('insertionorders').patch($scope.insertionorder.id, {
          name: $scope.insertionorder.name,
          active: $scope.insertionorder.active,
          comment: $scope.insertionorder.comment,
          options: $scope.insertionorder.options,
          advertiser_id: $scope.insertionorder.advertiser.id
        })
          .then(function (result) {
            return toastr.success($filter('translate')('CHANGES SAVED'));
          })
          .catch(function (error) {
            console.log('error', error);
            return toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'), $filter('translate')('NO ID AVAILABLE FOR UPDATE'));
      }
    };

    $scope.createInsertionorder = async function(){
      if ($stateParams.id){
        $feathers.service('insertionorders').patch($stateParams.id, _.clone($scope.insertionorder))
          .then(function (result) {
            return toastr.success($filter('translate')('CHANGES SAVED'));
          })
          .catch(function (error) {
            console.log('error', error);
            return toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      } else if ($scope.insertionorder.name){
        if ($scope.insertionorder.hasOwnProperty('advertiser')) {
          $feathers.service('insertionorders')
            .create({
              name: $scope.insertionorder.name,
              active: $scope.insertionorder.active,
              comment: $scope.insertionorder.comment,
              options: $scope.insertionorder.options,
              advertiser_id: $scope.insertionorder.advertiser.id
            })
            .then(function (result) {
              toastr.success($filter('translate')('NEW INSERTION ORDER CREATED'));
              $state.go('insertionorders.detail', {
                id: result.id
              });
            })
            .catch(function (error) {
              toastr.error($filter('translate')('NOT SAVED'));
              console.log('error', error);
            });
        } else {
          return toastr.error($filter('translate')('PLEASE SELECT ADVERTISER'));
        }
      } else {
        return toastr.error($filter('translate')('PLEASE ENTER A NAME'));
      }
    };

    $scope.routeToNewCampaign = function(){
      $state.go('ads.detail', {
        id: 'new',
        insertionorder: $scope.insertionorder
      });
    };

  }
})();

(function () {
  'use strict';
  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditCouponController', AddEditCouponController);

  /** @ngInject */
  function AddEditCouponController($scope, toastr, $window, $filter, $feathers, $uibModalStack, feathersSettings) {
    $scope.ad = $scope.$resolve.ad;
    $scope.admedia = $scope.$resolve.admedia;
    $scope.couponWizardTypes = $scope.$resolve.couponWizardTypes;
    $scope.couponWizardType = $scope.$resolve.couponWizardType;
    $scope.vouchers = $scope.$resolve.vouchers;
    $scope.usedVouchers = $scope.$resolve.usedVouchers;
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').imageUploadURL = feathersSettings.endpointUrl + '/files';
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').imageUploadURLHeader = $feathers.get('token');
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').couponWizardTypes = $scope.couponWizardTypes;
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').couponWizardType =  $scope.couponWizardType;
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').language = navigator.language;
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').imageSrcPrefix = 'https://cdn.c-i.as/a/';

    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').addEventListener('outputWizardType', async function (event) {
      $scope.couponWizardType = event.detail;
    });
    // eslint-disable-next-line angular/document-service
    document.querySelector('coupon-wizard').addEventListener('outputCoupon', async function (event) {
      const coupon = event.detail;
      if ($scope.ad && coupon && !$scope.admedia) {
        try {
          let createdAdmedia = await $feathers.service('admedias').create({
            active: false,
            size: 25,
            code: $scope.couponWizardType,
            type: 'template',
            status: 'NEW',
            ad: $scope.ad.id,
            name: coupon.couponData.title,
            options: {
              skipClickCheck: true,
              coupon: coupon
            }
          });
          if (coupon.couponData.hasDynamicCode) {
            try {
              await $feathers.service('advouchers').create({
                ad_id: $scope.ad.id,
                codes: coupon.couponData.code
              });
            } catch (e) {
              console.log(e);
              toastr.error($filter('translate')('VOUCHERS NOT CREATED'));
            }
          }
          let admedia = await $feathers.service('admedias').get(createdAdmedia.id);
          $scope.ad.admedias.push(admedia);
          $scope.$apply();
          toastr.success($filter('translate')('COUPON SUCCESSFULLY CREATED'));
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('COUPON NOT CREATED'));
        }
      } else if ($scope.admedia && coupon) {
        try {
          let options = $scope.admedia.options;
          options.coupon.actions = coupon.actions;
          options.coupon.advertiserData = Object.assign(options.coupon.advertiserData, coupon.advertiserData);
          options.coupon.couponData = Object.assign(options.coupon.couponData, coupon.couponData);
          options.coupon.bannerData = Object.assign(options.coupon.bannerData, coupon.bannerData);
          if (options.coupon.couponData.hasDynamicCode && options.coupon.couponData.code && options.coupon.couponData.code.length > 0) {
            try {
              await $feathers.service('advouchers').create({
                ad_id: $scope.ad.id,
                codes: options.coupon.couponData.code
              });
            } catch (e) {
              console.log(e);
              toastr.error($filter('translate')('VOUCHERS NOT CREATED'));
            }
          }
          await $feathers.service('admedias').patch($scope.admedia.id, {
            name: coupon.couponData.title,
            code: $scope.couponWizardType,
            options: options
          });
          $scope.$apply();
          toastr.success($filter('translate')('COUPON SUCCESSFULLY PATCHED'));
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('COUPON NOT PATCHED'));
        }
      }
      let top = $uibModalStack.getTop();
      if (top) {
        $uibModalStack.dismiss(top.key);
      }
    });
    if ($scope.admedia && $scope.admedia.options && $scope.admedia.options.coupon){
      // eslint-disable-next-line angular/document-service
      document.querySelector('coupon-wizard').couponInput = JSON.parse(JSON.stringify($scope.admedia.options.coupon));
      if ($scope.admedia.options.coupon.couponData && $scope.admedia.options.coupon.couponData.hasDynamicCode){
        if ($scope.vouchers){
          // eslint-disable-next-line angular/document-service
          document.querySelector('coupon-wizard').dynamicCodes = {
            voucherCount: $scope.vouchers,
            voucherCountUnissued: $scope.vouchers - $scope.usedVouchers,
          };
        }
      } else {
        // eslint-disable-next-line angular/document-service
        document.querySelector('coupon-wizard').dynamicCodes = {
          voucherCount: 0,
          voucherCountUnissued: 0
        };
      }
    } else {
      // eslint-disable-next-line angular/document-service
      document.querySelector('coupon-wizard').couponInput = {
        advetiserData: null,
        couponData: null,
        bannerData: null,
        actions: []
      };
      // eslint-disable-next-line angular/document-service
      document.querySelector('coupon-wizard').dynamicCodes = {
        voucherCount: 0,
        voucherCountUnissued: 0
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditCoupon', addEditCoupon);

  /** @ngInject */
  function addEditCoupon() {
    return {
      restrict: 'E',
      controller: 'AddEditCouponController',
      templateUrl: 'app/pages/ads/addEditCoupon/addEditCoupon.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditRegioTargetingController', AddEditRegioTargetingController);

  /** @ngInject */
  function AddEditRegioTargetingController($scope, toastr, $window, $filter, $feathers, $uibModalStack, lodash) {

    $scope.ad = $scope.$resolve.ad;
    $scope.showOutputLines = false;
    $scope.allZips = [];
    $scope.adrequestdesiresId = null;
    $scope.fc_query = {
    };
    $scope.forecast = {
    };
    $scope.queryTime = 0;
    $scope.input = {
    };
    $scope.input.parsed = {
    };
    $scope.input.zips = {
    };
    $scope.input.distance = 0;
    $scope.input.precision = 5;

    let requestCategoryTag = 'geo.zip';
    $scope.idxGeoTargeting = null;

    $scope.init = function () {
      // geotargeting options only shown when regotargeting is existing
      $scope.idxGeoTargeting = $scope.ad.adrequestdesires.findIndex(x => x.requestcategory.tag === requestCategoryTag);
      console.log($scope.ad.adrequestdesires);
      if ($scope.ad.options.hasOwnProperty('_geoTageting') && $scope.idxGeoTargeting >= 0) {
        $scope.input.distance = $scope.ad.options._geoTageting.distance;
        $scope.input.precision = $scope.ad.options._geoTageting.precision;
        $scope.input.unparsed = $scope.ad.options._geoTageting.input;
        $scope.changed($scope.input.unparsed);
      }
    };

    $scope.changeDistance = function (data) {
      $scope.input.distance = data.from;
      $scope.input.precision = 5;
      $scope.$apply();
    };
    $scope.changePrecision = function (data) {
      $scope.input.distance = 0;
      $scope.input.precision = data.from;
      $scope.$apply();
    };

    $scope.$watchGroup(['forecast', 'input.distance', 'input.precision'], async function () {
      let zips = {
      };
      lodash.each($scope.forecast, function (value, key) {
        zips[key] = value.parsed;
      });
      let query = {
      };
      query.query = {
        zips: zips,
        distance: $scope.input.distance,
        precision: $scope.input.precision,
      };
      $feathers.service('zips').timeout = 60000;

      try {
        let result = await $feathers.service('zips').find(query);
        lodash.each(result, function (zips, key) {
          if (zips.length) {
            $scope.forecast[key].zips = zips;
            $scope.forecast[key].status = 'OK';
          } else {
            $scope.forecast[key].status = 'INVALID ZIP';
          }
        });
        $scope.updateZips();
        $scope.$apply();
      } catch (e) {
        console.log('service zip error', e);
      }
    });

    function parseLine(line) {
      let zips = [];
      let input = [];
      if (line.indexOf('.') !== -1) {
        line = line.split('.').join('');
      }
      if (line.indexOf(',') !== -1) {
        input = line.split(',');
        input = input.map(function (l) {
          return l.trim();
        });
      } else {
        input.push(line.trim());
      }
      _.each(input, function (zip) {
        if (zip.length === 4) {
          zips.push(('0000' + zip).slice(-5));
        } else if (zip.length < 4) {
          let z = parseInt((zip + '00000').slice(0, 5));
          zips.push(z);

        } else if (zip.indexOf('-') !== -1) {
          let start = parseInt(zip.split('-')[0]);
          let end = parseInt(zip.split('-')[1]);
          if (!start || start <= 999 || start.length < 4 || end < start) {
            return;
          }
          if (!end || end <= 999 || end.length < 4) {
            return;
          }
          let current = start;
          while (current !== end) {
            let zzz = ('00000' + current.toString()).slice(-5);
            zips.push(zzz);
            current++;
          }
        } else if (zip.length === 5) {
          zips.push(zip);
        }

      });
      return zips;
    }

    $scope.updateZips = function () {
      $scope.allZips = [];
      for (let item of Object.keys($scope.forecast)) {
        if ($scope.forecast[item]['zips']) {
          for (let zip of $scope.forecast[item]['zips']) {
            if ($scope.allZips.indexOf(zip) < 0) {
              $scope.allZips.push(zip);
            }
          }
        }
      }
    };

    $scope.changed = function (data) {
      let lines = data.split('\n');
      let index = 0;
      $scope.forecast = {
      };
      lodash.each(lines, function (line) {
        let idx = 'line' + index;
        $scope.forecast[idx] = $scope.forecast[line] || {
        };
        $scope.forecast[idx] = {
          parsed: parseLine(line),
          input: line
        };
        index++;
      });
    };

    $scope.init();

    let geoTargetingProperty = $scope.ad.options.hasOwnProperty('_geoTageting');
    let geoTargetingKeyProperty = $scope.ad.options._geoTageting;

    if (!(geoTargetingProperty && geoTargetingKeyProperty.hasOwnProperty('input') &&
      geoTargetingKeyProperty.hasOwnProperty('distance') && geoTargetingKeyProperty.hasOwnProperty('precision'))) {
      if ($scope.idxGeoTargeting >= 0) {
        $scope.input.unparsed = $scope.ad.adrequestdesires[$scope.idxGeoTargeting].match['$any'].join(', ');
        $scope.adrequestdesiresId = $scope.ad.adrequestdesires[$scope.idxGeoTargeting].id;
        $scope.changed($scope.input.unparsed);
      }
    } else if ($scope.idxGeoTargeting >= 0) {
      $scope.adrequestdesiresId = $scope.ad.adrequestdesires[$scope.idxGeoTargeting].id;
    }

    $scope.trimString = function (string, maxLength) {
      if (!string || typeof string !== 'string') {
        return '';
      }
      if (string.length < maxLength) {
        return string;
      }
      return string.substring(0, maxLength) + ' ...';
    };

    $scope.saveRegioTargeting = async function () {
      let matchObj = {
        '$any': $scope.allZips
      };
      try {
        if ($scope.idxGeoTargeting < 0) {
          let requestcategories = await $feathers.service('requestcategories').find({
            query: {
              tag: requestCategoryTag,
              $paginate: false
            }
          });
          let requestcategory = requestcategories[0];
          await $feathers.service('adrequestdesires').create({
            ad: $scope.ad.id,
            requestcategory: requestcategory.id,
            weight: 1000,
            defaultweight: 0,
            name: requestcategory.name,
            match: matchObj,
            overwrite: requestcategory.overwrite
          });
          $scope.ad.adrequestdesires = await $feathers.service('adrequestdesires').find({
            query: {
              ad: $scope.ad.id,
              $paginate: false
            }
          });
        } else if ($scope.adrequestdesiresId) {
          await $feathers.service('adrequestdesires').patch($scope.adrequestdesiresId, {
            match: matchObj
          });
        } else {
          toastr.error($filter('translate')('REGIO TARGETING NOT PATCHED'));
        }
        $scope.ad.options._geoTageting = {
          input: $scope.input.unparsed,
          distance: $scope.input.distance,
          precision: $scope.input.precision
        };
        await $feathers.service('ads').patch($scope.ad.id, {
          options: $scope.ad.options
        });
        $scope.$apply();
        toastr.success($filter('translate')('REGIO TARGETING SUCCESSFULLY PATCHED'));
        $uibModalStack.dismissAll();
      } catch (e) {
        console.log('patch regio targeting error', e);
        toastr.error($filter('translate')('REGIO TARGETING NOT PATCHED'));
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditRegioTargeting', addEditRegioTargeting);

  /** @ngInject */
  function addEditRegioTargeting() {
    return {
      restrict: 'E',
      controller: 'AddEditRegioTargetingController',
      templateUrl: 'app/pages/ads/addEditRegioTargetings/addEditRegioTargeting.html'
    };
  }
})();

(function () {
  'use strict';
  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditCatalogController', AddEditCatalogController);

  /** @ngInject */
  function AddEditCatalogController($scope, toastr, $window, $filter, $feathers, $uibModalStack, feathersSettings) {
    $scope.ad = $scope.$resolve.ad;
    $scope.admedia = $scope.$resolve.admedia;
    $scope.catalogWizardType = $scope.$resolve.catalogWizardType;
    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').imageUploadURL = feathersSettings.endpointUrl + '/files';
    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').imageUploadURLHeader = $feathers.get('token');
    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').language = navigator.language;
    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').imageSrcPrefix = 'https://cdn.c-i.as/a/';
    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').catalogWizardType = $scope.catalogWizardType;

    // eslint-disable-next-line angular/document-service
    document.querySelector('catalog-wizard').addEventListener('outputCatalog', async function (event) {
      const catalog = event.detail;
      if ($scope.ad && catalog && !$scope.admedia) {
        try {
          let createdAdmedia = await $feathers.service('admedias').create({
            active: false,
            size: 1,
            code: $scope.catalogWizardType,
            type: 'template',
            status: 'NEW',
            ad: $scope.ad.id,
            name: catalog.bannerData.bannerType + '_catalog',
            options: {
              catalog: catalog,
              skipClickCheck: true
            }
          });
          let admedia = await $feathers.service('admedias').get(createdAdmedia.id);
          $scope.ad.admedias.push(admedia);
          $scope.$apply();
          toastr.success($filter('translate')('CATALOG SUCCESSFULLY CREATED'));
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('CATALOG NOT CREATED'));
        }
      } else if ($scope.admedia && catalog) {
        try {
          let options = $scope.admedia.options;

          options.catalog.pdfconvert = Object.assign(options.catalog.pdfconvert, catalog.pdfconvert);
          options.catalog.catalogData = Object.assign(options.catalog.catalogData, catalog.catalogData);
          options.catalog.bannerData = Object.assign(options.catalog.bannerData, catalog.bannerData);

          await $feathers.service('admedias').patch($scope.admedia.id, {
            options: options
          });
          $scope.$apply();
          toastr.success($filter('translate')('CATALOG SUCCESSFULLY PATCHED'));
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('CATALOG NOT PATCHED'));
        }
      }
      let top = $uibModalStack.getTop();
      if (top) {
        $uibModalStack.dismiss(top.key);
      }
    });
    if ($scope.admedia && $scope.admedia.options && $scope.admedia.options.catalog){
      // eslint-disable-next-line angular/document-service
      document.querySelector('catalog-wizard').catalogInput = JSON.parse(JSON.stringify($scope.admedia.options.catalog));
    } else {
      // eslint-disable-next-line angular/document-service
      document.querySelector('catalog-wizard').catalogInput = {
        pdfconvert: null,
        catalogData: null,
        bannerData: null
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditCatalog', addEditCatalog);

  /** @ngInject */
  function addEditCatalog() {
    return {
      restrict: 'E',
      controller: 'AddEditCatalogController',
      templateUrl: 'app/pages/ads/addEditCatalog/addEditCatalog.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditTargetController', AddEditTargetController);

  /** @ngInject */
  function AddEditTargetController($scope, toastr, $window, $filter, $feathers, $uibModalStack, distributions, targetTypes, volumeTypes) {
    $scope.filter = {
    };
    $scope.ad = $scope.$resolve.ad;
    $scope.helpertarget = $scope.ad.target || {
    };
    if ($scope.ad.target.from_date) {
      $scope.ad.target.from_date = moment(new Date($scope.ad.target.from_date)).format('DD.MM.YYYY HH:mm');
    }
    if ($scope.ad.target.to_date) {
      $scope.ad.target.to_date = moment(new Date($scope.ad.target.to_date)).format('DD.MM.YYYY HH:mm');
    }
    if ($scope.ad.target){
      if (!$scope.ad.target.filter || _.isEmpty($scope.ad.target.filter) || typeof($scope.ad.target.filter[Object.keys($scope.ad.target.filter)[0]]) === 'boolean'){
        $scope.filter.mode = 'boolean';
      } else {
        $scope.filter.mode= 'number';
      }
      $scope.helpermode = $scope.filter.mode;
    } else {
      $scope.filter.mode = 'boolean';
    }
    $scope.pacing = ($scope.ad.target.pacing || $scope.ad.target.pacing === 0) ? (1000-$scope.ad.target.pacing)/10 : 0;
    $scope.distributions = distributions;
    $scope.targetTypes = targetTypes;
    $scope.volumeTypes = volumeTypes;
    $scope.switchCheckboxDaysBool = false;

    $scope.saveTarget= function(target) {
      if (target.distribution === 'spread' && (target.from_date === '' || !target.from_date || target.to_date === '' || !target.to_date)) {
        return toastr.error($filter('translate')('FOR SPREAD, PLEASE FILL FROM AND TO DATE'));
      } else {
        if ($scope.filter.mode !== $scope.helpermode){
          _.forOwn(ad.target.filter, function(value, key) {
            if (typeof(value) !== $scope.filter.mode) {
              if ($scope.filter.mode === 'boolean'){
                target.filter[key] = false;
              } else {
                target.filter[key] = 0;
              }
            }
          });
        }
        target.pacing = 1000-($scope.pacing * 10);
        target.volume = $scope.formatBeautifyNumberBackToDecimal($scope.helpertarget.volume);
        if (!target.distribution) {
          return toastr.error($filter('translate')('PLEASE FILL DISTRIBUTION VALUE'));
        }
        if (!target.type) {
          return toastr.error($filter('translate')('PLEASE FILL TYPE VALUE'));
        }
        if (!target.volume){
          return toastr.error($filter('translate')('PLEASE FILL VOLUME VALUE'));
        }
        if (!target.volume_type){
          return toastr.error($filter('translate')('PLEASE FILL VOLUME TYP VALUE'));
        }
        if (target.from_date === 'undefined' || !target.from_date || target.from_date === 'Invalid date') {
          target.from_date = null;
        }
        if (target.to_date === 'undefined' || !target.to_date || target.to_date === 'Invalid date') {
          target.to_date = null;
        }
        if (target.distribution === 'daily') {
          target.filter = {
          };
        }
        let duration = moment.duration(moment($scope.ad.target.to_date, 'DD.MM.YYYY HH:mm').diff(moment($scope.ad.target.from_date, 'DD.MM.YYYY HH:mm'))).asDays();
        if (duration < 0){
          return toastr.error($filter('translate')('CHECK FROM AND TO DATE'));
        }
        if ($scope.ad.id) {
          $feathers.service('ads').patch($scope.ad.id, {
            target: {
              distribution: target.distribution,
              filter: target.filter,
              from_date: moment(target.from_date, 'DD.MM.YYYY HH:mm').toDate(),
              to_date: moment(target.to_date, 'DD.MM.YYYY HH:mm').toDate(),
              pacing: target.pacing,
              volume: target.volume,
              active: true,
              type: target.type,
              volume_type: target.volume_type
            }
          })
            .then(function(result){
              toastr.success($filter('translate')('CHANGES SAVED'));
              $uibModalStack.dismissAll();
            })
            .catch(function(error){
              console.log(error);
              toastr.error($filter('translate')('CHANGES NOT SAVED'));
            });
        } else {
          toastr.error($filter('translate')('NO ID AVAILABLE FOR UPDATE'));
        }
      }
    };
    $scope.changePacing = function(data){
      $scope.pacing = data.from;
    };

    // Thousand Separator for the Target Helper Value
    $scope.beautifyNumberTargetVolume = function() {
      if ($scope.helpertarget.volume) {
        $scope.helpertarget.volume = ($scope.helpertarget.volume.toString()).replace(/\./g, '');
        $scope.helpertarget.volume = ($scope.helpertarget.volume.toString()).replace(/\,/g, '');
        let formatNumber = parseInt($scope.helpertarget.volume).toLocaleString('de-DE', {
          style: 'decimal', useGrouping: true
        });
        if (formatNumber) {
          $scope.helpertarget.volume = formatNumber;
        }
      }
    };

    // Target Helper Value back to an INT
    $scope.formatBeautifyNumberBackToDecimal = function(number) {
      if (number) {
        number = (number.toString()).replace(/\./g, '');
        number = (number.toString()).replace(/\,/g, '');
        number = parseInt(number);
        return number;
      }
      return null;
    };

    $scope.$watch('filter.mode', function(newValue, oldValue) {
      if ($scope.ad.target) {
        _.forOwn($scope.ad.target.filter, function(value, key) {
          if (typeof(value) !== newValue) {
            if (newValue === 'boolean'){
              $scope.ad.target.filter[key] = false;
            } else {
              $scope.ad.target.filter[key] = 0;
            }
          }
        });
      }
    });

    // moment-picker has no option for selecting only Dates and Time is 00:00, this provides it
    $scope.$watch('ad.target.from_date', function(newValue, oldValue) {
      if ($scope.ad.target.from_date) {
        if (!oldValue){
          $scope.ad.target.from_date = moment(newValue, 'DD.MM.YYYY HH:mm').startOf('day');
        }
      }
    });

    $scope.$watch('ad.target.to_date', function(newValue, oldValue) {
      if ($scope.ad.target.to_date) {
        if (!oldValue){
          $scope.ad.target.to_date = moment(newValue, 'DD.MM.YYYY HH:mm').endOf('day');
        }
      }
    });

    $scope.resetDates = function() {
      $scope.ad.target.from_date = '';
      $scope.ad.target.to_date = '';
    };

    $scope.switchCheckboxDays = function(){
      if (!$scope.ad.target.hasOwnProperty('filter')) {
        $scope.ad.target['filter'] = {};
      }
      for (let i=0; i<=6; i++) {
        $scope.ad.target.filter[i] = !$scope.switchCheckboxDaysBool;
      }
      $scope.switchCheckboxDaysBool = !$scope.switchCheckboxDaysBool;
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditTarget', addEditTarget);

  /** @ngInject */
  function addEditTarget() {
    return {
      restrict: 'E',
      controller: 'AddEditTargetController',
      templateUrl: 'app/pages/ads/addEditTarget/addEditTarget.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditTargetingController', AddEditTargetingController);

  /** @ngInject */
  function AddEditTargetingController($scope, toastr, $window, $filter, $feathers, $uibModalStack, adOverwritesAutoComplete) {
    // workaround for ui-select error in uib-tabset
    $scope.tabTwoRendered = false;
    $scope.tabThreeRendered = false;
    $scope.overwrites = {
    };
    $scope.adOverwritesAutoComplete = adOverwritesAutoComplete;
    $scope.targeting = $scope.$resolve.targeting || {
    };
    if (!$scope.targeting.match) {
      $scope.targeting.match={
      };
    }
    if (!$scope.targeting.overwrite) {
      $scope.targeting.overwrite = {
      };
    }

    async function init() {
      if ($scope.targeting.id) {
        // existing targeting
        let {
          path
        } = await resolvePath($scope.targeting.requestcategory);
        $scope.targeting.requestcategory.path = path;
      } else {
        // new targeting
        $scope.targeting.weight = 1000;
        $scope.targeting.defaultweight = 0;
      }
    }

    init();

    $scope.targeting.copyRequestcategory = $scope.targeting.requestcategory;
    $scope.ad = $scope.$resolve.ad;
    $scope.formatLabel = function(model) {
      if (model) {
        return model.id;
      }
    };
    $scope.saveTargeting = async function (targeting) {
      if (targeting.id) {
        try {
          await $feathers.service('adrequestdesires').patch(targeting.id, {
            requestcategory: targeting.requestcategory.id,
            name: targeting.name,
            weight: targeting.weight,
            defaultweight: targeting.defaultweight,
            match: targeting.match,
            overwrite: targeting.overwrite
          });
          toastr.success($filter('translate')('CHANGES SAVED'));
          $uibModalStack.dismissAll();
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else if (targeting.requestcategory && $scope.ad.id) {
        try {
          let tg = await $feathers.service('adrequestdesires').create({
            ad: $scope.ad.id,
            requestcategory: targeting.requestcategory.id,
            weight: (targeting.weight ? targeting.weight : 1000),
            defaultweight: (targeting.defaultweight ? targeting.defaultweight : 0),
            name: targeting.name,
            match: targeting.match,
            overwrite: targeting.overwrite
          });
          let reqCat = await $feathers.service('requestcategories').get(tg.requestcategory);
          tg.requestcategory = reqCat;
          $scope.ad.adrequestdesires.push(tg);
          toastr.success($filter('translate')('REQUESTCATEGORY SUCCESSFULLY CREATED'));
          $uibModalStack.dismissAll();
        } catch (error) {
          console.log('Create Adrequestdesire ERROR: ', error);
          toastr.error($filter('translate')('REQUESTCATEGORY NOT CREATED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    async function resolvePath(requestcategory) {
      let active = requestcategory.active;
      let parent = requestcategory;
      let path = requestcategory.name + '(' + requestcategory.id + ')';
      while (parent.parent) {
        parent = await $feathers.service('requestcategories').get(parent.parent);
        if (parent.active === false) {
          active = false;
        }
        if (parent.name !== 'root') {
          path = parent.name + ' (' + parent.id + ') -> ' + path;
        }
      }
      return {
        path,
        active
      };
    }

    $scope.searchRequestCategory = async function (val) {
      try {
        let rqs = await $feathers.service('requestcategories').find({
          query: {
            active: true,
            name: {
              $ilike: '%' + val + '%'
            },
            $limit: 10,
            $paginate: false
          }
        });
        for (let requCat of rqs) {
          let {
            path,
            active
          } = await resolvePath(requCat);
          requCat.active = active;
          requCat.path = path;
        }
        rqs = rqs.filter(rq => rq.active);
        return rqs;
      } catch (error) {
        console.log('searchRequestCategory Error', error);
      }
    };
    $scope.getParent = async function(requCat){
      return await $feathers.service('requestcategories').get(requCat.id);
    };
    $scope.removeOverwrite = function(item, model) {
      delete $scope.targeting.overwrite[model];
    };
    $scope.addOverwrite = function(item, model) {
      $scope.targeting.overwrite[model] = '';
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditTargeting', addEditTargeting);

  /** @ngInject */
  function addEditTargeting() {
    return {
      restrict: 'E',
      controller: 'AddEditTargetingController',
      templateUrl: 'app/pages/ads/addEditTargetings/addEditTargeting.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AddEditOverwriteController', AddEditOverwriteController);

  /** @ngInject */
  function AddEditOverwriteController($scope, toastr, $window, $filter, $feathers, $uibModalStack, adoverwrites, adOverwritesAutoComplete) {
    $scope.overwrites = {
    };
    $scope.overwrites.options = adoverwrites;
    $scope.overwrites.selectedOverwrites = [];
    $scope.overwrite = $scope.$resolve.overwrite || {
    };
    $scope.adOverwritesAutoComplete = adOverwritesAutoComplete;
    if ($scope.overwrite.id) {
      $scope.overwrite.from_date = moment($scope.overwrite.from_date).format('DD.MM.YYYY');
      $scope.overwrite.to_date = moment($scope.overwrite.to_date).format('DD.MM.YYYY');
      // check if overwrites already has options to preselect
      _.forEach(Object.keys($scope.overwrite.overwrites), function(ow){
        if (_.find($scope.overwrites.options, {
          value: ow
        })) {
          $scope.overwrites.selectedOverwrites.push(_.find($scope.overwrites.options, {
            value: ow
          }));
        }
      });
    } else {
      $scope.overwrite.overwrites = {
      };
      $scope.overwrite.from_date = moment().format('DD.MM.YYYY');
      $scope.overwrite.to_date = moment().add(14, 'days')
        .format('DD.MM.YYYY');
      $scope.overwrite.comment = 'Graceful start';
    }
    $scope.ad = $scope.$resolve.ad;
    $scope.saveOverwrite = function(overwrite) {
      if (!overwrite.overwrites || _.isEmpty(overwrite.overwrites)) {
        return toastr.error ($filter('translate')('OVERWRITES CANNOT BE EMPTY'));
      }
      var notEmpty = true;
      _.some(overwrite.overwrites, function(ow){
        if ( ow === '' || ow === 'undefined' || !ow) {
          notEmpty = false;
        }
      });
      if (!notEmpty) {
        return toastr.error($filter('translate')('EVERY OPTION NEEDS A VALUE'));
      }
      if (overwrite.id) {
        $feathers.service('adoverwrites').patch(overwrite.id, {
          ad_id: $scope.ad.id,
          from_date: moment(overwrite.from_date, 'DD.MM.YYYY').toDate(),
          to_date: moment(overwrite.to_date, 'DD.MM.YYYY').toDate(),
          comment: overwrite.comment,
          overwrites: overwrite.overwrites,
          active: overwrite.active
        })
          .then(function(result){
            toastr.success($filter('translate')('CHANGES SAVED'));
            $uibModalStack.dismissAll();
          })
          .catch(function(error){
            console.log(error);
            toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      } else {
        if (overwrite.from_date && overwrite.to_date && overwrite.comment && overwrite.overwrites) {
          $feathers.service('adoverwrites').create({
            comment: overwrite.comment,
            ad_id: $scope.ad.id,
            overwrites: overwrite.overwrites,
            active: overwrite.active,
            from_date: moment(overwrite.from_date, 'DD.MM.YYYY').toDate(),
            to_date: moment(overwrite.to_date, 'DD.MM.YYYY').toDate()
          })
            .then(function(result){
              toastr.success($filter('translate')('NEW OVERWRITE CREATED'));
              $uibModalStack.dismissAll();
            });
        } else {
          toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
        }
      }
    };

  /*  $scope.removeItem = function(item, model) {
      delete $scope.overwrite.overwrites[model];
    };
    $scope.addItem = function(item, model) {
      $scope.overwrite.overwrites[model] = '';
    };*/
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('addEditOverwrite', addEditOverwrite);

  /** @ngInject */
  function addEditOverwrite() {
    return {
      restrict: 'E',
      controller: 'AddEditOverwriteController',
      templateUrl: 'app/pages/ads/addEditOverwrites/addEditOverwrite.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AdsListController', AdsListController);

  /** @ngInject */
  function AdsListController($scope, $state, $feathers, hotkeys, adKinds, networkTypes) {
    $scope.smartTablePageSize = (JSON.parse(localStorage.getItem('adsListFilter'))) ? (JSON.parse(localStorage.getItem('adsListFilter')).pagination.number) : 25;
    $scope.networkTypes = networkTypes;
    $scope.isLoading = false;
    $scope.total = 0;
    $scope.adKinds = adKinds;
    $scope.networkType='';
    $scope.kind = '';
    $scope.subkind = '';
    $scope.ads = [];
    $scope.selectedSumProfitStates = ['neutral', 'negative', 'positive'];
    $scope.getNetworks = function(){
      $feathers.service('networks').find({
        query: {
          $limit: 25
        }
      })
        .then(function(result){
          $scope.networks = _.map(result.data, _.partialRight(_.pick, 'id', 'network', 'name'));
        })
        .catch(function(error){
          console.log(error);
        });
    };

    if (!$scope.networks){
      $scope.getNetworks();
    }
    function setPage(adjust) {
      var pager = angular
        .element('#pager')
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.toggleSelection = function(sumProfitState) {
      var index = $scope.selectedSumProfitStates.indexOf(sumProfitState);
      if ( index === -1 ) {
        $scope.selectedSumProfitStates.push(sumProfitState);
      } else {
        $scope.selectedSumProfitStates.splice(index, 1);
      }
    };

    $scope.sumProfitStateFilter = function(item) {
      if ( $scope.selectedSumProfitStates.indexOf(item.sumProfitState) !== -1 ) {
        return item;
      }
    };

    $scope.getAds = function(tableState) {
      console.log('tableState', tableState);
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = tableState.pagination.start;
      console.log('tableState2', tableState, start);
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }
      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: {
            adrequestdesires: false,
            placementgroups: false,
            inventories: false
          }
        }
      };
      if (tableState.search && tableState.search.predicateObject) {
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'network') {
            query.query.network_id = {
              $in: _.map(_.filter($scope.networks, {
                network: tableState.search.predicateObject[key]
              }), 'id')
            };
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
            // Logic when you switch from (kind+subkind) to "all" at kind,subkind
            if (!tableState.search.predicateObject['kind']){
              if (tableState.search.predicateObject['subkind']){
                delete tableState.search.predicateObject['subkind'];
              } if (query.query['subkind']){
                delete query.query['subkind'];
              }
            // When you switch to other kind and there is no subkind
            } else {
              if (adKinds[tableState.search.predicateObject['kind']].length === 0){
                if (tableState.search.predicateObject['subkind']){
                  delete tableState.search.predicateObject['subkind'];
                } if (query.query['subkind']){
                  delete query.query['subkind'];
                }
              }
            }
          }
        }
      }
      $feathers.service('ads').find(query)
        .then(function(result) {
          $scope.ads = result.data;
          $scope.total = result.data.length;
          $feathers.service('statistics').find({
            query: {
              ads: _.map($scope.ads, 'id'),
              from: moment().add(-10, 'days')
                .toDate(),
              to: moment().toDate()
            }
          })
            .then(function(result){
              _.forEach($scope.ads, function(ad){
                ad.sumProfit = 0;
                ad.sumProfitState = 'neutral';
                ad.sumSales = 0;
                ad.salesOverPeriod = [];
                _.forEach(result, function(day){
                  _.forEach(day.items, function(item){
                    if (item.ad_id === ad.id) {
                      ad.sumProfit += item.profit;
                      ad.sumSales += item.sales;
                      if ( !ad.salesPerDay ) {
                        ad.salesPerDay = {
                        };
                      }
                      ad.salesPerDay[moment(day.date).format('DD-MM-YYYY')]=item.sales;
                    }
                  });
                });
              });
              _.forEach($scope.ads, function(ad) {
                if ( ad.sumProfit > 0 ) {
                  ad.sumProfitState='positive';
                } else if ( ad.sumProfit  < 0 ) {
                  ad.sumProfitState = 'negative';
                }
                var m = moment().add(-10, 'days');
                var diff = m.diff(moment(), 'days');
                for (m; diff <= 0; m.add(1, 'days'), diff+=1) {
                  if (_.has(ad.salesPerDay, m.format('DD-MM-YYYY'))) {
                    ad.salesOverPeriod.push(ad.salesPerDay[m.format('DD-MM-YYYY')]);
                  } else {
                    ad.salesOverPeriod.push(0);
                  }
                }
              });
              $scope.$apply();
            })
            .catch(function(error){
              console.log(error);
            });
          tableState.pagination.totalItemCount = result.total;
          tableState.pagination.numberOfPages = Math.ceil(result.total/tableState.pagination.number);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

    $scope.routeToNewCampaign = function(){
      $state.go('ads.detail');
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('CloneAdController', CloneAdController);

  /** @ngInject */
  function CloneAdController($rootScope, $scope, $q, toastr, $filter, $feathers, $location, $stateParams) {
    $scope.filters = {
    };
    $scope.filters.kind = 'performance';

    $scope.ad = {
    };

    $scope.newAd={
    };

    $scope.adname = {
    };
    $scope.adname.name = '';

    $scope.searchAds = function (ad) {
      return $feathers.service('ads').find({
        query: {
          name: {
            $ilike: '%' + ad + '%'
          },
          $limit: 20,
          kind: $scope.filters.kind
        }
      })
        .then(function (result) {
          return result.data.map(function(item){
            return item;
          });
        })
        .catch(function (error) {
          console.log('searchAds Error', error);
        });
    };

    if ($stateParams.id){
      $feathers.service('ads').get($stateParams.id, {
        $populate: false
      })
        .then(function(ad){
          $scope.ad = ad;
          $scope.adname.name = $scope.ad.name + 'Kopie';
        });
    }

    $scope.onSelect = function($item) {
      $scope.ad = $item;
      $scope.adname.name = $scope.ad.name + ' Kopie';
    };

    $scope.cloneAd = function(){
      $rootScope.$pageFinishedLoading = false;
      $scope.newAd = _.omit($scope.ad, ['adrequestdesires', 'admedias', 'adtimeslots', 'name', 'id', 'advertiser', 'metrics']);
      $scope.newAd.active = false;
      $scope.newAd.name = $scope.adname.name;
      $scope.newAd.advertiser = $scope.ad.advertiser.id;

      var helpAdmedias = _.filter($scope.ad.admedias, function(adm){
        return adm.choose;
      });
      helpAdmedias = _.map(helpAdmedias, function(adm){
        return _.pick(adm, ['active', 'options', 'type', 'size', 'code', 'name']);
      });

      var helpAdrequDesire = _.filter($scope.ad.adrequestdesires, function(requDes){
        return requDes.choose;
      });
      helpAdrequDesire = _.map(helpAdrequDesire, function(requDes){
        return _.pick(requDes, ['active', 'requestcategory', 'weight', 'name', 'defaultweight', 'overwrite', 'match']);
      });

      var helpPlacementgroups = _.filter($scope.ad.placementgroups, function(placementgroups){
        return placementgroups.choose;
      });
      helpPlacementgroups = _.map(helpPlacementgroups, function(placementgroups){
        return _.pick(placementgroups, ['active', 'ad_id', 'choose', 'id', 'include', 'placementgroup', 'placementgroup_id']);
      });

      var helpInventories = _.filter($scope.ad.inventories, function(inventories){
        return inventories.choose;
      });
      helpInventories = _.map(helpInventories, function(inventories){
        return _.pick(inventories, ['active', 'ad_id', 'choose', 'id', 'include', 'inventory', 'inventory_id']);
      });

      $feathers.service('ads').create(_.omit($scope.newAd, 'metrics'))
        .then(function(createdAd){
          var jobs = [];

          _.each(helpAdrequDesire, function(adreq){
            adreq.ad = createdAd.id;
            adreq.requestcategory = adreq.requestcategory.id;
            var job = $feathers.service('adrequestdesires').create(adreq);
            jobs.push(job);
          });

          _.each(helpAdmedias, function(adm){
            adm.ad = createdAd.id;
            adm.size = adm.size.id;
            var job = $feathers.service('admedias').create(adm);
            jobs.push(job);
          });

          _.each(helpPlacementgroups, function(placementgroup){
            const ads2plac = {
              ad_id: createdAd.id,
              active: placementgroup.active,
              placementgroup_id: placementgroup.placementgroup_id,
              include: placementgroup.include
            };
            var job = $feathers.service('ads2placementgroups').create(ads2plac);
            jobs.push(job);
          });

          _.each(helpInventories, function(inventory){
            const ads2inv = {
              ad_id: createdAd.id,
              active: inventory.active,
              inventory_id: inventory.inventory_id,
              include: inventory.include
            };
            var job = $feathers.service('ads2inventories').create(ads2inv);
            jobs.push(job);
          });

          $q.all(jobs).then(function() {
            $rootScope.$pageFinishedLoading = true;
            $location.url('ads/'+createdAd.id);
          })
            .catch(function(error){
              console.log(error);
              toastr.error($filter('translate')('CHANGES NOT SAVED'));
              $rootScope.$pageFinishedLoading = true;
            });
        })
        .catch(function(error){
          console.log(error);
        });
    };

    $scope.updateAll = function(){
      $scope.filters.selectAll = !$scope.filters.selectAll;
      $scope.updateByType('admedias');
      $scope.updateByType('adtimeslots');
      $scope.updateByType('adrequestdesires');
      $scope.updateByType('placementgroups');
      $scope.updateByType('inventories');
    };

    $scope.updateByType = function(type) {
      $scope.filters[type] = !$scope.filters[type];
      _.each($scope.ad[type], function(item){
        item.choose = $scope.filters[type];
      });
    };

    $scope.validateItems = function(type){
      var helper = _.filter($scope.ad[type], function(item){
        return item.choose;
      });
      if (helper.length === 0){
        $scope.filters[type] = 0;
      } else if (helper.length === $scope.ad[type].length){
        $scope.filters[type] = 1;
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AssignPlacementGroupsController', AssignPlacementGroupsController);

  /** @ngInject */
  function AssignPlacementGroupsController($scope, toastr, $window, $filter, $feathers, $uibModalStack, hotkeys, inventoryKinds) {
    $scope.ad = $scope.$resolve.ad;
    $scope.selectedPlacementGroups = [];
    $scope.selectedInventories = [];
    $scope.smartTablePageSize = 25;
    $scope.isLoading = false;
    $scope.inventoryKinds= ['Alle'];
    $scope.inventoryKinds = $scope.inventoryKinds.concat(inventoryKinds);

    function setPage(adjust) {
      let pager = angular
        .element($('#pagerId'))
        .isolateScope();
      pager
        .selectPage(pager.currentPage + adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function () {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function () {
          setPage(-1);
        }
      });

    $scope.getAllInventories = async function(tableState) {
      $scope.isLoading = true;
      let pagination = tableState.pagination;
      let start = pagination.start || 0;
      let number = pagination.number || $scope.smartTablePageSize;
      let sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      let queryInventories = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: false
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        for (let key in tableState.search.predicateObject) {
          if (key === 'id') {
            queryInventories.query.id = tableState.search.predicateObject[key];
          } else if (key === 'kind') {
            if (tableState.search.predicateObject[key] === 'Alle') {
              delete queryInventories.query.kind;
            } else {
              queryInventories.query.kind = tableState.search.predicateObject[key];
            }
          } else {
            queryInventories.query[key] = {
              '$iLike': '%' + tableState.search.predicateObject[key] + '%'
            };
          }
        }
      }
      try {
        let allInventories = await $feathers.service('inventories').find(queryInventories);
        $scope.allInventories = allInventories.data;
        tableState.pagination.numberOfPages = Math.ceil(allInventories.total / $scope.smartTablePageSize);
        $scope.isLoading = false;
        for (let m = 0; m < $scope.selectedInventories.length; m++) {
          for (let n = 0; n < $scope.allInventories.length; n++) {
            if ($scope.selectedInventories[m].inventory_id === $scope.allInventories[n].id) {
              $scope.allInventories[n].include = $scope.selectedInventories[m].include;
            }
          }
        }
        $scope.$apply();
      } catch (error) {
        console.log(error);
      }
    };

    $scope.getAllPlacementGroups = async function (tableState) {
      $scope.isLoading = true;
      let pagination = tableState.pagination;

      let start = pagination.start || 0;
      let number = pagination.number || $scope.smartTablePageSize;

      let sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      let queryPlacementGroups = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: false
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        for (let key in tableState.search.predicateObject) {
          if (key === 'id') {
            queryPlacementGroups.query.id = tableState.search.predicateObject[key];
          } else {
            queryPlacementGroups.query[key] = {
              '$iLike': '%' + tableState.search.predicateObject[key] + '%'
            };
          }
        }
      }
      try {
        let allPlacementGroups = await $feathers.service('placementgroups').find(queryPlacementGroups);
        $scope.allPlacementGroups = allPlacementGroups.data;
        tableState.pagination.numberOfPages = Math.ceil(allPlacementGroups.total / $scope.smartTablePageSize);
        $scope.isLoading = false;
        for (let m = 0; m < $scope.selectedPlacementGroups.length; m++) {
          for (let n = 0; n < $scope.allPlacementGroups.length; n++) {
            if ($scope.selectedPlacementGroups[m].placementgroup_id === $scope.allPlacementGroups[n].id) {
              $scope.allPlacementGroups[n].include = $scope.selectedPlacementGroups[m].include;
            }
          }
        }
        $scope.$apply();

      } catch (error) {
        console.log(error);
      }
    };

    let init = async function(){
      let initQueryParams = {
        query: {
          $limit: $scope.smartTablePageSize,
          $populate: false
        }
      };
      try {
        let allPlacementGroups = await $feathers.service('placementgroups').find(initQueryParams);
        $scope.allPlacementGroups =  allPlacementGroups.data;
        let allInventories = await $feathers.service('inventories').find(initQueryParams);
        $scope.allInventories = allInventories.data;
      } catch (error){
        console.log(error);
      }
      try {
        let ads2place = await $feathers.service('ads2placementgroups').find({
          query: {
            ad_id: $scope.ad.id,
          }
        });
        let s = 0;
        do {
          try {
            let ads2placementGroups = await $feathers.service('ads2placementgroups').find({
              query: {
                ad_id: $scope.ad.id,
                $skip: s
              }
            });
            $scope.selectedPlacementGroups = $scope.selectedPlacementGroups.concat(ads2placementGroups.data);
            for (let m = 0; m < $scope.selectedPlacementGroups.length; m++) {
              for (let n = 0; n < $scope.allPlacementGroups.length; n++) {
                if ($scope.selectedPlacementGroups[m].placementgroup_id === $scope.allPlacementGroups[n].id) {
                  $scope.allPlacementGroups[n].include = $scope.selectedPlacementGroups[m].include;
                }
              }
            }
          } catch (error){
            console.log(error);
          }
          s = s + ads2place.limit;
        } while (s < ads2place.total);
        let ads2Inv = await $feathers.service('ads2inventories').find({
          query: {
            ad_id: $scope.ad.id
          }
        });
        let t = 0;
        do {
          let ads2Inventories = await $feathers.service('ads2inventories').find({
            query: {
              ad_id: $scope.ad.id,
              $skip: t
            }
          });
          try {
            $scope.selectedInventories = $scope.selectedInventories.concat(ads2Inventories.data);
            for (let m = 0; m < $scope.selectedInventories.length; m++) {
              for (let n = 0; n < $scope.allInventories.length; n++) {
                if ($scope.selectedInventories[m].inventory_id === $scope.allInventories[n].id) {
                  $scope.allInventories[n].include = $scope.selectedInventories[m].include;
                }
              }
            }
          } catch (error){
            console.log(error);
          }
          t = t + ads2Inv.limit;
        } while (t < ads2Inv.total);

        $scope.changeInventories = function (inventory, boolean, model) {
          if (model && inventory.include !== boolean) {
            for (let i = 0; i < $scope.selectedInventories.length; i++) {
              if ($scope.selectedInventories[i].inventory_id === inventory.inventory_id) {
                $scope.selectedInventories[i].include = boolean;
                $scope.selectedInventories[i].inventory.include = boolean;
              }
            }
            for (let m = 0; m < $scope.allInventories.length; m++) {
              if ($scope.allInventories[m].id === inventory.inventory_id) {
                $scope.allInventories[m].include = boolean;
              }
            }
          } else {
            for (let i = 0; i < $scope.selectedInventories.length; i++) {
              if ($scope.selectedInventories[i].inventory_id === inventory.inventory_id) {
                $scope.selectedInventories.splice(i, 1);
                i--;
              }
            }
            for (let m = 0; m < $scope.allInventories.length; m++) {
              if ($scope.allInventories[m].id === inventory.inventory_id) {
                delete $scope.allInventories[m]['include'];
              }
            }
          }
        };
        $scope.addInventories = function (inventory, boolean, model) {
          let changeStatus = false;
          let createNew = false;
          if (model && inventory.include !== boolean) {
            inventory.include = boolean;
            let newInventory = {
              ad_id: $scope.ad.id,
              inventory_id: inventory.id,
              active: inventory.active,
              include: boolean,
              inventory: inventory
            };
            if ($scope.selectedInventories.length > 0) {
              for (let i = 0; i < $scope.selectedInventories.length; i++) {
                if (inventory.id === $scope.selectedInventories[i].inventory_id) {
                  if ($scope.selectedInventories[i].include !== boolean) {
                    changeStatus = true;
                  }
                } else {
                  createNew = true;
                }
              }
              if (changeStatus) {
                for (let k = 0; k < $scope.selectedInventories.length; k++) {
                  if ($scope.selectedInventories[k].inventory_id === inventory.id) {
                    $scope.selectedInventories[k].include = boolean;
                    $scope.selectedInventories[k].inventory.include = boolean;
                  }
                }
              } else if (createNew) {
                $scope.selectedInventories.push(newInventory);
              }
            } else {
              $scope.selectedInventories.push(newInventory);
            }
          } else {
            delete inventory['include'];
            for (let x = 0; x < $scope.selectedInventories.length; x++) {
              if ($scope.selectedInventories[x].inventory_id === inventory.id) {
                $scope.selectedInventories.splice(x, 1);
                x--;
              }
            }
          }
        };

        $scope.changePlacementGroups = function (placementGroup, boolean, model) {
          if (model && placementGroup.include !== boolean) {
            for (let i = 0; i < $scope.selectedPlacementGroups.length; i++) {
              if ($scope.selectedPlacementGroups[i].placementgroup_id === placementGroup.placementgroup_id) {
                $scope.selectedPlacementGroups[i].include = boolean;
                $scope.selectedPlacementGroups[i].placementgroup.include = boolean;
              }
            }
            for (let m = 0; m < $scope.allPlacementGroups.length; m++) {
              if ($scope.allPlacementGroups[m].id === placementGroup.placementgroup_id) {
                $scope.allPlacementGroups[m].include = boolean;
              }
            }
          } else {
            for (let i = 0; i < $scope.selectedPlacementGroups.length; i++) {
              if ($scope.selectedPlacementGroups[i].placementgroup_id === placementGroup.placementgroup_id) {
                $scope.selectedPlacementGroups.splice(i, 1);
                i--;
              }
            }
            for (let m = 0; m < $scope.allPlacementGroups.length; m++) {
              if ($scope.allPlacementGroups[m].id === placementGroup.placementgroup_id) {
                delete $scope.allPlacementGroups[m]['include'];
              }
            }
          }
        };
        $scope.addPlacementGroups = function (placementGroup, boolean, model) {
          let changeStatus = false;
          let createNew = false;
          if (model && placementGroup.include !== boolean) {
            placementGroup.include = boolean;
            let newPlacementGroup = {
              ad_id: $scope.ad.id,
              placementgroup_id: placementGroup.id,
              active: placementGroup.active,
              include: boolean,
              placementgroup: placementGroup
            };
            if ($scope.selectedPlacementGroups.length > 0) {
              for (let i = 0; i < $scope.selectedPlacementGroups.length; i++) {
                if (placementGroup.id === $scope.selectedPlacementGroups[i].placementgroup_id) {
                  if ($scope.selectedPlacementGroups[i].include !== boolean) {
                    changeStatus = true;
                  }
                } else {
                  createNew = true;
                }
              }
              if (changeStatus) {
                placementGroup.include = boolean;
                for (let k = 0; k < $scope.selectedPlacementGroups.length; k++) {
                  if ($scope.selectedPlacementGroups[k].placementgroup_id === placementGroup.id) {
                    $scope.selectedPlacementGroups[k].include = boolean;
                    $scope.selectedPlacementGroups[k].placementgroup.include = boolean;
                  }
                }
              } else if (createNew) {
                $scope.selectedPlacementGroups.push(newPlacementGroup);
              }
            } else {
              $scope.selectedPlacementGroups.push(newPlacementGroup);
            }
          } else {
            delete placementGroup['include'];
            for (let x = 0; x < $scope.selectedPlacementGroups.length; x++) {
              if ($scope.selectedPlacementGroups[x].placementgroup_id === placementGroup.id) {
                $scope.selectedPlacementGroups.splice(x, 1);
                x--;
              }
            }
          }
        };
        $scope.$apply();
      } catch (error){
        console.log(error);
      }
    };

    init();

    $scope.save = async function () {
      let DBAd2inv = await $feathers.service('ads2inventories').find({
        query: {
          ad_id: $scope.ad.id,
          $paginate: false
        }
      });
      _.each($scope.selectedInventories, async function(ad2inv) {
        if (!_.find(DBAd2inv, {
          id: ad2inv.id
        })) {
          try {
            let ads2inventories = await $feathers.service('ads2inventories').create({
              ad_id: $scope.ad.id,
              active: ad2inv.active,
              inventory_id: ad2inv.inventory_id,
              include: ad2inv.include
            });
            toastr.success(ads2inventories.id + ' ' + 'CREATED');
          } catch (error) {
            console.log(error);
          }
        } else {
          let matchingEntry =_.find(DBAd2inv, {
            id: ad2inv.id
          });
          if (_.reduce(_.omit(ad2inv, '$$hashKey'), function (result, value, key) {
            return _.isEqual(value, matchingEntry[key]) ?
              result : result.concat(key);
          }, []).length !== 0) {
            try {
              let patched = await $feathers.service('ads2inventories').patch(ad2inv.id, _.omit(ad2inv, ['id']));
              toastr.success(patched.id + ' ' + 'PATCHED');
            } catch (error) {
              console.log(error);
            }
          }
        }
      });
      _.each(DBAd2inv, async function(item) {
        if (!_.find($scope.selectedInventories, {
          id: item.id
        })) {
          try {
            let deleted = await $feathers.service('ads2inventories').remove(item.id);
            toastr.success(deleted.id + ' ' + $filter('translate')('DELETED'));
          } catch (error) {
            console.log(error);
          }
        }
      });
      let DBAd2plac = await $feathers.service('ads2placementgroups').find({
        query: {
          ad_id: $scope.ad.id,
          $paginate: false
        }
      });
      _.each($scope.selectedPlacementGroups, async function(ad2plac) {
        if (!_.find(DBAd2plac, {
          id: ad2plac.id
        })) {
          try {
            let ads2placementgroups = await $feathers.service('ads2placementgroups').create({
              ad_id: $scope.ad.id,
              active: ad2plac.active,
              placementgroup_id: ad2plac.placementgroup_id,
              include: ad2plac.include
            });
            toastr.success(ads2placementgroups.id + ' ' + 'CREATED');
          } catch (error) {
            console.log(error);
          }
        } else {
          let matchingEntry =_.find(DBAd2plac, {
            id: ad2plac.id
          });
          if (_.reduce(_.omit(ad2plac, '$$hashKey'), function (result, value, key) {
            return _.isEqual(value, matchingEntry[key]) ? result : result.concat(key);
          }, []).length !== 0) {
            try {
              let patched = await $feathers.service('ads2placementgroups').patch(ad2plac.id, _.omit(ad2plac, ['id']));
              toastr.success(patched.id + ' ' + 'PATCHED');
            } catch (error) {
              console.log(error);
            }
          }
        }
      });
      _.each(DBAd2plac, async function(item) {
        if (!_.find($scope.selectedPlacementGroups, {
          id: item.id
        })) {
          try {
            let deleted = await $feathers.service('ads2placementgroups').remove(item.id);
            toastr.success(deleted.id + ' ' + $filter('translate')('DELETED'));
          } catch (error) {
            console.log(error);
          }
        }
      });
      $uibModalStack.dismissAll();
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('assignPlacementGroups', assignPlacementGroups);

  /** @ngInject */
  function assignPlacementGroups() {
    return {
      restrict: 'E',
      controller: 'AssignPlacementGroupsController',
      templateUrl: 'app/pages/ads/assignPlacementGroups/assignPlacementGroups.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('CreateAdmediaController', CreateAdmediaController);

  /** @ngInject */
  function CreateAdmediaController($scope, toastr, $window, $filter, $feathers, $uibModalStack) {
    $scope.newAdcode = {
    };
    $scope.ad = $scope.$resolve.ad;
    $scope.admediaSizes = $scope.$resolve.admediaSizes;
    $scope.contentTypes = $scope.$resolve.contentTypes;
    $feathers.service('templates').find({
      query: {
        $paginate: false
      }
    })
      .then( function( templates){
        $scope.admediaTemplates = templates;
      }) ;
    $scope.importCreative = async function () {
      if (_.isEmpty($scope.newAdcode) || !$scope.newAdcode.code || !$scope.newAdcode.size || !$scope.newAdcode.type) {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      } else {
        try {
          let createdAdmedia = await $feathers.service('admedias').create({
            active: false,
            size: $scope.newAdcode.size,
            code: $scope.newAdcode.code,
            type: $scope.newAdcode.type,
            status: 'NEW',
            ad: $scope.ad.id,
            name: $scope.newAdcode.name
          });
          let admedia = await $feathers.service('admedias').get(createdAdmedia.id);
          $scope.ad.admedias.push(admedia);
          $scope.newAdmedia = {
          };

          var top = $uibModalStack.getTop();
          if (top) {
            $uibModalStack.dismiss(top.key);
          }
          return toastr.success($filter('translate')('NEW ADMEDIA CREATED'));
        } catch (error) {
          console.log('error', error);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('createAdmedia', createAdmedia);

  /** @ngInject */
  function createAdmedia() {
    return {
      restrict: 'E',
      controller: 'CreateAdmediaController',
      templateUrl: 'app/pages/ads/createAdmedia/createAdmedia.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('AdsDetailController', AdsDetailController);

  /** @ngInject */
  function AdsDetailController($scope, $rootScope, $stateParams, $window, $state, $uibModal, $sce, $feathers, $filter, editableOptions, editableThemes, toastr, adKinds, revenueTypes, distributions, adoverwrites, adOptionsAutoComplete, contentTypes) {

    $scope.attributes = ['tag', 'weight', 'defaultweight'];
    $scope.dataHasLoaded = false;
    $scope.retargetingStatus = '';
    $scope.distributions = distributions;
    $scope.adKinds = adKinds;
    $scope.contentTypes = contentTypes;
    $scope.todotypes = [];
    $scope.todos = [];

    $scope.revenueTypes = revenueTypes;
    $scope.newAdmedia = {
    };
    $scope.ad = {
    };
    $scope.targetingTreeCompare = [];
    $scope.vouchers = [];
    $scope.newTarget = {
    };
    $scope.newTimeslot = {
      active: true,
      distribution: 'daily'
    };
    $scope.adOptionsAutoComplete = adOptionsAutoComplete;
    $scope.newAdmedia = {
      active: false,
      type: 'html',
      status: 'NEW'
    };
    $scope.ad.productfeed = {
    };
    $scope.possibleInsertionorders = [];
    $scope.aceOption = {
      mode: 'html',
      theme: 'crimson_editor',
      autoScrollEditorIntoView: true,
      onLoad: function (_ace) {
        _ace.$blockScrolling = Infinity;
      }
    };

    async function getVouchersOfAd() {
      $scope.vouchers = await $feathers.service('advouchers').find({
        query: {
          ad_id: $scope.ad.id,
          $paginate: false
        }
      });
      $scope.usedVouchers = [];
      $scope.unUsedVouchers = [];
      if ($scope.vouchers) {
        for (const code of $scope.vouchers) {
          if (code) {
            if (code.issued_at) {
              $scope.usedVouchers.push(code);
            } else {
              $scope.unUsedVouchers.push(code);
            }
          }
        }
      }
    }

    $scope.init = async function () {
      let possibleAdvertiser=[];

      $scope.couponWizardTypeTemplates = await $feathers.service('templates').find({
        query: {
          $paginate: false,
          $sort: {
            created: -1
          },
          options: {
            wizardType: 'coupon'
          },
        }
      });

      $scope.catalogWizardTypeTemplates = await $feathers.service('templates').find({
        query: {
          $paginate: false,
          $sort: {
            created: -1
          },
          options: {
            wizardType: 'catalog'
          },
        }
      });
      $scope.admediaTemplates = await $feathers.service('templates').find({
        query: {
          $paginate: false
        }
      });
      $scope.networks = await $feathers.service('networks').find({
        query: {
          $limit: 100,
          $paginate: false
        }
      });
      $scope.admediaSizes = await $feathers.service('admediasizes').find({
        query: {
          $limit: 1000,
          $sort: {
            name: 1
          },
          $paginate: false
        }
      });
      $scope.todotypes = await $feathers.service('todotypes').find({
        query: {
          service_name: 'ads',
          $paginate: false
        }
      });

      if ($stateParams.id && $stateParams.id !== 'new') {
        try {
          $scope.ad = await $feathers.service('ads').get($stateParams.id, {
            $populate: false
          });
          $scope.ad.revenue_percentage = parseFloat($scope.ad.revenue_percentage);
          getVouchersOfAd();
          $state.current.title = $filter('translate')('AD') + ': ' + $scope.ad.name;
          $scope.todos = await $feathers.service('todos').find({
            query: {
              todotype_id: {
                $in: $scope.todotypes.map(function (todotype) {
                  return todotype.id;
                })
              },
              element_id: $stateParams.id,
              $paginate: false
            }
          });
          $scope.helperAd = _.clone($scope.ad, true);
          if ($scope.ad.productfeed_id) {
            let productfeed = await $feathers.service('productfeeds').get($scope.ad.productfeed_id);
            $scope.ad.productfeed = productfeed.name;
          }
          if ($scope.ad.advertiser.id) {
            $scope.refreshInsertionorders(true);
          }
          $scope.debug = JSON.stringify($scope.ad, null, 2);
          $scope.updateRetargetingStatus();
          $scope.$apply();
        } catch (e) {
          console.error(e);
          toastr.error($filter('translate')('THE AD YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('ads.all');
        }
        $feathers.service('ads').on('updated', function (updated) {
          $scope.ad = updated;
          $scope.debug = JSON.stringify($scope.ad, null, 2);
          $scope.$apply();
        });
      } else {
        $state.current.title = 'NEW CAMPAIGN';
        $scope.ad = {
          weight: 0,
          media: 6,
          insertionorder_id: 0,
          revenue_percentage: 1.0,
          kind: 'performance',
          options: {
          },
          target: {
          }
        };
        if ($stateParams && $stateParams.insertionorder) {
          $scope.ad.advertiser = $stateParams.insertionorder.advertiser;
          $scope.ad.insertionorder_id = $stateParams.insertionorder.id;
          $scope.refreshInsertionorders(true);
          $scope.$apply();
        }
      }
      $scope.dataHasLoaded = true;
    };
    $scope.init();

    $scope.updateRetargetingStatus = async function () {
      if (!$scope.ad || !$scope.ad.retargeting_token) {
        return;
      }
      let status = await $feathers.service('pixelStatus').get($scope.ad.retargeting_token);
      let text = 'Last 24hrs:<br>';
      for (let tag in status) {
        if (status.hasOwnProperty(tag) && status[tag]) {
          text += tag + ': ' + status[tag] + '<br>';
        }
      }
      $scope.retargetingStatus = $sce.trustAsHtml(text);
      $scope.$apply();
    };
    $scope.openPreview = async function (admedia) {
      $window.open('https://a.df-srv.de/preview/hash/' + admedia.hash);
    };
    $scope.openFiddle = async function (admedia) {
      // eslint-disable-next-line angular/document-service
      let form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('action', 'https://jsfiddle.net/api/post/library/pure/');
      form.setAttribute('target', 'check');
      form.setAttribute('name', 'previewForm');
      // eslint-disable-next-line angular/document-service
      let input = document.createElement('input');
      input.setAttribute('type', 'text');
      input.setAttribute('name', 'html');
      input.setAttribute('value', admedia.preview);
      form.appendChild(input);
      // eslint-disable-next-line angular/document-service
      let button = document.createElement('button');
      button.setAttribute('type', 'submit');
      form.appendChild(button);
      // eslint-disable-next-line angular/document-service
      document.body.appendChild(form);
      button.click();
    };
    $scope.generateAdcode = async function (admedia) {
      let result = await $feathers.service('tagids').create({
        ids: [1221, admedia.ad, admedia.size.id, 0, admedia.id]
      });
      let hash = result.hash;
      admedia.hash = hash;
      admedia.adcode = '<script id="' + hash + '" src="//a.df-srv.de/v2/view/' + hash + '/a.js?random=[timestamp]"></script>';
      admedia.preview = '<script id="' + hash + '" src="//a.df-srv.de/v2/view/' + hash + '/a.js?random=' + Math.random().toString()
        .slice(2) + '"></script>';
    };

    $scope.refreshInsertionorders = async function (init) {
      if (!init){
        $scope.resetInsertionorders();
      }
      if ($scope.ad.advertiser && $scope.ad.advertiser.hasOwnProperty('id')) {
        let insertionorders = await $feathers.service('insertionorders').find({
          query: {
            $paginate: false,
            advertiser_id: $scope.ad.advertiser.id
          }
        });
        if (insertionorders.length) {
          $scope.possibleInsertionorders = insertionorders;
          if ($scope.ad.insertionorder_id === 0 && insertionorders.length > 0) {
            $scope.ad.insertionorder_id = insertionorders[0].id;
          }
        }
      }
    };

    $scope.resetInsertionorders = function () {
      $scope.possibleInsertionorders = [];
      $scope.ad.insertionorder_id = 0;
    };
    $scope.detectChanges = function () {
      return _.isEqual(JSON.stringify(_.omit($scope.helperAd, 'modified')), JSON.stringify(_.omit($scope.ad, 'modified')));
    };
    $scope.saveAd = async function () {
      if ($stateParams.id && $stateParams.id !== 'new') {
        var changes = {
        };
        if (!_.isEqual($scope.helperAd.products, $scope.ad.products)) {
          changes.products = $scope.ad.products;
        }
        if (!_.isEqual($scope.helperAd.options, $scope.ad.options)) {
          changes.options = $scope.ad.options;
        }
        if ($scope.ad && $scope.ad.productfeed && $scope.ad.productfeed.id) {
          changes.productfeed_id = $scope.ad.productfeed.id;
        } else if ($scope.ad.productfeed === '') {
          changes.productfeed_id = null;
        }
        changes.insertionorder_id = $scope.ad.insertionorder_id;
        changes.advertiser = $scope.ad.advertiser.id;
        changes.name = $scope.ad.name;
        changes.active = $scope.ad.active;
        changes.weight = $scope.ad.weight;
        changes.download_token = $scope.ad.download_token;
        changes.retargeting_token = $scope.ad.retargeting_token;
        changes.network_id = $scope.ad.network_id;
        changes.kind = $scope.ad.kind;
        changes.subkind = $scope.ad.subkind;
        changes.revenue_type = $scope.ad.revenue_type;
        changes.revenue_value = $scope.ad.revenue_value;
        changes.revenue_percentage = $scope.ad.revenue_percentage;
        changes.comment = $scope.ad.comment;
        try {
          await $feathers.service('ads').patch($stateParams.id, changes);
          toastr.success($filter('translate')('CHANGES SAVED'));
        } catch (e) {
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
          console.log('Patch error', e);
        }
      } else if ($scope.ad.name && $scope.ad.advertiser && $scope.ad.media) {
        if (!$scope.ad.advertiser.id){
          return toastr.error($filter('translate')('CHOOSE OR CREATE AN ADVERTISER'));
        }
        if (!$scope.ad.insertionorder_id){
          return toastr.error($filter('translate')('CHOOSE OR CREATE AN INSERTIONORDER'));
        }
        if (!$scope.ad.revenue_type) {
          return toastr.error($filter('translate')('REVENUE TYPE') + ' ' + $filter('translate')('IS REQUIRED'));
        }
        if (['CPM', 'CPC', 'eCPM', 'eCPC'].includes($scope.ad.revenue_type) && !($scope.ad.revenue_value > 0)) {
          return toastr.error($filter('translate')('REVENUE VALUE') + ' ' + $filter('translate')('IS REQUIRED'));
        }
        $scope.ad.advertiser = $scope.ad.advertiser.id;
        try {
          let createdAd = await $feathers.service('ads').create($scope.ad);
          toastr.success($filter('translate')('SAVED'));
          $state.go('ads.detail', {
            id: createdAd.id
          });
        } catch (e) {
          toastr.error($filter('translate')('NOT SAVED'));
          console.log('error', e);
        }
      } else {
        return toastr.error($filter('translate')('PLEASE FILL NAME, ADVERTISER, INSERTIONORDER'));
      }
    };

    $scope.deleteAdmedia = async function (admedia) {
      return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE ADMEDIA?'), {
        progressBar: true,
        onHidden: async function (clicked) {
          if (clicked) {
            try {
              let result = await $feathers.service('admedias').remove(admedia.id);
              _.remove($scope.ad.admedias, function (n) {
                return n.id === result.id;
              });
              toastr.success($filter('translate')('ADMEDIA SUCCESSFULLY REMOVED'));
            } catch (error) {
              console.log('Remove Admedia Error: ', error);
              toastr.error($filter('translate')('ADMEDIA NOT REMOVED'));
            }
          }
        }
      });
    };
    $scope.saveAdmedia = async function (admedia) {
      var patch = {
        active: admedia.active,
        type: admedia.type,
        size: admedia.size.id,
        next_check: null,
        name: admedia.name,
        code: admedia.code
      };
      // next_date null is required to immediately check admedia when status is set to NEW
      let dbAdmedia = await $feathers.service('admedias').get(admedia.id);
      if (JSON.stringify(dbAdmedia.code) !== JSON.stringify(admedia.code) || JSON.stringify(dbAdmedia.options) !== JSON.stringify(admedia.options)) {
        patch.status = 'NEW';
      }
      try {
        $scope.ad.admedias[admedia] = await $feathers.service('admedias').patch(admedia.id, patch);
        $scope.$apply();
        return toastr.success($filter('translate')('CHANGES SAVED'));
      } catch (e) {
        console.log('error', e);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.saveOverwrite = async function (overwrite) {
      if (overwrite.id) {
        try {
          let ow = await $feathers.service('adoverwrites').patch(overwrite.id, {
            active: overwrite.active
          });
          if (ow.active) {
            return toastr.success($filter('translate')('OVERWRITE ACTIVATED'));
          } else {
            return toastr.success($filter('translate')('OVERWRITE DEACTIVATED'));
          }
        } catch (e) {
          overwrite.active = false;
          console.log(e);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.savePlacementGroups = async function (placementGroup) {
      if (placementGroup.id) {
        try {
          let patchedPG = await $feathers.service('ads2placementgroups').patch(placementGroup.id, {
            active: placementGroup.active
          });
          if (patchedPG.active) {
            return toastr.success($filter('translate')('PLACEMENT GROUP ACTIVATED'));
          } else {
            return toastr.success($filter('translate')('PLACEMENT GROUP DEACTIVATED'));
          }
        } catch (e) {
          placementGroup.active = false;
          console.log(e);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.saveInventories = async function (inventory) {
      if (inventory.id) {
        try {
          let patchedInv = await $feathers.service('ads2inventories').patch(inventory.id, {
            active: inventory.active
          });
          if (patchedInv.active) {
            return toastr.success($filter('translate')('INVENTORY ACTIVATED'));
          } else {
            return toastr.success($filter('translate')('INVENTORY DEACTIVATED'));
          }
        } catch (e) {
          inventory.active = false;
          console.log(e);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.saveTarget = async function (target) {
      if ($scope.ad.id) {
        try {
          let patchedTarget = await $feathers.service('ads').patch($scope.ad.id, {
            target: $scope.ad.target
          });
          if (patchedTarget.target.active) {
            return toastr.success($filter('translate')('TARGET ACTIVATED'));
          } else {
            return toastr.success($filter('translate')('TARGET DEACTIVATED'));
          }
        } catch (e) {
          target.active = false;
          console.log('error', e);
          return toastr.error($filter('translate')('ONLY ONE TIMESLOT CAN BE ACTIVE'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.deleteTarget = function (RequDesireID) {
      if (RequDesireID) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE TARGET?'), {
          progressBar: true,
          onHidden: async function (clicked) {
            if (clicked) {
              try {
                let result = await $feathers.service('adrequestdesires').remove(RequDesireID);
                _.remove($scope.ad.adrequestdesires, function (n) {
                  return n.id === result.id;
                });
                toastr.success($filter('translate')('REQUESTCATEGORY SUCCESSFULLY REMOVED'));
              } catch (error) {
                console.log('Remove Adrequestdesire Error: ', error);
                toastr.error($filter('translate')('REQUESTCATEGORY NOT REMOVED'));
              }
            }
          }
        });
      } else {
        toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };

    $scope.searchAdvertiser = function(advertiser){
      let query = {
        name: {
          $ilike: '%'+advertiser+'%'
        }, $limit: 20
      };
      return $feathers.service('advertisers').find({
        query: query
      })
        .then(function(result){
          $scope.possibleAdvertiser = result.data;
          $scope.$apply();
        })
        .catch(function(err){
          console.log('searchAdvertiser Error', err);
        });
    };

    $scope.searchProductFeeds = async function (val) {
      try {
        let result = await $feathers.service('productfeeds').find({
          query: {
            name: {
              $ilike: '%' + val + '%'
            }, $limit: 20
          }
        });
        return result.data.map(function (item) {
          return item;
        });
      } catch (error) {
        console.log('searchProductFeeds error', error);
      }
    };
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    $scope.createHash = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/pixels/createHash/createHash.html',
        controller: 'CreateHashController',
        size: 'lg'
      });
      modalInstance.result.then(function (result) {
        $scope.ad.retargeting_token = result;
      });
    };

    $scope.openExportAdTags = function () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'exportAdtags',
        resolve: {
          ad: function () {
            return $scope.ad;
          },
          admedias: function () {
            return $scope.ad.admedias;
          }
        }
      });
    };

    $scope.openImportAdcode = function () {
      $uibModal.open({
        animation: true,
        component: 'importAdCode',
        size: 'lg',
        resolve: {
          admediaSizes: function () {
            return $scope.admediaSizes;
          },
          ad: function () {
            return $scope.ad;
          },
          network: function () {
            return $scope.ad && $scope.ad.network ? $scope.ad.network : undefined;
          }
        }
      });
    };
    $scope.openCreateAdmedia = function () {
      $uibModal.open({
        animation: true,
        component: 'createAdmedia',
        size: 'lg',
        resolve: {
          admediaSizes: function () {
            return $scope.admediaSizes;
          },
          ad: function () {
            return $scope.ad;
          },
          contentTypes: function () {
            return $scope.contentTypes;
          }
        }
      });
    };

    $scope.showCouponEdit = function (admedia) {
      return !!$scope.couponWizardTypeTemplates.some(type => type && type.id === parseInt(admedia.code));
    };

    $scope.showCatalogEdit = function (admedia) {
      return !!$scope.catalogWizardTypeTemplates.some(type => type && type.id === parseInt(admedia.code));
    };

    $scope.openEditCoupon = function (admedia) {
      $scope.admedia = admedia;
      $uibModal.open({
        animation: true,
        size: 'xlg',
        component: 'addEditCoupon',
        resolve: {
          ad: function () {
            return $scope.ad;
          },
          admedia: function () {
            return admedia;
          },
          couponWizardTypes: function () {
            return $scope.couponWizardTypeTemplates;
          },
          couponWizardType: function () {
            return $scope.couponWizardTypeTemplates.filter(type => type && type.id === parseInt(admedia.code))[0];
          },
          vouchers: function () {
            return $scope.vouchers.length;
          },
          usedVouchers: function () {
            return $scope.usedVouchers.length;
          }
        }
      }).closed.then(async function () {
        try {
          $scope.ad.admedia = (await $feathers.service('ads').get($scope.admedia.ad)).admedia;
          getVouchersOfAd();
        } catch (error) {
          console.log(error);
        }
      });
    };

    $scope.openEditCatalog = function (admedia) {
      $scope.admedia = admedia;
      $uibModal.open({
        animation: true,
        size: 'xlg',
        component: 'addEditCatalog',
        resolve: {
          ad: function () {
            return $scope.ad;
          },
          admedia: function () {
            return admedia;
          },
          catalogWizardType: function () {
            return $scope.catalogWizardTypeTemplates.filter(type => type && type.id === parseInt(admedia.code))[0];
          },
        }
      }).closed.then(async function () {
        try {
          $scope.ad.admedia = (await $feathers.service('ads').get($scope.admedia.ad)).admedia;
        } catch (error) {
          console.log(error);
        }
      });
    };
    $scope.openEditAdmedia = function (admedia) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'editAdmedia',
        resolve: {
          admedia: function () {
            return admedia;
          }
        }
      });
    };
    $scope.openAddEditOverwrite = function (overwrite) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEditOverwrite',
        resolve: {
          overwrite: function () {
            return overwrite;
          },
          ad: function () {
            return $scope.ad;
          }
        }
      }).closed.then(async function () {
        try {
          $scope.ad.adoverwrites = await $feathers.service('adoverwrites').find({
            query: {
              ad_id: $scope.ad.id,
              $limit: 100,
              $paginate: false
            }
          });
          $scope.$apply();
        } catch (error) {
          console.log(error);
        }
      });
    };
    $scope.openAddEditTargeting = function (targeting) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEditTargeting',
        resolve: {
          targeting: function () {
            return targeting;
          },
          ad: function () {
            return $scope.ad;
          }
        }
      }).closed.then(async function () {
        try {
          $scope.ad.adrequestdesires = await $feathers.service('adrequestdesires').find({
            query: {
              ad: $scope.ad.id,
              $paginate: false
            }
          });
        } catch (error) {
          console.log(error);
        }
      });
    };

    $scope.openAddEditRegioTargeting = function () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEditRegioTargeting',
        resolve: {
          ad: function () {
            return $scope.ad;
          }
        }
      }).closed.then(async function () {
      });
    };

    $scope.openAddEditTarget = function () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEditTarget',
        resolve: {
          ad: function () {
            return $scope.ad;
          }
        }
      }).closed.then(async function () {
        try {
          let ad = await $feathers.service('ads').get($scope.ad.id);
          if (ad.target) {
            $scope.ad.target = ad.target;
          } else {
            $scope.ad.target = {
            };
          }
        } catch (error) {
          console.log(error);
        }
      });
    };
    $scope.openAddCoupon = function () {
      $uibModal.open({
        animation: true,
        size: 'xlg',
        component: 'addEditCoupon',
        resolve: {
          ad: function () {
            return $scope.ad;
          },
          couponWizardTypes: function () {
            return $scope.couponWizardTypeTemplates;
          },
          couponWizardType: function () {
            return null;
          }
        }
      }).closed.then(async function () {
        try {
          getVouchersOfAd();
        } catch (error) {
          console.log(error);
        }
      });
    };

    $scope.openAddCatalog = function () {
      $uibModal.open({
        animation: true,
        size: 'xlg',
        component: 'addEditCatalog',
        resolve: {
          ad: function () {
            return $scope.ad;
          },
          catalogWizardType: function () {
            let newestCatalogTemplateId;
            if ($scope.catalogWizardTypeTemplates[0]) {
              newestCatalogTemplateId = $scope.catalogWizardTypeTemplates[0].id;
            }
            return newestCatalogTemplateId;
          }
        }
      }).closed.then(async function () {
      });
    };
    $scope.openAssignPlacementGroups = function () {
      $uibModal.open({
        animation: true,
        component: 'assignPlacementGroups',
        size: 'xlg',
        resolve: {
          ad: function () {
            return $scope.ad;
          }
        }
      }).closed.then(async function () {
        try {
          let ad = await $feathers.service('ads').get($scope.ad.id);
          if (ad.placementgroups) {
            $scope.ad.placementgroups = ad.placementgroups;
          } else {
            $scope.ad.placementgroups = {
            };
          }
          if (ad.inventories) {
            $scope.ad.inventories = ad.inventories;
          } else {
            $scope.ad.inventories = {
            };
          }
          $scope.$apply();
        } catch (error) {
          console.log(error);
        }
      });
    };
    $scope.showCode = function (admedia) {
      console.log(admedia);
      admedia.showAce = admedia.showAce === true ? admedia.showAce = false : admedia.showAce = true;
    };

    $scope.addToTargetTree = async function () {
      $scope.targetingTreeResult = Object.assign(obj, $scope.targetingTreeResult);
      console.log($scope.targetingTreeResult);
    };

    $scope.saveAdmediaCode = async function (admedia) {
      try {
        await $feathers.service('admedias').patch(admedia.id, {
          type: admedia.type,
          code: admedia.code
        });
        toastr.success($filter('translate')('CODE SUCCESSFULLY PATCHED'));
      } catch (e) {
        console.log(e);
        toastr.error($filter('translate')('CODE NOT PATCHED'));
      }
    };

    $scope.undoAction = function (admedia) {
      let editor = ace.edit(admedia.id.toString());
      let _session = editor.getSession();
      _session.getUndoManager().undo();
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };
    $scope.redoAction = function (admedia) {
      let editor = ace.edit(admedia.id.toString());
      let _session = editor.getSession();
      _session.getUndoManager().redo();
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };
    $scope.insertPlainClickUrlPlaceholder = function (admedia) {
      let editor = ace.edit(admedia.id.toString());
      editor.insert('[[PLAINCLICKURL]]');
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };
    $scope.insertLongsubidPlaceholder = function (admedia) {
      let editor = ace.edit(admedia.id.toString());
      editor.insert('[[LONGSUBID]]');
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };
    $scope.mediaPanelOptions = {
      title: $filter('translate')('MEDIAS'),
      buttons: [
        {
          title: $filter('translate')('IMPORT CREATIVE'),
          click: $scope.openImportAdcode,
          icon: 'ion-wand'
        },
        {
          title: $filter('translate')('ADD CREATIVE'),
          click: $scope.openCreateAdmedia,
          icon: 'ion-plus-round'
        },
        {
          title: $filter('translate')('EXPORT ADTAGS'),
          click: $scope.openExportAdTags,
          icon: 'ion-ios-cloud-download'
        },
        {
          title: $filter('translate')('ADD COUPON'),
          click: $scope.openAddCoupon,
          icon: 'ion-flash'
        },
        {
          title: $filter('translate')('ADD CATALOG'),
          click: $scope.openAddCatalog,
          icon: 'ion-ios-book'
        }
      ]
    };

    $scope.targetingTreePanelOptions = {
      title: $filter('translate')('TARGETING TREE'),
      buttons: [
        {
          title: $filter('translate')('ADD TARGETING'),
          click: $scope.openAddEditTargeting,
          icon: 'ion-plus-round'
        },
        {
          title: $filter('translate')('EDIT REGIO TARGETING'),
          click: $scope.openAddEditRegioTargeting,
          icon: 'ion-navigate'
        },
      ]
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('EditAdmediaController', EditAdmediaController);

  /** @ngInject */
  function EditAdmediaController($scope, toastr, $window, $filter, $feathers, $uibModalStack) {
    $scope.options = {
    };
    $scope.admedia = $scope.$resolve.admedia;

    $scope.saveOptions= function() {
      $feathers.service('admedias').patch($scope.admedia.id, {
        options: $scope.admedia.options
      })
        .then(function (result) {
          return toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function (error) {
          console.log('error', error);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('editAdmedia', editAdmedia);

  /** @ngInject */
  function editAdmedia() {
    return {
      restrict: 'E',
      controller: 'EditAdmediaController',
      templateUrl: 'app/pages/ads/editAdmedia/editAdmedia.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('ExportAdtagsController', ExportAdtagsController);

  /** @ngInject */
  function ExportAdtagsController($scope, toastr, $window, $filter, $document) {
    $scope.admedias = $scope.$resolve.admedias;
    $scope.ad = $scope.$resolve.ad;

    $scope.success = function () {
      toastr.success($filter('translate')('ADCODE COPIED TO CLIPBOARD'));
    };

    $scope.fail = function (err) {
      toastr.error($filter('translate')('ADCODE NOT COPIED'));
      console.log(err);
    };

    $scope.downloadOneAdcode = function (admedia) {
      var blob = new Blob([admedia.adcode], {
          type: 'text/plain'
        }),
        url = $window.URL || $window.webkitURL;
      var file = url.createObjectURL(blob);
      // eslint-disable-next-line angular/document-service
      var element = document.createElement('a');
      element.setAttribute('download', 'Adcode (ad ' + $scope.ad.id + ')-' + admedia.size.name + '(admedia ' + admedia.id + ').txt');
      element.setAttribute('href', file);
      element.click();
      toastr.success($filter('translate')('ADCODE SUCCESSFULLY DOWNLOADED'));
    };

    $scope.copyAllAdcodes = function(admedias){
      return JSON.stringify(admedias);
    };

    $scope.downloadAllAdcodes = function (admedias) {
      var text = '';
      _.forEach(admedias, function (admedia) {
        text += admedia.size.name + ' (Admedia: ' + admedia.id + ')\r\n' + admedia.adcode + '\r\n\r\n';
      });
      var blob = new Blob([text], {
          type: 'text/plain'
        }),
        url = $window.URL || $window.webkitURL;
      var file = url.createObjectURL(blob);
      // eslint-disable-next-line angular/document-service
      var element = document.createElement('a');
      element.setAttribute('download', 'All Adcodes (ad ' + $scope.ad.id + ')');
      element.setAttribute('href', file);
      element.click();
      toastr.success($filter('translate')('ADCODES SUCCESSFULLY DOWNLOADED'));
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('exportAdtags', exportAdtags);

  /** @ngInject */
  function exportAdtags() {
    return {
      restrict: 'E',
      controller: 'ExportAdtagsController',
      templateUrl: 'app/pages/ads/exportAdtags/exportAdtags.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('EditAdrequestdesireController', EditAdrequestdesireController);

  /** @ngInject */
  function EditAdrequestdesireController($scope, toastr, $window, $filter, $feathers, $uibModalStack) {
    $scope.adrequestdesire = $scope.$resolve.adrequestdesire;

    $scope.saveAdrequestdesire= function() {
      $feathers.service('adrequestdesires').patch($scope.adrequestdesire.id, {
        match: $scope.adrequestdesire.match,
        overwrite: $scope.adrequestdesire.overwrite
      })
        .then(function (result) {
          return toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function (error) {
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('editAdrequestdesire', editAdrequestdesire);

  /** @ngInject */
  function editAdrequestdesire() {
    return {
      restrict: 'E',
      controller: 'EditAdrequestdesireController',
      templateUrl: 'app/pages/ads/editAdrequestdesire/editAdrequestdesire.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('HistoryController', HistoryController);

  /** @ngInject */
  function HistoryController($scope, toastr, $window, $filter, $feathers, $stateParams, $location) {
    $scope.filters = {
    };
    $scope.dateRange = {
    };
    $scope.filters.selectedDate = {
      model: {
        id: '5', 'name': $filter('translate')('LAST 30 DAYS'),
        from: moment().subtract(30, 'days')
          .format('LL'),
        to: moment()
          .format('LL')
      },
      availableFilters: [
        {
          id: '1', 'name': $filter('translate')('TODAY'),
          from: moment()
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '2', 'name': $filter('translate')('LAST 7 DAYS'),
          from: moment().subtract(7, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '3', 'name': $filter('translate')('LAST WEEK'),
          from: moment().subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('LL'),
          to: moment().subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '4', 'name': $filter('translate')('THIS WEEK'),
          from: moment()
            .startOf('isoWeek')
            .format('LL'),
          to: moment()
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '5', 'name': $filter('translate')('LAST 30 DAYS'),
          from: moment().subtract(30, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '6', 'name': $filter('translate')('LAST MONTH'),
          from: moment().subtract(1, 'months')
            .startOf('month')
            .format('LL'),
          to: moment().subtract(1, 'months')
            .endOf('month')
            .format('LL')
        },
        {
          id: '7', 'name': $filter('translate')('THIS MONTH'),
          from: moment()
            .startOf('month')
            .format('LL'),
          to: moment().endOf('month')
            .format('LL')
        },
        {
          id: '8', 'name': $filter('translate')('LAST 365 DAYS'),
          from: moment().subtract(365, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '9', 'name': $filter('translate')('LAST YEAR'),
          from: moment().subtract(1, 'years')
            .startOf('year')
            .format('LL'),
          to: moment().subtract(1, 'years')
            .endOf('year')
            .format('LL')
        },
        {
          id: '10', 'name': $filter('translate')('THIS YEAR'),
          from: moment()
            .startOf('year')
            .format('LL'),
          to: moment().endOf('year')
            .format('LL')
        }
      ]
    };
    if ($stateParams.id) {
      $feathers.service('ads').get($stateParams.id)
        .then(function(ad){
          $scope.ad = ad;
        })
        .catch(function(error){
          console.log(error);
        });
    }
    $scope.updateDateFilter = function() {
      if ($scope.filters.selectedDate.model !== ''){
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }
    };

    $scope.initFilters = function() {
      if ($scope.filters.selectedDate.model !== '') {
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }
    };
    $scope.initFilters();

    $scope.getHistory = function(){
      $feathers.service('histories').find({
        query: {
          $paginate: false,
          $or: [
            {
              object_id: $scope.ad.id.toString(),
              service: 'ads'
            },
            {
              related: 'ad:' + $scope.ad.id.toString()
            }
          ],
          created: {
            $gte: moment.utc($scope.dateRange.from, 'LL').startOf('day'),
            $lte: moment.utc($scope.dateRange.to, 'LL').endOf('day')
          },
          $sort: {
            created: -1
          }
        },

      })
        .then(function(result){
          $scope.ad.history = result;
          $scope.$apply();
          if ($scope.ad.history.length === 0) {
            toastr.info($filter('translate')('NO HISTORY AVAILABLE'));
          }
        })
        .catch(function(error){
          console.log(error);
        });
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('ImportAdcodeController', ImportAdcodeController);

  /** @ngInject */
  function ImportAdcodeController($scope, toastr, $window, $filter, $feathers, $uibModalStack, networkTypes) {
    $scope.newAdcode = {
    };
    $scope.importTypes = networkTypes;
    $scope.ad = $scope.$resolve.ad;
    $scope.admediaSizes = $scope.$resolve.admediaSizes;
    $scope.newAdcode.network = $scope.importTypes.indexOf($scope.$resolve.network.network)!==-1? $scope.$resolve.ad.network.network : 'affilinet';
    $scope.newAdcode.belboon_pda = $scope.ad.options.belboon_pda || '';
    $scope.newAdcode.leadalliance_htlp = $scope.ad.options.leadalliance_htlp || '';
    $scope.externalAid;
    $scope.buildAdcode = function () {
      var code = '';
      var urlRegex = /((?:([\w\d\.-]+)\:\/\/?){1}(?:(www)\.?){0,1}(((?:[\w\d-]+\.)*)([\w\d-]+\.[\w\d]+))){1}(?:\:(\d+)){0,1}((\/(?:(?:[^\/\s\?]+\/)*))(?:([^\?\/\s#]+?(?:.[^\?\s"']+){0,1}){0,1}(?:\?([^\s#'"]+)){0,1})){0,1}(?:#([^#\s]+)){0,1}/gim;
      var iFrameRegex = /<iframe[^>]*?(?:\/>|>[^<]*?<\/iframe>)/;
      var commentRegex = /<!--(.*?)\s(iFrame)\s(.*?)-->/;
      if ($scope.newAdcode.network === 'affilinet'){
        var affilinetExternalAidRegex = /(site=)\d+/g;
        code = $scope.newAdcode.code.substring($scope.newAdcode.code.indexOf('<script'), $scope.newAdcode.code.indexOf('</script>') + 9);
        if ($scope.ad.options && $scope.ad.options.affilinet_pvent && !isNaN($scope.ad.options.affilinet_pvent)) {
          code = code.substring(0, code.lastIndexOf('"')) + '&pvent=' + $scope.ad.options.affilinet_pvent + '&subid=[[LONGSUBID]]&PURL=[[ENCLICKURL]]' + code.substring(code.lastIndexOf('"'));
        } else {
          code = code.substring(0, code.lastIndexOf('"')) + '&subid=[[LONGSUBID]]&PURL=[[ENPLAINCLICKURL]]' + code.substring(code.lastIndexOf('"'));
        }
        // add external_aid to ad.options
        if (code.match(affilinetExternalAidRegex)) {
          $scope.externalAid = parseInt(code.match(affilinetExternalAidRegex)[0].match(/\d+/g)[0]);
        }
        // remove comments
        code = code.replace(/<!--[\s\S]*?-->\n/gim, '');
        // replace all http with https
        code = code.split('http://').join('https://');
      } else if ($scope.newAdcode.network === 'zanox'){
        code = $scope.newAdcode.code;
        var urls = code.match(urlRegex);
        for (var index in urls) {
          var newUrl = '';
          var url = urls[index];
          if (url.indexOf('ad.zanox.com') !== -1) {
            if (url.indexOf('ad.zanox.com/ppc') !== -1) {
              // click url
              if (url.toLowerCase().indexOf('&ulp=') !== -1) {
                newUrl = '[[PLAINCLICKURL]]' + url.toLowerCase().replace('&ulp=', '') + '&zpar0=[[LONGSUBID]]-click&ulp=';
              } else {
                newUrl = '[[PLAINCLICKURL]]' + url + '&zpar0=[[LONGSUBID]]-click';
              }
              code = code.replace(url, newUrl);
              // add tpv tracking pixel
              code += '<img src="' + url.replace('ppc', 'tpv') + '&zpar0=[[LONGSUBID]]-pview" align="bottom" width="1" height="1" border="0">';
            }
            if (url.indexOf('ad.zanox.com/ppv') !== -1) {
              // view url
              code = code.replace(url, url + '&zpar0=[[LONGSUBID]]-view');
            }
          }
        }
        // remove comments
        code = code.replace(/<!--[\s\S]*?-->\n/gim, '');
        // replace all http with https
        code = code.split('http://').join('https://');

        /*
        code = $scope.newAdcode.code.substring($scope.newAdcode.code.indexOf('<a href'), $scope.newAdcode.code.indexOf('</a>') + 4);
        code = code.substring(0, code.indexOf('">')) +
          '&zpar0=[[LONGSUBID]]-click" target="_blank' +
          code.substring(code.indexOf('">'), code.indexOf('" align')) +
          '&zpar0=[[LONGSUBID]]-view' + code.substring(code.indexOf('" align'), code.indexOf(' width')) + ' '+
          code.substring(code.indexOf('border'), code.indexOf('border')+ 10) + '></a>' +
          code.substring(code.indexOf('<img'), code.indexOf('ppv')) + 'tpv' + code.substring(code.indexOf('ppv') + 3, code.indexOf('" align')) +
          '&zpar0=[[LONGSUBID]]-pview" align="bottom" width="1" height="1" border="0">';
        */
      } else if ($scope.newAdcode.network === 'medialead'){
        code = $scope.newAdcode.code;
        code = code.replace('"></script>', '&subid=[[SUBID]]"></script>');
      } else if ($scope.newAdcode.network === 'adcell'){
        code = $scope.newAdcode.code;
        code = code.substring(0, code.indexOf('"_blank"') + 8) + ', \n\t"subid": "[[LONGSUBID]]"' + code.substring(code.indexOf('"_blank"') + 8);
      } else if ($scope.newAdcode.network === 'webgains'){
        code = $scope.newAdcode.code;
        var urls = code.match(urlRegex);
        var url = urls[0];
        var iFrame = '';
        var comment = '';
        if (code.match(iFrameRegex)) {
          iFrame = code.match(iFrameRegex)[0];
          if (code.match(commentRegex)) {
            comment = code.match(commentRegex)[0];
          }
        }

        code = '<script src="'+url+'&clickref=[[LONGSUBID]]-click&viewref=[[LONGSUBID]]-pview"></script>\n' +
          '<script>\n' +
          'document.getElementsByTagName("a")[0].onclick = function() {  document.createElement("img").src="[[CLICKURL]]"; };\n' +
          '</script>' + comment + iFrame;

        // replace all http with https
        code = code.split('http://').join('https://');
      } else if ($scope.newAdcode.network === 'awin'){
        var awinExternalAidRegex = /(v=)\d+/g;
        code = $scope.newAdcode.code;
        var urls = code.match(urlRegex);
        for (var index in urls){
          var url = urls[index];
          if (url.indexOf('cread') !== -1){
            code = code.replace(url, '[[PLAINCLICKURL]]' + url + '&pref1=[[LONGSUBID]]-click');
          } else if (url.indexOf('cshow') !== -1){
            code = code.replace(url, url + '&pref1=[[LONGSUBID]]-pview');
          }
        }
        var anchorTag = code.replace(/(?:\r\n|\r|\n)/g, '').match(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g);
        if (anchorTag !== null) {
          var anchorTag =anchorTag[0];
          if (anchorTag.includes('href')) {
            if (!anchorTag.includes('target="_blank"')) {
              code = code.replace('<a', '<a target="_blank"');
            }
          }
        }
        // add external_aid to ad.options
        if (code.match(awinExternalAidRegex)) {
          $scope.externalAid = parseInt(code.match(awinExternalAidRegex)[0].match(/\d+/g)[0]);
        }
      } else if ($scope.newAdcode.network === 'tradedoubler'){
        code = $scope.newAdcode.code;
        var urls = code.match(urlRegex);
        for (var index in urls){
          var url = urls[index];
          if (url.indexOf('imp') !== -1){
            code =code.replace(url, url + 'epi([[LONGSUBID]])');
          } else if (url.indexOf('click') !== -1){
            code = code.replace(url, '[[PLAINCLICKURL]]' + url + '&epi=[[LONGSUBID]]');
          }
        }
      } else if ($scope.newAdcode.network === 'belboon') {
        code = $scope.newAdcode.code;
        var belboonPdaCode = $scope.newAdcode.belboon_pda || '';
        var newCode = '';
        var urls = code.match(urlRegex);
        newCode += '<a href="[[PLAINCLICKURL]]' + urls[0] + '/subid=[[LONGSUBID]]" target="_blank">';
        if (belboonPdaCode !== '') {
          var pdaUrls = belboonPdaCode.match(urlRegex);
          newCode += '<img src="' + urls[1] + code.substring(code.indexOf(urls[1]) + urls[1].length, code.indexOf('/>') + 2) + '</a>';
          newCode += '<img src="' + pdaUrls[1] + '/subid=[[LONGSUBID]]" width="1" height="1" border="0">';
          $scope.ad.options['belboon_pda'] = belboonPdaCode;
          $feathers.service('ads').patch($scope.ad.id, {
            options: $scope.ad.options
          })
            .then(function (result) {
              $scope.newAdcode.belboon_pda = result.options.belboon_pda;
            });
        } else {
          newCode += '<img src="' + urls[1] + '/subid=[[LONGSUBID]]' + code.substring(code.indexOf(urls[1]) + urls[1].length, code.indexOf('/>') + 2);
          newCode += '</a>';
        }
        code = newCode;
      } else if ($scope.newAdcode.network === 'leadalliance') {
        code = $scope.newAdcode.code;
        var leadallianceCode = $scope.newAdcode.leadalliance_htlp || '';
        var anchor = code.replace(/(?:\r\n|\r|\n)/g, '').match(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g);
        var url = anchor[0].match(urlRegex)[0];
        code =code.replace(url, url + '&subid=[[LONGSUBID]]');
        var newCode = '';
        if (leadallianceCode !== '') {
          var leadallianceiFrame = leadallianceCode.match(iFrameRegex);
          var url = leadallianceiFrame[0].match(urlRegex);
          newCode = leadallianceCode.replace(url, url + '&subid=[[LONGSUBID]]');
          code += newCode;
          $scope.ad.options['leadalliance_htlp'] = leadallianceCode;
          $feathers.service('ads').patch($scope.ad.id, {
            options: $scope.ad.options
          })
            .then(function (result) {
              $scope.newAdcode.leadalliance_htlp = result.options.leadalliance_htlp;
            });
        }
        code = code.split('http://').join('https://');
      } else if ($scope.newAdcode.network === 'verticaladsgroup') {
        code = $scope.newAdcode.code;
        var urls = code.match(urlRegex);
        for (var index in urls){
          if (urls.hasOwnProperty(index)) {
            var url = urls[index];
            if (url.indexOf('tb.php') !== -1){
              code =code.replace(url, url + '&subid=[[LONGSUBID]]');
            } else if (url.indexOf('tc.php') !== -1){
              code = code.replace(url, '[[PLAINCLICKURL]]' + url + '&subid=[[LONGSUBID]]');
            }
          }
        }
      }
      var anchorTag = code.replace(/(?:\r\n|\r|\n)/g, '').match(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g);
      if (anchorTag !== null) {
        var anchorTag =anchorTag[0];
        if (anchorTag.includes('href')) {
          if (!anchorTag.includes('target="_blank"')) {
            code = code.replace('<a', '<a target="_blank"');
          }
        }
      }
      return code;
    };

    $scope.importCreative = function () {
      if (_.isEmpty($scope.newAdcode) || !$scope.newAdcode.code || !$scope.newAdcode.network || !$scope.newAdcode.size) {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      } else {
        var adcode = $scope.buildAdcode();
        // safe external_aid to ad.options
        $scope.ad.options.external_aid = $scope.externalAid;
        $feathers.service('ads').patch($scope.ad.id, {
          options: $scope.ad.options
        })
          .then(function() {
            toastr.success($filter('translate')('EXTERNAL AID WAS SET'));
          });
        $feathers.service('admedias').create({
          active: false,
          size: $scope.newAdcode.size,
          code: adcode,
          type: 'html',
          ad: $scope.ad.id,
          name: $scope.newAdcode.name
        })
          .then(function (result) {
            $feathers.service('admedias').get(result.id)
              .then(function (admedia) {
                $scope.ad.admedias.push(admedia);
                $scope.newAdmedia = {
                };
              });
            var top = $uibModalStack.getTop();
            if (top) {
              $uibModalStack.dismiss(top.key);
            }
            return toastr.success($filter('translate')('NEW ADMEDIA CREATED'));
          })
          .catch(function (error) {
            console.log('error', error);
            return toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('importAdCode', importAdCode);

  /** @ngInject */
  function importAdCode() {
    return {
      restrict: 'E',
      controller: 'ImportAdcodeController',
      templateUrl: 'app/pages/ads/importAdCode/importAdcode.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .directive('salesStatistics', salesStatistics);

  /** @ngInject */
  function salesStatistics() {
    return {
      restrict: 'E',
      scope: {
        salesItem: '='
      },
      template: '<canvas id="canvas" style="vertical-align: middle;"></canvas>',
      link: function(scope, element, attrs) {
        var canvas = element.find('canvas')[0];
        var context = canvas.getContext('2d');
        var width = canvas.width = 80, height = canvas.height = 26;
        var stats=[];
        scope.$watch('salesItem', function(newValue) {
          if (newValue) {
            stats = newValue;
            drawCanvas();
          }
        });
        var drawLine = function( context, sx, sy, tx, ty, width, style) {
          context.beginPath();
          context.moveTo(sx, sy);
          context.lineTo(tx, ty);
          context.lineWidth = width;
          context.strokeStyle = style;
          context.stroke();
        };
        var drawCanvas = function() {
          var min, max;

          // find max and min
          for (var i in stats) {
            if ( min === undefined || stats[i] < min ) {
              min = stats[i];
            }
            if ( max === undefined || stats[i] > max ) {
              max = stats[i];
            }
          }
          var padding = 0;
          var textPadding = 11;

          var x=padding,
            y=0,
            incX=(width-2*padding)/(stats.length);

          context.setLineDash([2, 2]);
          drawLine(context,
            width-padding, padding,
            width-padding, height-padding,
            2, '#c3c3c3' );
          drawLine(context,
            x, padding,
            x, height-padding,
            2, '#c3c3c3' );

          context.fillStyle = '#000000';
          context.fillRect(padding, height-padding-textPadding, width-2*padding, textPadding+padding);

          for (var i in stats) {
            y=stats[i]*(height-padding-textPadding)/max;
            context.setLineDash([]);

            context.fillStyle = '#000000';
            context.fillRect(x, height-y-textPadding, incX, y);

            context.setLineDash([2, 2]);
            drawLine(context,
              x, height-textPadding,
              x, padding,
              1, '#c3c3c3' );

            context.fillStyle = '#ffffff';
            context.textAlign = 'center';
            context.font = '9px Courier new';

            var label = stats[i]>9?'^':''+stats[i];
            context.fillText(label, x+incX*0.5, height-3);

            x += incX;

          }
          context.setLineDash([2, 2]);
          drawLine(context,
            padding, height-textPadding,
            width-padding, height-textPadding,
            1, '#c3c3c3' );
        };

      }
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.forecast')
    .controller('ForecastController', ForecastController);

  /** @ngInject */
  function ForecastController($rootScope, $scope, $feathers, $timeout, lodash, forecastSites) {
    $scope.distanceDisabled = false;
    $scope.precisionDisabled = false;

    $scope.showOutput = false;
    $scope.queryDisabled = true;

    $scope.fc_query = {
    };
    $scope.forecast = {
    };
    $scope.queryTime = 0;

    // NEW:
    $scope.input = {
    };
    $scope.input.parsed ={
    };
    $scope.input.zips = {
    };
    $scope.input.sites = [];
    $scope.input.channels = [];
    $scope.input.pageSettings = 'excludeHome';
    $scope.input.days = 7;
    $scope.input.type = 'desktop';
    $scope.input.distance = 0;
    $scope.input.precision = 5;
    $scope.input.unparsed = '';
    $scope.input.fromTime = '';
    $scope.input.toTime = '';
    $scope.input.dateRange = {
      startDate: moment(),
      endDate: moment().add(14, 'days')
    };

    $scope.timepicker_options = {
      default: '',
      donetext: 'Done',
      twelvehour: false,
      autoclose: true
    };

    $scope.changeDistance = function(data) {
      $scope.input.distance = data.from;
      $scope.precisionDisabled = $scope.input.distance!==0;
      $scope.$apply();
    };
    $scope.changePrecision = function(data) {
      $scope.input.precision = data.from;
      $scope.distanceDisabled = $scope.input.precision!==5;
      $scope.$apply();
    };

    var sites = forecastSites;

    $scope.sites = [];
    $scope.channels = [];

    $scope.init = async function() {
      $scope.sites = await $feathers.service('inventories').find({
        query: {
          $paginate: false,
          parent_id: 1,
          kind: 'publisher'
        }
      });

      $scope.channels = await $feathers.service('placementgroups').find({
        query: {
          $paginate: false,
          $sort: {
            name: 1
          }
        }
      });
    };

    $scope.init();

    // console.log($scope.sites);

    /*
    lodash.each(sites, function(id, site) {
      $scope.sites.push({
        id: id,
        label: site
      });
    });
    */

    /*
    * http://df01.df-srv.de:3030/zips/?
    * zips=93049&
    * zips=93053&
    * zips=93047&
    * distance=50&
    * precision=5&
    * token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MiwiaWF0IjoxNDc1MjIzOTA1LCJleHAiOjE0NzU4Mjg3MDUsImlzcyI6ImZlYXRoZXJzIn0.jAGhG5U3GYUT0N_hAs2Q0JfP7jVLKQimFRBQDaJHsvQ
    *
    */

    $scope.$watchGroup(['forecast', 'input.distance', 'input.precision'], function() {

      // Promise.all(lodash.map($scope.forecast, function (zips, key) {
      var zips = {
      };
      lodash.each($scope.forecast, function(value, key) {
        zips[key]=value.parsed;
      });
      var query = {
      };
      query.query = {
        zips: zips,
        distance: $scope.input.distance,
        precision: $scope.input.precision,
        fromTime: $scope.input.fromTime,
        toTime: $scope.input.toTime
      };
      $scope.queryDisabled = true;
      $feathers.service('zips').timeout = 60000;
      $feathers.service('zips').find(query)
        .then(function(result) {
          var status = false;
          lodash.each(result, function(zips, key) {
            $scope.forecast[key].zips=zips;
            if (zips.length) {
              status = true;
              $scope.forecast[key].status = 'OK';
            } else {
              $scope.forecast[key].status = 'INVALID ZIP';
            }
          });
          if (status) {
            $scope.queryDisabled = false;
          }
          $scope.$apply();
        });
      // }))
      // .then(function() {
      // console.log("forecast", $scope.forecast);
      // });
    });

    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };

    $scope.getForecast = function() {
      $scope.queryTime = 0;
      var rs = $rootScope;

      /*
       * type=desktop||mobile||any
       * siteNames[]=bild
       * pageNames[]=-home_index
       * zips[]=93047
       * days=7
       * country=DE
       *
       */
      var zips = {
      };
      lodash.each($scope.forecast, function(value, key) {
        zips[key]=value.zips;
      });

      $scope.fc_query.query = {
        zips: zips,
        days: $scope.input.days,
        type: $scope.input.type
      };
      if (moment($scope.input.fromTime).format('hh:mm') !== 'Invalid date'){
        var fromTime= moment($scope.input.fromTime).format('hh:mm');
        $scope.fc_query.query['fromTime'] = fromTime;
      }
      if (moment($scope.input.toTime).format('hh:mm') !== 'Invalid date'){
        var toTime= moment($scope.input.toTime).format('hh:mm');
        $scope.fc_query.query['toTime'] = toTime;
      }

      if ($scope.input.sites.length) {
        $scope.fc_query.query.siteNames = lodash.map($scope.input.sites, function(site) {
          return site.name;
        });
        $scope.fc_query.query.publisherIds = lodash.map($scope.input.sites, function(site) {
          return site.external_id;
        });
      }

      if ($scope.input.channels.length) {
        $scope.fc_query.query.placementGroupIds = lodash.map($scope.input.channels, function(channel) {
          return channel.id;
        });
      }

      if ($scope.input.pageSettings === 'excludeHome') {
        $scope.fc_query.query.pageNames = ['-home_index'];
      } else if ($scope.input.pageSettings === 'onlyHome') {
        $scope.fc_query.query.pageNames = ['home_index'];
      } else {
        $scope.fc_query.query.pageNames = [];
      }

      // console.log($scope.fc_query);

      $feathers.service('forecasts').timeout = 86400000;
      return $feathers.service('forecasts').find($scope.fc_query)
        .then(function(result) {
          $scope.f = result.data;
          $scope.queryTime = result.took;

          lodash.each($scope.forecast, function(data, key) {
            if ( $scope.f && $scope.f[key] ){
              $scope.forecast[key].impressions = $scope.f[key].visitors || 0;
            } else {
              $scope.forecast[key].impressions = 0;
            }
          });

          $scope.$apply();
        })
        .catch(function(error) {
          console.log('getForecast error', error);
        });
    };

    function parseLine (line) {
      var zips = [];
      var input = [];
      if (line.indexOf('.') !== -1) {
        line = line.split('.').join('');
      }
      if (line.indexOf(',') !== -1) {
        input = line.split(',');
        input = input.map(function(l) {
          return l.trim();
        });
      } else {
        input.push(line.trim());
      }
      _.each(input, function(zip) {
        if (zip.length === 4) {
          zips.push(('0000'+zip).slice(-5));
        } else if (zip.length < 4) {
          var z=parseInt((zip+'00000').slice(0, 5));
          zips.push(z);
          return;
        } else if (zip.indexOf('-') !== -1) {
          var start=parseInt(zip.split('-')[0]);
          var end=parseInt(zip.split('-')[1]);
          if (!start || start<=999 || start.length<4 || end<start) {
            return;
          }
          if (!end || end<=999 || end.length<4) {
            return;
          }
          var current=start;
          while (current!==end) {
            var zzz=('00000'+current.toString()).slice(-5);
            zips.push(zzz);
            current++;
          }
        } else if (zip.length === 5) {
          zips.push(zip);
        };
      });
      return zips;
    }

    $scope.changed = function(data) {
      if ($scope.input.combine) {

        $scope.forecast = {
        };
        $scope.forecast['line0'] = {
          parsed: parseLine(data.split('\n').join(',')),
          input: data
        };
      } else {
        var lines = data.split('\n');
        var index = 0;
        $scope.forecast = {
        };
        lodash.each(lines, function (line) {
          var idx = 'line' + index;
          $scope.forecast[idx] = $scope.forecast[idx] || {};
          $scope.forecast[idx] = {
            parsed: parseLine(line),
            input: line
          };
          index++;
        });
      }
    };

    $scope.resetTime = function(){
      $scope.input.fromTime = '';
      $scope.input.toTime = '';
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.pixels')
    .controller('PixelsListController', PixelsListController);

  /** @ngInject */
  function PixelsListController($scope, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.ads = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getAds = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              $regex: tableState.search.predicateObject[key], $options: '-i'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('pixels').find(query)
        .then(function(result) {
          $scope.ads = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.pixels')
    .controller('CreateHashController', CreateHashController);

  /** @ngInject */
  function CreateHashController($uibModalInstance, $scope, $feathers, $filter, toastr){
    var hash = '';
    $scope.createHash = function (newCiAdId, newAffilinetPid, newAwinPid, newWebgainsPid, newRandom) {
      if ((!newCiAdId && !newAffilinetPid && !newAwinPid && !newWebgainsPid && !newRandom) || newRandom) {
        $feathers.service('tagids').create({
          ids: [0, 0, 0, 0]
        })
          .then(function(result){
            hash = result.hash;
            toastr.success($filter('translate')('RANDOM HASH SUCCESSFULLY CREATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('HASH NOT CREATED'));
          });
      } else if (newCiAdId){
        $feathers.service('tagids').create({
          ids: [newCiAdId, 0, 0, 0]
        })
          .then(function(result){
            hash = result.hash;
            toastr.success($filter('translate')('HASH SUCCESSFULLY CREATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('HASH NOT CREATED'));
          });
      } else if (newAffilinetPid){
        $feathers.service('tagids').create({
          ids: [0, newAffilinetPid, 0, 0]
        })
          .then(function(result){
            hash = result.hash;
            toastr.success($filter('translate')('HASH SUCCESSFULLY CREATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('HASH NOT CREATED'));
          });
      } else if (newAwinPid){
        $feathers.service('tagids').create({
          ids: [0, 0, newAwinPid, 0]
        })
          .then(function(result){
            hash = result.hash;
            toastr.success($filter('translate')('HASH SUCCESSFULLY CREATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('HASH NOT CREATED'));
          });
      } else if (newWebgainsPid){
        $feathers.service('tagids').create({
          ids: [0, 0, 0, newWebgainsPid]
        })
          .then(function(result){
            hash = result.hash;
            toastr.success($filter('translate')('HASH SUCCESSFULLY CREATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('HASH NOT CREATED'));
          });
      }
    };

    $feathers.service('tagids').on('created', function(tagids){
      hash = tagids.hash;
      $uibModalInstance.close(hash);
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.pixels')
    .controller('PixelsDetailController', PixelsDetailController);

  /** @ngInject */
  function PixelsDetailController($rootScope, $scope, $uibModal, $stateParams, $state, $filter, $window, $document, $feathers, $sce, toastr, pixelTypes) {
    $scope.pixel = {
      name: '',
      subkind: '',
      codes: {
      },
      redirects: {

      }
    };

    $scope.saveCodes = function(data) {
      // Check if pixeltype, pixelvalue + pixelcode is already there
      if (data.pixelType && data.pixelValue !== '' && data.pixelCode !== '') {
        if ($scope.pixel.codes[data.pixelType] && $scope.pixel.codes[data.pixelType][data.pixelValue]) {
          toastr.error($filter('translate')('PIXELTYPE WITH PIXELVALUE ALREADY THERE'));
          delete $scope.pixel.codes[''];
          return false;
        }
      } else if (data.pixelType && data.pixelValue === '' && data.pixelCode !== '') {
        if ($scope.pixel.codes[data.pixelType]) {
          toastr.error($filter('translate')('PIXELTYPE WITH CODE ALREADY THERE'));
          delete $scope.pixel.codes[''];
          return false;
        }
      } else {
        toastr.error($filter('translate')('FIELDS ARE NOT FILLED'));
        delete $scope.pixel.codes[''];
        return false;
      }
      // Create Pixel Codes Temp Object for Patching
      if (data.pixelType && data.pixelCode !== '') {
        var codes = {
        };
        codes[data.pixelType] = {
        };
        // Build object by pixelValue
        if (data.pixelValue) {
          codes[data.pixelType][data.pixelValue] = data.pixelCode;
        } else {
          codes[data.pixelType] = data.pixelCode;
        }
        // Check if you have to create it new or add it
        if (data.pixelValue !== ''){
          if ($scope.pixel.codes[data.pixelType]){
            Object.assign($scope.pixel.codes[data.pixelType], codes[data.pixelType]);
          } else {
            $scope.pixel.codes[data.pixelType] = codes[data.pixelType];
          }
        } else {
          $scope.pixel.codes[data.pixelType] = codes[data.pixelType];
        }
        // Delete add row which is init with ['']
        delete $scope.pixel.codes[''];
        if ($scope.pixel._id && $scope.pixel.hash && $scope.pixel.codes) {
          $feathers.service('pixels').patch(
            null,
            {
              codes: $scope.pixel.codes
            },
            {
              query: {
                _id: $scope.pixel._id
              }
            }
          )
            .then(function (result) {
              toastr.success($filter('translate')('PIXEL SUCCESSFULLY UPDATED'));
            })
            .catch(function (error) {
              toastr.error($filter('translate')('CHANGES NOT SAVED'));
            });
        }

      }
    };
    $scope.isAObject = function(value) {
      return typeof value === 'object';
    };
    $scope.cancelCodes = function(){
      delete $scope.pixel.codes[''];
    };
    $scope.removeCodes = function(keyPixelCodes, valuePixelCodes, keyPixelValue, valuePixelValue) {
      if (keyPixelValue) {
        delete $scope.pixel.codes[keyPixelCodes][keyPixelValue];
        if (Object.keys($scope.pixel.codes[keyPixelCodes]).length <= 0){
          delete $scope.pixel.codes[keyPixelCodes];
        }
      } else {
        delete $scope.pixel.codes[keyPixelCodes];
      }
      if ($scope.pixel._id && $scope.pixel.hash && $scope.pixel.codes){
        $feathers.service('pixels').patch(
          null,
          {
            codes: $scope.pixel.codes
          },
          {
            query: {
              _id: $scope.pixel._id
            }
          }
        )
          .then(function(result){
            toastr.success($filter('translate')('PIXEL SUCCESSFULLY UPDATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      }
    };
    $scope.addCodes = function() {
      $scope.inserted = {
        '': ''
      };
      if ($scope.pixel.codes) {
        $scope.pixel.codes[''] = $scope.inserted;
      } else {
        $scope.pixel.codes = {
        };
        $scope.pixel.codes[''] = $scope.inserted;
      }
    };


    $scope.saveRedirects = function(data) {
      // Check if pixeltype, pixelvalue + pixelredirect is already there
      if (data.pixelType && data.pixelValue !== '' && data.pixelRedirect !== '') {
        if ($scope.pixel.redirects[data.pixelType] && $scope.pixel.redirects[data.pixelType][data.pixelValue]) {
          toastr.error($filter('translate')('PIXELTYPE WITH PIXELVALUE ALREADY THERE'));
          delete $scope.pixel.redirects[''];
          return false;
        }
      } else if (data.pixelType && data.pixelValue === '' && data.pixelRedirect !== '') {
        if ($scope.pixel.redirects[data.pixelType]) {
          toastr.error($filter('translate')('PIXELTYPE WITH CODE ALREADY THERE'));
          delete $scope.pixel.redirects[''];
          return false;
        }
      } else {
        toastr.error($filter('translate')('FIELDS ARE NOT FILLED'));
        delete $scope.pixel.redirects[''];
        return false;
      }
      // Create Pixel Redirects Temp Object for Patching
      if (data.pixelType && data.pixelRedirect !== '') {
        var redirects = {
        };
        redirects[data.pixelType] = {
        };
        // Build object by pixelValue
        if (data.pixelValue) {
          redirects[data.pixelType][data.pixelValue] = data.pixelRedirect;
        } else {
          redirects[data.pixelType] = data.pixelRedirect;
        }
        // Check if you have to create it new or add it
        if (data.pixelValue !== ''){
          if ($scope.pixel.redirects[data.pixelType]){
            Object.assign($scope.pixel.redirects[data.pixelType], redirects[data.pixelType]);
          } else {
            $scope.pixel.redirects[data.pixelType] = redirects[data.pixelType];
          }
        } else {
          $scope.pixel.redirects[data.pixelType] = redirects[data.pixelType];
        }
        // Delete add row which is init with ['']
        delete $scope.pixel.redirects[''];
        if ($scope.pixel._id && $scope.pixel.hash && $scope.pixel.redirects) {
          $feathers.service('pixels').patch(
            null,
            {
              redirects: $scope.pixel.redirects
            },
            {
              query: {
                _id: $scope.pixel._id
              }
            }
          )
            .then(function (result) {
              toastr.success($filter('translate')('PIXEL SUCCESSFULLY UPDATED'));
            })
            .catch(function (error) {
              toastr.error($filter('translate')('CHANGES NOT SAVED'));
            });
        }

      }
    };
    $scope.isAObject = function(value) {
      return typeof value === 'object';
    };
    $scope.cancelRedirects = function(){
      delete $scope.pixel.redirects[''];
    };
    $scope.removeRedirects = function(keyPixelRedirects, valuePixelRedirects, keyPixelValue, valuePixelValue) {
      if (keyPixelValue) {
        delete $scope.pixel.redirects[keyPixelRedirects][keyPixelValue];
        if (Object.keys($scope.pixel.redirects[keyPixelRedirects]).length <= 0){
          delete $scope.pixel.redirects[keyPixelRedirects];
        }
      } else {
        delete $scope.pixel.redirects[keyPixelRedirects];
      }
      if ($scope.pixel._id && $scope.pixel.hash && $scope.pixel.redirects){
        $feathers.service('pixels').patch(
          null,
          {
            redirects: $scope.pixel.redirects
          },
          {
            query: {
              _id: $scope.pixel._id
            }
          }
        )
          .then(function(result){
            toastr.success($filter('translate')('PIXEL SUCCESSFULLY UPDATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      }
    };
    $scope.addRedirects = function() {
      $scope.insertedRe = {
        '': ''
      };
      if ($scope.pixel.redirects) {
        $scope.pixel.redirects[''] = $scope.insertedRe;
      } else {
        $scope.pixel.redirects = {
        };
        $scope.pixel.redirects[''] = $scope.insertedRe;
      }
    };


    $scope.types = pixelTypes;

    $scope.downloadTags = function(){
      var text = '';
      _.each($scope.types, function(type){
        text += type.name + ' Tag\r\n';
        if (type.description) {
          text += 'Description: ' + type.description + '\r\n';
        }
        text += $scope.generateTag(type.type, $scope.pixel.hash, type.params) + '\r\n\r\n';
      });

      var blob = new Blob([text], {
          type: 'text/plain'
        }),
        url = $window.URL || $window.webkitURL;
      var file = url.createObjectURL(blob);
      // eslint-disable-next-line angular/document-service
      var element = document.createElement('a');
      element.setAttribute('download', 'All Tags (Pixel '+ $scope.pixel.name+')');
      element.setAttribute('href', file);
      element.click();
    };

    $scope.generateTag = function(type, hash, params) {
      var code = '';
      code += '<script async="async" defer="defer" src="//r.df-srv.de/v2/';
      code += type;
      code += '/';
      code += hash;
      code += '/a.js?';
      let idx = 0;
      for (let key in params) {
        let val = params[key];
        code += key + '=' + val;
        if (idx < _.size(params)-1) {
          code += '&';
        }
        idx++;
      }
      code += '"></script>';
      return code;
    };

    $scope.saveChanges = function(){
      if ($scope.pixel._id && $scope.pixel.hash){
        $feathers.service('pixels').patch(
          null,
          {
            hash: $scope.pixel.hash,
            name: $scope.pixel.name,
            code: $scope.pixel.code,
            active: $scope.pixel.active
          },
          {
            query: {
              _id: $scope.pixel._id
            }
          }
        )
          .then(function(result){
            toastr.success($filter('translate')('PIXEL SUCCESSFULLY UPDATED'));
          })
          .catch(function(error){
            toastr.error($filter('translate')('CHANGES NOT SAVED'));
          });
      }
    };

    $scope.createPixel = function(){
      if ($scope.pixel.name && $scope.pixel.hash && $scope.pixel.hash.length === 20){
        $feathers.service('pixels').create($scope.pixel)
          .then(function(result){
            toastr.success($filter('translate')('PIXEL SUCCESSFULLY CREATED'));
            $state.go('pixels.detail', {
              hash: result.hash
            });
          })
          .catch(function(error){
            console.log('PixelCreate Error: ', error);
            toastr.error($filter('translate')('PIXEL NOT CREATED'));
          });
      } else {
        toastr.info($filter('translate')('PLEASE ENTER NAME AND A VALID HASH (20 CHARACTERS)'));
      }
    };

    $scope.removePixel = function() {
      if (!$scope.pixel._id) {
        return toastr.error($filter('translate')('THIS PIXEL IS NOT SAVED YET'), $filter('translate')('NOT DELETED'));
      }
      return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE PIXEL?'), {
        progressBar: true,
        onHidden: function(clicked, toast) {
          if (clicked && $scope.pixel._id) {
            $feathers.service('pixels').remove($scope.pixel._id)
              .then(function() {
                toastr.success($filter('translate')('PIXEL SUCCESSFULLY DELETED'));
                $state.go('pixels.all');
              });
          }
        }
      });
    };

    function initialize (result) {
      if (result.data) {
        result=result.data[0];
        $state.current.title = result.name;
        $scope.pixel = result;
        $scope.$apply();
      }
    }

    if ($stateParams.hash) {
      $feathers.service('pixels')
        .find({
          query: {
            hash: $stateParams.hash, $populate: false
          }
        })
        .then(initialize)
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE PIXEL YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('pixels.all');
        });

      $feathers.service('targetings').on('created', function(targeting){
        console.log('created', targeting);
      });
      $feathers.service('targetings').on('updated', function(targeting){
        if (targeting._id===$stateParams.id) {
          initialize(targeting);
        }
        console.log('updated', targeting);
      });
      $feathers.service('targetings').on('patched', function(targeting){
        if (targeting._id===$stateParams.id) {
          initialize(targeting);
        }
        console.log('updated', targeting);
      });
      $feathers.service('targetings').on('removed', function(targeting){
        toastr.warning('The targeting you viewed got removed!', 'Removed!');
        if (targeting._id===$stateParams.id) {
          $state.go('targetings.all');
        }
      });
    } else {
      // NEW TARGETING
      $state.current.title = 'NEW PIXEL';
    }

    $scope.createHash = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/pixels/createHash/createHash.html',
        controller: 'CreateHashController',
        size: 'lg'
      });
      modalInstance.result.then(function(result) {
        $scope.pixel.hash = result;
      });
    };

    $scope.success = function(){
      toastr.success($filter('translate')('TAG COPIED TO CLIPBOARD'));
    };

    $scope.fail = function(err) {
      toastr.error($filter('translate')('TAG NOT COPIED'));
      console.log(err);
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.productfeeds')
    .controller('ProductFeedsListController', ProductFeedsListController);

  /** @ngInject */
  function ProductFeedsListController($scope, $state, $feathers, hotkeys) {
    $scope.productFeeds = [];

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;
    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });
    $scope.getProductFeeds = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      $feathers.service('productfeeds').find(query)
        .then(function(result) {
          $scope.productFeeds = result.data;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };
    $scope.routeToNewProductFeed = function() {
      $state.go('productfeeds.detail');
    };
  }
})();

/**
 * Created by f.gildner on 24.10.18.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.productfeeds')
    .controller('ProductFeedsDetailController', ProductFeedsDetailController);

  function ProductFeedsDetailController($rootScope, $scope, $stateParams, $state, $feathers, $filter, $sce, editableOptions, editableThemes, toastr) {
    $scope.productFeed = {
    };
    $scope.helperProductFeed = {
    };

    if ($stateParams.id) {
      $feathers.service('productfeeds').get($stateParams.id)
        .then(function(result) {
          $state.current.title = result.name;
          $scope.productFeed = result;
          if (_.isEmpty($scope.helperProductFeed)) {
            $scope.helperProductFeed = _.clone($scope.productFeed, true);
          }
          $scope.$apply();
        });
    } else {
      $state.current.title= $filter('translate')('NEW PRODUCTFEED');
      $scope.productFeed = {
      };
    }
    $scope.helperProductFeed = $scope.productFeed;
    $scope.saveProductFeed = function() {
      if ($scope.productFeed.id) {
        $feathers.service('productfeeds').patch($scope.productFeed.id, _.omit($scope.productFeed, ['id', 'modified']))
          .then(function(result) {
            toastr.success($filter('translate')('SAVED'));
            $scope.productFeed = result;
            $scope.helperProductFeed = _.clone($scope.productFeed, true);
          })
          .catch(function(error) {
            toastr.error($filter('translate')('NOT SAVED'));
            console.log(error);
          });
      } else {
        if ($scope.productFeed.name && $scope.productFeed.name !== '' &&
          $scope.productFeed.parser && $scope.productFeed.parser !== '') {
          $feathers.service('productfeeds').create($scope.productFeed)
            .then(function(result) {
              toastr.success($filter('translate')('SAVED'));
              $state.go('productfeeds.detail', {
                id: result.id
              });
            })
            .catch(function(error) {
              console.log(error);
              toastr.error($filter('translate')('NOT SAVED'));
            });
        } else {
          toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
        }
      }
    };
    $scope.detectChanges = function() {
      return _.isEqual(JSON.stringify(_.omit($scope.helperProductFeed, 'modified')), JSON.stringify(_.omit($scope.productFeed, 'modified')));
    };
    $scope.setImportStatus = function() {
      $scope.productFeed.import_status = 'importNow';
      $feathers.service('productfeeds').patch($scope.productFeed.id, $scope.productFeed)
        .then(function(productfeed) {
          toastr.success($filter('translate')('IMPORT STARTED'));
          $scope.productFeed = productfeed;
          $scope.helperProductFeed = _.clone($scope.productFeed, true);
        })
        .catch(function(error) {
          console.log(error);
        });
    };
    $scope.compareImportDate = function() {
      if ($scope.productFeed.import_date) {
        return moment($scope.productFeed.import_date).isBefore(moment().add('-2', 'h'));
      }
      return false;
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics')
    .directive('chart', chart);

  /** @ngInject */
  function chart() {
    return {
      restrict: 'E',
      controller: 'ChartController',
      templateUrl: 'app/pages/statistics/chart/chart.html'
    };
  }
})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics')
    .controller('ChartController', ChartController);

  /** @ngInject */
  function ChartController($element, baConfig, $scope, layoutPaths, $filter) {
    $scope.$watch('chartData', function () {
      createGraph();
    });

    function handleLegendClick( graph ) {
      var chart = graph.chart;
      var hidden = graph.hidden;
      if ( hidden ) {
        chart.showGraph(graph);
      } else {
        chart.hideGraph(graph);
      }
      return false;
    }

    var createGraph= function(){
      var layoutColors = baConfig.colors;
      var id = $element[0].getAttribute('id');
      var chart = AmCharts.makeChart(id, {
        'type': 'serial',
        'theme': 'light',
        'fontFamily': 'Roboto, sans-serif',
        'fontSize': 10,
        'color': '#000000',
        'startDuration': 0,
        synchronizeGrid: true,
        'valueAxes': [
          {
            color: '#000000',
            axisColor: '#000000',
            gridColor: '#000000',
            id: 'v1',
            title: $filter('translate')('IMPRESSIONS'),
            position: 'left',
            autoGridCount: false,
            labelFunction: function(value) {
              return Math.round(value) + 'Ais';
            }
          },
          {
            color: '#000000',
            axisColor: '#000000',
            gridColor: '#000000',
            id: 'v2',
            title: $filter('translate')('AMOUNT'),
            position: 'right',
            autoGridCount: false,
            labelFunction: function(value) {
              return Math.round(value) + '€';
            }
          },
          {
            color: '#000000',
            axisColor: '#000000',
            gridColor: '#000000',
            'id': 'v3',
            'title': $filter('translate')('CPM'),
            'position': 'right',
            'autoGridCount': false,
            'labelFunction': function(value) {
              return Math.round(value * 100) / 100 + '€';
            },
            offset: 70
          }
        ],
        'graphs': [
          {
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>',
            'fillAlphas': 0.8,
            'valueAxis': 'v2',
            'precision': 2,
            'lineColor': layoutColors.primaryLight,
            'fillColors': layoutColors.primaryLight,
            'lineAlpha': 0.2,
            'title': $filter('translate')('YIELD'),
            clustered: false,
            'type': 'column',
            'valueField': 'yield',
            'legendPeriodValueText': 'Total: [[value.sum]]'
          },
          {
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>',
            'fillAlphas': 0.8,
            'valueAxis': 'v2',
            'precision': 2,
            'lineColor': layoutColors.primary,
            'fillColors': layoutColors.primary,
            'lineAlpha': 0.2,
            'title': $filter('translate')('SPENT'),
            clustered: false,
            'type': 'column',
            'valueField': 'spent',
            'legendPeriodValueText': 'Total: [[value.sum]]'
          },
          {
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>',
            'valueAxis': 'v2',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'bulletSize': 5,
            'precision': 0,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.success,
            'title': $filter('translate')('PROFIT'),
            'type': 'smoothedLine',
            'valueField': 'profit',
            'legendPeriodValueText': 'Total: [[value.sum]]'
          },
          {
            'valueAxis': 'v1',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'bulletSize': 5,
            'precision': 0,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.chart.surfieGreen,
            'type': 'smoothedLine',
            'title': $filter('translate')('IMPRESSIONS'),
            'useLineColorForBulletBorder': true,
            'valueField': 'impressions',
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]</b>',
            'legendPeriodValueText': 'Total: [[value.sum]]'
          },
          {
            'valueAxis': 'v1',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'bulletSize': 5,
            'precision': 0,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.chart.silverTree,
            'type': 'smoothedLine',
            'title': $filter('translate')('CLICKS'),
            'useLineColorForBulletBorder': true,
            'valueField': 'clicks',
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]</b>',
            'legendPeriodValueText': 'Total: [[value.sum]]'
          },
          {
            'valueAxis': 'v3',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'bulletSize': 5,
            'precision': 4,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.chart.gossip,
            'type': 'smoothedLine',
            'title': $filter('translate')('CPM'),
            'useLineColorForBulletBorder': true,
            'valueField': 'cpm',
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>'
          },
          {
            'valueAxis': 'v3',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'precision': 4,
            'bulletSize': 5,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.chart.white,
            'type': 'smoothedLine',
            'title': $filter('translate')('YIELD CPM'),
            'useLineColorForBulletBorder': true,
            'valueField': 'yield_cpm',
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>'
          },
          {
            'valueAxis': 'v3',
            'bullet': 'round',
            'bulletBorderAlpha': 1,
            'bulletColor': '#000000',
            color: '#000000',
            'precision': 4,
            'bulletSize': 5,
            'hideBulletsCount': 50,
            'lineThickness': 2,
            'lineColor': layoutColors.info,
            'type': 'smoothedLine',
            'title': $filter('translate')('PROFIT CPM'),
            'useLineColorForBulletBorder': true,
            'valueField': 'profit_cpm',
            'balloonText': '[[title]]<br/><b style=\'font-size: 100%\'>[[value]]€</b>'
          }
        ],
        'chartScrollbar': {
          'oppositeAxis': false,
          'offset': 30,
          gridAlpha: 0,
          color: '#000000',
          scrollbarHeight: 20,
          backgroundAlpha: 0.25,
          selectedBackgroundAlpha: 1,
          selectedBackgroundColor: '#d4d4d4',
          autoGridCount: true,
        },
        'chartCursor': {
          'pan': true,
          'cursorColor': layoutColors.danger,
          'valueLineEnabled': true,
          'valueLineBalloonEnabled': true,
          'cursorAlpha': 0,
          'valueLineAlpha': 0.2
        },
        'categoryField': 'date',
        'categoryAxis': {
          'axisColor': '#000000',
          'color': '#000000',
          'gridColor': '#000000',
          'parseDates': true,
          'dashLength': 1,
          'minorGridEnabled': true
        },
        'legend': {
          'equalWidths': false,
          'position': 'top',
          'valueAlign': 'left',
          'valueWidth': 100,
          'horizontalGap': 10,
          'useGraphSettings': true,
          'markerSize': 10,
          'clickMarker': handleLegendClick,
          'clickLabel': handleLegendClick
        },
        'balloon': {
          'borderThickness': 1,
          'shadowAlpha': 0
        },
        'export': {
          'enabled': true
        },
        'dataProvider': $scope.chartData,
        pathToImages: layoutPaths.images.amChart
      });
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics')
    .controller('StatisticsController', StatisticsController);

  /** @ngInject */
  function StatisticsController($scope, $element, $attrs, $location, $feathers, $filter, toastr, $timeout, $window, adKinds) {
    $scope.adKinds = adKinds;
    $scope.dateRange = {
    };
    $scope.sum = {
    };
    $scope.filters = {
    };
    if ('statisticsType' in $attrs && $attrs.statisticsType) {
      $scope.statisticsType = $attrs.statisticsType;
    }
    $scope.filters.selectedSitemedias = [];
    $scope.filters.selectedInsertionOrders = [];
    $scope.filters.selectedAds = [];
    $scope.filters.selectedAdmedias = [];
    $scope.filters.selectedAdvertiser = [];
    $scope.filters.selectedOmitAds = [];
    $scope.filters.kind = 'performance';
    $scope.filters.subkind = ['display', 'retargeting', 'directorder'];
    $scope.filters.selectedColumns = [
      $filter('translate')('IMPRESSIONS'),
      $filter('translate')('CLICKS'),
      'CTR',
      'CPM',
      'CPC',
      $filter('translate')('SPENT'),
      $filter('translate')('YIELD CPC'),
      $filter('translate')('YIELD CPM'),
      $filter('translate')('YIELD'),
      $filter('translate')('SALES'),
      $filter('translate')('PROFIT CPC'),
      $filter('translate')('PROFIT CPM'),
      $filter('translate')('PROFIT')
    ];

    if ($scope.extraAdInformation){
      $scope.filters.selectedColumns.push($filter('translate')('KIND'));
      $scope.filters.selectedColumns.push($filter('translate')('SUBKIND'));
    }

    if ('firstColumnType' in $attrs && $attrs.firstColumnType) {
      $scope.firstColumnType = $attrs.firstColumnType;
      $scope.filters.selectedColumns.push($filter('translate')($scope.firstColumnType));
    }
    $scope.filters.selectedDate = {
      model: {
        id: '2', 'name': $filter('translate')('LAST 7 DAYS'),
        from: moment().subtract(6, 'days')
          .format('LL'),
        to: moment()
          .format('LL')
      },
      availableFilters: [
        {
          id: '1', 'name': $filter('translate')('TODAY'),
          from: moment()
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '2', 'name': $filter('translate')('LAST 7 DAYS'),
          from: moment().subtract(6, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '3', 'name': $filter('translate')('LAST WEEK'),
          from: moment().subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('LL'),
          to: moment().subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '4', 'name': $filter('translate')('THIS WEEK'),
          from: moment()
            .startOf('isoWeek')
            .format('LL'),
          to: moment()
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '5', 'name': $filter('translate')('LAST 30 DAYS'),
          from: moment().subtract(29, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '6', 'name': $filter('translate')('LAST MONTH'),
          from: moment().subtract(1, 'months')
            .startOf('month')
            .format('LL'),
          to: moment().subtract(1, 'months')
            .endOf('month')
            .format('LL')
        },
        {
          id: '7', 'name': $filter('translate')('THIS MONTH'),
          from: moment()
            .startOf('month')
            .format('LL'),
          to: moment().endOf('month')
            .format('LL')
        },
        {
          id: '8', 'name': $filter('translate')('LAST 365 DAYS'),
          from: moment().subtract(364, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '9', 'name': $filter('translate')('LAST YEAR'),
          from: moment().subtract(1, 'years')
            .startOf('year')
            .format('LL'),
          to: moment().subtract(1, 'years')
            .endOf('year')
            .format('LL')
        },
        {
          id: '10', 'name': $filter('translate')('THIS YEAR'),
          from: moment()
            .startOf('year')
            .format('LL'),
          to: moment().endOf('year')
            .format('LL')
        }
      ]
    };

    $scope.initFilters = function() {
      var ads=[], admedias=[], omitads=[], sitemedias = [], insertionOrders = [], advertiser = [];
      var params = $location.search();
      if ($scope.filters.selectedDate.model !== ''){
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }
      if (params.ads && params.ads.length !== 0) {
        if (!_.isArray(params.ads)){
          ads.push(params.ads);
        } else {
          ads = params.ads;
        }
        _.each(ads, function(element){
          $feathers.service('ads').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedAds.push(result.data[0]);
            })
            .catch(function(error){
              console.log('searchAd Error', error);
            });
        });
      }
      if (params.admedias && params.admedias.length !== 0) {
        if (!_.isArray(params.admedias)){
          admedias.push(params.admedias);
        } else {
          admedias = params.admedias;
        }
        _.each(admedias, function(element){
          $feathers.service('admedias').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedAdmedias.push(result.data[0]);
            })
            .catch(function(error){
              console.log('searchAdmedias Error', error);
            });
        });
      }
      if (params.omitads && params.omitads.length !== 0) {
        if (!_.isArray(params.omitads)){
          omitads.push(params.omitads);
        } else {
          omitads = params.omitads;
        }
        _.each(omitads, function(element){
          $feathers.service('ads').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedOmitAds.push(result.data[0]);
            })
            .catch(function(error){
              console.log('searchAd Error', error);
            });
        });
      }
      if (params.sitemedias && params.sitemedias.length !== 0) {
        if (!_.isArray(params.sitemedias)){
          sitemedias.push(params.sitemedias);
        } else {
          sitemedias = params.sitemedias;
        }
        _.each(sitemedias, function(element){
          $feathers.service('sitemedias').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedSitemedias.push(result.data[0]);
            })
            .catch(function(error){
              console.log('searchAd Error', error);
            });
        });
      }
      if (params.insertionorders && params.insertionorders.length !== 0){
        if (!_.isArray(params.insertionorders)){
          insertionOrders.push(params.insertionorders);
        } else {
          insertionOrders = params.insertionorders;
        }
        _.each(insertionOrders, function(element){
          $feathers.service('insertionorders').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedInsertionOrders.push(result.data[0]);
            })
            .catch(function(err){
              console.log('searchInsertionOrder Error', err);
            });
        });
      }
      if (params.selectedAdvertiser && params.selectedAdvertiser.length !== 0){
        if (!_.isArray(params.selectedAdvertiser)){
          advertiser.push(params.advertiser);
        } else {
          advertiser = params.advertiser;
        }
        _.each(advertiser, function(element){
          $feathers.service('advertiser').find({
            query: {
              id: element
            }
          })
            .then(function(result){
              $scope.filters.selectedAdvertiser.push(result.data[0]);
            })
            .catch(function(err){
              console.log('searchAdvertiser Error', err);
            });
        });
      }
      if (params.from){
        $scope.dateRange.from = moment(params.from, 'YYYY-MM-DD').format('LL');
      }
      if (params.to){
        $scope.dateRange.to = moment(params.to, 'YYYY-MM-DD').format('LL');
      }
      if (params.kind){
        $scope.filters.kind = params.kind;
      }
      if (params.subkind){
        if (!_.isArray(params.subkind)) {
          $scope.filters.subkind = [params.subkind];
        } else {
          $scope.filters.subkind = params.subkind;
        }
      }
      if (params.columns) {
        $scope.filters.selectedColumns = params.columns;
      }
      if (params.ads && params.ads.length !== 0 && $scope.dateRange.from){
        $timeout(function() {
          $location.search('ads', _.map($scope.filters.selectedAds, 'id'));
          $location.search('admedias', _.map($scope.filters.selectedAdmedias, 'id'));
          $location.search('omitads', _.map($scope.filters.selectedOmitAds, 'id'));
          $location.search('sitemedias', _.map($scope.filters.selectedSitemedias, 'id'));
          $location.search('advertiser', _.map($scope.filters.selectedAdvertiser, 'id'));
          $location.search('insertionorders', _.map($scope.filters.selectedInsertionOrders, 'id'));
          $scope.getStatistics($scope.createStatistic);
        }, 700);
      }
    };

    $scope.updateDateFilter = function() {
      if ($scope.filters.selectedDate.model !== ''){
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }
    };

    $scope.updateFilters = function(type){
      if (type === 'ads') {
        $scope.filters.selectedAdmedias = [];
      }
      $location.search('insertionorders', _.map($scope.filters.selectedInsertionOrders, 'id'));
      $location.search('ads', _.map($scope.filters.selectedAds, 'id'));
      $location.search('admedias', _.map($scope.filters.selectedAdmedias, 'id'));
      $location.search('advertiser', _.map($scope.filters.selectedAdvertiser, 'id'));
      $location.search('omitads', _.map($scope.filters.selectedOmitAds, 'id'));
      $location.search('sitemedias', _.map($scope.filters.selectedSitemedias, 'id'));
      $location.search('from', moment($scope.dateRange.from, 'LL').format('YYYY-MM-DD'));
      $location.search('to', moment($scope.dateRange.to, 'LL').format('YYYY-MM-DD'));
      $location.search('kind', $scope.filters.kind);
      $location.search('subkind', $scope.filters.subkind);
    };

    $scope.initFilters();
    $scope.getStatistics = function(callback){
      if ($scope.dateRange.from){
        var query = {
          ads: _.map($scope.filters.selectedAds, 'id'),
          admedias: _.map($scope.filters.selectedAdmedias, 'id'),
          omitAds: _.map($scope.filters.selectedOmitAds, 'id'),
          from: moment.utc($scope.dateRange.from, 'LL').toDate(),
          to: moment.utc($scope.dateRange.to, 'LL').toDate(),
        };
        if (!$scope.filters.selectedAds.length){
          query.kind = $scope.filters.kind;
          query.subkind = $scope.filters.subkind;
        }
        if ($scope.filters.selectedSitemedias.length > 0){
          query.sitemedias = _.map($scope.filters.selectedSitemedias, 'id');
        }
        if ($scope.filters.selectedAdvertiser.length > 0){
          query.advertiser = _.map($scope.filters.selectedAdvertiser, 'id');
        }
        if ($scope.filters.selectedInsertionOrders.length > 0 && $scope.filters.selectedAds.length === 0){
          query['insertionorder_id']= _.map($scope.filters.selectedInsertionOrders, 'id');
          $feathers.service('ads').find({
            query: {
              'insertionorder_id': _.map($scope.filters.selectedInsertionOrders, 'id')
            }
          })
            .then(function(result){
              query.ads = _.map(result.data, 'id');
              callback(query);
            })
            .catch(function(err){
              console.log('findAds Error', err);
            });
        } else {
          callback(query);
        }
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };

    $scope.createStatistic = function(query){
      $feathers.service('statistics').timeout = 60000;
      $feathers.service('statistics').get($attrs.statisticsType, {
        query: query
      })
        .then(async function(result){
          $scope.statistics = result;
          $scope.sum.impressions = _.sum(_.map($scope.statistics, 'impressions'));
          $scope.sum.clicks = _.sum(_.map($scope.statistics, 'clicks'));
          $scope.sum.spent = _.sum(_.map($scope.statistics, 'spent'));
          $scope.sum.yield = _.sum(_.map($scope.statistics, 'yield'));
          $scope.sum.sales = _.sum(_.map($scope.statistics, 'sales'));
          $scope.sum.profit = _.sum(_.map($scope.statistics, 'profit'));
          if ($scope.extraColumns) {
            $scope.sum.yieldConfirmed = _.sum(_.map($scope.statistics, 'yield_confirmed'));
            $scope.sum.yieldRejected = _.sum(_.map($scope.statistics, 'yield_rejected'));
            $scope.sum.yieldPending = _.sum(_.map($scope.statistics, 'yield_pending'));
            $scope.sum.salesConfirmed = _.sum(_.map($scope.statistics, 'sales_confirmed'));
            $scope.sum.salesRejected = _.sum(_.map($scope.statistics, 'sales_rejected'));
            $scope.sum.salesPending = _.sum(_.map($scope.statistics, 'sales_pending'));
          }
          $scope.chartData = result;
          $scope.$apply();
          if (result.length === 0) {
            toastr.info($filter('translate')('NO STATISTICS AVAILABLE'));
          }
        })
        .catch(function(error){
          console.log('getStatistics Error: ', error);
          toastr.error($filter('translate')('ERROR'));
        });
    };

    $scope.searchSitemedias = function(sitemedia){
      var query = {
        name: {
          $ilike: '%'+sitemedia+'%'
        }, $limit: 20
      };
      if ($scope.filters.kind) {
        query.kind = $scope.filters.kind;
      }
      return $feathers.service('sitemedias').find({
        query: query
      })
        .then(function(result){
          $scope.sitemedias = result.data;
          $scope.$apply();
        })
        .catch(function(error){
          console.log('searchSitemedia Error', error);
        });
    };

    $scope.searchAds = function(ad){
      var query = {
        name: {
          $ilike: '%'+ad+'%'
        }, $limit: 20
      };
      if ($scope.filters.kind) {
        query.kind = $scope.filters.kind;
      }
      if ($scope.filters.selectedInsertionOrders.length > 0){
        query['insertionorder_id'] = {
          $in: $scope.filters.selectedInsertionOrders.map(insertionorder => insertionorder.id)
        };
      }
      return $feathers.service('ads').find({
        query: query
      })
        .then(function(result){
          $scope.ads = result.data;
          $scope.$apply();
        })
        .catch(function(error){
          console.log('searchAd Error', error);
        });
    };

    $scope.searchAdmedias = function(name){
      var query = {
        name: {
          $ilike: '%'+name+'%'
        }, $limit: 20
      };
      if ($scope.filters.selectedAds.length > 0){
        query['ad'] = {
          $in: $scope.filters.selectedAds.map(ad => ad.id)
        };
      }
      return $feathers.service('admedias').find({
        query: query
      })
        .then(function(result){
          $scope.admedias = result.data;
          $scope.$apply();
        })
        .catch(function(error){
          console.log('searchAdmedia Error', error);
        });
    };

    $scope.searchInsertionOrders = function(insertionOrder){
      var query = {
        name: {
          $ilike: '%'+insertionOrder+'%'
        }, $limit: 20
      };
      return $feathers.service('insertionorders').find({
        query: query
      })
        .then(function(result){
          $scope.insertionOrders = result.data;
          $scope.$apply();
        })
        .catch(function(err){
          console.log('searchInsertionOrder Error', err);
        });
    };

    $scope.searchAdvertiser = function(advertiser){
      var query = {
        name: {
          $ilike: '%'+advertiser+'%'
        }, $limit: 20
      };
      return $feathers.service('advertisers').find({
        query: query
      })
        .then(function(result){
          $scope.advertiser = result.data;
          $scope.$apply();
        })
        .catch(function(err){
          console.log('searchAdvertiser Error', err);
        });
    };

    $scope.exportData = function(){
      _.forEach($scope.statistics, function(element){
        if (element.expanded){
          element.expanded = false;
        }
      });
      $timeout(function(){
        var header = '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        // eslint-disable-next-line angular/document-service
        var blob = new Blob([header + document.getElementById('exportable').outerHTML], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=iso-8859-1'
          }), url = $window.URL || $window.webkitURL;
        var file = url.createObjectURL(blob);
        // eslint-disable-next-line angular/document-service
        var element = document.createElement('a');
        element.setAttribute('download', 'Statistics.xls');
        element.setAttribute('href', file);
        element.click();
      }, 200);

    };
    $scope.columns = [
      $filter('translate')($scope.firstColumnType),
      $filter('translate')('IMPRESSIONS'),
      $filter('translate')('CLICKS'),
      'CTR',
      'CPM',
      'CPC',
      $filter('translate')('SPENT'),
      $filter('translate')('YIELD CPC'),
      $filter('translate')('YIELD CPM'),
      $filter('translate')('YIELD'),
      $filter('translate')('SALES'),
      $filter('translate')('PROFIT CPC'),
      $filter('translate')('PROFIT CPM'),
      $filter('translate')('PROFIT')
    ];
    if ($scope.extraColumns) {
      $scope.columns.push($filter('translate')('YIELD PENDING'));
      $scope.columns.push($filter('translate')('YIELD REJECTED'));
      $scope.columns.push($filter('translate')('SALES PENDING'));
      $scope.columns.push($filter('translate')('SALES CONFIRMED'));
      $scope.columns.push($filter('translate')('SALES REJECTED'));
      $scope.columns.push($filter('translate')('YIELD CONFIRMED'));
    }
    if ($scope.extraAdInformation){
      $scope.columns.splice(1, 0, $filter('translate')('KIND'));
      $scope.columns.splice(2, 0, $filter('translate')('SUBKIND'));
    }
    $scope.reset = function() {
      $scope.statistics = [];
      $scope.filters.kind = 'performance';
      $scope.filters.subkind = ['display', 'retargeting', 'directorder'];
      $scope.filters.selectedAds = [];
      $scope.filters.selectedAdmedias = [];
      $scope.filters.selectedAdvertiser = [];
      $scope.filters.selectedSitemedias = [];
      $scope.filters.selectedDate.model.id = '2';
      $scope.filters.selectedInsertionOrders = [];
      $scope.dateRange.from = moment().subtract(7, 'days')
        .format('LL');
      $scope.dateRange.to = moment().format('LL');
      $scope.filters.selectedColumns = $scope.columns;
    };
    $scope.isSelected = function(column) {
      if ($scope.filters && 'selectedColumns' in $scope.filters) {
        return $scope.filters.selectedColumns.indexOf($filter('translate')(column)) !== -1;
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics')
    .directive('statistics', statistics);

  /** @ngInject */
  function statistics() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/statistics/statistics/statistics.html',
      scope: {
        statisticsType: '=',
        extraColumns: '=',
        firstColumnType: '=',
        showChart: '=',
        extraAdInformation: '=',
      },
      controller: 'StatisticsController'
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.statistics')
    .controller('ActionReportController', ActionReportController);

  /** @ngInject */
  function ActionReportController($scope, $state, $feathers, $filter, $http, toastr, $location, feathersSettings) {
    $scope.dateRange = {
    };
    $scope.filters = {
    };
    $scope.selectedPreset = ['coupon', 'catalog', 'engagementAd'];
    $scope.filters.selectedInsertionOrder;
    $scope.filters.selectedAdmedias = [];
    $scope.filters.selectedPreset = 'engagementAd';
    $scope.filters.activeDateRange = false;
    $scope.admedias = [];
    $scope.url = '';

    let today = moment().format('LL');

    $scope.filters.selectedDate = {
      model: {
        id: '2', 'name': $filter('translate')('LAST 7 DAYS')
      },
      availableFilters: [
        {
          id: '1', 'name': $filter('translate')('TODAY'),
          from: today,
          to: today,
        },
        {
          id: '2', 'name': $filter('translate')('LAST 7 DAYS'),
          from: moment().subtract(6, 'days')
            .format('LL'),
          to: today,
        },
        {
          id: '3', 'name': $filter('translate')('LAST WEEK'),
          from: moment().subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('LL'),
          to: moment().subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '4', 'name': $filter('translate')('THIS WEEK'),
          from: moment()
            .startOf('isoWeek')
            .format('LL'),
          to: moment()
            .endOf('isoWeek')
            .format('LL')
        },
        {
          id: '5', 'name': $filter('translate')('LAST 30 DAYS'),
          from: moment().subtract(29, 'days')
            .format('LL'),
          to: moment()
            .format('LL')
        },
        {
          id: '6', 'name': $filter('translate')('LAST MONTH'),
          from: moment().subtract(1, 'months')
            .startOf('month')
            .format('LL'),
          to: moment().subtract(1, 'months')
            .endOf('month')
            .format('LL')
        },
        {
          id: '7', 'name': $filter('translate')('THIS MONTH'),
          from: moment()
            .startOf('month')
            .format('LL'),
          to: moment().endOf('month')
            .format('LL')
        },
        {
          id: '8', 'name': $filter('translate')('LAST 365 DAYS'),
          from: moment().subtract(364, 'days')
            .format('LL'),
          to: today
        },
        {
          id: '9', 'name': $filter('translate')('LAST YEAR'),
          from: moment().subtract(1, 'years')
            .startOf('year')
            .format('LL'),
          to: moment().subtract(1, 'years')
            .endOf('year')
            .format('LL')
        },
        {
          id: '10', 'name': $filter('translate')('THIS YEAR'),
          from: moment()
            .startOf('year')
            .format('LL'),
          to: moment().endOf('year')
            .format('LL')
        }
      ]
    };

    $scope.initFilters = async function () {
      let admedias = [], insertionOrders;
      let params = $location.search();

      if ($scope.filters.selectedDate.model !== '') {
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }

      if (params.insertionorders && params.insertionorders >= 0) {
        insertionOrders = params.insertionorders;
        try {
          $scope.filters.selectedInsertionOrder = await $feathers.service('insertionorders').get(insertionOrders);
        } catch (e) {
          console.log('searchInsertionOrder Error', e);
        }
      }
      if (params.admedias && params.admedias.length !== 0) {
        if (!_.isArray(params.admedias)) {
          admedias.push(params.admedias);
        } else {
          admedias = params.admedias;
        }
        for (let admedia of admedias) {
          try {
            let result = await $feathers.service('admedias').get(admedia);
            $scope.filters.selectedAdmedias.push(result);
            $location.search('admedias', _.map($scope.filters.selectedAdmedias, 'id'));
          } catch (e) {
            console.log('searchAdmedias Error', e);
          }
        }
        $location.search('admedias', _.map($scope.filters.selectedAdmedias, 'id'));
      }

      if (params.from) {
        $scope.dateRange.from = moment(params.from, 'YYYY-MM-DD').format('LL');
      } else {
        $scope.dateRange.from = moment().subtract(6, 'days')
          .format('LL');
      }
      if (params.to) {
        $scope.dateRange.to = moment(params.to, 'YYYY-MM-DD').format('LL');
      } else {
        $scope.dateRange.to = today;
      }
      if (params.preset) {
        $scope.filters.selectedPreset = params.preset;
      }
      if (params.hasOwnProperty('activeDateRange')) {
        $scope.filters.activeDateRange = JSON.parse(params.activeDateRange);
      } else {
        $scope.filters.activeDateRange = true;
      }
      $scope.updateUrl();
    };

    $scope.updateDateFilter = function () {
      if ($scope.filters.selectedDate.model !== '') {
        $scope.dateRange.from = $scope.filters.selectedDate.model.from;
      }
      if ($scope.filters.selectedDate.model !== '') {
        $scope.dateRange.to = $scope.filters.selectedDate.model.to;
      }
    };

    $scope.updateFilters = function (type) {
      if (type === 'insertionorders') {
        $scope.filters.selectedAdmedias = [];
        $scope.admedias = [];
        $location.search('insertionorders', ($scope.filters.selectedInsertionOrder) ? $scope.filters.selectedInsertionOrder.id : null);
      }
      $location.search('admedias', _.map($scope.filters.selectedAdmedias, 'id'));
      if ($scope.dateRange.from) {
        $location.search('from', moment($scope.dateRange.from, 'LL').format('YYYY-MM-DD'));
      }
      if ($scope.dateRange.to) {
        $location.search('to', moment($scope.dateRange.to, 'LL').format('YYYY-MM-DD'));
      }
      if ($scope.filters.selectedPreset) {
        $location.search('preset', $scope.filters.selectedPreset);
      }
      $location.search('activeDateRange', $scope.filters.activeDateRange);

      $scope.updateUrl();
    };

    $scope.updateUrl = function () {
      if ($scope.filters.selectedInsertionOrder && $scope.filters.selectedInsertionOrder.id > 0) {
        let admediaUrl = '';
        if ($scope.filters.selectedAdmedias.length > 0) {
          admediaUrl = $scope.filters.selectedAdmedias.map(function (elem) {
            return 'admedias[]=' + elem.id;
          }).join('&');
          admediaUrl += '&';
        }
        let dateUrl = '';
        if ($scope.filters.activeDateRange) {
          dateUrl = `from=${moment($scope.dateRange.from, 'LL').format('YYYY-MM-DD')}&to=${moment($scope.dateRange.to, 'LL').format('YYYY-MM-DD')}&`;
        }
        $scope.url = `${feathersSettings.endpointUrl}/publicStatistics/dailyActions/${$scope.filters.selectedInsertionOrder.download_token}?${dateUrl}${admediaUrl}preset=${$scope.filters.selectedPreset}`;
      } else {
        $scope.url = '';
      }
    };

    $scope.initFilters();

    $scope.searchInsertionOrders = async function (insertionOrder) {
      let query = {
        name: {
          $ilike: '%' + insertionOrder + '%'
        }, $limit: 20
      };
      try {
        let result = await $feathers.service('insertionorders').find({
          query: query
        });
        $scope.insertionOrders = result.data;
        $scope.$apply();
      } catch (e) {
        console.log('searchInsertionOrder Error', e);
      }
    };

    $scope.searchAdmedias = async function (name) {
      if ($scope.filters.selectedInsertionOrder && $scope.filters.selectedInsertionOrder.id > 0) {
        let ioQuery = {
        };
        try {
          ioQuery['insertionorder_id'] = $scope.filters.selectedInsertionOrder.id;
          let adsRes = await $feathers.service('ads').find({
            query: ioQuery
          });
          let amQuery = {
            name: {
              $ilike: '%' + name + '%'
            }, $limit: 50
          };
          amQuery['ad'] = {
            $in: adsRes.data.map(ad => ad.id)
          };
          let admRes = await $feathers.service('admedias').find({
            query: amQuery
          });
          $scope.admedias = admRes.data;
          $scope.$apply();
        } catch (e) {
          console.log('searchAdmedia Error', e);
        }
      }
    };

    $scope.downloadStatistic = async function () {
      if ($scope.url) {
        try {
          let checkWebsite = await $http({
            method: 'GET',
            url: $scope.url,
            timeout: 3000
          });
          if (checkWebsite.status === 200) {
            // eslint-disable-next-line angular/document-service
            const link = document.createElement('a');
            link.setAttribute('target', '_blank');
            link.setAttribute('href', $scope.url);
            // eslint-disable-next-line angular/document-service
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        } catch (e) {
          if (e.status === -1) {
            toastr.error($filter('translate')('TRY AGAIN LATER'), $filter('translate')('TIMEOUT'));
            console.log('error', e);
          } else {
            toastr.error($filter('translate')('NO ACTION STATISTIC AVAILABLE'));
            console.log('error', e);
          }
        }
      } else {
        toastr.error($filter('translate')('PLEASE SELECT INSERTIONORDER'));
      }
    };

    $scope.resetFilter = function () {
      $scope.filters.selectedPreset = 'engagementAd';
      $scope.filters.selectedAdmedias = [];
      $scope.filters.selectedDate.model.id = '2';
      $scope.filters.selectedInsertionOrder = {
      };
      $scope.dateRange.from = moment().subtract(6, 'days')
        .format('LL');
      $scope.dateRange.to = moment().format('LL');
      $scope.updateFilters('insertionorders');
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.targetings')
    .controller('TargetingsListController', TargetingsListController);

  /** @ngInject */
  function TargetingsListController($rootScope, $scope, $filter, $state, $feathers, hotkeys, principal) {
    $scope.smartTablePageSize = 25;
    $scope.totalObjects = 0;
    $scope.isLoading = false;

    $scope.targetings = [];
    $scope.identity = principal.identity().$$state.value;

    function setPage(adjust) {
      var pager = angular
        .element('#pagerId')
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });
    $scope.$watch('smartTablePageSize', function(newValue, oldValue) {
      if (newValue!==oldValue) {
        tableState.pagination.numberOfPages = Math.ceil($scope.totalObjects/$scope.smartTablePageSize);
        $scope.$apply();
      }
    });

    $scope.getTargetings = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,

          /* $populate: {
            adrequestdesires: false,
            adbase: true
          },*/
          // kind: 'datafactor'
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.smartTarget = tableState.search.predicateObject[key];
          } else if (key === 'active' || key === 'createdBy'){
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = '/' + tableState.search.predicateObject[key] + '/';
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('targetings').find(query)
        .then(function(result) {
          $scope.targetings = result.data;
          $scope.totalObjects=result.total;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };
    $scope.routeToNewTargeting = function(){
      $state.go('targetings.detail');
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('AdcheckerController', AdcheckerController);

  /** @ngInject */
  function AdcheckerController($scope, $filter, $feathers, toastr, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.admedias = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getAdmedias = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          status: {
            $ne: 'OK'
          }
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'ad') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      $feathers.service('admedias').find(query)
        .then(function(result) {
          $scope.admedias = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.log(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.targetings')
    .controller('TargetingsDetailController', TargetingsDetailController);

  /** @ngInject */
  function TargetingsDetailController($rootScope, $translate, $scope, $state, $stateParams, $filter, $feathers, $timeout, lodash, toastr, editableOptions, editableThemes) {
    $scope.distanceDisabled = false;
    $scope.precisionDisabled = false;

    $scope.targeting = {
      name: '',
      options: {

      }
    };

    $scope.daterange = {
    };
    $scope.queryTime = 0;

    // NEW:
    $scope.input = {
    };
    $scope.input.raw = '';
    $scope.input.zips = [];
    $scope.input.distance = 0;
    $scope.input.precision = 5;


    $scope.$watchGroup(['daterange.from', 'daterange.to'], function() {
      if ($scope.daterange.from) {
        $scope.targeting.from=moment($scope.daterange.from, 'LL').toDate();
      }
      if ($scope.daterange.to) {
        $scope.targeting.to=moment($scope.daterange.to, 'LL').endOf('day')
          .toDate();
      }
    });

    $scope.myDateRange;
    $scope.renderHtml = function(html) {
      return $sce.trustAsHtml(html);
    };

    function initialize (result) {
      $state.current.title = result.name;
      $scope.targeting = result;
      if (result.input) {
        if (result.input.raw) {
          $scope.input.raw=result.input.raw;
        }
        if (result.input.distance) {
          $scope.input.distance=result.input.distance;
          $scope.precisionDisabled = $scope.input.distance!==0;
        }
        if (result.input.precision) {
          $scope.input.precision=result.input.precision;
          $scope.distanceDisabled = $scope.input.precision!==5;
        }
        if (result.input.zips) {
          $scope.input.zips=result.input.zips;
        }
      }
      if (result.from) {
        $scope.daterange.from = moment(result.from);
      }
      if (result.to) {
        $scope.daterange.to = moment(result.to);
      }
      $scope.targeting.input=$scope.input;
      $scope.$apply();
    }

    if ($stateParams.id) {
      $feathers.service('targetings')
        .get($stateParams.id, {
          $populate: false
        })
        .then(initialize)
        .catch(function(error) {
          toastr.error($filter('translate')('THE TARGETING YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('targetings.all');
        });

      $feathers.service('targetings').on('created', function(targeting){
        console.log('created', targeting);
      });
      $feathers.service('targetings').on('updated', function(targeting){
        if (targeting._id===$stateParams.id) {
          initialize(targeting);
        }
        console.log('updated', targeting);
      });
      $feathers.service('targetings').on('patched', function(targeting){
        if (targeting._id===$stateParams.id) {
          initialize(targeting);
        }
        console.log('updated', targeting);
      });
      $feathers.service('targetings').on('removed', function(targeting){
        toastr.warning($filter('translate')('THE TARGETING YOU VIEWED GOT REMOVED'), $filter('translate')('REMOVED'));
        if (targeting._id===$stateParams.id) {
          $state.go('targetings.all');
        }
      });
    } else {
      // NEW TARGETING
      $state.current.title = $filter('translate')('NEW TARGETING');
      $scope.targeting.name='';
      $scope.targeting.targeting = {
        geo: {
        }
      };
    }

    $scope.remove = function() {
      if ($scope.targeting.locked) {
        return toastr.error($filter('translate')('This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.'), $filter('translate')('NOT DELETED'));
      }
      if (!$scope.targeting._id) {
        return toastr.error($filter('translate')('THIS TARGETING IS NOT SAVED YET'), $filter('translate')('NOT DELETED'));
      }
      return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE TARGETING?'), {
        progressBar: true,
        onHidden: function(clicked, toast) {
          if (clicked && $scope.targeting._id) {
            $feathers.service('targetings').remove($scope.targeting._id)
              .then(function() {
                $state.go('targetings.all');
              });
          }
        }
      });
    };

    $scope.save = function() {
      if ($scope.targeting.locked) {
        return toastr.error($filter('translate')('This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.'), $filter('translate')('NOT SAVED'));
      }
      if (!$scope.targeting.name) {
        return toastr.error($filter('translate')('PLEASE ENTER A NAME'), $filter('translate')('NOT SAVED'));
      }
      if (!$scope.targeting.permanent && (!$scope.targeting.from || !$scope.targeting.to)) {
        return toastr.error($filter('translate')('PLEASE SELECT FROM & TO OR PERMANENT'), $filter('translate')('NOT SAVED'));
      }
      if (!$scope.targeting.targeting.geo.zips || !$scope.targeting.targeting.geo.zips.length) {
        return toastr.error($filter('translate')('NO ZIPS SELECTED?!'), $filter('translate')('NOT SAVED'));
      }
      if ($scope.user.publisher_id!==2) {
        // if ($scope.targeting.smartTarget && ($scope.targeting.smartTarget.slice(0, 4) !== 'dfx_' && $scope.targeting.smartTarget.slice(0, 4) !== 'dfv_' && $scope.targeting.smartTarget.slice(0, 3) !== 'df=' && $scope.targeting.smartTarget.slice(0, 4) !== 'dfc=' && $scope.targeting.smartTarget.slice(0, 4) !== 'dfr=')) {
        //   return toastr.error('Please enter Target that starts with \'dfx_\' or \'dfv_\'', $filter('translate')('NOT SAVED'));
        // }
        if ($scope.targeting.smartTarget && $scope.targeting.smartTarget.length > 20) {
          return toastr.error($filter('translate')('PLEASE USE A TARGET NOT LONGER THAN 20 CHARACTERS'), $filter('translate')('NOT SAVED'));
        }
      }
      if ($stateParams.id) {
        $scope.targeting.input=$scope.input;
        $feathers.service('targetings')
          .patch($stateParams.id, _.omit(_.clone($scope.targeting), ['version', 'createdBy']))
          .then(function(result) {
            toastr.success('Changes saved!');
          });
      } else {
        $scope.targeting.input=$scope.input;
        $feathers.service('targetings')
          .create($scope.targeting)
          .then(function(result) {
            toastr.success($filter('translate')('SAVED'));
            $state.go('targetings.detail', {
              id: result._id
            });
          })
          .catch(function(error) {
            toastr.error($filter('translate')('TARGET IS ALREADY DEFINED'), $filter('translate')('NOT SAVED'));
            console.log('error', error);
          });
      }
    };

    $scope.changeDistance = function(data) {
      $scope.input.distance = data.from;
      $scope.precisionDisabled = $scope.input.distance!==0;
      $scope.$apply();
    };
    $scope.changePrecision = function(data) {
      $scope.input.precision = data.from;
      $scope.distanceDisabled = $scope.input.precision!==5;
      $scope.$apply();
    };

    /*
    * http://df01.df-srv.de:3030/zips/?
    * zips=93049&
    * zips=93053&
    * zips=93047&
    * distance=50&
    * precision=5&
    * token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MiwiaWF0IjoxNDc1MjIzOTA1LCJleHAiOjE0NzU4Mjg3MDUsImlzcyI6ImZlYXRoZXJzIn0.jAGhG5U3GYUT0N_hAs2Q0JfP7jVLKQimFRBQDaJHsvQ
    *
    */

    $scope.$watchGroup(['input.zips', 'input.distance', 'input.precision'], function() {

      if (!$scope.input.zips.length) {
        return;
      }
      var query = {
      };
      query.query = {
        zips: $scope.input.zips,
        distance: $scope.input.distance,
        precision: $scope.input.precision
      };
      $feathers.service('zips').timeout = 60000;
      return $feathers.service('zips').find(query)
        .then(function(result) {
          var zips = [];
          // $scope.input.zips = result;
          _.each(result, function(v, k) {
            zips = zips.concat(v);
          });
          $scope.targeting.targeting.geo.zips = _.uniq(zips);
          $scope.$apply();
        })
        .then(function() {
        });


    });


    function parseLine (line) {
      var zips = [];
      var input = [];
      if (line.indexOf('.') !== -1) {
        line = line.split('.').join('');
      }
      if (line.indexOf(',') !== -1) {
        // TODO multiple inputs per zip?
        input = line.split(',');
        input = input.map(function(l) {
          return l.trim();
        });
      } else {
        input.push(line);
      }
      _.each(input, function(zip) {
        if (zip.length === 4) {
          zips.push(('0000'+zip).slice(-5));
        } else if (zip.length < 4) {
          var z=parseInt((zip+'00000').slice(0, 5));
          zips.push(z);
          return;

          /*
            var start=parseInt((zip+"00000").slice(0,5));
            var end=parseInt((zip+"99999").slice(0,5));
            var current=start;
            while (current!=end) {
              var zzz=("00000"+current.toString()).slice(-5);
              zips.push(zzz);
              current++;
            }*/
        } else if (zip.indexOf('-') !== -1) {
          var start=parseInt(zip.split('-')[0]);
          var end=parseInt(zip.split('-')[1]);
          if (!start || start<=999 || start.length<4 || end<start) {
            return;
          }
          if (!end || end<=999 || end.length<4) {
            return;
          }
          var current=start;
          while (current!==end) {
            var zzz=('00000'+current.toString()).slice(-5);
            zips.push(zzz);
            current++;
          }
        } else if (zip.length === 5) {
          zips.push(zip);
        };
      });
      // _.each(zips, function(zip) {
      //  console.log(unzip(zip))
      // });
      return zips;
    }

    ;

    $scope.changed = function(data) {
      if (!data) {
        return;
      }
      $scope.input.raw = data;
      var lines = data.split('\n');
      var index = 0;
      var zips = [];
      lodash.each(lines, function(line) {
        var tmp = parseLine(line);
        if (tmp.length) {
          zips=zips.concat(tmp);
        }
      });
      $scope.input.zips = zips;
    };
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/* eslint-disable new-cap */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('EventsController', EventsController);

  /** @ngInject */
  function EventsController($scope, $filter, $feathers, toastr, collection) {

    $scope.bidderRefreshAll = {
      'service': 'events',
      'event': 'bidderReloadAll'
    };

    $scope.importSales = {
      networkId: 0,
      days: 30
    };

    $scope.startImportSales = async function () {
      if ($scope.importSales.networkId === undefined) {
        return toastr.error($filter('translate')('IMPORT SALES NETWORK REQUIRED'));
      }
      try {
        await $feathers.service('events').create({
          service: 'events',
          event: 'importSales',
          payload: $scope.importSales
        });
      } catch (e) {
        console.error('event importSales error: ', error);
        return toastr.error($filter('translate')('IMPORT SALES FAILED'));
      }
      toastr.success($filter('translate')('IMPORT SALES SUCCESSFUL'));
    };

    $scope.networks = [];

    $scope.init = async function () {
      $scope.networks = await $feathers.service('networks').find({
        query: {
          active: true,
          $paginate: false
        }
      });
      $scope.networks.push({
        id: 0,
        name: 'All Networks'
      });
    };
    $scope.init();

    $scope.submit = function() {
      $feathers.service('events').create($scope.bidderRefreshAll)
        .then(function() {
          toastr.success($filter('translate')('BIDDER RELOAD SUCCESSFUL'));
        })
        .catch(function(error){
          console.log('event bidderReloadAll error: ', error);
          toastr.success($filter('translate')('BIDDER RELOAD FAILED'));
        });
    };
  }
})();

/* eslint-disable new-cap */
/**
 * @author m.ermer
 * created on 13.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('InventoriesController', InventoriesController);

  /** @ngInject */
  function InventoriesController($scope, $feathers, toastr, $filter, $uibModal, editableOptions, editableThemes) {
    $scope.limit = 25;

    $scope.getInventories = function() {
      $feathers.service('inventories').find({
        query: {
          $paginate: false,
          parent_id: 0
        }
      })
        .then(function(result){
          $scope.inventories = result;
        });
    };
    $scope.getInventories();

    $scope.removeInventory = function(scope) {
      if (scope.$nodeScope.$modelValue) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE INVENTORY?'), {
          progressBar: true,
          onHidden: function (clicked, toast) {
            if (clicked) {
              $feathers.service('inventories').remove(scope.$nodeScope.$modelValue.id)
                .then(function() {
                  scope.remove();
                  return toastr.success($filter('translate')('INVENTORY ITEM SUCCESSFULLY DELETED'));
                })
                .catch(function(error){
                  toastr.error($filter('translate')('INVENTORY NOT DELETED BECAUSE: '+ error));
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };

    $scope.getChildren = function (parentId, searchInput) {
      if (searchInput){
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $limit: $scope.limit,
            name: {
              $ilike: '%' +  searchInput + '%'
            }
          }
        });
      } else {
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $limit: $scope.limit
          }
        });
      }
    };
    $scope.getAllChildren = function (parentId, searchInput) {
      if (searchInput){
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $paginate: false,
            name: {
              $ilike: '%' +  searchInput + '%'
            }
          }
        });
      } else {
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $paginate: false
          }
        });
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button style="margin:0 0 0 5px; color: green" type="submit" class="btn btn-default btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button style="margin:0 0 0 5px; color: red" type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm';

    $scope.createInventory = function(parent, scope) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'createInventory',
        resolve: {
          inventories: function () {
            return $scope.inventories;
          },
          parent: function(){
            return parent;
          }, isChild: function () {
            return $scope.isChild;
          }
        }
      }).closed.then(function () {
        $scope.isChild = false;
        if (parent){
          $scope.getChildren(parent.id, scope.$nodeScope.$modelValue.searchInput)
            .then(function (children) {
              scope.$nodeScope.$modelValue.nodes = children.data;
              scope.$nodeScope.$modelValue.total = children.total;
              $scope.$apply();
            });
        } else {
          $scope.getInventories();
        }

      });
    };


    $scope.customToggle = function (scope, checker) {
      if (checker) {
        if (scope.$nodeScope.collapsed) {
          $scope.getChildren(scope.$nodeScope.$modelValue.id, scope.$nodeScope.$modelValue.searchInput)
            .then(function (children) {
              scope.$nodeScope.$modelValue.nodes = children.data;
              scope.$nodeScope.$modelValue.total = children.total;
              scope.$nodeScope.toggle();
              $scope.$apply();

            });
        } else {
          delete scope.$nodeScope.$modelValue.nodes;
          delete scope.$nodeScope.$modelValue.total;
          scope.$nodeScope.toggle();
        }
      } else {
        $scope.getAllChildren(scope.$nodeScope.$modelValue.id, scope.$nodeScope.$modelValue.searchInput)
          .then(function (children) {
            scope.$nodeScope.$modelValue.nodes = children;
            scope.$nodeScope.$modelValue.total = 0;
            $scope.$apply();
          });
      }
    };
    $scope.saveNode = function(scope) {
      $feathers.service('inventories').patch(scope.$nodeScope.$modelValue.id, scope.$nodeScope.$modelValue)
        .then(function(newInventory) {
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error) {
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
          console.log(error);
        });
    };

    $scope.findNodes = function (searchInput, id, scope) {
      if (searchInput) {
        $scope.getChildren(id, searchInput)
          .then(function(children) {
            scope.$nodeScope.$modelValue.nodes = children.data;
            scope.$nodeScope.$modelValue.total = children.total;
            $scope.$apply();
            if (children.data.length === 0) {
              scope.$nodeScope.toggle();
              delete scope.$nodeScope.$modelValue.nodes;
              delete scope.$nodeScope.$modelValue.total;
              $scope.$apply();
            }
          });
        if (scope.$nodeScope.collapsed) {
          scope.$nodeScope.toggle();

        }
      } else {
        scope.$nodeScope.toggle();
        delete scope.$nodeScope.$modelValue.total;

        delete scope.$nodeScope.$modelValue.nodes;
      }
      return searchInput;
    };


    $scope.moveLastToTheBeginning = function () {
      var a = $scope.data.pop();
      $scope.data.splice(0, 0, a);
    };

    $scope.newSubItem = function (parent, scope) {
      $scope.isChild = true;
      $scope.createInventory(parent, scope);

      /* var nodeData = scope.$modelValue;
      nodeData.nodes.push({
        id: nodeData.id * 10 + nodeData.nodes.length,
        title: nodeData.title + '.' + (nodeData.nodes.length + 1),
        nodes: []
      });*/
    };

    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };
    $scope.treeOptions = {
      beforeDrop: function (scope) {
        var object =scope.source.nodeScope.$modelValue;
        var oldParent = scope.source.nodeScope.$modelValue.parent_id;
        object.parent_id = (scope.dest.nodesScope.$parent.$modelValue) ? scope.dest.nodesScope.$parent.$modelValue.id : 0;
        object.parent_id = (scope.dest.nodesScope.$parent.$modelValue) ? scope.dest.nodesScope.$parent.$modelValue.id : 0;
        $feathers.service('inventories').patch(scope.source.nodeScope.$modelValue.id,
          object)
          .then(function(res){
            if (parseInt(oldParent)!== parseInt(res.parent_id)){
              toastr.success($filter('translate')('NEW PARENT_ID SAVED'));
            }
          })
          .catch(function(){
            toastr.error($filter('translate')('SAVE NEW PARENT_ID DID NOT WORK'));
          });
      }
    };
  }
})();

/* eslint-disable new-cap */
/**
 * @author m.ermer
 * created on 13.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('LocationsController', LocationsController);

  /** @ngInject */
  function LocationsController($scope, $filter, $feathers, toastr, collection) {

    $scope.locations = new collection();
    $scope.location = {
      zip: '',
      name: '',
      ip: ''
    };

    $scope.delete = function(location) {
      if (!location._id) {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
      $feathers.service('locations').remove(location._id)
        .then(function() {
          return toastr.success($filter('translate')('LOCATION DELETED'), $filter('translate')('DELETED'));
        });
    };
    $scope.delete = function(location) {
      if (location._id) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE LOCATION?'), {
          progressBar: true,
          onHidden: function (clicked, toast) {
            if (clicked) {
              $feathers.service('locations').remove(location._id)
                .then(function() {
                  return toastr.success($filter('translate')('LOCATION DELETED'), $filter('translate')('DELETED'));
                })
                .catch(function(error){
                  console.log('remove location error: ', error);
                  toastr.error($filter('translate')('LOCATION NOT DELETED'));
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };

    $scope.submit = function() {
      if (!$scope.location.name || !$scope.location.ip || !$scope.location.zip) {
        return toastr.error($filter('translate')('PLEASE ENTER A NAME, ZIP AND IP'), $filter('translate')('CHANGES NOT SAVED'));
      }
      $scope.location.ips=[$scope.location.ip];
      delete $scope.location.ip;
      $feathers.service('locations').create($scope.location)
        .then(function() {
          $scope.location = {
            zip: '',
            name: '',
            ip: ''
          };
          toastr.success($filter('translate')('LOCATION SUCCESSFULLY CREATED'));
        })
        .catch(function(error){
          console.log('create location error: ', error);
          toastr.success($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $feathers.service('locations').find({
      query: {
        $limit: 1000
      }
    })
      .then(function(result) {
        $scope.locations.apply(result.data);
      });
    var l = $feathers.service('locations');
    l.on('created', function(location) {
      $scope.locations.update('created', location);
      $scope.$apply();
    });
    l.on('removed', function(location) {
      $scope.locations.update('removed', location);
      $scope.$apply();
    });
    l.on('updated', function(location) {
      $scope.locations.update('updated', location);
      $scope.$apply();
    });
    l.on('patched', function(location) {
      $scope.locations.update('patched', location);
      $scope.$apply();
    });
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('RequestCategoriesController', requestCategoriesController);

  /** @ngInject */
  function requestCategoriesController($scope, $filter, $feathers, hotkeys, toastr, editableOptions, editableThemes, $uibModal) {
    $scope.attributes = ['active', 'average', 'tag', 'decay'];
    $scope.init = async function() {
      $scope.requestCategories = await $feathers.service('requestcategories').find({
        query: {
          $paginate: false,
          parent: 1,
          $sort: {
            'id': 1
          }
        }
      });
    };

    $scope.init();

    $scope.addEditRequestcategory = function() {
      let modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        component: 'addEditRequestcategory',
        resolve: {
          Requestcategory: function () {
            return {
              parent: 1
            };
          }
        }
      });
      modalInstance.result.then(function(data) {
        $scope.requestCategories.push(data);
      });
    };
  }
})();

/* eslint-disable new-cap */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('PlacementGroupsController', PlacementGroupsController);

  /** @ngInject */
  function PlacementGroupsController($scope, $feathers, toastr, $filter) {
    let vm = $scope;
    let doc = document;
    $scope.npg = {
    };
    $scope.changePG={
    };
    $scope.changeI = [];
    $scope.limit = 25;
    $scope.globalSearchLimit = 100000;
    $scope.globalSearchPreviewLimit = 100;

    $scope.allPlacementGroups = [];

    $scope.totalResults = {
    };

    $scope.smartTablePageSize = 5;
    $scope.currentPage = 0;
    $scope.totalPages = 0;

    $scope.searchAllInput = '';
    $scope.isLoaded = false;

    $scope.paginate = async function(actualPage, num) {
      $scope.currentPage = actualPage + num;
      await $scope.getPlacementGroups();
      $scope.$apply();
    };

    $scope.getPlacementGroups = async function() {
      $scope.isLoaded = false;
      var number = $scope.smartTablePageSize;

      try {
        $scope.showLoadingError = false;

        let query = {
          $skip: $scope.currentPage * number,
          $limit: number,
          $sort: {
            id: -1
          }
        };

        if ($scope.searchAllInput) {
          query = {
            $skip: $scope.currentPage * number,
            $limit: number,
            $sort: {
              id: -1
            },
            name: {
              $ilike: '%' + $scope.searchAllInput  + '%'
            }
          };
        }
        $scope.placementGroups = await $feathers.service('placementgroups').find({
          query
        });

        $scope.allPlacementGroups = $scope.placementGroups.data;

        $scope.totalPages = Math.ceil($scope.placementGroups.total / $scope.smartTablePageSize);
        $scope.isLoaded = true;
        $scope.$apply();
      } catch (e) {
        $scope.showLoadingError = true;
        $scope.isLoaded = true;
      }
    };

    $scope.findNodes = async function (searchInput, id, scope) {
      if (searchInput) {
        let children = await $scope.getChildren(id, searchInput);
        if ($scope.newPlacementGroupInventories){
          for (let i = 0; i< children.data.length; i++){
            for (let m = 0; m < $scope.newPlacementGroupInventories.length; m++){
              if ($scope.newPlacementGroupInventories[m].id === children.data[i].id){
                children.data[i].include = $scope.newPlacementGroupInventories[m].include;
              }
            }
          }
        }
        scope.$nodeScope.$modelValue.nodes = children.data;
        scope.$nodeScope.$modelValue.total = children.total;
        $scope.$apply();
        if (children.data.length === 0) {
          scope.$nodeScope.toggle();
          delete scope.$nodeScope.$modelValue.nodes;
          delete scope.$nodeScope.$modelValue.total;
          $scope.$apply();
        }
        if (scope.$nodeScope.collapsed) {
          scope.$nodeScope.toggle();
        }
      } else {
        scope.$nodeScope.toggle();
        delete scope.$nodeScope.$modelValue.total;
        delete scope.$nodeScope.$modelValue.nodes;
      }
      return searchInput;
    };

    $scope.visible = function (item) {
      return !($scope.searchInput && $scope.searchInput.length > 0
        && item.name.indexOf($scope.searchInput) === -1);
    };

    async function init() {
      $scope.getPlacementGroups();
      if (!$scope.inventories) {
        $scope.inventories = await $feathers.service('inventories').find({
          query: {
            $paginate: false,
            parent_id: 0
          }
        });
      }
    }

    init();

    $scope.removeInventory = function (scope) {
      scope.remove();
    };

    $scope.getChildren = async function (parentId, searchInput) {
      if ($scope.inputOfSearchGlobal && !searchInput){
        let result = await $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $paginate: false,
            name: {
              $ilike: '%' + $scope.inputOfSearchGlobal  + '%'
            }
          }
        });
        let data = {
        };
        data.data = result;
        return Promise.resolve(data);
      } else {
        if (searchInput) {
          return $feathers.service('inventories').find({
            query: {
              parent_id: parentId,
              $limit: $scope.limit,
              name: {
                $ilike: '%' + searchInput + '%'
              }
            }
          });
        } else {
          return $feathers.service('inventories').find({
            query: {
              parent_id: parentId,
              $limit: $scope.limit
            }
          });
        }
      }
    };

    let generateTreeStructure = async function(treeData, key, parentKey) {
      let keys = [];
      treeData.map(function(x){
        x.nodes = [];
        keys.push(x[key]);
      });
      let roots = treeData.filter(function(x){
        return keys.indexOf(x[parentKey])===-1;
      });
      let nodes = [];
      roots.map(function(x){
        nodes.push(x);
      });
      while (nodes.length > 0) {

        let node = nodes.pop();
        let children =  treeData.filter(function(x){
          return x[parentKey] === node[key];
        });
        children.map(function(x){
          node.nodes.push(x);
          nodes.push(x);
        });
      }
      $scope.$apply();

      if (roots.length===1) {
        return roots[0];
      }
      return roots;
    };

    $scope.searchAll = async function(searchInput) {
      $scope.searchAllInput = searchInput;
      $scope.currentPage = 0;
      await $scope.getPlacementGroups();
    };

    $scope.findGlobal = async function(searchInput, restrict) {
      $scope.ignoringPlacements = false;
      $scope.inputOfSearchGlobal = null;
      let loadingIcons = angular.element(doc.getElementsByClassName('loader'));
      let showPlacement = true;
      let query;
      $scope.allLoaded = false;
      if (restrict){
        query = {
          $paginate: false,
          name: {
            $ilike: '%' + searchInput + '%'
          },
          $limit: $scope.globalSearchPreviewLimit,
        };
      } else {
        $scope.allLoaded = true;
        query = {
          $paginate: false,
          name: {
            $ilike: '%' + searchInput + '%'
          }
        };
      }
      try {
        if (searchInput) {
          $scope.inputOfSearchGlobal = searchInput;
          _.each(loadingIcons, function (c) {
            c.style.visibility = 'visible';
          });
          let tempInventories = [];
          $scope.totalResults = await $feathers.service('inventories').find({
            query: {
              name: {
                $ilike: '%' + searchInput + '%'
              },
              $limit: 0
            }
          });
          let results = await $feathers.service('inventories').find({
            query: query
          });
          if (results.length <= 0) {
            toastr.error($filter('translate')('NO SEARCH RESULT'));
          } else {
            $scope.ignoringPlacements = true;
            // Check if searchresult length is to big and restrict the search
            // so kind placementgroup is excluded
            if (results.length > $scope.globalSearchLimit) {
              toastr.error($filter('translate')('SEARCH RESULT IS TOO BIG. HIDING ALL ITEMS OF KIND PLACEMENT'));
              query.kind = {
                $ne: 'placement'
              };
              results = await $feathers.service('inventories').find({
                query: query
              });
              showPlacement = false;
            }
            let tempAlreadyExistingNodes = [];
            if (results.length > 0 && results.length <= $scope.globalSearchLimit) {
              for (let result of results) {
                result.total = $scope.totalResults.total;
                let parent = result;
                let parentAlreadyInTempInventories = false;
                for (let i = 0; i < tempInventories.length; i++) {
                  if (tempInventories[i].id === parent.id) {
                    parentAlreadyInTempInventories = true;
                    break;
                  }
                }
                if (!parentAlreadyInTempInventories) {
                  tempInventories.push(parent);
                }
                while (parent.parent_id !== '0') {
                  if (tempAlreadyExistingNodes[parent.parent_id] !== undefined){
                    parent = tempAlreadyExistingNodes[parent.parent_id];
                  } else {
                    parent = await $feathers.service('inventories').get(parent.parent_id);
                    tempAlreadyExistingNodes[parent.id] = parent;
                  }
                  let parentsTotalAlreadyInTempInventories = false;
                  for (let i = 0; i < tempInventories.length; i++) {
                    if (tempInventories[i].id === parent.id) {
                      tempInventories[i].total = $scope.totalResults.total;
                      parentsTotalAlreadyInTempInventories = true;
                      break;
                    }
                  }
                  if (!parentsTotalAlreadyInTempInventories) {
                    tempInventories.push(parent);
                  }
                }
              }
              let root = await generateTreeStructure(tempInventories, 'id', 'parent_id');
              if (Array.isArray(root)) {
                $scope.inventories = root;
              } else {
                $scope.inventories = [];
                $scope.inventories.push(root);
              }
              $scope.$apply();
              $scope.expandAfterGlobalSearch(showPlacement, true);
              $scope.$apply();
            } else {
              toastr.error($filter('translate')('SEARCH RESULT IS STILL TOO BIG. RESTRICT YOUR SEARCH'));
            }
          }
        } else {
          $scope.inventories = await $feathers.service('inventories').find({
            query: {
              $paginate: false,
              parent_id: 0
            }
          });
          $scope.$apply();
        }
      } catch (e) {
        console.log('findglobal ', e);
      } finally {
        _.each(loadingIcons, function (c) {
          c.style.visibility = 'hidden';
        });
      }
    };

    $scope.collapseNodes = function (array, isAlreadyCollapsed){
      _.each(array, function (c) {
        if (isAlreadyCollapsed) {
          c.expand();
        } else {
          c.collapse();
        }
      });
    };

    $scope.expandAfterGlobalSearch = function(showPlacement, isAlreadyCollapsed){
      let uiTreeScope = angular.element(doc.getElementById('tree-root')).scope();
      let childNodes = uiTreeScope.$nodesScope.childNodes();
      $scope.collapseNodes(childNodes, isAlreadyCollapsed);
      if (childNodes && childNodes.length > 0) {
        for (let childNodeElement of childNodes) {
          let grandChildNodes = childNodeElement.$childNodesScope.$nodeScope.childNodes();
          $scope.collapseNodes(grandChildNodes, isAlreadyCollapsed);
          if (grandChildNodes && grandChildNodes.length > 0 && showPlacement) {
            for (let grandChildNodeElement of grandChildNodes) {
              let grandGrandChildNodes = grandChildNodeElement.$childNodesScope.$nodeScope.childNodes();
              $scope.collapseNodes(grandGrandChildNodes, isAlreadyCollapsed);
            }
          }
        }
      }
    };

    $scope.getAllChildren = async function (parentId, searchInput) {
      if (searchInput){
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $paginate: false,
            name: {
              $ilike: '%' +  searchInput + '%'
            }
          }
        });
      } else {
        return $feathers.service('inventories').find({
          query: {
            parent_id: parentId,
            $paginate: false
          }
        });
      }
    };

    $scope.addInventories = function (inventory, include) {
      let changeStatus = false;
      let createNew = false;
      if (inventory.include !== include) {
        inventory.include = include;
        let newInventory = {
          id: inventory.id,
          name: inventory.name,
          inventory_id: inventory.id,
          active: inventory.active,
          include: include,
          inventory: inventory,
          kind: inventory.kind,
          depth: inventory.depth
        };
        if ($scope.newPlacementGroupInventories.length > 0) {
          for (let i = 0; i < $scope.newPlacementGroupInventories.length; i++) {
            if (inventory.id === $scope.newPlacementGroupInventories[i].inventory_id) {
              if ($scope.newPlacementGroupInventories[i].include !== include) {
                changeStatus = true;
              }
            } else {
              createNew = true;
            }
          }
          if (changeStatus) {
            for (let k = 0; k < $scope.newPlacementGroupInventories.length; k++) {
              if ($scope.newPlacementGroupInventories[k].inventory_id === inventory.id) {
                $scope.newPlacementGroupInventories[k].include = include;
                $scope.newPlacementGroupInventories[k].inventory.include = include;
              }
            }
          } else if (createNew) {
            $scope.newPlacementGroupInventories.push(newInventory);
          }
        } else {
          $scope.newPlacementGroupInventories.push(newInventory);
        }
      } else {
        delete inventory['include'];
        for (let x = 0; x < $scope.newPlacementGroupInventories.length; x++) {
          if ($scope.newPlacementGroupInventories[x].inventory_id === inventory.id) {
            $scope.newPlacementGroupInventories.splice(x, 1);
            x--;
          }
        }
      }
    };

    function changeInclude(theObject, id){
      let result = null;
      if (theObject instanceof Array) {
        for (let i = 0; i < theObject.length; i++) {
          result = changeInclude(theObject[i], id);
          if (result) {
            break;
          }
        }
      } else {
        for (let prop in theObject) {
          if (prop === 'id') {
            if (theObject[prop] === id) {
              theObject.include= !theObject.include;
              return theObject;
            }
          }
          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = changeInclude(theObject[prop], id);
            if (result) {
              break;
            }
          }
        }
      }
      return result;
    }

    function resetInclude(theObject, id) {
      let result = null;
      if (theObject instanceof Array) {
        for (let i = 0; i < theObject.length; i++) {
          result = resetInclude(theObject[i], id);
          if (result) {
            break;
          }
        }
      } else {
        for (let prop in theObject) {
          if (prop === 'id') {
            if (theObject[prop] === id) {
              delete theObject['include'];
              return theObject;
            }
            if (!id && theObject.hasOwnProperty('include')){
              delete theObject['include'];
            }
          }
          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = resetInclude(theObject[prop], id);
            if (result) {
              break;
            }
          }
        }
      }
      return result;
    }

    $scope.changeInventories = function (inventory, boolean) {
      if (inventory.include !== boolean) {
        changeInclude($scope.inventories, inventory.inventory_id);
        for (let i = 0; i < $scope.newPlacementGroupInventories.length; i++) {
          if ($scope.newPlacementGroupInventories[i].inventory_id === inventory.inventory_id) {
            $scope.newPlacementGroupInventories[i].include = boolean;
            $scope.newPlacementGroupInventories[i].inventory.include = boolean;
          }
        }
      } else {
        for (let i = 0; i < $scope.newPlacementGroupInventories.length; i++) {
          if ($scope.newPlacementGroupInventories[i].inventory_id === inventory.inventory_id) {
            $scope.newPlacementGroupInventories.splice(i, 1);
            i--;
          }
        }
        resetInclude($scope.inventories, inventory.inventory_id);
        for (let m = 0; m < $scope.inventories.length; m++) {
          if ($scope.inventories[m].id === inventory.inventory_id) {
          }
        }
      }
    };

    $scope.createPlacementGroup = function() {
      $scope.editMode = true;
      $scope.newPlacementGroupInventories = [];
      $scope.npg = {
      };
      resetInclude($scope.inventories, null);
    };

    $scope.customToggle = async function (scope, amountIsLimited) {
      // Check if globalSearchInput has an value,
      // when yes than the left toggle button doesnt search new items in the database
      if ($scope.ignoringPlacements && scope.$nodeScope.$modelValue.kind !== 'domain'){
        scope.$nodeScope.toggle();
      } else {
        if (amountIsLimited) {
          if (scope.$nodeScope.collapsed) {
            let children = await $scope.getChildren(scope.$nodeScope.$modelValue.id, await scope.$nodeScope.$modelValue.searchInput || $scope.inputOfSearchGlobal);
            if ($scope.newPlacementGroupInventories) {
              for (let i = 0; i < children.data.length; i++) {
                for (let m = 0; m < $scope.newPlacementGroupInventories.length; m++) {
                  if ($scope.newPlacementGroupInventories[m].inventory_id === children.data[i].id) {
                    children.data[i].include = $scope.newPlacementGroupInventories[m].include;
                  }
                }
              }
            }
            scope.$nodeScope.$modelValue.nodes = children.data;
            scope.$nodeScope.$modelValue.total = children.total;
            scope.$nodeScope.toggle();
            $scope.$apply();
          } else {
            delete scope.$nodeScope.$modelValue.nodes;
            delete scope.$nodeScope.$modelValue.total;
            scope.$nodeScope.toggle();
          }
        } else {
          let children = await $scope.getAllChildren(scope.$nodeScope.$modelValue.id, await scope.$nodeScope.$modelValue.searchInput || $scope.inputOfSearchGlobal);
          if ($scope.newPlacementGroupInventories) {
            for (let i = 0; i < children.length; i++) {
              for (let m = 0; m < $scope.newPlacementGroupInventories.length; m++) {
                if ($scope.newPlacementGroupInventories[m].id === children[i].id) {
                  children[i].include = $scope.newPlacementGroupInventories[m].include;
                }
              }
            }
          }
          scope.$nodeScope.$modelValue.nodes = children;
          scope.$nodeScope.$modelValue.total = 0;
          $scope.$apply();
        }
      }
    };

    $scope.allPlacementGroupsToggle = function(scope) {
      if (scope.$nodeScope.$modelValue.inventories && scope.$nodeScope.$modelValue.inventories.length > 0){
        scope.$nodeScope.toggle();
      }
    };

    $scope.nodeIsIncluded = function (node) {
      let find = $scope.newPlacementGroupInventories.find(inventory => inventory.inventory.id === node.id);
      if (find) {
        return find.include;
      }
    };

    $scope.getDepth = function (node) {
      if (node && !node.length > 0) {
        switch (node.kind || node.inventory.kind) {
        case 'network':
          return 1;
        case 'publisher':
          return 2;
        case 'domain':
          return 3;
        case 'placement':
          return 4;
        default:
          return 0;
        }
      }
    };


    $scope.moveLastToTheBeginning = function () {
      let a = $scope.data.pop();
      $scope.data.splice(0, 0, a);
    };

    $scope.newSubItem = function (scope) {
      let nodeData = scope.$modelValue;
      nodeData.nodes.push({
        id: nodeData.id * 10 + nodeData.nodes.length,
        title: nodeData.title + '.' + (nodeData.nodes.length + 1),
        nodes: []
      });
    };

    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };
    $scope.remove = function (scope) {
      scope.remove();
    };


    $scope.saveNewPlacementGroup = async function() {
      if (! $scope.npg.name) {
        toastr.error($filter('translate')('PLEASE ENTER A NAME'));
      }
      if (!$scope.newPlacementGroupInventories.length) {
        toastr.error($filter('translate')('PLEASE SELECT AT LEAST ONE INVENTORY ITEM'));
      }
      if ($scope.npg.id) {
        let placementGroup = await $feathers.service('placementgroups').patch($scope.npg.id, {
          name: $scope.npg.name
        });
        let inventories = await $feathers.service('placementgroups2inventories').find({
          query: {
            placementgroup_id: placementGroup.id,
            $paginate: false
          }
        });
        for (let inventory of $scope.newPlacementGroupInventories) {
          let exists = inventories.find(i => i.inventory_id===inventory.inventory.id);
          if (exists) {
            if (exists.include !== inventory.include) {
              await $feathers.service('placementgroups2inventories').patch(exists.id, {
                include: inventory.include
              });
            }
            // unchanged, remove from inventories array, so we later know which ones never exist
            inventories.splice(inventories.indexOf(exists), 1);
          } else {
            await $feathers.service('placementgroups2inventories').create({
              placementgroup_id: placementGroup.id,
              include: inventory.include,
              active: true,
              inventory_id: inventory.inventory.id
            });
          }
        }
        await $feathers.service('placementgroups2inventories').remove(null, {
          query: {
            id: {
              $in:
                  inventories.map(inventory => parseInt(inventory.id))
            }
          }
        });
        $scope.getPlacementGroups();
        toastr.success($filter('translate')('PLACEMENTGROUP SUCCESSFULLY CHANGED'));
        $scope.editMode = false;
        resetInclude($scope.inventories, null);
        $scope.npg = {
        };
        delete $scope.newPlacementGroupInventories;
      } else {
        let placementGroup = await $feathers.service('placementgroups').create({
          name: $scope.npg.name,
          active: true
        });
        let successMessage = true;
        _.forEach($scope.newPlacementGroupInventories, function(pG) {
          delete pG.inventory['depth'];
          $feathers.service('placementgroups2inventories').create({
            placementgroup_id: placementGroup.id,
            include: pG.include,
            active: true,
            inventory_id: pG.inventory.id,
            inventory: pG.inventory
          });
          try {
            $scope.getPlacementGroups();
            $scope.editMode = false;
            resetInclude($scope.inventories, null);
            $scope.npg = {
            };
          } catch (error) {
            console.log(error);
            successMessage = false;
          }
        });
        if (successMessage){
          toastr.success($filter('translate')('PLACEMENTGROUP SUCCESSFULLY CREATED'));
        } else {
          toastr.error($filter('translate')('PlACEMENTGROUP NOT CREATED'));
        }
        delete $scope.newPlacementGroupInventories;
      }
    };

    $scope.changePlacementGroup = async function(placementGroup, placementGroupName){
      $feathers.service('placementgroups2inventories').remove(null, {
        query: {
          placementgroup_id: placementGroup.id
        }
      });
      if (placementGroup) {
        $feathers.service('placementgroups').patch(placementGroup.id, {
          name: placementGroupName,
          active: true
        });
        _.forEach(newPlacementGroup, function(pG) {
          delete pG.inventory['depth'];
          $feathers.service('placementgroups2inventories').create({
            placementgroup_id: placementGroup.id,
            include: pG.include,
            active: true,
            inventory_id: pG.inventory.id,
            inventory: pG.inventory
          });
          try {
            toastr.success($filter('translate')('PLACEMENTGROUP SUCCESSFULLY CHANGED'));
            $scope.getPlacementGroups();
            $scope.editMode = false;
            resetInclude($scope.inventories, null);
            $scope.npg = {
            };
          } catch (error) {
            toastr.error($filter('translate')('PlACEMENTGROUP NOT CHANGED'));
            console.log(error);
          }
        });
        delete $scope.newPlacementGroupInventories;
      } else {
        toastr.error($filter('translate')('PLEASE ENTER A NAME'));
      }
    };

    $scope.editPlacementGroup = function(placementGroup){
      vm.editMode = true;
      vm.npg = placementGroup;
      vm.newPlacementGroupInventories = placementGroup.inventories.map(function(inventory) {
        inventory.name = inventory.inventory.name;
        inventory.kind = inventory.inventory.kind;
        return inventory;
      });
    };

    $scope.remove = function (scope) {
      scope.remove();
    };


    $scope.treeOptions = {
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .directive('nodesList', nodesList);

  /** @ngInject */
  function nodesList(RecursionHelper) {
    return {
      restrict: 'E',
      requre: 'nodesList',
      templateUrl: 'app/pages/settings/placementgroups/nodes_list.html',
      scope: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .directive('nodesRenderer', nodesRenderer);

  /** @ngInject */
  function nodesRenderer(RecursionHelper) {
    return {
      restrict: 'E',
      requre: 'nodesRenderer',
      templateUrl: 'app/pages/settings/placementgroups/nodes_renderer.html',
      scope: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .directive('nodesSelected', nodesSelected);

  /** @ngInject */
  function nodesSelected(RecursionHelper) {
    return {
      restrict: 'E',
      requre: 'nodesSelected',
      templateUrl: 'app/pages/settings/placementgroups/nodes_selected.html',
      scope: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('SettingsTemplatesController', SettingsTemplatesController);

  /** @ngInject */
  function SettingsTemplatesController($rootScope, $scope, $filter, $feathers, toastr, editableOptions, editableThemes, wizardTypes) {
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    $scope.template = {
      active: true,
      code: '',
      name: '',
      engine: 'pug',
      kind: 'admedia',
      options: null
    };
    $scope.wizardTypes = wizardTypes;
    async function loadTemplates () {
      $scope.templates = await $feathers.service('templates').find({
        query: {
          $paginate: false
        }
      });
      $scope.$apply();
    }

    $rootScope.$pageLoadingController = true;
    loadTemplates().then(() => {
      $rootScope.$pageLoadingController = false;
    });
    $scope.submit = async function() {
      if (!$scope.template.name || !$scope.template.kind || !$scope.template.engine || !$scope.template.code) {
        return toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'), $filter('translate')('NOT SAVED'));
      }
      try {
        if ($scope.template.options && !$scope.template.options.wizardTypes){
          delete $scope.template.options;
        }
        let result = await $feathers.service('templates').create($scope.template);
        $scope.template = {
          active: true,
          code: '',
          name: '',
          engine: 'pug',
          kind: 'admedia',
          options: null
        };
        $scope.templates.push(result);
        toastr.success($filter('translate')('TEMPLATE SUCCESSFULLY CREATED'));
      } catch (e) {
        console.log(e);
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.optionsChanged = function(template) {
      if (template) {
        template.optionsChanged = true;
      }
    };

    $scope.saveTemplate = async function(template){
      if (template.id) {
        if (template.options && !template.options.wizardType){
          template.options = null;
        }
        delete template.optionsChanged;
        try {
          let result = await $feathers.service('templates').patch(template.id, template);
          return toastr.success($filter('translate')('CHANGES SAVED'));
        } catch (e) {
          console.log('error', e);
          return toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
  }

})();

/**
 * Created by frank on 18.08.17.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.todos')
    .controller('TodosListController', TodosListController);

  /** @ngInject */
  function TodosListController($rootScope, $state, $scope, $filter, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.todos = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.formatLinkName = function(todo) {
      let expression = todo.todotype.service_name.toLowerCase();
      switch (expression) {
      case 'ads':
        return ' Ad';
      default:
        return '';
      }
    };

    $scope.linkToServiceName = function() {
      if ($scope.todos){
        for (let todo of $scope.todos){
          let expression = todo.todotype.service_name.toLowerCase();
          switch (expression) {
          case 'ads':
            todo.link_service = `ads.detail({id:${todo.element_id}})`;
            break;
          default:
            todo.link_service = null;
            break;
          }
        }
      }
    };

    $scope.trimString = function(string, maxLength){
      if (string && string.length >0 ) {
        if (string.length < maxLength) {
          return string;
        } else {
          let result = string.substring(0, maxLength);
          result += '  ...';
          return result;
        }
      } return '';
    };

    $scope.getTodos = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      $scope.formatDateTime = function (dateTime){
        return moment(dateTime).format('LLL');
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'editing_user_id') {
            query.query.editing_user_id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('todos').find(query)
        .then(function(result) {
          $scope.todos = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.linkToServiceName();
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };
  }

})();

/**
 * Created by frank on 18.08.17.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.todos')
    .controller('TodosDetailController', TodosDetailController);

  function TodosDetailController($rootScope, $scope, $stateParams, $state, $feathers, $filter, $sce, editableOptions, editableThemes, toastr) {
    $scope.insertionorder = {
      options: {
      }
    };
    $scope.todo = {
    };

    $scope.status = {
      progress: 'PROGRESS',
      done: 'DONE',
    };

    $scope.getEditingUserInformation = async function () {
      try {
        return await $feathers.service('users').get($scope.todo.editing_user_id);
      } catch (error) {
        return $scope.todo.editing_user_id;
      }
    };

    $scope.formatLinkName = function (todo) {
      let expression = $scope.todo.todotype.service_name.toLowerCase();
      switch (expression) {
      case 'ads':
        return ` Ad Nr. ${$scope.todo.element_id}`;
      default:
        return '';
      }
    };

    $scope.saveChanges = async function () {
      try {
        let result = await $feathers.service('todos').patch($stateParams.id, {
          comment: $scope.todo.comment
        });
        $scope.debug = JSON.stringify($scope.todo, null, 2);
        toastr.success($filter('translate')('TODO COMMENT CHANGED'));
        $scope.$apply();
      } catch (error) {
        console.error(error);
        toastr.error($filter('translate')('THE TODO YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
        $state.go('todos.all');
      }
    };

    $scope.changeStatus = async function (status) {
      try {
        if (Object.values($scope.status).includes(status)) {
          let result = await $feathers.service('todos').patch($stateParams.id, {
            status: status
          });
          const tempTodoType = $scope.todo.todotype;
          $scope.todo = result;
          $scope.todo.todotype = tempTodoType;
          $scope.todo.user = await $scope.getEditingUserInformation();
          $scope.linkToServiceName();
          $scope.debug = JSON.stringify($scope.todo, null, 2);
          toastr.success($filter('translate')('TODO STATUS CHANGED'));
          $scope.$apply();
        } else {
          toastr.error($filter('translate')('TODO STATUS FALSE'), $filter('translate')('ERROR'));
        }
      } catch (error) {
        console.error(error);
        toastr.error($filter('translate')('THE TODO YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
        $state.go('todos.all');
      }

    };

    $scope.linkToServiceName = function () {
      if ($scope.todo) {
        let expression = $scope.todo.todotype.service_name.toLowerCase();
        switch (expression) {
        case 'ads':
          $scope.todo.link_service = `ads.detail({id:${$scope.todo.element_id}})`;
          break;
        default:
          $scope.todo.link_service = null;
          break;
        }
      }
    };

    $scope.initFunction = async function () {
      if ($stateParams.id && $stateParams.id !== 'new') {
        try {
          $scope.todo = await $feathers.service('todos').get($stateParams.id);
          $scope.debug = JSON.stringify($scope.ad, null, 2);
          if ($scope.todo.editing_user_id) {
            $scope.todo.user = await $scope.getEditingUserInformation();
          } else {
            $scope.todo.user = null;
          }
          $scope.linkToServiceName();
          $scope.$apply();
        } catch (error) {
          console.error(error);
          toastr.error($filter('translate')('THE TODO YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('todos.all');
        }
      }
    };

    $scope.initFunction();

  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tools')
    .controller('ToolsBeautifyController', ToolsBeautifyController);

  /** @ngInject */
  function ToolsBeautifyController($scope) {

    $scope.code = {
      unbeautified: '',
      beautified: ''
    };

    $scope.$watchGroup(['code.unbeautified'], function() {
      if ($scope.code.unbeautified.match(/html/) || $scope.code.unbeautified.match(/body/)) {
        $scope.code.beautified = html_beautify($scope.code.unbeautified);
      } else {
        $scope.code.beautified = js_beautify($scope.code.unbeautified);
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tools')
    .controller('ToolsTaggenController', ToolsTaggenController);

  /** @ngInject */
  function ToolsTaggenController($scope, $stateParams, $feathers) {

    $scope.tag = {
      ids: [],
      hash: $stateParams.hash||'',
      out: ''
    };
    $scope.parseHash = function() {
      $feathers.service('tagids').get($scope.tag.hash)
        .then(function(result) {
          $scope.tag.ids = result.ids;
          $scope.$apply();
        });
    };
    if ($scope.tag.hash) {
      $scope.parseHash();
    }

    $scope.generateHash = function() {
      $feathers.service('tagids').create({
        ids: $scope.tag.ids
      })
        .then(function(result) {
          $scope.tag.hash = result.hash;
          $scope.$apply();
        });
    };

    $scope.$watchGroup(['tag.hash'], function() {
      var codes = '';
      codes += '//Minimalistic Tag:\n';
      codes += '<script src="//a.df-srv.de/v2/view/'+$scope.tag.hash+'/a.js"></script>';
      codes += '\n';
      codes += '\n';
      codes += '//Better Tag:\n';
      codes += '<script id="'+$scope.tag.hash+'" src="//a.df-srv.de/v2/view/'+$scope.tag.hash+'/a.js?random=[timestamp]"></script>';
      codes += '\n';
      codes += '\n';
      codes += '//SMART Tag:\n';
      codes += '<script id="'+$scope.tag.hash+'" src="//a.df-srv.de/v2/view/'+$scope.tag.hash+'/a.js?random=[timestamp]&redirect2enc=[countgo]"></script>';
      codes += '\n';
      codes += '/*\n';
      codes += 'Additional Parameters:\n';
      codes += '  random: Random Number/Timestamp\n';
      codes += '  redirect2enc: Clicktracker that expects encoded URL at the end\n';
      codes += '  redirect2unenc: Clicktracker that expects plain URL at the end\n';
      codes += '  sync: Set to "dontusethis" to serve ad synchronous using document.write\n';
      codes += '*/\n';
      codes += '\n';
      codes += '//Async Tag (Experimental):\n';
      codes += '<script id="BLbeA0KDyU89muG4qODW"> \n';
      codes += 'var s=document.createElement("script"); \n';
      codes += 's.src="//a.df-srv.de/v2/view/BLbeA0KDyU89muG4qODW/a.js?_rnd="+Math.floor(Math.random()*100000000);\n';
      codes += 'var p=document.currentScript||document.getElementById("BLbeA0KDyU89muG4qODW"); \n';
      codes += 'p.parentNode.insertBefore(s, p.nextSibling);\n';
      codes += '</script>';
      $scope.tag.out=codes;


    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tools')
    .controller('ToolsUploadController', ToolsUploadController);

  /** @ngInject */
  function ToolsUploadController($scope, $stateParams, $feathers, feathersSettings) {
    $scope.uploaded = [];
    $scope.dzOptions = {
      url: feathersSettings.endpointUrl + '/files',
      paramName: 'uri',
      maxFilesize: '200',
      acceptedFiles: 'image/gif, image/jpeg, images/jpg, image/png, application/zip',
      addRemoveLinks: false,
      uploadMultiple: false,
      parallelUploads: 1,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + $feathers.get('token')
      },
      init: function(){
        this.on('uploadprogress', function(file, progress){
          console.log('progresss', progress);
        });
      }
    };


    // Handle events for dropzone
    // Visit http://www.dropzonejs.com/#events for more events
    $scope.dzCallbacks = {
      'addedfile': function(file){
        console.log(file);
        $scope.newFile = file;
      },
      'success': function(file, xhr){
        console.log(file, xhr);
        xhr.name = file.name;
        $scope.uploaded.push(xhr);
        $scope.$apply();
      }
    };


    // Apply methods for dropzone
    // Visit http://www.dropzonejs.com/#dropzone-methods for more methods
    $scope.dzMethods = {
    };
    $scope.removeNewFile = function(){
      $scope.dzMethods.removeFile($scope.newFile); // We got $scope.newFile from 'addedfile' event callback
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.users')
    .controller('UsersListController', UsersListController);

  /** @ngInject */
  function UsersListController($scope, $feathers, hotkeys, toastr) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.ads = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.toggle = function(user) {
      $feathers.service('users').patch(user.id, {
        active: !user.active
      })
        .then(function(err, res) {
          console.log('user updated', err, res);
        });
    };
    $scope.resetPassword = function(user) {
      $feathers.service('authManagement').create({
        'action': 'sendResetPwd',
        'value': {
          'username': user.username
        }
      })
        .then(function(err, res) {
          if (err) {
            console.log(err);
          }
          toastr.success('New Password sent.', 'Saved!');
        });
    };

    $scope.getAds = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: {
            adrequestdesires: false,
            adbase: true
          }
          // kind: 'datafactor'
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('users').find(query)
        .then(function(result) {
          $scope.ads = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.users')
    .controller('UsersDetailController', UsersDetailController);

  /** @ngInject */
  function UsersDetailController(toastr, $filter, $scope, $stateParams, $state, $feathers) {
    $scope.debug=JSON.stringify($stateParams);
    $scope.user = {
      permissions: [],
      groups: []
    };

    $feathers.service('publishers').find({
      query: {
        $limit: 100
      }
    })
      .then(function (result) {
        $scope.publishers = result.data;
      });

    $scope.save = function() {
      delete $scope.user.isVerified;
      $feathers.service('users').patch($stateParams.id, $scope.user)
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };
    if ($stateParams.id){
      $feathers.service('users').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.username;
          $scope.user = result;
          $scope.user.groups = $scope.user.groups ||[];
          $scope.user.permissions = $scope.user.permissions ||[];
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE USER YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('users.list');
        });
      $feathers.service('users').on('updated', function(){
      });
    }

    $scope.savePermissions = function() {
      $feathers.service('users').patch($scope.user.id, {
        permissions: $scope.user.permissions
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveGroups = function() {
      $feathers.service('users').patch($scope.user.id, {
        groups: $scope.user.groups
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createUser = function(){
      if ($scope.user.publisher_id && $scope.user.firstname && $scope.user.lastname && $scope.user.username && $scope.user.email && $scope.user.roles) {
        $feathers.service('users').create($scope.user)
          .then(function(user){
            toastr.success($filter('translate')('USER SUCCESSFULLY CREATED'));
            $state.go('users.detail', {
              id: user.id
            });
          })
          .catch(function(error){
            toastr.error($filter('translate')('NOT SAVED'));
            console.log('error', error);
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
    .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({
    }, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .factory('baPanel', ['$window', baPanel]);

  /** @ngInject */
  function baPanel($window) {

    /** Base baPanel directive */
    return {
      restrict: 'AE',
      transclude: true,
      scope: {
        options: '='
      },
      template: function (elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.options) {
          var titleTpl = '<div class="panel-heading"><h3 class="panel-title pull-left">{{options.title}}</h3>';
          titleTpl += '<a ng-repeat="button in options.buttons" title="{{button.title}}" class="panel-functionality" ng-click="button.click($event)" alt="{{button.title}}"><i class="{{button.icon}}"></i> {{windowSize > 845 ? button.title: ""}}</a>';
          res = titleTpl + '</div>' + res;
        } else if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading"><h3 class="panel-title pull-left">' + attrs.baPanelTitle + '</h3>';
          if (attrs.baPanelNewTitle) {
            titleTpl += '<a class="panel-functionality" ng-click=' + attrs.baPanelNewClick + '><i class="' + (attrs.baPanelNewIcon ? attrs.baPanelNewIcon : 'ion-plus-round') + '"></i> ' + attrs.baPanelNewTitle + '</a>';
          }
          res = titleTpl + '</div>' + res; // title should be before
        }
        return res;
      },
      link: function (scope, elem, attrs) {
        scope.windowSize = 900;
        angular.element($window).on('resize', function () {
          scope.windowSize = $window.innerWidth;
        });
        if (attrs.baPanelNewClick) {
          // legacy function pass trough
          // TODO remove once unused
          scope[attrs.baPanelNewClick.slice(0, -2)] = scope.$parent[attrs.baPanelNewClick.slice(0, -2)];
        }
        scope.windowsize = 0;
      },
    }
  }
})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if (!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if (elemW <= 640) {
        return;
      }
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return {
        width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2
      };
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
    .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({
    }, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  // eslint-disable-next-line angular/controller-name
  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, $http, feathersSettings) {
    $scope.appVersion = 'APP N/A';
    $scope.apiVersion = 'API N/A';
    $http.get('version.json').then((data) => {
      $scope.appVersion = 'APP ' +  data.data.raw;
    }, error => {
      console.log('error get appVersion: ', error);
    });

    $http.get(feathersSettings.endpointUrl + '/info').then((data) => {
      $scope.apiVersion = data.data.title + ' ' + data.data.version;
    }, error => {
      console.log('error get apiVersion: ', error);
    });

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed);
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes, principal) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .filter(function(s) {
              return (s && s.data && s.data.roles && s.data.roles.length && principal.isInAnyRole(s.data.roles));
            })
            .filter(function(s) {
              return typeof s.visible === 'undefined' || (typeof s.visible === 'boolean' && s.visible === true) || (typeof s.visible === 'function' && s.visible() === true);
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                tooltip: s.tooltip,
                level: (s.name.match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                img: meta.img,
                stateRef: s.name,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baSidebarToggleMenu', baSidebarToggleMenu)
    .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
    .directive('baSidebarTogglingItem', baSidebarTogglingItem)
    .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
    .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
    .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() {
        console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu');
      };
      vm.$$collapseSubmenu = function() {
        console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu');
      };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
          vm.$collapse() :
          vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
        return state.name.split('.')[0].indexOf(subItemState.split('.')[0]) == 0;
      });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() {
          el.slideDown();
        };
        baSidebarTogglingItem.$$collapseSubmenu = function() {
          el.slideUp();
        };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    };
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {
      return vm.tabNum;
    }), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1);
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1);
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl: 'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }
        moment()
        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('MsgCenterCtrl', MsgCenterCtrl);



  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, $feathers) {
    $scope.numberUnreadNotifications = 0;

    $scope.maxNotificationsShowLimit = 5;

    $scope.notifications = [];

    $scope.notificationViewedAll = async function(id){
      try {
        const foundIndex = await $scope.notifications.findIndex( item => item.id === id);
        if (foundIndex >= 0) {
          $scope.notifications[foundIndex].read = true;
        }
        $scope.$apply();
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.notificationViewed = async function(id){
      try {
        await $feathers.service('notifications').patch(id, {
          read: true,
        });
        $scope.$apply();
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.getNotifications = async function(){
      $scope.notifications = await $feathers.service('notifications').find({
        query: {
          $sort : {id: -1},
          $limit: $scope.maxNotificationsShowLimit,
          $paginate: false
        }
      });
      const unreadNotifications = await $feathers.service('notifications').find({
        query: {
          $limit: 0,
          read: false
        }
      });
      $scope.numberUnreadNotifications = unreadNotifications.total;
      $scope.$apply();
    };

    $scope.getUnreadNotificationsCount = async function (){
      const unreadNotifications = await $feathers.service('notifications').find({
        query: {
          $limit: 0,
          read: false
        }
      });
      $scope.numberUnreadNotifications = unreadNotifications.total;
      $scope.$apply();
    };

    $scope.patchedNotification = async function (notification){
      const foundIndex = await $scope.notifications.findIndex( item => item.id === notification.id);
      if (foundIndex >= 0) {
        $scope.notifications[foundIndex] = notification;
        await $scope.getUnreadNotificationsCount();
      }
      $scope.$apply();
    };

    $scope.deletedNotification = async function (notification){
      const foundIndex = await $scope.notifications.findIndex( item => item.id === notification.id);
      if (foundIndex >= 0) {
        delete $scope.notifications[foundIndex];
        await $scope.getUnreadNotificationsCount();
      }
      $scope.$apply();
    };

    $scope.patchedAllNotificationToRead = async function(notification){
      const foundIndex = await $scope.notifications.findIndex( item => item.id === notification.id);
      if (foundIndex >= 0) {
        $scope.notifications[foundIndex].read = true;
        await $scope.getUnreadNotificationsCount();
      }
      $scope.$apply();
    };

    $scope.formatDateTime = function (dateTime){
      return moment(dateTime).format('LLL');
    };

    $scope.sortArray = function sortFunction(a,b){
      var dateA = new Date(a.created);
      var dateB = new Date(b.created);
      return dateA > dateB ? -1 : 1;
    };

    $scope.markAllNotificationsAsRead = async function (){
      let result =  await $feathers.service('notifications').patch(null, {
        'read': true
      }, {
        query: {
          read: false,
          $select: ['id', 'user_id']
        }
      });
      for (let item of result){
        await $scope.notificationViewedAll(item.id);
      }
      $scope.$apply();
    };

    $scope.createdNotification = async function (notification){
        if ($scope.notifications.length < $scope.maxNotificationsShowLimit) {
          $scope.notifications.push(notification);
        } else {
          const lastNotification = $scope.notifications.reduce((r, o) => o.created < r.created ? o : r);
          $scope.notifications = $scope.notifications.filter(item => {
            return item.id !== lastNotification.id;
          });
          $scope.notifications.push(notification);
        }
      $scope.notifications.sort($scope.sortArray);
        await $scope.getUnreadNotificationsCount();
        $scope.$apply();
    };

    $scope.getNotifications();
    $scope.getUnreadNotificationsCount();


    const notificationsServices = $feathers.service('notifications');
    notificationsServices.on('created', async function(notification) {
      // Event fired for every user_id, only react for own user_id
      if (notification.user_id === $scope.user.id){
      await $scope.createdNotification(notification);
      $scope.$apply();
      }
    });
    notificationsServices.on('removed', async function(notification) {
      if (notification.user_id === $scope.user.id) {
        await $scope.deletedNotification();
        $scope.$apply();
      }
    });
    notificationsServices.on('updated', async function(notification) {
      if (notification.user_id === $scope.user.id) {
        await $scope.patchedNotification();
        $scope.$apply();
      }
    });
    notificationsServices.on('patched', async function(notification) {
      if (notification.user_id === $scope.user.id) {
        // Differentiation if all notifications are marked as read
        let onlyPatchAllNotifications = !Object.keys(notification).includes('text');
        if (onlyPatchAllNotifications){
          await $scope.patchedAllNotificationToRead(notification);
        } else {
          await $scope.patchedNotification(notification);
        }
        $scope.$apply();
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('PageTopController', PageTopController);

  function PageTopController($scope, baConfig, $state, $log, $feathers, principal) {
  	principal.identity().then(function(user) {
      $scope.user = user;
    });

    $scope.logout = function() {
      principal.logout();
      $state.go('login');
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      controller: 'PageTopController',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('join', join);

  /** @ngInject */
  function join() {
    return function(text, separator) {
      if (!separator) {
        separator = ', ';
      }
      return  text.join(separator);
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author m.ermer
 * created on 26.04.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('comma2decimal', comma2decimal);

  /** @ngInject */
  function comma2decimal() {
    return function(input) {
      var ret=(input)?input.toString().trim().replace(",","."):null;
      return parseFloat(ret)||null;
    };
  }

})();

/**
 * @author m.ermer
 * created on 26.04.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('decimal2comma', decimal2comma);

  /** @ngInject */
  function decimal2comma() {
    return function(input) {
      var ret=(input)?input.toString().replace(".",","):null;
      if(ret){
        var decArr=ret.split(",");
        if(decArr.length>1){
          var dec=decArr[1].length;
          if(dec===1){ret+="0";}
        }
      }
      return ret;
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('addEditTargetingTree', addEditTargetingTree);

  /** @ngInject */
  function addEditTargetingTree() {
    return {
      restrict: 'E',
      controller: 'addEditTargetingTreeController',
      templateUrl: 'app/theme/directives/recursiveTargetingTree/addEditTargetingTree.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ads')
    .controller('addEditTargetingTreeController', addEditTargetingTreeController);

  /** @ngInject */
  function addEditTargetingTreeController($scope, $attrs, toastr, $window, $filter, $feathers, adoverwrites, adOverwritesAutoComplete) {
    // workaround for ui-select error in uib-tabset
    $scope.tabTwoRendered = false;
    $scope.tabThreeRendered = false;
    $scope.overwrites = {
    };
    $scope.adOverwritesAutoComplete = adOverwritesAutoComplete;

    if ($scope.$resolve.targeting){
      $scope.targeting = angular.copy($scope.$resolve.targeting);
    } else if ($scope.$resolve.node){
      $scope.targeting = angular.copy($scope.$resolve.node);
    } else {
      $scope.targeting = {
      };
    }

    if (!$scope.targeting.match) {
      $scope.targeting.match={
      };
    }
    if (!$scope.targeting.overwrite) {
      $scope.targeting.overwrite = {
      };
    }
    $scope.targeting.copyRequestcategory = $scope.targeting.requestcategory;
    $scope.ad = $scope.$resolve.ad;
    $scope.formatLabel = function(model) {
      if (model) {
        return model.name;
      }
    };
    $scope.saveTargeting = async function (targeting) {
      console.log('save', targeting);
      let resCategory = null;
      if (targeting.originalId) {
        try {
          let res = await $feathers.service('adrequestdesires').patch(targeting.originalId, {
            requestcategory: targeting.requestcategory.id,
            name: targeting.name,
            weight: targeting.weight,
            defaultweight: targeting.defaultweight,
            match: targeting.match,
            overwrite: targeting.overwrite
          });
          if ($scope.targeting.requestcategory.id !== res.requestcategory) {
            resCategory = await $feathers.service('adrequestdesires').get(res.requestcategory);
          }
          toastr.success($filter('translate')('CHANGES SAVED'));
          let data = [];
          data[0] =res;
          data[1] =resCategory;
          console.log(data);
          $scope.$close(data);
        } catch (e) {
          console.log(e);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        }
      } else if (targeting.requestcategory && $scope.ad.id) {
        try {
          let tg = await $feathers.service('adrequestdesires').create({
            ad: $scope.ad.id,
            requestcategory: targeting.requestcategory.id,
            weight: (targeting.weight ? targeting.weight : 1000),
            defaultweight: (targeting.defaultweight ? targeting.defaultweight : 0),
            name: targeting.name,
            match: targeting.match,
            overwrite: targeting.overwrite
          });
          let reqCat = await $feathers.service('requestcategories').get(tg.requestcategory);
          tg.requestcategory = reqCat;
          $scope.ad.adrequestdesires.push(tg);
          toastr.success($filter('translate')('REQUESTCATEGORY SUCCESSFULLY CREATED'));
          $scope.$close(null);
        } catch (error) {
          console.log('Create Adrequestdesire ERROR: ', error);
          toastr.error($filter('translate')('REQUESTCATEGORY NOT CREATED'));
        }
      } else {
        toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };
    $scope.searchRequestCategory = async function (val) {
      try {
        let rqs = await $feathers.service('requestcategories').find({
          query: {
            name: {
              $ilike: '%' + val + '%'
            },
            $limit: 10,
            $paginate: false
          }
        });
        for (let requCat of rqs) {
          let parent = requCat;
          requCat.path = requCat.name + '(' + requCat.id + ')';
          while (parent.parent) {
            parent = await $feathers.service('requestcategories').get(parent.parent);
            requCat.path = parent.name + '(' + parent.id + ') -> ' + requCat.path;
          }
        }
        return rqs;
      } catch (error) {
        console.log('searchRequestCategory Error', error);
      }
    };
    $scope.getParent = async function(requCat){
      return await $feathers.service('requestcategories').get(requCat.id);
    };
    $scope.removeOverwrite = function(item, model) {
      delete $scope.targeting.overwrite[model];
    };
    $scope.addOverwrite = function(item, model) {
      $scope.targeting.overwrite[model] = '';
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('recursiveTargetingTree', recursiveTargetingTree);

  /** @ngInject */
  function recursiveTargetingTree(RecursionHelper) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/directives/recursiveTargetingTree/recursiveTargetingTreeTop.html',
      scope: {
        nodes: '=',
        type: '=',
        showAdd: '=',
        showAttributes: '=',
        modal: '=',
        getNodes: '=',
        adrequestdesires: '=',
        adid: '='
      },
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      },
      controller: 'RecursiveTargetingTreeController',
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('recursiveTargetingTreeBody', recursiveTargetingTreeBody);

  /** @ngInject */
  function recursiveTargetingTreeBody(RecursionHelper) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/directives/recursiveTargetingTree/recursiveTargetingTreeBody.html',
      scope: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .controller('RecursiveTargetingTreeController', RecursiveTargetingTreeController);

  /** @ngInject */
  function RecursiveTargetingTreeController($scope, $filter, $feathers, $attrs, $uibModal, toastr) {
    $scope.limit = 5;
    $scope.stdNodeColor = '#eef1f2';
    $scope.searchNodeColor = '#d4f2fb';
    $scope.isExpand = false;
    $scope.expandAndCollapseString = 'EXPAND ALL';
    $scope.targetingTreeCompare = [];
    $scope.inputSearch = '';
    $scope.showOnlyFoundItems = false;

    $scope.toggle = function (scope) {
      scope.toggle();
    };

    $scope.expandAndCollapseAll = function () {
      if ($scope.isExpand) {
        $scope.$broadcast('angular-ui-tree:collapse-all');
        $scope.expandAndCollapseString = 'EXPAND ALL';
        $scope.isExpand = false;
      } else {
        $scope.$broadcast('angular-ui-tree:expand-all');
        $scope.expandAndCollapseString = 'COLLAPSE ALL';
        $scope.isExpand = true;
      }
    };

    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };

    $scope.getAllChildren = async function (node) {
      node.$nodeScope.$modelValue.total = Object.keys(node.$nodeScope.$modelValue.children).length;
      node.$nodeScope.node.nodes = node.$nodeScope.$modelValue.children;
      delete node.$nodeScope.$modelValue.total;
    };

    $scope.returnVisibleResult = function (bol, color) {
      return [bol, color];
    };

    $scope.isAnObject = function (obj) {
      if (obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    };

    $scope.visible = function (item) {
      let color = null;
      let bol = null;
      // resultArr [ hide, color]
      let resultArr = [];
      if ($scope.inputSearch.length === 0) {
        return $scope.returnVisibleResult(false, $scope.stdNodeColor);
      } else {
        if (!$scope.showOnlyFoundItems) {
          if ($scope.inputSearch && $scope.inputSearch.length > 0) {
            if ($scope.inputSearch && $scope.inputSearch.length > 0
                            && item.name.toLowerCase().indexOf($scope.inputSearch.toLowerCase()) === -1) {
              color = $scope.stdNodeColor;
            } else {
              color = $scope.searchNodeColor;
            }
          } else {
            color = $scope.stdNodeColor;
          }
          return $scope.returnVisibleResult(false, color);
        } else {
          let res = ($scope.inputSearch && $scope.inputSearch.length > 0
                        && item.name.toLowerCase().indexOf($scope.inputSearch.toLowerCase()) === -1);
          if (!res && item.requestcategory) {
            color = $scope.searchNodeColor;
            bol = false;
          } else {
            color = $scope.stdNodeColor;
            bol = true;
          }
          return $scope.returnVisibleResult(bol, color);
        }
      }
    };

    $scope.findNodes = function (item) {
      $scope.inputSearch = item.inputSearch;
      $scope.showOnlyFoundItems = item.showOnlyFoundItems;
      if (item && item.inputSearch) {
        if (item.inputSearch.length === 0) {
          $scope.collapseAll();
        } else {
          $scope.expandAll();
        }
      }
    };

    $scope.getDepth = function (node) {
      return node.parent;
    };

    $scope.openAddEditTargeting = function () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEditTargetingTree',
      }).closed.then(async function () {
        try {
          await $scope.getAdrequestdesires();
          await $scope.createTargetingTree();
        } catch (error) {
          console.log(error);
        }
      });
    };

    $scope.getAdrequestdesires = async function () {
      try {
        $scope.adrequestdesires = await $feathers.service('adrequestdesires').find({
          query: {
            ad: $scope.adid,
            $limit: 100,
            $paginate: false
          }
        });
      } catch (error) {
        console.log(error);
      }
    };


    $scope.createTargetingTree = async function () {
      // Check for ad.adrequestdesires changes then reload tree
      if (JSON.stringify($scope.targetingTreeCompare) === JSON.stringify($scope.adrequestdesires)) {
        // no changes
      } else {
        $scope.targetingTreeIsLoading = true;
        $scope.targetingTreeResult = null;
        $scope.targetingTreeObject = [];
        let targetingTreeItems = [];
        angular.copy($scope.adrequestdesires, targetingTreeItems);
        angular.copy($scope.adrequestdesires, $scope.targetingTreeCompare);
        let parentTempHelper = {
        };

        // Prepare targetingTreeItems Array for the recursive Function
        for (let item of targetingTreeItems) {
          if (item.requestcategory && item.requestcategory.parent) {
            item['originalId'] = item.id;
            item.id = item.requestcategory.id;
            item['parent'] = item.requestcategory.parent;
            item['average'] = item.requestcategory.average;
            item['tag'] = item.requestcategory.tag;
            item['decay'] = item.requestcategory.decay;
            item['maxweight'] = item.requestcategory.maxweight;
            item['color'] = '#eef1f2';
            item['height'] = '100px';
          }
        }

        // Get all needed Items for Tree Structure (The Parent Item for the Child Items)
        for (let item of targetingTreeItems) {
          if ((item.requestcategory && item.requestcategory.id &&
                        item.requestcategory.parent) || (item.id && item.parent)) {
            if (parentTempHelper[item.parent]) {
              $scope.targetingTreeObject.push(parentTempHelper[item.parent]);
              if (parentTempHelper[item.parent].parent) {
                if (!targetingTreeItems.findIndex(x => x.id === parentTempHelper[item.parent].id)) {
                  targetingTreeItems.push(parentTempHelper[item.parent]);
                }
              }
            } else {
              let parent = null;
              if (item.requestcategory && item.requestcategory.parent) {
                parent = await $feathers.service('requestcategories').get(item.requestcategory.parent);
              } else if (item.parent) {
                parent = await $feathers.service('requestcategories').get(item.parent);
              }
              parentTempHelper[item.parent] = parent;
              if (parent && parent.parent) {
                targetingTreeItems.push(parent);
              }
            }
          }
        }

        let recursiveArrayTargetingTreeItems = targetingTreeItems;

        function findFor(parentId) {
          // create a new object to store the result
          let result = {
          };
          // for each item in a
          for (var i = 0; i < recursiveArrayTargetingTreeItems.length; i++) {
            // find all children of parentId
            if (recursiveArrayTargetingTreeItems[i].parent === parentId) {
              // recursively find children for each children of parentId
              var ch = findFor(recursiveArrayTargetingTreeItems[i].id);
              // if it has no children, skip adding the children prop
              var keys = Object.keys(ch).length === 0 ? {
              } : {
                nodes: ch
              };
              result[recursiveArrayTargetingTreeItems[i].id] = Object.assign(keys, recursiveArrayTargetingTreeItems[i]);
            }
          }
          return result;
        }

        $scope.targetingTreeResult = findFor(1);
        $scope.nodes = $scope.targetingTreeResult;
        $scope.targetingTreeIsLoading = false;
      }
    };


    $scope.addEditNode = function (node, edit, scope) {
      let modalInstance = $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEdit' + $attrs.modal,
        resolve: {
          node: function () {
            return node;
          },
          ad: function () {
            return $scope.ad;
          }
        }
      });
      modalInstance.result.then(async function (data) {
        await $scope.getAdrequestdesires();
        $scope.$apply();
        if (!edit) {
        }
      });
    };

    $scope.$watch('adrequestdesires', function (newValue, oldValue) {
      $scope.init();
    });

    $scope.deleteNode = async function (node, scope) {
      return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE REQUESTCATEGORY?'), {
        progressBar: true,
        onHidden: async function (clicked, toast) {
          if (clicked) {
            try {
              await $feathers.service($attrs.type).remove(node.originalId);
              await $scope.getAdrequestdesires();
            } catch (e) {
              console.log(e);
              toastr.error($filter('translate')('REMOVING FAILED'));
            }
            toastr.success($filter('translate')('REMOVING SUCCESSFULL'));
          }
        }
      });
    };


    $scope.init = async function () {
      await $scope.createTargetingTree();
      $scope.$apply();
    };

  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .controller('RecursiveTreeController', RecursiveTreeController);

  /** @ngInject */
  function RecursiveTreeController($scope, $filter, $feathers, $attrs, $uibModal, toastr) {
    $scope.limit = 25;
    $scope.customToggle = async function (node) {
      let query = {
        query: {
          parent: node.$nodeScope.$modelValue.id,
          $sort: {id: 1},
          $paginate: false,
        }
      };
      let total =await $feathers.service($attrs.type).find(query);
      node.$nodeScope.$modelValue.total = total.length;
      query.query.$limit = $scope.limit;
      let nodes = await $feathers.service($attrs.type).find(query);
      node.$nodeScope.$modelValue.nodes = nodes;
      node.searchInput = undefined;
      node.toggle();
      $scope.$apply();
    };
    $scope.getAllChildren = async function(node) {
      let query = {
        query: {
          parent: node.$nodeScope.$modelValue.id,
          $sort: {id: 1},
          $paginate: false,
        }
      };
      let allChildren = await $feathers.service($attrs.type).find(query);
      node.$nodeScope.$modelValue.nodes = allChildren;
      delete node.$nodeScope.$modelValue.total;
      $scope.$apply();
    };

    $scope.findNodes = async function (searchInput, id, scope) {
      if (searchInput) {
        let children = await $feathers.service($attrs.type).find({
          query: {
            parent: id,
            $paginate: false,
            name: {
              $ilike: '%' + searchInput + '%'
            }
          }
        });
        console.log(children);
      scope.$nodeScope.$modelValue.nodes = children;
      if (scope.collapsed) {
        scope.toggle();
      }
      $scope.$apply();
      }
      return searchInput;
    };

    $scope.getDepth = function(node) {
      return node.parent;
    };
    $scope.addEditNode = function(node, edit, scope) {
      if (!edit) {
        node = {parent: node.id};
      }
      let modalInstance = $uibModal.open({
        animation: true,
        size: 'lg',
        component: 'addEdit' + $attrs.modal,
        resolve: {
          [$attrs.modal] : function () {
            return node;
          }
        }
      });
      modalInstance.result.then(function(data) {
        if (!edit) {
          scope.$parent.$modelValue.nodes.push(data);
        }
      });
    };
    $scope.deleteNode = async function(scope, node) {
      return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE REQUESTCATEGORY?'), {
        progressBar: true,
        onHidden: async function(clicked, toast) {
          if (clicked) {
            try {
              await $feathers.service($attrs.type).remove(node.id);
              scope.remove();
            } catch(e) {
              console.log(e);
              toastr.error($filter('translate')('REMOVING FAILED'));
            }
            toastr.success($filter('translate')('REMOVING SUCCESSFULL'));
          }
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('recursiveTree', recursiveTree);

  /** @ngInject */
  function recursiveTree(RecursionHelper) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/directives/recursiveTree/recursiveTreeTop.html',
      scope: {
        nodes: '=',
        type: '=',
        showAdd: '=',
        showAttributes: '=',
        modal: '=',
        getNodes: '='
      },
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      },
      controller: 'RecursiveTreeController',
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('recursiveTreeBody', recursiveTreeBody);

  /** @ngInject */
  function recursiveTreeBody(RecursionHelper) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/directives/recursiveTree/recursiveTreeBody.html',
      scope: true,
      compile: function(element) {
        return RecursionHelper.compile(element, function (scope, iElement, iAttrs, controller, transcludeFn) {
          // Define your normal link function here.
          // Alternative: instead of passing a function,
          // you can also pass an object with
          // a 'pre'- and 'post'-link function.
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('AdsizesController', AdsizesController);

  /** @ngInject */
  function AdsizesController($scope, $filter, $feathers, toastr) {
    $scope.admediasizes = [];
    $scope.size = {
      size: '',
      name: '',
      width: null,
      height: null
    };

    $scope.trimOptionsObject = function(obj){
      let maxLength = 30;
      if (obj) {
        let stringifyObj = JSON.stringify(obj);
        if (stringifyObj.length < maxLength) {
          return stringifyObj;
        } else {
          let result = stringifyObj.substring(0, maxLength);
          result += '  .....  }';
          return result;
        }
      } return '-';
    };

    $feathers.service('admediasizes').find({
      query: {
        $limit: 1000,
        $sort: {
          id: 1
        },
      }
    })
      .then(function(result) {
        $scope.admediasizes = result.data;
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('GroupsListController', GroupsListController);

  /** @ngInject */
  function GroupsListController($scope, $feathers, hotkeys, toastr) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.groups = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getGroups = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
          // kind: 'datafactor'
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      $feathers.service('groups').find(query)
        .then(function(result) {
          $scope.groups = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('AdsizesDetailController', AdsizesDetailController);

  /** @ngInject */
  function AdsizesDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.adMediaSize = {
    };
    if ($stateParams.id){
      $feathers.service('admediasizes').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.adMediaSize = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE ADMEDIASIZE YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.adsizes');
        });
    }


    $scope.createAdMediaSize = function() {
      if (!$scope.adMediaSize.name || !$scope.adMediaSize.size || !$scope.adMediaSize.width || !$scope.adMediaSize.height) {
        return toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'), $filter('translate')('NOT SAVED'));
      }
      $feathers.service('admediasizes').create($scope.adMediaSize)
        .then(function(admediasize) {
          toastr.success($filter('translate')('ADMEDIASIZE SUCCESSFULLY CREATED'));
          $state.go('settings.adsizes-detail', {
            id: admediasize.id
          });
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CREATE ADMEDIASIZE FAILED'));
        });
    };

    $scope.save = function(){
      $feathers.service('admediasizes').patch($stateParams.id, {
        name: $scope.adMediaSize.name,
        width: $scope.adMediaSize.width,
        height: $scope.adMediaSize.height,
        size: $scope.adMediaSize.size,
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveOptions = function() {
      $feathers.service('admediasizes').patch($stateParams.id, {
        options: $scope.adMediaSize.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.deleteAdMediaSize = function() {
      if ($scope.adMediaSize.id) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE ADMEDIASIZE?'), {
          progressBar: true,
          onHidden: function (clicked) {
            if (clicked) {
              $feathers.service('admediasizes').remove($scope.adMediaSize.id)
                .then(function() {
                  $state.go('settings.adsizes');
                  return toastr.success($filter('translate')('ADMEDIASIZE SUCCESSFULLY DELETED'), $filter('translate')('DELETED'));
                })
                .catch(function(error){
                  console.log('remove admediasize error: ', error);
                  toastr.error($filter('translate')('ADMEDIASIZE NOT DELETED'));
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('GroupsDetailController', GroupsDetailController);

  /** @ngInject */
  function GroupsDetailController(toastr, $filter, $scope, $stateParams, $state, $feathers) {
    $scope.debug=JSON.stringify($stateParams);
    $scope.group = {
      permissions: []
    };

    $scope.save = function() {
      $feathers.service('groups').patch($stateParams.id, $scope.group)
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };
    if ($stateParams.id){
      $feathers.service('groups').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.group = result;
          $scope.group.permissions = $scope.group.permissions ||[];
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE GROUP YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.groups');
        });
      $feathers.service('groups').on('updated', function(){
      });
    }

    $scope.createGroup = function(){
      if ($scope.group.name && $scope.group.permissions.length) {
        $feathers.service('groups').create($scope.group)
          .then(function(group){
            toastr.success($filter('translate')('USER SUCCESSFULLY CREATED'));
            $state.go('settings.groups-detail', {
              id: group.id
            });
          })
          .catch(function(error){
            toastr.error($filter('translate')('NOT SAVED'));
            console.log('error', error);
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('CreateInventoryController', CreateInventoryController);

  /** @ngInject */
  function CreateInventoryController($scope, toastr, $window, $filter, $feathers, inventoryKinds, $uibModalStack) {
    $scope.inventory = {
    };
    $scope.isChild = $scope.$resolve.isChild;
    $scope.parent = $scope.$resolve.parent;
    $scope.inventoryKinds = inventoryKinds;
    $scope.inventories = $scope.$resolve.inventories;
    if ( $scope.$resolve.parent){
      $scope.inventory.parent_id =  $scope.$resolve.parent.id;
      switch ($scope.$resolve.parent.kind){
      case 'network':
        $scope.inventory.kind = 'publisher';
        break;
      case 'publisher':
        $scope.inventory.kind = 'domain';
        break;
      case 'domain':
        $scope.inventory.kind = 'placement';
        break;
      default:
        $scope.inventory.kind = '';
      }
    }
    $scope.saveInventory = function(inventory) {
      if (inventory.kind === '') {
        toastr.error($filter('translate')('PLEASE SELECT KIND'));
      }
      inventory.active = true;
      $feathers.service('inventories').find({
        query: {
          id: inventory.parent_id,
          $paginate: false
        }
      })
        .then(function(result) {
          if (result.length === 0 && inventory.parent_id !== '0') {
            toastr.error($filter('translate')('PARENT ID DOESN\'T EXIST'));
          } else {
            $feathers.service('inventories').create(inventory)
              .then(function() {
                toastr.success($filter('translate')('INVENTORY SUCCESSFULLY CREATED'));
                $uibModalStack.dismissAll();
              });
          }
        });
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .directive('createInventory', createInventory);

  /** @ngInject */
  function createInventory() {
    return {
      restrict: 'E',
      controller: 'CreateInventoryController',
      templateUrl: 'app/pages/settings/inventories/createInventory/createInventory.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('MatchersController', matchersController);

  /** @ngInject */
  function matchersController($scope, $filter, $feathers, hotkeys, toastr) {
    $scope.pageSize = [5, 10, 15, 25, 50, 100];
    $scope.smartTablePageSize = 25;
    $scope.matchers = [];
    $scope.isLoading = false;

    var l = $feathers.service('matchers');
    l.on('updated', function(matcher) {
      $scope.matchers.update('updated', matcher);
      $scope.$apply();
    });

    function setPage(adjust) {
      $scope.pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      $scope.pager
        .selectPage($scope.pager.currentPage + adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });


    $scope.getMatchers = function(tableState) {
      var pagination = tableState.pagination;
      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;
      var sort = {
      };
      $scope.query = {
        query: {
          $limit: number,
          $skip: start,
          $sort: sort
        }
      };
      $scope.isLoading = true;

      if (tableState.search && tableState.search.predicateObject) {
        for (var key in tableState.search.predicateObject) {
          if (key === '_id') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else {
            $scope.query.query[key] = {
              '$regex': tableState.search.predicateObject[key],
              '$options': 'i'
            } ;
            console.log($scope.query);
          }
        }
      }

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      $feathers.service('matchers').find($scope.query)
        .then(function(result) {
          $scope.matchers  = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total / tableState.pagination.number);
          $scope.size = result.total;
          $scope.isLoading = false;
        })
        .then(function(){
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
      $scope.deleteParas = function() {
        if ($scope.matchers.length === 0){
          $scope.query = {
            query: {
              $limit: number,
              $skip: start,
              $sort: sort
            }
          };
          $feathers.service('matchers').find($scope.query)
            .then(function(result) {
              $scope.matchers  = result.data;
              tableState.pagination.numberOfPages = Math.ceil(result.total / $scope.smartTablePageSize);
              $scope.size = result.total;
              $scope.isLoading = false;
            })
            .then(function(){
              $scope.$apply();
            })
            .catch(function(error) {
              $scope.isLoading = false;
              $scope.$apply();
            });
        }
        tableState.search = {
          predicateObject: {
          }
        };
        $scope.pager = angular
          .element( $('#pagerId') )
          .isolateScope();
        $scope.pager.selectPage(1);
      };
    };

    $scope.delete = function(matcher) {
      if (matcher._id) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE MATCHER?'), {
          progressBar: true,
          onHidden: function (clicked, toast) {
            if (clicked) {
              $feathers.service('matchers').remove(matcher._id)
                .then(function() {
                  $feathers.service('matchers').find($scope.query)
                    .then(function(result){
                      $scope.matchers = result.data;
                      $scope.$apply();
                    });
                  return toastr.success($filter('translate')('MATCHER DELETED'), $filter('translate')('DELETED'));
                })
                .catch(function(error){
                  console.log('remove location error: ', error);
                  toastr.error($filter('translate')('MATCHER NOT DELETED'));
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('MatchersDetailController', MatchersDetailController);

  /** @ngInject */
  function MatchersDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.matcher = {
    };
    if ($stateParams.id){
      $feathers.service('matchers').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.matcher = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE MATCHER YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.matchers');
        });
    }

    $scope.save = function(){
      $feathers.service('matchers').patch($stateParams.id, {
        name: $scope.matcher.name
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveEvents = function() {
      $feathers.service('matchers').patch($stateParams.id, {
        events: $scope.matcher.events
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveMatch = function() {
      $feathers.service('matchers').patch($stateParams.id, {
        match: $scope.matcher.match
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveAction = function() {
      $feathers.service('matchers').patch($stateParams.id, {
        action: $scope.matcher.action
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createMatcher = function() {
      if ($scope.matcher.name !== ''){
        $feathers.service('matchers').create($scope.matcher)
          .then(function(matcher) {
            toastr.success($filter('translate')('MATCHER SUCCESSFULLY CREATED'));
            $state.go('settings.matchers-detail', {
              id: matcher._id
            });
          })
          .catch(function(error){
            console.log(error);
            toastr.error($filter('translate')('MATCHER NOT CREATED'));
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('NetworksDetailController', NetworksDetailController);

  /** @ngInject */
  function NetworksDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.network = {
    };
    if ($stateParams.id){
      $feathers.service('networks').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.network = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE NETWORK YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.networks');
        });
    }

    $scope.save = function(){
      $feathers.service('networks').patch($stateParams.id, {
        name: $scope.network.name,
        network: $scope.network.network,
        active: $scope.network.active
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveOptions = function() {
      $feathers.service('networks').patch($stateParams.id, {
        options: $scope.network.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveProducts = function() {
      $feathers.service('networks').patch($stateParams.id, {
        products: $scope.network.products
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveCredentials = function() {
      $feathers.service('networks').patch($stateParams.id, {
        credentials: $scope.network.credentials
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createNetwork = function() {
      if ($scope.network.name !== '' && $scope.network.network !== ''){
        $feathers.service('networks').create($scope.network)
          .then(function(network) {
            toastr.success($filter('translate')('NETWORK SUCCESSFULLY CREATED'));
            $state.go('settings.networks-detail', {
              id: network.id
            });
          })
          .catch(function(error){
            console.log(error);
            toastr.error($filter('translate')('NETWORK NOT CREATED'));
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('NetworksListController', NetworksListController);

  /** @ngInject */
  function NetworksListController($scope, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.networks = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getNetworks = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      $feathers.service('networks').find(query)
        .then(function(result) {
          $scope.networks = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          console.log(error);
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

    $scope.days = 1;
    $scope.importSales = function(days, networkId) {
      $feathers.service('events').create({
        service: 'events',
        event: 'importSales',
        payload: {
          days,
          networkId
        }
      })
        .then(function() {
          toastr.success($filter('translate')('BIDDER RELOAD SUCCESSFUL'));
        })
        .catch(function(error){
          console.log('event bidderReloadAll error: ', error);
          toastr.success($filter('translate')('BIDDER RELOAD FAILED'));
        });
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('PublishersListController', PublishersListController);

  /** @ngInject */
  function PublishersListController($scope, $feathers, hotkeys, toastr) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.publishers = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getPublishers = function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      $feathers.service('publishers').find(query)
        .then(function(result) {
          $scope.publishers = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
          $scope.isLoading = false;
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('PublishersDetailController', PublishersDetailController);

  /** @ngInject */
  function PublishersDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.publisher = {
    };
    if ($stateParams.id){
      $feathers.service('publishers').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.publisher = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE PUBLISHER YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.publishers');
        });
    }

    $scope.save = function(){
      $feathers.service('publishers').patch($stateParams.id, {
        name: $scope.publisher.name,
        active: $scope.publisher.active
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveOptions = function() {
      $feathers.service('publishers').patch($stateParams.id, {
        options: $scope.publisher.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createPublisher = function() {
      $feathers.service('publishers').create($scope.publisher)
        .then(function(publisher) {
          toastr.success($filter('translate')('PUBLISHER SUCCESSFULLY CREATED'));
          $state.go('settings.publishers-detail', {
            id: publisher.id
          });
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('PUBLISHER NOT CREATED'));
        });
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('AddEditRequestcategoryController', AddEditRequestcategoryController);

  /** @ngInject */
  function AddEditRequestcategoryController($scope, $attrs, toastr, $window, $filter, $feathers) {
    $scope.requestCategory = $scope.$resolve.Requestcategory;
    $scope.saveRequestCategory = async function(requestcategory) {
      let newReq = {
      };
      console.log(requestcategory);
      if (requestcategory.id) {
        await $feathers.service('requestcategories').patch(requestcategory.id, requestcategory);
        toastr.success($filter('translate')('REQUESTCATEGORY SUCCESSFULLY CHANGED'));
        $scope.$close(null);
      } else {
        newReq = await $feathers.service('requestcategories').create(requestcategory);
        toastr.success($filter('translate')('REQUESTCATEGORY SUCCESSFULLY CREATED'));
        $scope.$close(newReq);
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .directive('addEditRequestcategory', addEditRequestcategory);

  /** @ngInject */
  function addEditRequestcategory() {
    return {
      restrict: 'E',
      controller: 'AddEditRequestcategoryController',
      templateUrl: 'app/pages/settings/requestcategories/addEditRequestcategory/addEditRequestcategory.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('SitemediasController', SitemediasController);

  /** @ngInject */
  function SitemediasController($scope, $filter, $feathers, hotkeys, toastr, $location, $stateParams) {
    $scope.pageSize = [5, 10, 15, 25, 50, 100];
    $scope.smartTablePageSize = 25;
    $scope.sitemedias = [];
    $scope.isLoading = false;
    $scope.params = $location.search();
    $scope.onceFilter = false;


    var l = $feathers.service('sitemedias');
    l.on('updated', function(sitemedia) {
      $scope.sitemedias.update('updated', sitemedia);
      $scope.$apply();
    });

    function setPage(adjust) {
      $scope.pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      $scope.pager
        .selectPage($scope.pager.currentPage + adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getSitemedias = function(tableState) {
      var pagination = tableState.pagination;
      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      if ($stateParams.var) {
        tableState.search = {
          predicateObject: {
            site: $stateParams.site
          }
        };
      }
      var sort = {
      };
      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      $scope.query = {
        query: {
          $limit: number,
          $skip: start,
          $sort: sort,
        }
      };
      $scope.isLoading = true;
      if (tableState.search && tableState.search.predicateObject) {
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          }  else if (key === 'active') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'media') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'site') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'cpm') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'share') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else {
            $scope.query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }

      var params = $location.search();
      if ($scope.onceFilter===false) {
        tableState.search = {
          predicateObject: {
            site: params.site
          }
        };
        $scope.onceFilter=true;
        $location.search('site', null);
      };

      $feathers.service('sitemedias').find($scope.query)
        .then(function(result) {
          $scope.sitemedias  = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total / tableState.pagination.number);
          $scope.size = result.total;
          $scope.isLoading = false;
        })
        .then(function(){
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
      $scope.deleteParas = function() {
        if ($stateParams.site){
          $stateParams.site = undefined;
        }
        if ($scope.sitemedias.length === 0){
          $scope.query = {
            query: {
              $limit: number,
              $skip: start,
              $sort: sort
            }
          };
          $feathers.service('sitemedias').find($scope.query)
            .then(function(result) {
              $scope.sitemedias  = result.data;
              tableState.pagination.numberOfPages = Math.ceil(result.total / $scope.smartTablePageSize);
              $scope.size = result.total;
              $scope.isLoading = false;
            })
            .then(function(){
              $scope.$apply();
            })
            .catch(function(error) {
              $scope.isLoading = false;
              $scope.$apply();
            });
        }
        $scope.parent = undefined;
        tableState.search = {
          predicateObject: {
          }
        };
        $scope.pager = angular
          .element( $('#pagerId') )
          .isolateScope();
        $scope.pager.selectPage(1);
      };
    };

    $scope.delete = function(sitemedia) {
      if (sitemedia.id) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE SITEMEDIA?'), {
          progressBar: true,
          onHidden: function (clicked, toast) {
            if (clicked) {
              $feathers.service('sitemedias').remove(sitemedia.id)
                .then(function() {
                  $feathers.service('sitemedias').find($scope.query)
                    .then(function(result){
                      $scope.sitemedias = result.data;
                      $scope.$apply();
                    });
                  return toastr.success($filter('translate')('SITEMEDIA DELETED'), $filter('translate')('DELETED'));
                })
                .catch(function(error){
                  console.log('remove location error: ', error);
                  toastr.error($filter('translate')('SITEMEDIA NOT DELETED'));
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('SitesController', sitesController);

  /** @ngInject */
  function sitesController($scope, $filter, $feathers, hotkeys, toastr) {
    $scope.pageSize = [5, 10, 15, 25, 50, 100];
    $scope.smartTablePageSize = 25;
    $scope.sites = [];
    $scope.isLoading = false;

    var l = $feathers.service('sites');
    l.on('updated', function(site) {
      $scope.sites.update('updated', site);
      $scope.$apply();
    });

    function setPage(adjust) {
      $scope.pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      $scope.pager
        .selectPage($scope.pager.currentPage + adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });


    $scope.getSites = function(tableState) {
      var pagination = tableState.pagination;
      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;
      var sort = {
      };
      $scope.query = {
        query: {
          $limit: number,
          $skip: start,
          $sort: sort
        }
      };
      $scope.isLoading = true;

      if (tableState.search && tableState.search.predicateObject) {
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            $scope.query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'auto') {
            $scope.query.query['auto_accept_advertiser'] = tableState.search.predicateObject[key];
          } else {
            $scope.query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }

      $feathers.service('sites').find($scope.query)
        .then(function(result) {
          $scope.sites  = result.data;
          tableState.pagination.numberOfPages = Math.ceil(result.total / tableState.pagination.number);
          $scope.size = result.total;
          $scope.isLoading = false;
        })
        .then(function(){
          $scope.$apply();
        })
        .catch(function(error) {
          $scope.isLoading = false;
          $scope.$apply();
        });
      $scope.deleteParas = function() {
        if ($scope.sites.length === 0){
          $scope.query = {
            query: {
              $limit: number,
              $skip: start,
              $sort: sort
            }
          };


          $feathers.service('sites').find($scope.query)
            .then(function(result) {
              $scope.sites  = result.data;
              tableState.pagination.numberOfPages = Math.ceil(result.total / $scope.smartTablePageSize);
              $scope.size = result.total;
              $scope.isLoading = false;
            })
            .then(function(){
              $scope.$apply();
            })
            .catch(function(error) {
              $scope.isLoading = false;
              $scope.$apply();
            });
        }
        $scope.parent = undefined;
        tableState.search = {
          predicateObject: {
          }
        };
        $scope.pager = angular
          .element( $('#pagerId') )
          .isolateScope();
        $scope.pager.selectPage(1);
      };
      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }
    };

    $scope.delete = function(site) {
      if (site.id) {
        return toastr.warning($filter('translate')('PLEASE CLICK HERE TO CONFIRM REMOVAL'), $filter('translate')('REMOVE SITE?'), {
          progressBar: true,
          onHidden: function (clicked, toast) {
            if (clicked) {
              $feathers.service('sites').remove(site.id)
                .then(function() {
                  $feathers.service('sites').find($scope.query)
                    .then(function(result){
                      $scope.sites = result.data;
                      $scope.$apply();
                    });
                  return toastr.success($filter('translate')('SITE DELETED'), $filter('translate')('DELETED'));
                })
                .catch(function(error){
                  if (error.message.includes('update or delete on table "sites" violates foreign key constraint "sitemedias_site_fkey" on table "sitemedias')){
                    toastr.error($filter('translate')('SITE NOT DELETED, PLEASE REMOVE FIRST ALL SITEMEDIAS OF THIS SITE'));
                  } else {
                    console.log('remove location error: ', error);
                    toastr.error($filter('translate')('SITE NOT DELETED'));
                  }
                });
            } else {
              toastr.error($filter('translate')('DELETION WITHOUT CONFIRMATION NOT POSSIBLE'));
            }
          }
        });
      } else {
        return toastr.error($filter('translate')('DELETION WITHOUT ID NOT POSSIBLE'));
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('SitemediasDetailController', SitemediasDetailController);

  /** @ngInject */
  function SitemediasDetailController($scope, $state, $stateParams, $feathers, $filter, toastr, adKinds) {
    $scope.adKinds = adKinds;
    $scope.sitemedia = {
    };
    if ($stateParams.id){
      $feathers.service('sitemedias').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.sitemedia = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE SITEMEDIA YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.sitemedias');
        });
    }

    $scope.save = function(){
      $feathers.service('sitemedias').patch($stateParams.id, {
        name: $scope.sitemedia.name,
        active: $scope.sitemedia.active,
        media: $scope.sitemedia.media,
        site: $scope.sitemedia.site,
        cpm: $scope.sitemedia.cpm,
        share: $scope.sitemedia.share,
        kind: $scope.sitemedia.kind,
        download_token: $scope.sitemedia.download_token
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveOptions = function() {
      $feathers.service('sitemedias').patch($stateParams.id, {
        options: $scope.sitemedia.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createSitemedia = function() {
      if ($scope.sitemedia.name && $scope.sitemedia.media && $scope.sitemedia.site ) {
        $feathers.service('sitemedias').create($scope.sitemedia)
          .then(function(sitemedia) {
            toastr.success($filter('translate')('SITEMEDIAS SUCCESSFULLY CREATED'));
            $state.go('settings.sitemedias-detail', {
              id: sitemedia.id,
            });
          })
          .catch(function(error){
            console.log(error);
            toastr.error($filter('translate')('SITEMEDIA NOT CREATED'));
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('SitesDetailController', SitesDetailController);

  /** @ngInject */
  function SitesDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.site = {
    };
    $feathers.service('publishers').find()
      .then(function(result){
        $scope.publishers = result.data;
        if ($stateParams.id){
          $feathers.service('sites').get($stateParams.id, {
            $populate: false
          })
            .then(function(result) {
              $state.current.title = result.name;
              $scope.site = result;
              $scope.debug=JSON.stringify(result, null, 2);
              $scope.$apply();
            })
            .catch(function(error) {
              console.error(error);
              toastr.error($filter('translate')('THE SITE YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
              $state.go('settings.sites');
            });
        }
      });


    $scope.save = function(){
      $feathers.service('sites').patch($stateParams.id, {
        name: $scope.site.name,
        cpm: $scope.site.cpm,
        kind: $scope.site.kind,
        share: $scope.site.share,
        'auto_accept_advertiser': $scope.site['auto_accept_advertiser'],
        active: $scope.site.active,
        publisher: $scope.site.publisher
      })
        .then(function(res){
          console.log(res);
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };


    $scope.saveOptions = function() {
      $feathers.service('sites').patch($stateParams.id, {
        events: $scope.site.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.log(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createSite = function() {
      if ($scope.site.name !== '' && $scope.site.publisher !== undefined){
        $feathers.service('sites').create($scope.site)
          .then(function(site) {
            toastr.success($filter('translate')('SITE SUCCESSFULLY CREATED'));
            $state.go('settings.sites-detail', {
              id: site.id
            });
          })
          .catch(function(error){
            console.log(error);
            toastr.error($filter('translate')('SITE NOT CREATED'));
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('TodoTypesDetailController', TodoTypesDetailController);

  /** @ngInject */
  function TodoTypesDetailController($scope, $state, $stateParams, $feathers, $filter, toastr) {
    $scope.todoType = {
      name: '',
      service_name: '',
      template_text: '',
      description: null,
      trigger_fn: '',
      kind: '',
      active: true,
      options: null,
      showAce: true,
    };

    if ($stateParams.id){
      $feathers.service('todotypes').get($stateParams.id, {
        $populate: false
      })
        .then(function(result) {
          $state.current.title = result.name;
          $scope.todoType = result;
          $scope.debug=JSON.stringify(result, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE TODOTYPE YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('settings.todoTypes');
        });
    }

    $scope.saveTodoTypeCode = async function(todoType) {
      try {
        await $feathers.service('todotypes').patch($stateParams.id, {
          trigger_fn: todoType.trigger_fn
        });
        toastr.success($filter('translate')('CODE SUCCESSFULLY PATCHED'));
      } catch (error) {
        console.error(error);
        toastr.error($filter('translate')('CODE NOT PATCHED'));
      }
    };

    $scope.undoAction = function(todoType) {
      let editor = ace.edit(todoType.id.toString());
      let _session = editor.getSession();
      _session.getUndoManager().undo();
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };
    $scope.redoAction = function(todoType) {
      let editor = ace.edit(todoType.id.toString());
      let _session = editor.getSession();
      _session.getUndoManager().redo();
      angular.element(editor.container).controller('ngModel')
        .$setViewValue(editor.getValue());
    };

    $scope.save = function(){
      $feathers.service('todotypes').patch($stateParams.id, {
        name: $scope.todoType.name,
        active: $scope.todoType.active,
        service_name: $scope.todoType.service_name,
        description: $scope.todoType.description,
        template_text: $scope.todoType.template_text,
        trigger_fn: $scope.todoType.trigger_fn,
        kind: $scope.todoType.kind,
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.error(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.saveOptions = function() {
      $feathers.service('todotypes').patch($stateParams.id, {
        options: $scope.todoType.options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.error(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.showCode = function(todoType) {
      todoType.showAce = todoType.showAce === true ? todoType.showAce = false : todoType.showAce = true;
    };

    $scope.saveTriggerOptions = function() {
      $feathers.service('todotypes').patch($stateParams.id, {
        trigger_options: $scope.todoType.trigger_options
      })
        .then(function(){
          toastr.success($filter('translate')('CHANGES SAVED'));
        })
        .catch(function(error){
          console.error(error);
          toastr.error($filter('translate')('CHANGES NOT SAVED'));
        });
    };

    $scope.createTodoType = function() {

      $scope.checkRequiredValues = function () {
        if ($scope.todoType) {
          if ($scope.todoType.name && $scope.todoType.service_name && $scope.todoType.kind
            && $scope.todoType.template_text) {
            if ($scope.todoType.name !== '' && $scope.todoType.service_name !== '' && $scope.todoType.kind !== ''
              && $scope.todoType.template_text !== '') {
              return true;
            }
          }
        }
        return false;
      };

      if ($scope.checkRequiredValues()){
        $feathers.service('todotypes').create($scope.todoType)
          .then(function(todoType) {
            toastr.success($filter('translate')('TODOTYPE SUCCESSFULLY CREATED'));
            $state.go('settings.todoTypes-detail', {
              id: todoType.id
            });
          })
          .catch(function(error){
            console.error(error);
            toastr.error($filter('translate')('TODOTYPE NOT CREATED'));
          });
      } else {
        toastr.error($filter('translate')('PLEASE FILL ALL INPUTS'));
      }
    };
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('TodoTypesListController', TodoTypesListController);

  /** @ngInject */
  function TodoTypesListController($scope, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.todoTypes = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.trimString = function(string, maxLength){
      if (string && string.length>0 ) {
        if (string.length < maxLength) {
          return string;
        } else {
          let result = string.substring(0, maxLength);
          result += '  ...';
          return result;
        }
      } return '';
    };

    $scope.trimOptionsObject = function(obj, maxLength){
      if (obj) {
        let stringifyObj = JSON.stringify(obj);
        if (stringifyObj.length < maxLength) {
          return stringifyObj;
        } else {
          let result = stringifyObj.substring(0, maxLength);
          result += '  .....  }';
          return result;
        }
      } return '-';
    };

    $scope.getTodoTypes = async function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate){
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }

      try {
        let result = await $feathers.service('todotypes').find(query);
        $scope.todoTypes = result.data;
        tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
        $scope.isLoading = false;
        $scope.$apply();
      } catch (error) {
        console.error(error);
        $scope.isLoading = false;
        $scope.$apply();
      }
    };

  }

})();

/* Minified js for jQuery BackTop */
!function(o){
  o.fn.backTop=function(e){
    var n=this, i=o.extend({
        position: 400, speed: 500, color: 'white'
      }, e), t=i.position, c=i.speed, d=i.color;n.addClass('white'==d?'white':'red'==d?'red':'green'==d?'green':'black'), n.css({
      right: 40, bottom: 40, position: 'fixed'
    }), o(document).scroll(function(){
      var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c);
    }), n.click(function(){
      o('html, body').animate({
        scrollTop: 0
      }, {
        duration: 1200
      });
    });
  };
}(jQuery);
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('RunTasksListController', RunTasksListController);

  /** @ngInject */
  function RunTasksListController($rootScope, $state, $scope, $filter, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.runTasks = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getRunTasks = async function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {
      };

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: {
          }
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'success') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else if (key === 'task_id') {
            query.query.task_id = tableState.search.predicateObject[key];
          } else if (key === 'fromDate') {
            query.query['created'] = query.query['created'] || {};
            query.query['created']['$gte'] = moment.utc(tableState.search.predicateObject[key]).startOf('day');
          } else if (key === 'toDate') {
            query.query['created'] = query.query['created'] || {};
            query.query['created']['$lte'] = moment.utc(tableState.search.predicateObject[key]).endOf('day');
          } else {
            query.query[key] = {
              '$iLike': '%'+tableState.search.predicateObject[key]+'%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }
      try {
        let result = await $feathers.service('tasksrun').find(query);
        $scope.runTasks = result.data;
        tableState.pagination.numberOfPages = Math.ceil(result.total/$scope.smartTablePageSize);
        $scope.isLoading = false;
        $scope.$apply();
      } catch (error){
        console.error(error);
        $scope.isLoading = false;
        $scope.$apply();
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('TasksListController', TasksListController);

  /** @ngInject */
  function TasksListController($rootScope, $state, $scope, $filter, $feathers, hotkeys) {

    $scope.smartTablePageSize = 25;

    $scope.isLoading = false;

    $scope.tasks = [];

    function setPage(adjust) {
      var pager = angular
        .element( $('#pagerId') )
        .isolateScope();
      pager
        .selectPage(pager.currentPage+adjust);
    }

    hotkeys.bindTo($scope)
      .add({
        combo: 'right',
        description: 'Next Page',
        callback: function() {
          setPage(1);
        }
      })
      .add({
        combo: 'left',
        description: 'Previous Page',
        callback: function() {
          setPage(-1);
        }
      });

    $scope.getTasks = async function(tableState) {
      $scope.isLoading = true;
      var pagination = tableState.pagination;

      var start = pagination.start || 0;
      var number = pagination.number || $scope.smartTablePageSize;

      var sort = {};

      if (tableState.sort) {
        if (tableState.sort.predicate) {
          sort[tableState.sort.predicate] = tableState.sort.reverse ? -1 : 1;
        }
      }

      var query = {
        query: {
          $skip: start,
          $limit: number,
          $sort: sort,
          $populate: {}
        }
      };

      if (tableState.search && tableState.search.predicateObject) {
        // search = tableState.search.predicateObject
        for (var key in tableState.search.predicateObject) {
          if (key === 'active') {
            query.query[key] = tableState.search.predicateObject[key];
          } else if (key === 'id') {
            query.query.id = tableState.search.predicateObject[key];
          } else {
            query.query[key] = {
              '$iLike': '%' + tableState.search.predicateObject[key] + '%'
            };
          }
        }
      }
      // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.id) {
      //  query.query.id = tableState.search.predicateObject.id
      // }

      try {
        let result = await $feathers.service('tasks').find(query);
        $scope.tasks = result.data;
        tableState.pagination.numberOfPages = Math.ceil(result.total / $scope.smartTablePageSize);
        $scope.isLoading = false;
        $scope.$apply();
      } catch (error) {
        console.error(error);
        $scope.isLoading = false;
        $scope.$apply();
      }
    };

    $scope.routeToNewTask = function(){
      $state.go('settings.tasks-new');
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('TasksDetailController', TasksDetailController);

  function TasksDetailController($rootScope, $scope, $stateParams, $state, $feathers, $filter, $sce, editableOptions, editableThemes, toastr) {
    $scope.task = {
    };
    $scope.insertionorders = {
    };
    $scope.campaigns = {
    };
    $scope.filters = {
    };

    $scope.filters.selectedParentTask = [];

    if ($stateParams.id && $stateParams.id !== 'new') {
      $feathers.service('tasks').get($stateParams.id, {
        $populate: false
      })
        .then(async function(result) {
          $state.current.title = $filter('translate')('TASK') + ': ' + result.name;
          $scope.task = result;
          if ($scope.task.parent_task) {
            $scope.filters.selectedParentTask = await $feathers.service('tasks').get($scope.task.parent_task);
          }
          $scope.debug=JSON.stringify($scope.ad, null, 2);
          $scope.$apply();
        })
        .catch(function(error) {
          console.error(error);
          toastr.error($filter('translate')('THE TASK YOU REQUESTED DOES NOT EXIST'), $filter('translate')('NOT FOUND'));
          $state.go('tasks.all');
        });


      $feathers.service('tasks').on('updated', function(updated){
        $scope.task = updated;
        $scope.debug=JSON.stringify($scope.task, null, 2);
        $scope.$apply();
      });
    } else {
      $state.current.title = $filter('translate')('NEW TASK');
      $stateParams.id = null;
      $scope.task = {
      };
      $scope.task.active = false;
    }

    $scope.saveConfig = async function() {
      try {
        if ($stateParams.id && $scope.task.id) {
          await $feathers.service('tasks').patch($scope.task.id, {
            parent_task: ($scope.filters.selectedParentTask) ? $scope.filters.selectedParentTask.id : null,
            name: $scope.task.name,
            crontab: $scope.task.crontab,
            action: $scope.task.action,
            active: $scope.task.active,
            kind: $scope.task.kind,
            options: $scope.task.options
          });
          return toastr.success($filter('translate')('CHANGES SAVED'));
        } else {
          toastr.error($filter('translate')('CHANGES NOT SAVED'), $filter('translate')('NO ID AVAILABLE FOR UPDATE'));
        }
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('CHANGES NOT SAVED'));
      }
    };

    $scope.setParentTask = function(){
      if ($scope.filters.selectedParentTask) {
        $scope.task.parent_task = $scope.filters.selectedParentTask.id;

      }
    };

    $scope.createTask = async function() {
      try {
        if ($stateParams.id) {
          await $feathers.service('tasks').patch($stateParams.id, _.clone($scope.task));
          return toastr.success($filter('translate')('CHANGES SAVED'));
        } else if ($scope.task.name) {
          let result = await $feathers.service('tasks').create($scope.task);
          toastr.success($filter('translate')('NEW TASK CREATED'));
          $state.go('settings.tasks-detail', {
            id: result.id
          });
        } else {
          return toastr.error($filter('translate')('PLEASE ENTER A NAME'));
        }
      } catch (error) {
        console.error('error', error);
        return toastr.error($filter('translate')('NOT SAVED'));
      }
    };

    $scope.searchParentTasks = async function(parentTaskName){
      try {
        let query = {
          $select: ['id', 'name'],
          name: {
            $ilike: '%'+parentTaskName+'%'
          }, $limit: 20
        };
        let result = await $feathers.service('tasks').find({
          query: query
        });
        $scope.possibleParentTask = result.data;
        $scope.$apply();
      } catch (error){
        console.log('searchParentTask Error', error);
      }
    };

    $scope.routeToNewInsertionorder = function(){
      $state.go('insertionorders.new', {
        task_id: $scope.task.id
      });
    };
  }
})();
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/theme/directives/jsonEditorToggleMode.html","<div><div ng-jsoneditor=\"\" ng-model=\"source\" options=\"editorOptions ? editorOptions : {mode: \'tree\', modes: [\'tree\', \'code\']}\" ng-style=\"{\'height\': height + \'px\'}\"></div></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"panel panel-danger contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">This tool is under development.</div><div class=\"panel-body\">Please report errors to dev@contactimpact.de</div></div>");
$templateCache.put("app/pages/login/login.html","<main class=\"auth-main\" ng-controller=\"LoginController\"><div class=\"auth-block\"><div style=\"text-align: center;\"><img src=\"/assets/img/logo_adup.png\" style=\"max-width: 100%; padding: 20px 0\"></div><form class=\"form-horizontal\" ng-submit=\"submit()\"><div class=\"form-group\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\" translate=\"\">USERNAME</label><div class=\"col-sm-7\"><input type=\"text\" ng-model=\"username\" class=\"form-control\" id=\"inputUsername\" placeholder=\"Username\"></div></div><div class=\"form-group\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\" translate=\"\">PASSWORD</label><div class=\"col-sm-7\"><input type=\"password\" ng-model=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"Password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-7\"><button type=\"submit\" class=\"btn btn-ci btn-auth\" translate=\"\">LOGIN</button> <a href=\"https://adops.adup.tech/auth/forgot-password\" uib-tooltip=\"adops.adup.tech verwendet die gleichen Zugangsdaten\" class=\"forgot-pass\" translate=\"\">FORGOT PASSWORD?</a></div></div></form></div><div><ul style=\"list-style-type: none; padding-left: 20px; color: grey;bottom: 0;left: 0;position: absolute;text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\"><li>{{appVersion}}</li><li>{{apiVersion}}</li></ul></div></main>");
$templateCache.put("app/pages/profile/profile.html","<div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"activeTabIndex\"><uib-tab heading=\"{{\'NOTIFICATIONS\'|translate}}\"><div class=\"horizontal-scroll\"><th><button class=\"btn btn-info\" ng-click=\"markAllNotificationsAsRead()\">{{\'MARK ALL AS READ\'|translate}}</button></th><table class=\"table table-hover\" st-persist=\"notificationsList\" st-pipe=\"getNotifications\" st-table=\"notifications\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"read\" translate=\"\">READ</th><th translate=\"\">TEXT</th><th translate=\"\">TODO ID</th><th st-sort=\"created\" translate=\"\">CREATED</th><th translate=\"\">ACTION</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\" translate=\"\">TRUE</option><option value=\"false\" translate=\"\">FALSE</option></select></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-style=\"!item.read && {\'background-color\':\'#0b74b9\', \'color\': \'white\'} || {}\" ng-repeat=\"item in notifications\"><td class=\"table-id\">{{item.id}}</td><td>{{item.read}}</td><td>{{item.text}}</td><td><a ui-sref=\"todos.detail({id: item.todo_id})\">#{{item.todo_id}}</a></td><td><span>{{ formatDateTime(item.created) }}</span></td><td><div><button class=\"btn btn-info\" ui-sref=\"todos.detail({id: item.todo_id})\" ng-show=\"item.todo_id\">{{\'GOTO TODO\'|translate}}</button> <button class=\"btn btn-primary\" ng-click=\"notificationViewed(item.id)\" ng-show=\"!item.read\">{{\'MARK AS READ\'|translate}}</button></div></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></uib-tab><uib-tab active=\"active\" heading=\"{{\'OPTIONS\'|translate}}\"><h3 class=\"with-line\" translate=\"\">CHANGE PASSWORD</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\" translate=\"\">CURRENT PASSWORD</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputCurrentPassword\" placeholder=\"\" ng-model=\"helperUser.currentPassword\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\" translate=\"\">NEW PASSWORD</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" ng-model=\"profile.password\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\" translate=\"\">CONFIRM PASSWORD</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\" ng-model=\"profile.confirmPassword\"></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"changePassword()\"><i class=\"ion-android-checkmark-circle\"></i>{{\'CHANGE PASSWORD\'|translate}}</button><h3 class=\"with-line\" ng-if=\"todoTypesNotificationSettings\" translate=\"\">CHANGE NOTIFICATIONS</h3><table ng-if=\"todoTypesNotificationSettings\" class=\"table table-hover\" st-persist=\"notificationSettingList\" st-pipe=\"getNotificationSettings\" st-table=\"notificationSettings\"><thead><tr><th translate=\"\">ACTIVE</th><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">DESCRIPTION</th></tr></thead><tbody><tr ng-repeat=\"item in todoTypesNotificationSettings\"><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"item.notificationVisible\" ng-change=\"changeNotificationIsActive(item)\"> <span></span></label></td><td><span>{{item.id}}</span></td><td><span>{{item.name}}</span></td><td><span>{{item.description}}</span></td></tr></tbody></table></uib-tab></uib-tabset></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{item.tooltip}}\"><img ng-if=\"::item.img\" ng-src=\"/assets/img/{{::item.img}}\" style=\"width:14px; margin-right: 18px;display:inline-block;\"> <i class=\"{{ ::item.icon }}\" ng-if=\"::item.icon\"></i><span translate=\"\">{{ ::item.title}}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{item.tooltip}}\"><i class=\"{{ ::item.icon }}\"></i><span translate=\"\">{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span translate=\"\">{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\" translate=\"\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\" translate=\"\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\" translate=\"\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\" translate=\"\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div><div><ul style=\"list-style-type:none;margin-top: -40px;overflow-wrap: break-word;padding-left: 10px;color: #333;\"><li>{{ appVersion }}</li><li>{{ apiVersion }}</li></ul></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ (activePageTitle.includes(\'ALL\') || activePageTitle.includes(\'NEW\') || activePageTitle.includes(\'CAMPAIGN\') || activePageTitle.includes(\'ADMEDIA\'))? (activePageTitle | translate) : activePageTitle}}</h1><ul class=\"breadcrumb al-breadcrumb\"><li><a ui-sref=\"dashboard\">{{\'HOME\' | translate}}</a></li><li>{{ (activePageTitle.includes(\'ALL\') || activePageTitle.includes(\'NEW\'))? (activePageTitle | translate) : activePageTitle}}</li></ul></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><style>\n        .msg-list a:hover {\n            background-color: #e4e6e9 !important;\n            color: black!important;\n        }\n        .top-dropdown-menu {\n          width: 400px;\n        }\n      .top-dropdown-menu .msg-list > a .msg-area {\n         width: 316px;\n      }\n    </style><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>{{numberUnreadNotifications}}</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong translate=\"\">NOTIFICATIONS</strong> <a href=\"\" ng-click=\"markAllNotificationsAsRead()\" translate=\"\">MARK ALL AS READ</a> <a href=\"\" ui-sref=\"profile.tab({tab: \'options\'})\" translate=\"\">SETTINGS</a></div><div class=\"msg-list\"><a href=\"\" ng-click=\"notificationViewed(item.id)\" ui-sref=\"todos.detail({id: item.todo_id})\" ng-style=\"!item.read && {\'background-color\':\'#0b74b9\', \'color\': \'white\'} || {}\" class=\"clearfix\" ng-repeat=\"item in notifications\" style=\"border-bottom: 1px solid lightgray\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::(\'assets/img/notification.svg\') }}\"></div><div class=\"msg-area\"><div>{{item.text}}</div><div>{{item.options}}</div><span>{{formatDateTime(item.created)}}</span></div></a></div><a href=\"\" ui-sref=\"profile.tab({tab: \'notifications\'})\" translate=\"\">SEE ALL NOTIFICATIONS</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a ui-sref=\"dashboard\" class=\"al-logo clearfix\"><img src=\"/assets/img/logo_adup.png\" style=\"max-width: 130px;\"></a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"hidden search\"><i class=\"ion-ios-search-strong\" ng-click=\"startSearch()\"></i> <input id=\"searchInput\" type=\"text\" placeholder=\"{{\'SEARCH_FOR\' | translate}}...\"></div><div class=\"user-profile clearfix\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img gravatar-src=\"user.email\" gravatar-size=\"100\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a ui-sref=\"profile\"><i class=\"fa fa-user\"></i>{{\'PROFILE\' | translate}}</a></li><li><a href=\"\" ng-click=\"logout()\" class=\"signout\"><i class=\"fa fa-power-off\"></i>{{\'SIGNOUT\' | translate}}</a></li></ul></div><msg-center></msg-center></div></div>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/theme/directives/recursiveTargetingTree/addEditTargetingTree.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{targeting.id ? \'EDIT TARGETING\' : \'ADD TARGETING\'| translate}}</h4></div><div class=\"modal-body\"><uib-tabset active=\"active\"><uib-tab heading=\"{{\'CONFIG\'|translate}}\" index=\"0\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-1\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"category\" translate=\"\">TYPE TO SEARCH CATEGORY</label> <input id=\"category\" placeholder=\"{{\'SEARCH REQUESTCATEGORY\'|translate}}\" type=\"text\" ng-model=\"targeting.requestcategory\" uib-typeahead=\"cat as cat.path for cat in searchRequestCategory($viewValue)\" typeahead-loading=\"loadingCategory\" typeahead-no-results=\"noResults\" class=\"form-control\" typeahead-min-length=\"1\" typeahead-input-formatter=\"formatLabel($model)\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"resetSearch\" translate=\"\">RESET CATEGORY SEARCH</label> <button id=\"resetSearch\" ng-click=\"targeting.requestcategory= targeting.copyRequestcategory\" class=\"form-control\" translate=\"\">RESET</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" type=\"text\" ng-model=\"targeting.name\" id=\"name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"weight\" translate=\"\">WEIGHT</label> <input id=\"weight\" type=\"number\" class=\"form-control\" ng-model=\"targeting.weight\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"defaultweight\" translate=\"\">DEFAULTWEIGHT</label> <input id=\"defaultweight\" type=\"number\" class=\"form-control\" ng-model=\"targeting.defaultweight\"></div></div></div></div></div></uib-tab><uib-tab heading=\"{{\'MATCH\'|translate}}\" select=\"tabTwoRendered = true\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-1\"><json-editor-toggle-mode source=\"targeting.match\" overwrite-height=\"200\"></json-editor-toggle-mode></div></div></uib-tab><uib-tab heading=\"{{\'OVERWRITE\'|translate}}\" select=\"tabThreeRendered = true\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-1\"><json-editor-toggle-mode source=\"targeting.overwrite\" opts=\"adOverwritesAutoComplete\" overwrite-height=\"200\"></json-editor-toggle-mode></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveTargeting(targeting)\" translate=\"\">{{targeting.id ? \'SAVE\' : \'ADD TARGETING\'}}</button></div></div>");
$templateCache.put("app/theme/directives/recursiveTargetingTree/recursiveTargetingTreeBody.html","<style>\n    .angular-ui-tree-node, .angular-ui-tree-placeholder, .ng-hide {\n        position: relative;\n        margin: 0px;\n        padding: 0px;\n        min-height: 0px !important;\n        line-height: 0px !important;\n    }\n    .table-responsive-sm {\n        width: 100%;\n        max-width: 100%;\n        margin-top: 0px;\n    }\n</style><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" data-nodrag=\"\" ng-style=\"{\'background-color\': visible(node)[1]}\" style=\"padding: 5px 10px; cursor:default !important ; color:#373737; min-height: 0px; {{\'border-left: 5px solid hsl(\' + (-65 + (65 * this.$nodeScope.depth())) + \',80%, 70%); margin-right:0;\'}}\" ng-hide=\"visible(node)[0]\"><div class=\"row\"><div class=\"col-md-10\"><table class=\"table-responsive-sm\"><thead class=\"text-left\"><tr><th style=\"width: 3%\" scope=\"col\"><a ng-if=\"node.nodes\" data-nodrag=\"\" style=\"cursor: pointer\" ng-click=\"toggle(this)\"><span class=\"glyphicon\" style=\"color: #555555; top:15px\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></a></th><th style=\"width: 10%\" scope=\"col\">{{\'ID\' | translate}}</th><th style=\"width: 25%\" scope=\"col\">{{\'NAME\' | translate}}</th><th scope=\"col\" ng-repeat=\"attr in showAttributes\">{{(attr && node[attr] != null) ? (attr.toUpperCase() | translate) : \'\'}}</th><th style=\"width: 5%\" scope=\"col\">{{node.requestcategory ? (\'MATCH\' | translate): \'\'}}</th><th style=\"width: 5%\" scope=\"col\">{{node.requestcategory ? (\'OVERWRITE\' | translate): \'\'}}</th></tr></thead><tbody class=\"text-left\"><tr><td></td><td>{{node.id}}</td><td>{{node.name}}</td><td ng-repeat=\"attr in showAttributes\">{{(attr && node[attr] !== null) ? (node[attr]) : \'\'}}</td><td><i ng-if=\"node.requestcategory\" tooltip-placement=\"top\" uib-tooltip=\"{{node.match}}\" ng-class=\"isAnObject(node.match) ? \'fa fa-check\' : \'fa fa-times\'\" style=\"{{(isAnObject(node.match)) ? \'color:green\': \'color:red\'}}\"></i></td><td><i ng-if=\"node.requestcategory\" tooltip-placement=\"top\" uib-tooltip=\"{{node.overwrite}}\" ng-class=\"isAnObject(node.overwrite) ? \'fa fa-check\' : \'fa fa-times\'\" style=\"{{(isAnObject(node.overwrite)) ? \'color:green\': \'color:red\'}}\"></i></td></tr></tbody></table></div><div class=\"pull-right col-xs-1\" style=\"top:7px\"><span class=\"pull-right\" ng-if=\"node.requestcategory\"><div class=\"btn-group\" role=\"group\" style=\"display:flex;\"><button class=\"btn btn-default\" ng-click=\"addEditNode(node, true, this)\"><span class=\"glyphicon glyphicon-cog\"></span></button> <button class=\"btn btn-default\" ng-click=\"deleteNode(node, this)\"><span class=\"fa fa-trash\"></span></button></div></span></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in node.nodes\" ui-tree-node=\"\" data-collapsed=\"true\"><recursive-targeting-tree-body></recursive-targeting-tree-body></li><li ng-if=\"node.total > limit\" ng-click=\"getAllChildren(this)\"><div class=\"tree-node tree-node-content load-all\" data-nodrag=\"\"><div class=\"row\"><div class=\"col-md-12\"><span class=\"col-md-2 col-md-offset-5 text-center\">{{\'LOAD ALL\' | translate}}</span></div></div></div></li></ol>");
$templateCache.put("app/theme/directives/recursiveTargetingTree/recursiveTargetingTreeTop.html","<div ui-tree=\"treeOptions\" id=\"e\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"input-group\"><span class=\"input-group-addon\">{{\'SEARCH\'|translate}}</span> <input type=\"text\" class=\"form-control\" aria-label=\"...\" ng-model=\"inputSearch\" ng-change=\"findNodes(this)\"> <span class=\"input-group-addon\"><input type=\"checkbox\" ng-model=\"showOnlyFoundItems\" ng-change=\"findNodes(this)\" aria-label=\"...\"> {{\'SHOW ONLY FOUND ITEMS\'|translate}}</span> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"expandAndCollapseAll(this)\" type=\"button\"><span class=\"glyphicon glyphicon-move\"></span> {{(expandAndCollapseString | translate)}}</button></span></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"nodes\"><li ng-repeat=\"node in nodes\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><recursive-targeting-tree-body inputsearch=\"\"></recursive-targeting-tree-body></li></ol></div>");
$templateCache.put("app/theme/directives/recursiveTree/recursiveTreeBody.html","<div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"cursor:default !important ; color:#373737; {{\'border-left: 5px solid hsl(\' + (-65 + (65 * this.$nodeScope.depth())) + \',80%, 70%); margin-right:0;\'}}\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"col-md-1\"><a data-nodrag=\"\" style=\"cursor: pointer\" ng-click=\"customToggle(this, true)\"><span class=\"glyphicon\" style=\"color: #555555\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></a></div><div class=\"col-md-3\"><span>{{node.id}}</span></div><div class=\"col-md-4\"><span>{{node.name || (\'EMPTY\'| translate)}}</span></div></div><div class=\"col-md-7\"><span ng-repeat=\"attr in showAttributes\" class=\"col-md-2\">{{attr}}: {{attr !== \'active\' && attr !== \'average\' ? node[attr]: \'\'}} <i ng-if=\"attr === \'active\' || attr === \'average\'\" ng-class=\"node[attr] ? \'fa fa-check\' : \'fa fa-ban\'\" style=\"{{(attr === \'active\' || attr === \'average\') ? (node[attr]? \'color:green\': \'color:red\'): \'\'}}\"></i></span></div><div class=\"col-md-1\"><div class=\"pull-right\"><a class=\"btn btn-default btn-xs\" data-toggle=\"tooltip\" title=\"Add new element to node\" ng-click=\"addEditNode(node, false, this)\"><span class=\"glyphicon glyphicon-plus\"></span></a> <a class=\"btn btn-default btn-xs\" data-toogle=\"tooltip\" title=\"Edit node\" data-nodrag=\"\" ng-click=\"addEditNode(node, true, this)\"><span class=\"glyphicon glyphicon-edit\"></span></a> <a class=\"btn btn-default btn-xs\" data-toggle=\"tooltip\" title=\"Delete node\" data-nodrag=\"\" ng-click=\"deleteNode(this, node)\"><span class=\"glyphicon glyphicon-remove\"></span></a></div></div><div class=\"col-md-2\"><input class=\"form-control input input-xs ui-tree-input\" type=\"text\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" ng-model=\"searchInput\" ng-change=\"findNodes(searchInput, node.id, this)\" data-nodrag=\"\"></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in node.nodes\" ui-tree-node=\"\" data-collapsed=\"true\"><recursive-tree-body></recursive-tree-body></li><li ng-if=\"node.total > limit\" ng-click=\"getAllChildren(this)\"><div class=\"tree-node tree-node-content load-all\" data-nodrag=\"\"><div class=\"row\"><div class=\"col-md-12\"><span class=\"col-md-2 col-md-offset-5 text-center\">{{\'LOAD ALL\' | translate}}</span></div></div></div></li></ol>");
$templateCache.put("app/theme/directives/recursiveTree/recursiveTreeTop.html","<div ui-tree=\"treeOptions\" id=\"e\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"nodes\"><li ng-repeat=\"node in nodes\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><recursive-tree-body></recursive-tree-body></li></ol></div>");
$templateCache.put("app/pages/advertisers/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'ADVERTISERS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW ADVERTISER\'| translate}}\" ba-panel-new-click=\"routeToNewAdvertiser()\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-persist=\"advertisersList\" st-pipe=\"getAdvertisers\" st-table=\"advertisers\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th translate=\"\">CREATED</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in advertisers\"><td class=\"table-id\"><a ui-sref=\"advertisers.detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td><td><span>{{ \'with_date\'|translate:{date:item.created} }}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/advertisers/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"advertisers.all\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createAdvertiser()\" ng-show=\"!advertiser.id\">{{\'CREATE ADVERTISER\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"advertiser.name\"></div><div class=\"form-group\"><label for=\"comment\" translate=\"\">COMMENT</label> <textarea class=\"form-control\" id=\"comment\" ng-model=\"advertiser.comment\"></textarea></div><div class=\"form-group\"><label for=\"created\" translate=\"\">CREATED</label> <label id=\"created\" class=\"form-control\">{{ \'with_date\'|translate:{date:advertiser.created} }}</label></div><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"advertiser.active\"> <span translate=\"\">ACTIVE</span></label></div><button ng-show=\"advertiser.id\" type=\"button\" ng-click=\"saveConfig()\" class=\"btn btn-default\" translate=\"\">SAVE CONFIG</button></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'INSERTION ORDERS\'|translate}}\" ba-panel-class=\"medium-panel panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW INSERTION ORDER\'| translate}}\" ba-panel-new-click=\"routeToNewInsertionorder()\"><table class=\"table\" st-table=\"insertionorders\"><thead><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">DOWNLOADTOKEN</th></thead><tr ng-repeat=\"insertionorder in insertionorders\" class=\"ng-scope\"><td><a ui-sref=\"insertionorders.detail({id: insertionorder.id})\">#{{insertionorder.id}}</a></td><td>{{insertionorder.name}}</td><td>{{insertionorder.download_token}}</td></tr></table></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"medium-panel panel-primary with-scroll\"><json-editor-toggle-mode source=\"advertiser.options\" overwrite-height=\"290\"></json-editor-toggle-mode></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CREDENTIALS\'|translate}}\" ba-panel-class=\"medium-panel panel-primary with-scroll\"><json-editor-toggle-mode source=\"advertiser.credentials\" overwrite-height=\"290\"></json-editor-toggle-mode></div></div></div></div>");
$templateCache.put("app/pages/forecast/forecast/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel panel-primary animated zoomIn\" ba-panel-title=\"{{\'GEOGRAPHY\'|translate}}\"><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-geography-precision\" translate=\"\">PRECISION</label><ion-slider id=\"input-geography-precision\" type=\"single\" grid=\"true\" min=\"1\" max=\"5\" from=\"input.precision\" disable=\"precisionDisabled\" on-change=\"changePrecision\"></ion-slider></div><div class=\"form-group\"><label for=\"input-geography-distance\" translate=\"\">DISTANCE</label><ion-slider id=\"input-geography-distance\" type=\"single\" grid=\"true\" min=\"0\" max=\"300\" postfix=\"km\" from=\"distance\" disable=\"distanceDisabled\" on-change=\"changeDistance\"></ion-slider></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-zips\" translate=\"\">ZIPS</label> <textarea class=\"form-control\" id=\"input-zips\" ng-model=\"input.unparsed\" ng-change=\"changed(input.unparsed)\" rows=\"14\"></textarea> <span class=\"help-block sub-little-text\" translate=\"\">You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.</span></div><div class=\"form-group\"><label for=\"input-combine\" translate=\"\">COMBINE ZIPS</label> <input type=\"checkbox\" class=\"form-control\" id=\"input-combine\" ng-model=\"input.combine\" ng-change=\"changed(input.unparsed)\"> <span class=\"help-block sub-little-text\" translate=\"\">Sum all zips instead of using them as unique rows.</span></div></div></div></div></div><div class=\"col-md-6\" style=\"position:relative;z-index:9999;\"><div ba-panel=\"\" ba-panel-class=\"panel panel-primary animated zoomIn\" ba-panel-title=\"{{\'INVENTORY\'|translate}}\"><div class=\"panel-body\"><div class=\"col-md-6\"><label for=\"input-inventory-sites\" translate=\"\">SITES</label><div class=\"form-group\"><select class=\"form-control\" id=\"input-inventory-sites\" selectpicker=\"\" title=\"\" multiple=\"\" ng-model=\"input.sites\" ng-options=\"item as item.name for item in sites track by item.id\"></select></div><label for=\"input-inventory-channels\" translate=\"\">CHANNELS</label><div class=\"form-group\"><select class=\"form-control\" id=\"input-inventory-channels\" selectpicker=\"\" title=\"\" multiple=\"\" ng-model=\"input.channels\" ng-options=\"item as item.name for item in channels track by item.id\"></select></div><span class=\"help-block sub-little-text\" translate=\"\">NO SELECTION = RUN ON PORTFOLIO</span> <span class=\"help-block sub-little-text\" translate=\"\">HOLD CTRL FOR MULTIPLE SELECT</span></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-inventory-daterange\" translate=\"\">HOW MANY DAYS?</label> <input class=\"form-control\" id=\"input-inventory-daterange\" type=\"text\" ng-model=\"input.days\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\">DEVICE TYPE</label></div></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"input-inventory-device\" ng-model=\"input.type\" id=\"inlineRadio1\" value=\"desktop\" checked=\"checked\"> <span>Desktop</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"input-inventory-device\" ng-model=\"input.type\" id=\"inlineRadio2\" value=\"mobile\"> <span>Mobile</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"input-inventory-device\" ng-model=\"input.type\" id=\"inlineRadio3\" value=\"any\"> <span>Any</span></label></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"\">PAGE SETTINGS</label></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"pageSettings custom-radio nowrap\"><input type=\"radio\" ng-model=\"input.pageSettings\" value=\"excludeHome\" checked=\"checked\"> <span translate=\"\">EXCLUDE HOME</span></label></div><div class=\"col-md-6\"><label class=\"pageSettings custom-radio nowrap\"><input type=\"radio\" ng-model=\"input.pageSettings\" value=\"onlyHome\"> <span translate=\"\">ONLY HOME</span></label></div><div class=\"col-md-6\"><label class=\"pageSettings custom-radio nowrap\"><input type=\"radio\" ng-model=\"input.pageSettings\" value=\"all\"> <span translate=\"\">ALL</span></label></div></div></div></div></div></div></div><div class=\"col-md-6 hidden\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel panel-default\"><div uib-accordion-heading=\"\">{{\'TIME FROM-TO\'|translate}}</div><div class=\"row\"><div class=\"col-md-4\"><input class=\"form-control\" placeholder=\"{{\'TIME FROM\'|translate}}\" type=\"text\" ng-model=\"input.fromTime\" lng-clockpicker=\"\" lng-clockpicker-options=\"timepicker_options\"></div><div class=\"col-md-4\"><input class=\"form-control\" placeholder=\"{{\'TIME TO\'|translate}}\" type=\"text\" ng-model=\"input.toTime\" lng-clockpicker=\"\" lng-clockpicker-options=\"timepicker_options\"></div><div class=\"col-md-4\"><button type=\"button\" ng-click=\"resetTime()\" class=\"btn btn-default\" translate=\"\">RESET TIME</button></div></div></div></uib-accordion></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary\" ba-panel-title=\"{{\'QUERY\'|translate}}\"><div class=\"panel-body\"><button progress-button=\"getForecast()\" pb-style=\"rotate-side-down\" type=\"button\" class=\"btn btn-default btn-with-icon\" ng-disabled=\"queryDisabled\"><i class=\"ion-loop\"></i>{{\'QUERY AVAILABILITY\'|translate}}</button> <small ng-if=\"queryTime\">Last query took {{queryTime}}ms.</small></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'RESULT\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block row\"><div class=\"col-md-12\"><button class=\"btn btn-xs btn-default\" ng-click=\"showOutput=!showOutput\">{{\'SHOW/HIDE OUTPUT\'|translate}}</button></div></div><div class=\"section-block row\"><div class=\"col-md-12\"><table class=\"table\"><thead><tr class=\"black-muted-bg\"><th translate=\"\">INPUT</th><th ng-if=\"showOutput\" translate=\"\">OUTPUT</th><th translate=\"\">STATUS</th><th translate=\"\">IMPRESSIONS</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in forecast\" ng-class=\"{danger:value.status!=\'OK\'}\"><td>{{value.input}}</td><td ng-if=\"showOutput\" class=\"small\">{{value.zips | join }}</td><td>{{value.status}}</td><td>{{value.impressions}}</td></tr></tbody><tfoot><tr><th></th><th ng-if=\"showOutput\"></th><th></th><th>{{sums.impression}}</th><th></th></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/insertionorders/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'INSERTION ORDERS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW INSERTION ORDER\'| translate}}\" ba-panel-new-click=\"routeToNewInsertionorder()\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-persist=\"insertionordersList\" st-pipe=\"getInsertionorders\" st-table=\"insertionorders\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th translate=\"\">CREATED</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in insertionorders\"><td class=\"table-id\"><a ui-sref=\"insertionorders.detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td><td><span>{{ \'with_date\'|translate:{date:item.created} }}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/insertionorders/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"insertionorders.all\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createInsertionorder()\" ng-show=\"!insertionorder.id\">{{\'CREATE INSERTION ORDER\'|translate}}</button> <button class=\"btn btn-info\" ui-sref=\"advertisers.detail({id: insertionorder.advertiser_id})\" ng-show=\"insertionorder.advertiser_id\">{{\'ADVERTISER\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"insertionorder.name\"></div><div class=\"form-group\"><label for=\"advertiser\" translate=\"\">ADVERTISER</label><div class=\"input-group\"><ui-select id=\"advertiser\" ng-model=\"insertionorder.advertiser\" title=\"Choose Advertiser\"><ui-select-match placeholder=\"{{\'SELECT ADVERTISER\'|translate}}\">{{insertionorder.advertiser.name}} ({{insertionorder.advertiser.id}})</ui-select-match><ui-select-choices repeat=\"io in possibleAdvertiser track by $index\" refresh=\"searchAdvertiser($select.search)\" refresh-delay=\"500\">{{io.name}} ({{io.id}})</ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"insertionorder.advertiser.id\"><a class=\"btn btn-default\" ng-href=\"#/advertisers/{{insertionorder.advertiser.id}}\" target=\"_blank\" translate=\"\">GO TO ADVERTISER</a></span> <span class=\"input-group-btn\"><a class=\"form-control btn btn-primary\" ng-href=\"#/advertisers/new\" target=\"_blank\" translate=\"\">CREATE ADVERTISER</a></span></div></div><div class=\"form-group\"><label for=\"download_token\" translate=\"\">DOWNLOADTOKEN</label><div class=\"input-group\"><label id=\"download_token\" class=\"form-control\">{{insertionorder.download_token}}</label> <span class=\"input-group-btn\" ng-if=\"insertionorder.download_token\"><a class=\"btn btn-default\" target=\"_blank\" href=\"https://stats.df-srv.de/v2/external/overview/{{insertionorder.download_token}}/\" translate=\"\">EXTERNAL STATISTICS</a></span></div></div><div class=\"form-group\"><label for=\"comment\" translate=\"\">COMMENT</label> <textarea class=\"form-control\" id=\"comment\" ng-model=\"insertionorder.comment\"></textarea></div><div class=\"form-group\"><label for=\"created\" translate=\"\">CREATED</label> <label id=\"created\" class=\"form-control\">{{ \'with_date\'|translate:{date:insertionorder.created} }}</label></div><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"insertionorder.active\"> <span translate=\"\">ACTIVE</span></label></div><button ng-show=\"insertionorder.id\" type=\"button\" ng-click=\"saveConfig()\" class=\"btn btn-default\" translate=\"\">SAVE CONFIG</button></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"medium-panel panel-primary with-scroll\"><json-editor-toggle-mode source=\"insertionorder.options\" overwrite-height=\"290\"></json-editor-toggle-mode></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CAMPAIGNS\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW CAMPAIGN\'| translate}}\" ba-panel-new-click=\"routeToNewCampaign()\"><table class=\"table\" st-table=\"campaigns\"><thead><th translate=\"\">ID</th><th translate=\"\">ACTIVE</th><th translate=\"\">KIND</th><th translate=\"\">SUBKIND</th><th translate=\"\">NAME</th><th translate=\"\">TYPE</th><th translate=\"\">VOLUME TYPE</th><th translate=\"\">TARGET VOLUME</th></thead><tr ng-repeat=\"campaign in campaigns\" class=\"ng-scope\"><td><a ui-sref=\"ads.detail({id: campaign.id})\">#{{campaign.id}}</a></td><td>{{campaign.active}}</td><td>{{campaign.kind}}</td><td>{{campaign.subkind}}</td><td>{{campaign.name}}</td><td>{{campaign.target.type}}</td><td>{{campaign.target.volume_type}}</td><td>{{campaign.target.volume}}</td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/ads/addEditCatalog/addEditCatalog.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button></div><div class=\"modal-body\"><div class=\"col-md-12\"><catalog-wizard></catalog-wizard></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/ads/addEditCoupon/addEditCoupon.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button></div><div class=\"modal-body\"><div class=\"col-md-12\"><coupon-wizard></coupon-wizard></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/ads/addEditOverwrites/addEditOverwrite.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{overwrite.id ? \'EDIT OVERWRITE\' : \'ADD OVERWRITE\'| translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><div class=\"form-group\"><label for=\"comment\" translate=\"\">COMMENT</label> <input id=\"comment\" class=\"form-control\" ng-model=\"overwrite.comment\"></div></div></div><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><div class=\"form-group\"><label for=\"from\" translate=\"\">FROM</label><div id=\"from\" class=\"form-control input-sm\" moment-picker=\"overwrite.from_date\" locale=\"{{moment.locale()}}\" format=\"DD.MM.YYYY\">{{overwrite.from_date|| \'Select date\'}}</div></div></div></div><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><div class=\"form-group\"><label for=\"to\" translate=\"\">TO</label><div id=\"to\" class=\"form-control input-sm\" moment-picker=\"overwrite.to_date\" locale=\"{{moment.locale()}}\" format=\"DD.MM.YYYY\">{{overwrite.to_date|| \'Select date\'}}</div></div></div></div><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"overwrite.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div></div><div class=\"col-md-6\"><json-editor-toggle-mode source=\"overwrite.overwrites\" opts=\"adOverwritesAutoComplete\" overwrite-height=\"400\"></json-editor-toggle-mode></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveOverwrite(overwrite)\" translate=\"\">{{overwrite.id ? \'SAVE\' : \'ADD OVERWRITE\'}}</button></div></div>");
$templateCache.put("app/pages/ads/addEditRegioTargetings/addEditRegioTargeting.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{\'EDIT REGIO TARGETING\' | translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"panel panel-primary animated zoomIn\" ba-panel-title=\"{{\'GEOGRAPHY\'|translate}}\"><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-geography-precision\" translate=\"\">PRECISION</label><ion-slider id=\"input-geography-precision\" type=\"single\" grid=\"true\" min=\"1\" max=\"5\" from=\"input.precision\" on-change=\"changePrecision\"></ion-slider></div><div class=\"form-group\"><label for=\"input-geography-distance\" translate=\"\">DISTANCE</label><ion-slider id=\"input-geography-distance\" type=\"single\" grid=\"true\" min=\"0\" max=\"300\" postfix=\"km\" from=\"input.distance\" on-change=\"changeDistance\"></ion-slider></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-zips\" translate=\"\">ZIPS</label> <textarea class=\"form-control\" id=\"input-zips\" ng-model=\"input.unparsed\" ng-change=\"changed(input.unparsed)\" rows=\"14\"></textarea> <span class=\"help-block sub-little-text\" translate=\"\">You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.</span></div></div></div><div class=\"section-block row\"><div class=\"col-md-12\"><button class=\"btn btn-xs btn-default\" ng-click=\"showOutputLines=!showOutputLines\">{{\'SHOW/HIDE OUTPUT\' | translate}}</button></div></div><div class=\"section-block row\"><div class=\"col-md-12\"><table class=\"table\"><thead><tr class=\"black-muted-bg\"><th style=\"max-width: 33%\" translate=\"\">INPUT</th><th translate=\"\" ng-if=\"showOutputLines\">OUTPUT</th><th translate=\"\">STATUS</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in forecast\" ng-class=\"{danger:value.status!=\'OK\'}\"><td>{{trimString(value.input.toString(), 100)}}</td><td ng-if=\"showOutputLines\" class=\"small\">{{value.zips ? (value.zips | join) : \'\' }}</td><td>{{value.status}}</td></tr></tbody></table></div></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'ALL ZIPS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block row\"><div class=\"col-md-12\"><h3>{{allZips.length}} PLZ</h3><p>{{allZips.join(\', \')}}</p></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveRegioTargeting()\" translate=\"\">{{idxGeoTargeting < 0 ? \'CREATE REGIO TARGETING\' : \'EDIT REGIO TARGETING\'}}</button></div></div>");
$templateCache.put("app/pages/ads/addEditTargetings/addEditTargeting.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{targeting.id ? \'EDIT TARGETING\' : \'ADD TARGETING\'| translate}}</h4></div><div class=\"modal-body\"><uib-tabset active=\"active\"><uib-tab heading=\"{{\'CONFIG\'|translate}}\" index=\"0\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"category\" translate=\"\">TYPE TO SEARCH CATEGORY</label> <input id=\"category\" placeholder=\"{{\'SEARCH REQUESTCATEGORY\'|translate}}\" type=\"text\" ng-model=\"targeting.requestcategory\" uib-typeahead=\"cat as cat.path for cat in searchRequestCategory($viewValue)\" typeahead-loading=\"loadingCategory\" typeahead-no-results=\"noResults\" class=\"form-control\" typeahead-min-length=\"1\" typeahead-input-formatter=\"formatLabel($model)\"></div><div><span>{{targeting.requestcategory.path}}</span></div></div><div class=\"col-md-4\"><button id=\"resetSearch\" ng-click=\"targeting.requestcategory= targeting.copyRequestcategory\" class=\"btn btn-default pull-right\" translate=\"\">RESET</button></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label><small>Optional</small> <input class=\"form-control\" type=\"text\" ng-model=\"targeting.name\" id=\"name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"weight\" translate=\"\">WEIGHT</label><small>1000 = 100 %, Gewichtung falls Targeting greift</small> <input id=\"weight\" type=\"number\" class=\"form-control\" ng-model=\"targeting.weight\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"defaultweight\" translate=\"\">DEFAULTWEIGHT</label><small>0 = 0 %, Gewichtung falls Targeting nicht greift</small> <input id=\"defaultweight\" type=\"number\" class=\"form-control\" ng-model=\"targeting.defaultweight\"></div></div></div></uib-tab><uib-tab heading=\"{{\'MATCH\'|translate}}\" select=\"tabTwoRendered = true\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-1\"><json-editor-toggle-mode source=\"targeting.match\" overwrite-height=\"200\"></json-editor-toggle-mode></div></div></uib-tab><uib-tab heading=\"{{\'OVERWRITE\'|translate}}\" select=\"tabThreeRendered = true\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-1\"><json-editor-toggle-mode source=\"targeting.overwrite\" opts=\"adOverwritesAutoComplete\" overwrite-height=\"200\"></json-editor-toggle-mode></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveTargeting(targeting)\" translate=\"\">{{targeting.id ? \'SAVE\' : \'ADD TARGETING\'}}</button></div></div>");
$templateCache.put("app/pages/ads/addEditTarget/addEditTarget.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"color:black;\">{{ad.target.volume ? \'EDIT TARGET\' : \'ADD TARGET\' | translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-1\"><div class=\"form-group\"><label for=\"distribution\" translate=\"\">DISTRIBUTION</label><select id=\"distribution\" class=\"form-control\" ng-model=\"ad.target.distribution\" ng-options=\"d.value as d.text for d in distributions\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"target\" translate=\"\">TARGET VOLUME</label> <input id=\"target\" type=\"text\" class=\"form-control\" ng-model=\"helpertarget.volume\" ng-change=\"beautifyNumberTargetVolume()\" ng-init=\"beautifyNumberTargetVolume()\"></div></div><div class=\"row\"><div class=\"col-md-4 col-md-offset-1\"><div class=\"form-group\"><label for=\"type\" translate=\"\">TYPE</label><select id=\"type\" class=\"form-control\" ng-model=\"ad.target.type\" ng-options=\"t.value as (t.text | translate) for t in targetTypes\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"volumeType\" translate=\"\">VOLUME TYPE</label><select id=\"volumeType\" class=\"form-control\" ng-model=\"ad.target.volume_type\" ng-options=\"vt.value as (vt.text | translate) for vt in volumeTypes\"></select></div></div></div><div class=\"row\"><div class=\"col-md-4 col-md-offset-1\"><div class=\"form-group\"><label for=\"from_date\" translate=\"\">FROM</label><div id=\"from_date\" class=\"form-control input-sm\" moment-picker=\"ad.target.from_date\" locale=\"{{moment.locale()}}\" format=\"DD.MM.YYYY HH:mm\" set-on-select=\"true\" today=\"true\">{{ad.target.from_date || \'Select date\'}}</div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"to_date\" translate=\"\">TO</label><div id=\"to_date\" class=\"form-control input-sm\" moment-picker=\"ad.target.to_date\" locale=\"{{moment.locale()}}\" format=\"DD.MM.YYYY HH:mm\" set-on-select=\"true\" today=\"true\">{{ad.target.to_date || \'Select date\'}}</div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"resetDates\" translate=\"\">RESET DATE</label> <button id=\"resetDates\" type=\"button\" class=\"form-control\" ng-click=\"resetDates()\" translate=\"\">RESET</button></div></div></div><div class=\"row\" style=\"margin-top:2em;\"><div class=\"col-md-8 col-md-offset-1\"><div class=\"form-group\"><label for=\"input-pacing\" translate=\"\">PACING</label> <input ion-slider=\"\" id=\"input-pacing\" type=\"single\" grid=\"true\" min=\"0\" max=\"100\" postfix=\"%\" from=\"pacing\" disable=\"distanceDisabled\" on-change=\"changePacing\"></div></div><div class=\"row\" ng-if=\"ad.target.distribution && ad.target.distribution !== \'daily\'\"><div class=\"col-md-6 col-md-offset-3\"><div class=\"row\" ng-if=\"ad.target.distribution===\'weekly\'\"><div class=\"col-md-2\"><label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"filter.mode\" value=\"boolean\"><span>BOOLEAN</span></label></div><div class=\"col-md-2 col-md-offset-2\"><label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"filter.mode\" value=\"number\"><span>VOLUME</span></label></div></div><hr><div class=\"row\"><form ng-if=\"filter.mode===\'boolean\'\"><div class=\"col-md-3 col-md-offset-2\"><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[1]\" type=\"checkbox\"> <span class=\"col-md-2\" translate=\"\">MONDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[2]\" type=\"checkbox\"> <span class=\"col-md-2\" translate=\"\">TUESDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[3]\" type=\"checkbox\"> <span translate=\"\">WEDNESDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[4]\" type=\"checkbox\"> <span translate=\"\">THURSDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[5]\" type=\"checkbox\"> <span translate=\"\">FRIDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[6]\" type=\"checkbox\"> <span translate=\"\">SATURDAY</span></label></div><div class=\"checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"ad.target.filter[0]\" type=\"checkbox\"> <span translate=\"\">SUNDAY</span></label></div></div><div class=\"col-md-3\"><button class=\"btn btn-default\" ng-click=\"switchCheckboxDays()\" translate=\"\">{{!switchCheckboxDaysBool ? \'CHECK ALL\' : \'UNCHECK ALL\'}}</button></div></form><form ng-if=\"filter.mode===\'number\'\"><div class=\"col-md-6 col-md-offset-2\"><div class=\"form-group\"><label for=\"monday\" translate=\"\">MONDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[1]\" class=\"form-control\" id=\"monday\"></div><div class=\"form-group\"><label for=\"tuesday\" translate=\"\">TUESDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[2]\" class=\"form-control\" id=\"tuesday\"></div><div class=\"form-group\"><label for=\"wednesday\" translate=\"\">WEDNESDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[3]\" class=\"form-control\" id=\"wednesday\"></div><div class=\"form-group\"><label for=\"thursday\" translate=\"\">THURSDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[4]\" class=\"form-control\" id=\"thursday\"></div><div class=\"form-group\"><label for=\"friday\" translate=\"\">FRIDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[5]\" class=\"form-control\" id=\"friday\"></div><div class=\"form-group\"><label for=\"saturday\" translate=\"\">SATURDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[6]\" class=\"form-control\" id=\"saturday\"></div><div class=\"form-group\"><label for=\"sunday\" translate=\"\">SUNDAY</label> <input type=\"number\" ng-model=\"ad.target.filter[0]\" class=\"form-control\" id=\"sunday\"></div></div></form></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveTarget(ad.target)\" translate=\"\">{{ad.target.volume ? \'SAVE\' : \'ADD TARGET\'}}</button></div></div></div>");
$templateCache.put("app/pages/ads/all/AdsList.html","<div class=\"widgets\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CAMPAIGNS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW CAMPAIGN\'| translate}}\" ba-panel-new-click=\"routeToNewCampaign()\"><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6 text-right\"><div class=\"form-group\"><label>Profit filter:</label> <label ng-repeat=\"sumProfitState in [\'neutral\',\'positive\',\'negative\']\" class=\"checkbox-inline custom-checkbox nowrap\" ng-class=\"(sumProfitState===\'positive\')?\'tableRow-positiveProfit\':(sumProfitState===\'negative\')?\'tableRow-negativeProfit\':\'\'\"><input type=\"checkbox\" name=\"selectedSumProfitStateCB\" value=\"{{sumProfitState}}\" ng-checked=\"selectedSumProfitStates.indexOf(sumProfitState) > -1\" ng-click=\"toggleSelection(sumProfitState)\"> <span>{{sumProfitState}}</span></label></div></div></div><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table\" st-persist=\"adsListFilter\" st-pipe=\"getAds\" st-table=\"ads\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"\" translate=\"\">MEDIAS</th><th st-sort=\"revenue_type\" translate=\"\">REVENUE TYPE</th><th st-sort=\"kind\" translate=\"\">KIND</th><th st-sort=\"subkind\" translate=\"\">SUBKIND</th><th st-sort=\"network\" translate=\"\">NETWORK</th><th translate=\"\">ACTION</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th></th><th></th><th><select st-search=\"kind\" class=\"input-sm form-control\" ng-model=\"kind\"><option value=\"\" translate=\"\">ALL</option><option ng-repeat=\"(key, value) in adKinds\" value=\"{{key}}\">{{key}}</option></select></th><th><select ng-disabled=\"!adKinds[kind].length>0\" st-search=\"subkind\" class=\"input-sm form-control\" ng-model=\"subkind\"><option selected=\"\" value=\"\" translate=\"\">ALL</option><option ng-repeat=\"(key, value) in adKinds[kind]\" value=\"{{value}}\">{{value}}</option></select></th><th><select st-search=\"network\" class=\"input-sm form-control\" ng-model=\"networkType\"><option selected=\"\" value=\"\" translate=\"\">ALL</option><option ng-repeat=\"networkType in networkTypes\">{{networkType}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in ads | filter: sumProfitStateFilter\" ng-class=\"(item.sumProfitState === \'positive\') ? \'tableRow-positiveProfit\': item.sumProfitState === \'negative\' ? \'tableRow-negativeProfit\': \'\'\"><td class=\"table-id\"><a ui-sref=\"ads.detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td><i class=\"{{(item.active) ? \'fa fa-check\': \'fa fa-ban\'}}\" style=\"{{(item.active) ? \'color:green;\' : \'color:red;\'}}\"></i></td><td style=\"{{((item.admedias | filter: {\'active\': \'true\', \'status\': \'OK\'}: \'true\' ).length===0)? \'color: red; font-weight: bold;\' : \'\'}}\">{{(item.admedias | filter: {\'active\': \'true\', \'status\': \'OK\'}: \'true\').length}}/{{item.admedias.length}}</td><td>{{item.revenue_type}}</td><td>{{item.kind}}</td><td>{{item.subkind || (\'EMPTY\' | translate)}}</td><td>{{item.network.network || (\'EMPTY\' | translate)}}</td><td><div class=\"btn-group\" role=\"group\" style=\"display:flex;\"><a class=\"btn btn-default adsListProfit\" ui-sref=\"ads.detail({id: item.id})\"><span class=\"glyphicon glyphicon-cog\"></span></a> <a class=\"btn btn-default adsListProfit\" style=\"padding:3px;\" ui-sref=\"statistics.dailyadsitemedia({ads: item.id, subkind: item.subkind, kind: item.kind, from: item.target.from_date, to: item.target.to_date})\"><sales-statistics sales-item=\"item.salesOverPeriod\"></sales-statistics></a></div></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\"><div id=\"pager\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100,200]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/ads/assignPlacementGroups/assignPlacementGroups.html","<style>\n    th {\n        font-weight: 500;\n    }\n</style><div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{\'DIRECT TARGETING\'|translate}}</h4></div><div class=\"modal-body\"><div><div class=\"col-md-6\"><div><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset><uib-tab heading=\"{{\'PLACEMENTGROUPS\'|translate}}\"><div style=\"height:530px;\" class=\"form-group\"><table class=\"table table-hover\" st-pipe=\"getAllPlacementGroups\" st-table=\"allPlacementGroups\"><thead style=\"position: relative; display: block\"><tr style=\"width:100%; display: block\"></tr><tr class=\"sortable\"><th width=\"71%\" st-sort=\"name\" style=\"text-align: left; padding: 0 0 0 25px\" translate=\"\">NAME</th><th width=\"20%\" translate=\"\"></th><th width=\"100px\" style=\"padding-right: 0px;\" translate=\"\">STATUS</th></tr><tr><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th><div style=\"min-width: 50px\"></div></th></tr></thead><tbody style=\"display:block; height: 415px; overflow-y: auto; overflow-x: hidden;\"><tr style=\"width: 100%; display: block\"></tr><tr ng-repeat=\"ow in allPlacementGroups\"><td style=\"padding: 0 0 0 25px;line-height: 20px; width:76%; text-align: left\">{{ow.name}}</td><td style=\"padding: 0px 8px;line-height: 20px; width:20%\"></td><td style=\"padding: 0px 8px;line-height: 20px; min-width: 75px\"><div class=\"row-sm pull-right\"><div class=\"form-group-xs\"><div class=\"btn-group-xs\"><label class=\"{{ow.include === true?\'active\':\'\'}}\" ng-click=\"addPlacementGroups(ow, true, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === true?\'color:green\':\'color:grey\'}}\"></span></label> <label class=\"{{ow.include === false?\'active\':\'\'}}\" ng-click=\"addPlacementGroups(ow, false, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === false?\'color:red\':\'color:grey\'}}\"></span></label></div></div></div></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading=\"{{\'INVENTORIES\'|translate}}\"><div style=\"height:530px;\" class=\"form-group\"><table class=\"table table-hover\" st-pipe=\"getAllInventories\" st-table=\"allInventories\"><thead style=\"position: relative; display: block\"><tr style=\"width:100%; display: block\"></tr><tr class=\"sortable\"><th style=\"width: 71%; text-align: left; padding: 0 0 0 25px\" st-sort=\"name\" translate=\"\">NAME</th><th width=\"20%\" translate=\"\">KIND</th><th width=\"100px\" style=\"padding-right: 0px;\" translate=\"\">STATUS</th></tr><tr><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select ng-init=\"inventory.kind = inventoryKinds[0]\" st-search=\"kind\" id=\"kind\" class=\"input-sm form-control search-input\" ng-model=\"inventory.kind\"><option ng-repeat=\"inventoryKind in inventoryKinds\">{{inventoryKind}}</option></select></th><th><div style=\"min-width: 50px\"></div></th></tr></thead><tbody style=\"display: block; height: 415px; overflow-y: auto; overflow-x: hidden;\"><tr style=\"width: 100%; display: block\"></tr><tr ng-repeat=\"ow in allInventories\"><td style=\"padding: 0 0 0 25px;line-height: 20px; width:76%; text-align: left\">{{ow.name}}</td><td style=\"padding: 0px 8px;line-height: 20px; width:20%\">{{ow.kind}}</td><td style=\"padding: 0px 8px;line-height: 20px; min-width:75px\"><div class=\"row-sm pull-right\"><div class=\"form-group-xs\"><div class=\"btn-group-xs\"><label class=\"{{ow.include === true?\'active\':\'\'}}\" ng-click=\"addInventories(ow, true, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === true?\'color:green\':\'color:grey\'}}\"></span></label> <label class=\"{{ow.include === false?\'active\':\'\'}}\" ng-click=\"addInventories(ow, false, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === false?\'color:red\':\'color:grey\'}}\"></span></label></div></div></div></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset><uib-tab heading=\"{{\'SELECTED\'|translate}}\"><div style=\"height:530px;\" class=\"form-group\"><h3 ng-if=\"selectedPlacementGroups.length>0\">{{\'PLACEMENTGROUPS\'|translate}}</h3><table class=\"table table-xs table-hover\" ng-if=\"selectedPlacementGroups.length>0\"><thead style=\"position:relative; display: block\"><tr style=\"width:100%; display: block\"></tr><tr class=\"sortable\" style=\"font-weight: 300\"><th width=\"71%\" style=\"text-align: left; padding: 0 0 0 25px\" translate=\"\">NAME</th><th width=\"20%\" translate=\"\"></th><th width=\"100px\" style=\"padding-right: 0px;\" translate=\"\">STATUS</th></tr></thead><tbody style=\"display: block; height: 175px; overflow-y: auto;\"><tr style=\"width: 100%; display: block\"></tr><tr ng-repeat=\"ow in selectedPlacementGroups\"><td style=\"padding: 0 0 0 25px; line-height: 20px; width: 76%; text-align: left\">{{ow.placementgroup.name}}</td><td style=\"padding: 0px 8px; line-height: 20px; width: 20%\"></td><td style=\"padding: 0px 8px; line-height: 20px; min-width: 75px\"><div class=\"form-group-xs pull-right\"><div class=\"btn-group-xs\"><label class=\"{{ow.include === true?\'active\':\'\'}}\" ng-click=\"changePlacementGroups(ow, true, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === true ? \'color:green\': \'color:grey\'}}\"></span></label> <label class=\"{{ow.include === false?\'active\':\'\'}}\" ng-click=\"changePlacementGroups(ow, false, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === false ? \'color:red\' : \'color:grey\'}}\"></span></label></div></div></td></tr></tbody></table><br><h3 ng-if=\"selectedInventories.length>0\">{{\'INVENTORIES\'|translate}}</h3><table class=\"table table-hover\" ng-if=\"selectedInventories.length>0\"><thead style=\"position:relative; display: block;\"><tr style=\"width:100%; display: block\"></tr><tr class=\"sortable\"><th width=\"71%\" style=\"text-align: left; padding: 0 0 0 25px\" translate=\"\">NAME</th><th width=\"20%\" translate=\"\">KIND</th><th width=\"100px\" style=\"padding-right: 0px;\" translate=\"\">STATUS</th></tr></thead><tbody style=\"display: block; height: 175px; overflow-y: auto;\"><tr style=\"width: 100%; display: block\"></tr><tr ng-repeat=\"ow in selectedInventories\"><td style=\"padding: 0 0 0 25px;line-height: 20px; width: 76%; text-align: left\">{{ow.inventory.name}}</td><td style=\"padding: 0px 8px;line-height: 20px; width: 20%\">{{ow.inventory.kind}}</td><td style=\"padding: 0px 8px;line-height: 20px; min-width:75px\"><div class=\"form-group-xs pull-right\"><div class=\"btn-group-xs\"><label class=\"{{ow.include === true?\'active\':\'\'}}\" ng-click=\"changeInventories(ow, true, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === true?\'color:green\':\'color:grey\'}}\"></span></label> <label class=\"{{ow.include === false?\'active\':\'\'}}\" ng-click=\"changeInventories(ow, false, radioModel)\" ng-model=\"radioModel\" uib-btn-radio=\"\'active\'\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{ow.include === false?\'color:red\':\'color:grey\'}}\"></span></label></div></div></td></tr></tbody></table></div></uib-tab></uib-tabset></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div>");
$templateCache.put("app/pages/ads/cloneAd/cloneAd.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-class=\"panel-primary animated zoomIn\" ba-panel-title=\"{{\'INPUT\'|translate}}\"><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">KIND</label><select class=\"form-control input-sm\" ng-model=\"filters.kind\"><option value=\"\" translate=\"\">ALL</option><option value=\"performance\">Performance</option><option value=\"regio\">Regio</option><option value=\"old\">Old</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE AD</label> <input id=\"advertiser\" type=\"text\" ng-model=\"filters.selectedAd\" uib-typeahead=\"ad as ad.name for ad in searchAds($viewValue)\" typeahead-loading=\"loadingAds\" typeahead-no-results=\"noResults\" typeahead-min-length=\"3\" typeahead-on-select=\"onSelect($item)\" aria-describedby=\"describeAds\" class=\"form-control\"></div></div></div><div ng-if=\"ad.id\" ba-panel=\"\" ba-panel-class=\"panel-primary animated zoomIn\" ba-panel-title=\"{{\'CHOOSE OPTIONS\'|translate}}\"><div class=\"header-wrapper\"><div><label translate=\"\">CHOOSE NEW AD NAME</label> <input class=\"form-control input-large\" ng-model=\"adname.name\"></div><div><button class=\"btn btn-default\" ng-click=\"updateAll()\" translate=\"\">{{filters.selectAll ? \'DESELECT ALL\' : \'CHOOSE ALL\'}}</button></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"table-responsive\"><div class=\"table-header-wrapper\"><div translate=\"\" class=\"header-text\">CHOOSE ADMEDIAS</div><button class=\"btn btn-default\" ng-click=\"updateByType(\'admedias\')\" translate=\"\">{{filters.admedias ? \'DESELECT ALL\' : \'CHOOSE ALL\'}}</button></div><table class=\"table table-bordered\"><thead><tr><th translate=\"\">CLONE</th><th translate=\"\">ID</th><th translate=\"\">TYPE</th><th translate=\"\">NAME</th><th translate=\"\">SIZE</th></tr></thead><tbody><tr ng-repeat=\"admedia in ad.admedias\"><td class=\"col\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-checked=\"filters.selectAll\" ng-model=\"admedia.choose\" ng-change=\"validateItems(\'admedias\')\"> <span></span></label></td><td>{{admedia.id}}</td><td>{{admedia.type}}</td><td>{{admedia.name}}</td><td>{{admedia.size.name + \' (\'+ admedia.size.size +\')\'}}</td></tr></tbody></table><br><div class=\"alert bg-danger\" role=\"alert\" ng-if=\"ad.kind === \'performance\'\"><strong translate=\"\">WARNING!</strong><translate>DO NOT CLONE ADMEDIAS FOR PERFORMANCE CAMPAIGNS</translate></div></div></div><div class=\"col-md-6\"><div class=\"table-responsive\"><div class=\"table-header-wrapper\"><div translate=\"\" class=\"header-text\">CHOOSE TARGETS</div><button class=\"btn btn-default\" ng-click=\"updateByType(\'adrequestdesires\')\" translate=\"\">{{filters.adrequestdesires ? \'DESELECT ALL\' : \'CHOOSE ALL\'}}</button></div><table class=\"table table-bordered\"><thead><tr><th translate=\"\">CLONE</th><th translate=\"\">ID</th><th translate=\"\">NAME</th></tr></thead><tbody><tr ng-repeat=\"target in ad.adrequestdesires\"><td class=\"col\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-checked=\"filters.selectAll\" ng-model=\"target.choose\" ng-change=\"validateItems(\'adrequestdesires\')\"> <span></span></label></td><td>{{target.id}}</td><td>{{target.name}}</td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"table-responsive\"><div class=\"table-header-wrapper\"><div translate=\"\" class=\"header-text\">CHOOSE PLACEMENTGROUPS</div><button class=\"btn btn-default\" ng-click=\"updateByType(\'placementgroups\')\" translate=\"\">{{filters.placementgroups ? \'DESELECT ALL\' : \'CHOOSE ALL\'}}</button></div><table class=\"table table-bordered\"><thead><tr><th translate=\"\">CLONE</th><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">STATUS</th><th translate=\"\">ACTIVE</th></tr></thead><tbody><tr ng-repeat=\"placementgroup in ad.placementgroups\"><td class=\"col\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-checked=\"filters.selectAll\" ng-model=\"placementgroup.choose\" ng-change=\"validateItems(\'placementgroups\')\"> <span></span></label></td><td>{{placementgroup.placementgroup_id}}</td><td>{{placementgroup.placementgroup.name}}</td><td class=\"text-center\"><span style=\"color: green\" class=\"glyphicon glyphicon-ok-circle\" ng-if=\"placementgroup.include\"></span> <span style=\"color: red\" class=\"glyphicon glyphicon-ban-circle\" ng-if=\"!placementgroup.include\"></span></td><td>{{placementgroup.placementgroup.active}}</td></tr></tbody></table></div></div><div class=\"col-md-6\"><div class=\"table-responsive\"><div class=\"table-header-wrapper\"><div translate=\"\" class=\"header-text\">CHOOSE INVENTORIES</div><button class=\"btn btn-default\" ng-click=\"updateByType(\'inventories\')\" translate=\"\">{{filters.inventories ? \'DESELECT ALL\' : \'CHOOSE ALL\'}}</button></div><table class=\"table table-bordered\"><thead><tr><th translate=\"\">CLONE</th><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">STATUS</th><th translate=\"\">ACTIVE</th></tr></thead><tbody><tr ng-repeat=\"inventory in ad.inventories\"><td class=\"col\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-checked=\"filters.selectAll\" ng-model=\"inventory.choose\" ng-change=\"validateItems(\'inventories\')\"> <span></span></label></td><td>{{inventory.inventory_id}}</td><td>{{inventory.inventory.name}}</td><td class=\"text-center\"><span style=\"color: green\" class=\"glyphicon glyphicon-ok-circle\" ng-if=\"inventory.include\"></span> <span style=\"color: red\" class=\"glyphicon glyphicon-ban-circle\" ng-if=\"!inventory.include\"></span></td><td>{{inventory.inventory.active}}</td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-default\" style=\"margin-top: 1em;\" ng-click=\"cloneAd()\" translate=\"\">CLONE AD</button></div></div></div></div></div>");
$templateCache.put("app/pages/ads/createAdmedia/createAdmedia.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" translate=\"\" style=\"color:black;\">ADD CREATIVE</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE SIZE</label><select class=\"form-control\" ng-model=\"newAdcode.size\" ng-options=\"size.id as size.name + \' (\' + size.size + \')\' for size in admediaSizes\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE TYPE</label><select class=\"form-control\" ng-init=\"newAdcode.type=contentTypes[0].type\" ng-model=\"newAdcode.type\" ng-options=\"item.type as item.type for item in contentTypes\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE NAME</label> <input class=\"form-control\" type=\"text\" ng-model=\"newAdcode.name\"></div></div></div><div class=\"row\"><div class=\"col-md-12\" ng-if=\"newAdcode.type !== \'template\'\"><div class=\"form-group\"><label for=\"inputAdcode\" translate=\"\">PLEASE PASTE IN THE CODE</label> <textarea id=\"inputAdcode\" ng-model=\"newAdcode.code\" class=\"form-control\" rows=\"3\" cols=\"110\" required=\"\"></textarea></div></div><div class=\"col-md-6\" ng-if=\"newAdcode.type === \'template\'\"><div class=\"form-group\"><label translate=\"\">CHOOSE TEMPLATE</label><select class=\"col-md-2 form-control\" ng-model=\"newAdcode.code\" ng-options=\"\'\'+template.id as template.name + \' (\' + template.id + \')\' for template in admediaTemplates\"></select></div></div></div></div><div class=\"modal-footer\"><div class=\"col-md-12\"><button class=\"btn btn-default\" ng-click=\"importCreative()\" translate=\"\">IMPORT</button></div></div></div>");
$templateCache.put("app/pages/ads/detail/AdsDetail.html","<style>\n  .modal-xlg{\n    width:75%;\n  }\n</style><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary\"><a class=\"btn btn-primary\" ui-sref=\"ads.all\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"saveAd()\" ng-show=\"!ad.id\">{{\'SAVE\'|translate}}</button> <a class=\"btn btn-info\" ui-sref=\"ads.clone({id: ad.id})\">{{\'CLONE\'|translate}}</a> <a class=\"btn btn-warning\" ui-sref=\"statistics.dailyadsitemedia({ads: ad.id, subkind: ad.subkind, kind: ad.kind, from: ad.target.from_date, to: ad.target.to_date})\">{{\'STATISTICS\'|translate}}</a> <a class=\"btn btn-warning\" ui-sref=\"ads.history({id: ad.id})\">{{\'HISTORY\'|translate}}</a> <a class=\"btn btn-danger\" ng-click=\"saveAd()\" ng-if=\"!detectChanges()\">{{\'SAVE CHANGES\'|translate}}</a></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel-primary\"><div class=\"section-block\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"ad_active\"><span translate=\"\">ACTIVE</span></label> <input type=\"checkbox\" id=\"ad_active\" class=\"form-control\" ng-model=\"ad.active\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"ad.name\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">KIND</label><select class=\"form-control input-sm\" ng-model=\"ad.kind\"><option value=\"\" translate=\"\">ALL</option><option ng-repeat=\"(key, value) in adKinds\" value=\"{{key}}\">{{key}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">SUBKIND</label><select ng-disabled=\"!adKinds[ad.kind].length>0\" class=\"form-control input-sm\" ng-model=\"ad.subkind\"><option value=\"\" translate=\"\">EMPTY</option><option ng-repeat=\"(key, value) in adKinds[ad.kind]\" value=\"{{value}}\">{{value}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"advertiser\" translate=\"\">ADVERTISER</label><div class=\"input-group\"><ui-select id=\"advertiser\" on-select=\"refreshInsertionorders()\" ng-model=\"ad.advertiser\" title=\"Choose Advertiser\"><ui-select-match placeholder=\"{{\'SELECT ADVERTISER\'|translate}}\">{{ad.advertiser.name}}</ui-select-match><ui-select-choices repeat=\"io in possibleAdvertiser track by $index\" refresh=\"searchAdvertiser($select.search)\" refresh-delay=\"500\">{{io.name}} ({{io.id}})</ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"ad.advertiser.id\"><a class=\"btn btn-default\" ng-href=\"#/advertisers/{{ad.advertiser.id}}\" target=\"_blank\" translate=\"\">GO TO ADVERTISER</a></span> <span class=\"input-group-btn\"><a class=\"form-control btn btn-primary\" ng-href=\"#/advertisers/new\" target=\"_blank\" translate=\"\">CREATE</a></span></div></div></div></div><div class=\"row\" ng-if=\"ad.advertiser.id\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"insertionorder\" translate=\"\">INSERTION ORDER</label><div class=\"input-group\"><select id=\"insertionorder\" ng-disabled=\"!ad.advertiser || possibleInsertionorders.length < 1\" class=\"form-control\" ng-model=\"ad.insertionorder_id\" ng-options=\"insertionorder.id as insertionorder.name for insertionorder in possibleInsertionorders\"></select><span class=\"input-group-btn\" id=\"insertionOrderButton\" ng-if=\"ad.insertionorder_id\"><a class=\"btn btn-default\" ng-href=\"#/insertionorders/detail/{{ad.insertionorder_id}}\" target=\"_blank\" translate=\"\">GO TO INSERTION ORDER</a></span> <span class=\"input-group-btn\"><a class=\"form-control btn btn-primary\" ng-href=\"#/insertionorders/new?advertiser_id={{ad.advertiser.id}}\" target=\"_blank\" translate=\"\">CREATE</a></span></div></div><span id=\"describeAdvertiser\" class=\"help-block\" translate=\"\">ADVERTISER AND INSERTIONORDER MUST BE CREATED PREVIOUSLY</span></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"revenueType\" translate=\"\">REVENUE TYPE</label><select id=\"revenueType\" class=\"form-control\" ng-model=\"ad.revenue_type\"><option ng-repeat=\"revenueType in revenueTypes\" value=\"{{revenueType}}\">{{revenueType}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-if=\"[\'CPM\', \'CPC\', \'eCPM\', \'eCPC\'].includes(ad.revenue_type)\"><div class=\"form-group\"><label for=\"revenueValue\" translate=\"\">REVENUE VALUE</label> <input type=\"text\" class=\"form-control\" id=\"revenueValue\" ng-model=\"ad.revenue_value\" money=\"\"></div></div><div class=\"col-md-6\" ng-if=\"[\'CPX\'].includes(ad.revenue_type)\"><div class=\"form-group\"><label for=\"network\" translate=\"\">NETWORK</label><select id=\"network\" class=\"form-control\" ng-model=\"ad.network_id\" ng-options=\"network.id as network.name + \' (\'+network.id+\')\' for network in networks\"><option value=\"\"></option></select></div></div><div class=\"col-md-6\" ng-if=\"[\'CPM\', \'CPC\', \'eCPM\', \'eCPC\'].includes(ad.revenue_type)\"><div class=\"form-group\"><label for=\"revenueShare\" translate=\"\">REVENUE SHARE</label> <input type=\"number\" class=\"form-control\" id=\"revenueShare\" ng-model=\"ad.revenue_percentage\" min=\"0.01\" max=\"1.0\" step=\"0.01\"> <span id=\"describeRevenueShare\" class=\"help-block\">{{ad.revenue_percentage*100}} %</span></div></div><div class=\"col-md-6\" ng-mouseover=\"updateRetargetingStatus()\" uib-tooltip-html=\"retargetingStatus\" ng-if=\"ad.subkind === \'retargeting\'\"><div class=\"form-group\"><label for=\"retargetingToken\" translate=\"\">RETARGETINGTOKEN</label> <input type=\"text\" class=\"form-control\" id=\"retargetingToken\" ng-model=\"ad.retargeting_token\"></div></div><div class=\"col-md-6\" ng-if=\"ad.subkind === \'retargeting\'\"><div class=\"form-group\"><label for=\"createHash\" translate=\"\">CREATE HASH</label> <button id=\"createHash\" type=\"button\" class=\"form-control btn btn-primary\" data-toogle=\"modal\" ng-click=\"createHash()\" translate=\"\">CREATE HASH</button></div></div><div class=\"col-md-6\" ng-if=\"ad.subkind === \'retargeting\'\"><div class=\"form-group\"><label for=\"productFeed\">Productfeed</label> <input id=\"productFeed\" type=\"text\" ng-model=\"ad.productfeed\" uib-typeahead=\"feed as feed.name for feed in searchProductFeeds($viewValue)\" typeahead-loading=\"loadingAdvertiser\" typeahead-no-results=\"noResults\" typeahead-min-length=\"1\" class=\"form-control\"></div></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset><uib-tab heading=\"{{\'COMMENT\'|translate}}\"><div class=\"form-group\"><textarea class=\"form-control\" ng-model=\"ad.comment\" style=\"height: 529px;\"></textarea></div></uib-tab><uib-tab heading=\"{{\'TODOS\'|translate}}\"><div class=\"form-group\"><ul><li ng-repeat=\"todo in todos\"><a ui-sref=\"todos.detail({id: todo.id})\">{{todo.id}}</a> {{todo.todotype.name}} {{todo.status}} {{todo.comment}}</li></ul></div></uib-tab><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"ad.options\" opts=\"adOptionsAutoComplete\"></json-editor-toggle-mode></div></uib-tab><uib-tab heading=\"{{\'RAW\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"ad\"></json-editor-toggle-mode></div></uib-tab><uib-tab ng-if=\"vouchers && vouchers.length > 0\" heading=\"{{\'VOUCHERS\'|translate}} ({{usedVouchers.length}}/{{vouchers.length}})\"><h4>{{\'USED_VOUCHERS\'|translate}}: ({{usedVouchers.length}})</h4><div class=\"codebox\"><div class=\"codes\" ng-repeat=\"code in usedVouchers\"><p class=\"code\">{{code.code}}</p><p class=\"spacer\" ng-if=\"$index < usedVouchers.length - 1\">{{\', \'}}</p></div></div><br><br><h4>{{\'UNUSED_VOUCHERS\'|translate}}: ({{unUsedVouchers.length}})</h4><div class=\"codebox\"><div class=\"codes\" ng-repeat=\"code in unUsedVouchers\"><p class=\"code\">{{code.code}}</p><p class=\"spacer\" ng-if=\"$index < unUsedVouchers.length - 1\">{{\', \'}}</p></div></div></uib-tab></uib-tabset></div></div></div><div class=\"row\" ng-show=\"ad.id\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TARGET\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'CONFIGURE TARGET\'| translate}}\" ba-panel-new-click=\"openAddEditTarget()\" ba-panel-new-icon=\"ion-gear-a\"><table class=\"table\" st-table=\"ad.target\"><thead><tr><th translate=\"\">ACTIVE</th><th translate=\"\">DISTRIBUTION</th><th translate=\"\">TARGET VOLUME</th><th translate=\"\">PACING</th><th translate=\"\">VOLUME TYPE</th><th translate=\"\">TYPE</th><th translate=\"\">FROM</th><th translate=\"\">TO</th></tr></thead><tbody><tr><td><input uib-tooltip=\"{{\'DISABLED TARGET RUN WITHOUT LIMITATION\'|translate}}\" type=\"checkbox\" ng-model=\"ad.target.active\" ng-change=\"saveTarget(ad.target)\"></td><td><span>{{ad.target.distribution}}</span></td><td><span>{{ad.target.volume.toLocaleString()}}</span></td><td><span>{{(ad.target.pacing || ad.target.pacing === 0) ? ((1000-ad.target.pacing)/10) : 0}} %</span></td><td><span>{{ad.target.volume_type.toUpperCase() | translate}}</span></td><td><span>{{ad.target.type.toUpperCase() | translate}}</span></td><td><span>{{(ad.target.from_date | amDateFormat: \'DD.MM.YYYY HH:mm\') || \'empty\'}}</span></td><td><span>{{(ad.target.to_date | amDateFormat: \'DD.MM.YYYY HH:mm\') || \'empty\'}}</span></td></tr></tbody></table></div></div></div><div class=\"row\" ng-show=\"ad.id\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OVERWRITES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'ADD OVERWRITE\'| translate}}\" ba-panel-new-click=\"openAddEditOverwrite()\"><table class=\"table\"><thead><tr><th>#</th><th translate=\"\">ACTIVE</th><th translate=\"\">COMMENT</th><th translate=\"\">OVERWRITES</th><th translate=\"\">FROM</th><th translate=\"\">TO</th><th translate=\"\">ACTION</th></tr></thead><tbody><tr ng-repeat=\"ow in ad.adoverwrites\"><td>{{ow.id}}</td><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"ow.active\" ng-change=\"saveOverwrite(ow)\"> <span></span></label></td><td>{{ow.comment}}</td><td><span data-ng-repeat=\"(key,value) in ow.overwrites\">{{key}}: {{value}}{{$last ? \'\' : \', \'}}</span></td><td><span>{{ow.from_date | date: \'dd.MM.yyyy\' || (\'EMPTY\' | translate)}}</span></td><td><span>{{ow.to_date | date: \'dd.MM.yyyy\' || (\'EMPTY\' | translate)}}</span></td><td><button class=\"btn btn-default\" ng-click=\"openAddEditOverwrite(ow)\"><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table></div></div></div><div class=\"row\" ng-show=\"ad.id\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'DIRECT TARGETING\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-icon=\"ion-gear-a\" ba-panel-new-title=\"{{\'CONFIGURE DIRECT TARGETING\'| translate}}\" ba-panel-new-click=\"openAssignPlacementGroups()\"><h4 ng-if=\"ad.placementgroups.length > 0\">{{\'PLACEMENTGROUPS\'|translate}}</h4><table ng-if=\"ad.placementgroups.length > 0\" class=\"table table-hover\"><thead><tr><th>ID</th><th translate=\"\">ACTIVE</th><th width=\"85%\" translate=\"\">NAME</th><th translate=\"\">STATUS</th></tr></thead><tbody><tr ng-repeat=\"ow in ad.placementgroups\"><td>{{ow.placementgroup_id}}</td><td class=\"text-center\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"ow.active\" ng-change=\"savePlacementGroups(ow)\"> <span></span></label></td><td width=\"75%\">{{ow.placementgroup.name}}</td><td class=\"text-center\"><span style=\"color: green\" class=\"glyphicon glyphicon-ok-circle\" ng-if=\"ow.include\"></span> <span style=\"color: red\" class=\"glyphicon glyphicon-ban-circle\" ng-if=\"!ow.include\"></span></td></tr></tbody></table><br><h4 ng-if=\"ad.inventories.length > 0\">{{\'INVENTORIES\'|translate}}</h4><table ng-if=\"ad.inventories.length > 0\" class=\"table table-hover\"><thead><tr><th>ID</th><th translate=\"\">ACTIVE</th><th width=\"85%\" translate=\"\">NAME</th><th translate=\"\">STATUS</th></tr></thead><tbody><tr ng-repeat=\"ow in ad.inventories\"><td>{{ow.inventory_id}}</td><td class=\"text-center\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"ow.active\" ng-change=\"saveInventories(ow)\"> <span></span></label></td><td width=\"75%\">{{ow.inventory.name}}</td><td class=\"text-center\"><span style=\"color: green\" class=\"glyphicon glyphicon-ok-circle\" ng-if=\"ow.include\"></span> <span style=\"color: red\" class=\"glyphicon glyphicon-ban-circle\" ng-if=\"!ow.include\"></span></td></tr></tbody></table></div></div></div><div class=\"row\" ng-show=\"ad.id\"><div class=\"col-md-12\"><ba-panel options=\"mediaPanelOptions\" ba-panel-class=\"panel-primary\"><table class=\"table\"><thead><tr><th translate=\"\">ID</th><th translate=\"\">ACTIVE</th><th translate=\"\">NAME</th><th>{{\'SIZE\' | translate}}</th><th>{{\'TYPE\' | translate}}</th><th translate=\"\">EDIT</th><th translate=\"\">ACTION</th></tr></thead><tbody><tr ng-repeat-start=\"admedia in ad.admedias | orderBy:\'-id\'\" ng-init=\"generateAdcode(admedia)\"><td>{{admedia.id}} <span class=\"label label-info\" style=\"background-color:#2dacd1\" ng-if=\"admedia.status===\'NEW\'\">{{admedia.status}}</span> <span class=\"label label-success\" ng-if=\"admedia.status===\'OK\'\">{{admedia.status}}</span> <span class=\"label label-warning\" ng-if=\"admedia.status!==\'OK\' && admedia.status!==\'NEW\'\">{{admedia.status}}</span></td><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"admedia.active\" ng-change=\"saveAdmedia(admedia)\"> <span></span></label></td><td><input type=\"text\" class=\"form-control\" ng-model=\"admedia.name\"></td><td><select class=\"form-control\" ng-model=\"admedia.size.id\" ng-options=\"size.id as size.name + \' (\' + size.size + \')\' for size in admediaSizes\"></select></td><td><select class=\"form-control\" ng-model=\"admedia.type\"><option ng-repeat=\"type in contentTypes\" value=\"{{type.type}}\">{{type.type}}</option></select></td><td><button ng-if=\"!admedia.showAce && admedia.type !==\'template\'\" class=\"btn btn-default\" ng-click=\"showCode(admedia)\"><span class=\"glyphicon glyphicon-cog\"></span> <span translate=\"\">CODE</span></button><select ng-if=\"admedia.type === \'template\'\" class=\"form-control\" ng-model=\"admedia.code\" ng-options=\"\'\'+template.id as template.name + \' (\' + template.id + \')\' for template in admediaTemplates\"></select></td><td><div class=\"btn-group\" role=\"group\" style=\"display:flex;\"><button class=\"btn btn-default\" ng-click=\"saveAdmedia(admedia)\"><span class=\"glyphicon glyphicon-floppy-disk\"></span></button> <button class=\"btn btn-default\" ng-click=\"deleteAdmedia(admedia)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default\" ng-click=\"openEditAdmedia(admedia)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-default\" ng-click=\"openPreview(admedia)\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default\" ng-if=\"showCouponEdit(admedia)\" ng-click=\"openEditCoupon(admedia)\"><span class=\"glyphicon glyphicon-flash\"></span></button> <button class=\"btn btn-default\" ng-if=\"showCatalogEdit(admedia)\" ng-click=\"openEditCatalog(admedia)\"><span class=\"glyphicon glyphicon-book\"></span></button></div></td></tr><tr ng-repeat-end=\"\" ng-if=\"admedia.showAce && admedia.type !== \'template\'\"><td colspan=\"7\"><div><div class=\"outer\"><div class=\"row\"><div class=\"sp toolbar tab-pane\" id=\"htmPane\"><div class=\"toolbar\"><button class=\"btn btn-default btn-sm\" title=\"Save only code\" ng-click=\"saveAdmediaCode(admedia)\"><span class=\"glyphicon glyphicon-floppy-disk\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Insert plainclickurl placeholder\" ng-click=\"insertPlainClickUrlPlaceholder(admedia)\">Insert plainclickurl</button> <button class=\"btn btn-default btn-sm\" title=\"Insert longsubid placeholder\" ng-click=\"insertLongsubidPlaceholder(admedia)\">Insert longsubid</button> <button class=\"btn btn-default btn-sm\" title=\"Undo action\" ng-click=\"undoAction(admedia)\"><span class=\"fa fa-undo\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Redo action\" ng-click=\"redoAction(admedia)\"><span class=\"fa fa-undo fa-flip-horizontal\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Close codeview\" ng-click=\"showCode(admedia)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div class=\"editor-container\" style=\"resize:vertical; overflow:auto;\"><div ng-if=\"admedia.showAce && admedia.type !== \'template\'\" class=\"editor\" ui-ace=\"aceOption\" id=\"{{admedia.id}}\" ng-model=\"admedia.code\"></div></div></div></div></div></div></td></tr></tbody></table></ba-panel></div></div><div class=\"row\" ng-show=\"ad.id\"><div class=\"col-md-12\"><ba-panel options=\"targetingTreePanelOptions\" ba-panel-class=\"panel-primary with-scroll\"><div colspan=\"4\" class=\"text-center\" ng-show=\"targetingTreeIsLoading\">{{\'LOADING\' | translate}} ...</div><div colspan=\"6\" class=\"text-center\" ng-show=\"!targetingTreeIsLoading\"><recursive-targeting-tree nodes=\"targetingTreeResult\" type=\"adrequestdesires\" show-add=\"true\" show-attributes=\"attributes\" modal=\"TargetingTree\" adrequestdesires=\"ad.adrequestdesires\" adid=\"ad.id\" ng-if=\"dataHasLoaded && ad.id\"></recursive-targeting-tree></div></ba-panel></div></div></div>");
$templateCache.put("app/pages/ads/editAdmedia/editAdmedia.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" translate=\"\" style=\"color:black;\">EDIT OPTIONS</h4></div><div class=\"modal-body\"><json-editor-toggle-mode source=\"admedia.options\" overwrite-height=\"320\"></json-editor-toggle-mode></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveOptions()\" translate=\"\">SAVE</button></div></div>");
$templateCache.put("app/pages/ads/editAdrequestdesire/editAdrequestdesire.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" translate=\"\" style=\"color:black;\">EDIT ADREQUESTDESIRE MATCH</h4></div><div class=\"modal-body\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab ng-if=\"adrequestdesire.requestcategory.parent == 141689\" heading=\"{{\'MATCH\'|translate}}\"><div class=\"form-group\"><div ng-jsoneditor=\"\" ng-model=\"adrequestdesire.match\" options=\"{mode: \'tree\'}\" style=\"height: 475px;\"></div></div></uib-tab><uib-tab heading=\"{{\'OVERWRITE\'|translate}}\"><div class=\"form-group\"><div ng-jsoneditor=\"\" ng-model=\"adrequestdesire.overwrite\" options=\"{mode: \'tree\'}\" style=\"height: 475px;\"></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveAdrequestdesire()\" translate=\"\">SAVE</button></div></div>");
$templateCache.put("app/pages/ads/exportAdtags/exportAdtags.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"color:black;\">ADTAGS</h4></div><div class=\"modal-body\"><div ng-repeat=\"admedia in admedias\"><div class=\"row\"><div class=\"col-md-3\"><h2>{{admedia.size.name}}</h2></div><div class=\"btn-group\"><button clipboard=\"\" type=\"button\" class=\"btn btn-default\" text=\"admedia.adcode\" on-copied=\"success()\" on-error=\"fail(err)\">{{\'COPY\' | translate}}</button> <a class=\"btn btn-default\" ng-click=\"downloadOneAdcode(admedia)\">{{\'DOWNLOAD\'|translate}}</a></div></div><pre>{{admedia.adcode}}</pre></div><div class=\"btn-group\"><a class=\"btn btn-default\" ng-click=\"downloadAllAdcodes(admedias)\">{{\'DOWNLOAD ALL\' | translate}}</a> <button clipboard=\"\" type=\"button\" class=\"btn btn-default\" text=\"copyAllAdcodes(admedias)\" on-copied=\"success()\" on-error=\"fail(err)\">{{\'COPY ALL\' | translate}}</button></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/ads/history/history.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"ads.detail({id: ad.id})\">{{\'BACK\'|translate}}</a></div></div></div><div class=\"row\"><div class=\"col-md-12\" style=\"position:relative;z-index:9999;\"><div ba-panel=\"\" ba-panel-class=\"panel-primary animated zoomIn\" ba-panel-title=\"{{\'INPUT\'|translate}}\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE FROM</label><div class=\"form-control input-sm\" moment-picker=\"dateRange.from\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.from || \'FROM\' }}</div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE TO</label><div class=\"form-control input-sm\" moment-picker=\"dateRange.to\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.to || \'TO\' }}</div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">DATEFILTER</label><select class=\"form-control input-sm\" ng-change=\"updateDateFilter()\" ng-model=\"filters.selectedDate.model\" ng-options=\"filter.name for filter in filters.selectedDate.availableFilters track by filter.id\"></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"getHistory()\" translate=\"\">GET HISTORY</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"HISTORY\" ba-panel-class=\"panel-primary with-scroll\"><table class=\"table\"><thead><tr><td translate=\"\">DATE</td><td translate=\"\">USER</td><td translate=\"\">SERVICE</td><td translate=\"\">METHOD</td><td translate=\"\">RELATED</td><td>DIFF</td></tr></thead><tbody><tr ng-repeat=\"element in ad.history\"><td style=\"text-align:left;\" class=\"text-nowrap\">{{element.created | amDateFormat:\'dd, L, HH:mm\'}}</td><td>{{element.user.firstname + \' \' + element.user.lastname}}</td><td>{{element.service}}</td><td>{{element.method}}</td><td>{{element.related}}</td><td><json-formatter open=\"2\" json=\"element.diff\"></json-formatter></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/ads/importAdCode/importAdcode.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" translate=\"\" style=\"color:black;\">IMPORT CREATIVE</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">CHOOSE NETWORK</label><select class=\"form-control\" ng-model=\"newAdcode.network\" required=\"\"><option ng-repeat=\"type in importTypes\" value=\"{{type}}\">{{type}}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE SIZE</label><select class=\"form-control\" ng-model=\"newAdcode.size\" ng-options=\"size.id as size.name + \' (\' + size.size + \')\' for size in admediaSizes\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">CHOOSE NAME</label> <input class=\"form-control\" ng-model=\"newAdcode.name\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"inputAdcode\" translate=\"\">PLEASE PASTE IN THE CODE</label> <textarea id=\"inputAdcode\" ng-model=\"newAdcode.code\" class=\"form-control\" rows=\"3\" cols=\"110\" required=\"\"></textarea></div></div><div class=\"col-md-12\" ng-if=\"newAdcode.network === \'belboon\'\"><div class=\"form-group\"><label for=\"belboonPda\" translate=\"\">Belboon PDA</label> <textarea id=\"belboonPda\" ng-model=\"newAdcode.belboon_pda\" class=\"form-control\" rows=\"3\" cols=\"110\" required=\"\"></textarea></div></div><div class=\"col-md-12\" ng-if=\"newAdcode.network === \'leadalliance\'\"><div class=\"form-group\"><label for=\"leadallianceHtlp\" translate=\"\">Leadalliance HTLP</label> <textarea id=\"leadallianceHtlp\" ng-model=\"newAdcode.leadalliance_htlp\" class=\"form-control\" rows=\"3\" cols=\"110\" required=\"\"></textarea></div></div></div><div class=\"col-md-12\"><button class=\"btn btn-default\" ng-click=\"importCreative()\" translate=\"\">IMPORT</button></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/pixels/createHash/createHash.html","<div class=\"modal-content\"><div class=\"modal-header bg-primary\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" translate=\"\">CREATE HASH</h4></div><div class=\"modal-body\"><div class=\"section-block\"><p>{{\'PLEASE FILL ONE OF THE FOLLOWING INPUTS (IF YOU WANT A RANDOM HASH, PLEASE CHECK RANDOM):\'|translate}}</p></div><div class=\"section-block\"><div ng-show=\"!(newAffilinetPid || newAwinPid || newRandom || newWebgainsPid)\" class=\"form-group\"><label for=\"ciAdId\" translate=\"\">CONTACT IMPACT AD ID</label> <input type=\"text\" class=\"form-control\" id=\"ciAdId\" ng-model=\"newCiAdId\"></div><div ng-show=\"!(newCiAdId || newAwinPid || newRandom || newWebgainsPid)\" class=\"form-group\"><label for=\"affilinetPid\" translate=\"\">AFFILINET PID</label> <input type=\"text\" class=\"form-control\" id=\"affilinetPid\" ng-model=\"newAffilinetPid\"></div><div ng-show=\"!(newCiAdId || newAffilinetPid || newRandom || newWebgainsPid)\" class=\"form-group\"><label for=\"awinPid\" translate=\"\">AWIN PID</label> <input type=\"text\" class=\"form-control\" id=\"awinPid\" ng-model=\"newAwinPid\"></div><div ng-show=\"!(newCiAdId || newAffilinetPid || newAwinPid || newRandom)\" class=\"form-group\"><label for=\"webgainsPid\" translate=\"\">WEBGAINS PID</label> <input type=\"text\" class=\"form-control\" id=\"webgainsPid\" ng-model=\"newWebgainsPid\"></div><div ng-show=\"!(newCiAdId || newAffilinetPid || newAwinPid || newWebgainsPid)\" class=\"form-group\"><label id=\"random\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"newRandom\"> <span translate=\"\">RANDOM</span></label></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"createHash(newCiAdId, newAffilinetPid, newAwinPid, newWebgainsPid, newRandom)\" translate=\"\">CREATE HASH</button></div></div>");
$templateCache.put("app/pages/pixels/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"pixels.all\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createPixel()\" ng-show=\"!pixel._id\">{{\'CREATE PIXEL\'|translate}}</button> <button ng-if=\"pixel._id\" class=\"btn btn-danger\" ng-click=\"removePixel()\" translate=\"\">DELETE</button></div><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control input-md\" id=\"name\" type=\"text\" ng-model=\"pixel.name\"></div></div></div><div class=\"form-group\"><label for=\"code\" translate=\"\">CODE</label> <textarea class=\"form-control\" id=\"code\" type=\"text\" ng-model=\"pixel.code\"></textarea></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"hash\" translate=\"\">HASH</label> <input class=\"form-control input-md\" id=\"hash\" placeholder=\"{{\'TYPE IN HASH\'|translate}}\" type=\"text\" ng-model=\"pixel.hash\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"createHash\" translate=\"\">OPENS MODAL TO CREATE NEW HASH</label> <button id=\"createHash\" type=\"button\" class=\"form-control btn btn-primary\" data-toogle=\"modal\" data-ng-click=\"createHash()\" translate=\"\">CREATE HASH</button></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"pixel.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-3\"><button ng-if=\"pixel._id\" type=\"button\" class=\"form-control btn btn-primary\" ng-click=\"saveChanges()\" translate=\"\">SAVE CHANGES</button></div></div></div></div><div ba-panel=\"\" ba-panel-title=\"{{\'CODES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"row\"><table ng-table=\"\" class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=\"width:15%\">Pixel Type</td><td style=\"width:15%\">Pixel Value</td><td style=\"width:60%\">Code</td><td style=\"width:10%\">Edit</td></tr><tbody ng-repeat=\"(keyPixelCodes, valuePixelCodes) in pixel.codes track by $index\"><tr ng-if=\"!isAObject(valuePixelCodes)\"><td><span editable-select=\"keyPixelCodes\" e-class=\"form-control\" e-name=\"pixelType\" e-form=\"rowform\" e-ng-options=\"type.type as type.name for type in types\">{{keyPixelCodes}}</span></td><td></td><td style=\"word-break: break-all;\"><span editable-textarea=\"valuePixelCodes\" e-class=\"form-control\" e-name=\"pixelCode\" e-form=\"rowform\">{{valuePixelCodes}}</span></td><td style=\"white-space: nowrap\"><form editable-form=\"\" name=\"rowform\" onbeforesave=\"saveCodes($data)\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\" translate=\"\">SAVE</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"cancelCodes()\" class=\"btn btn-default\" translate=\"\">CANCEL</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"removeCodes(keyPixelCodes,valuePixelCodes,null,null)\" translate=\"\">DELETE</button></div></td></tr><tr ng-if=\"isAObject(valuePixelCodes)\" ng-repeat=\"(keyPixelValue, valuePixelValue) in pixel.codes[keyPixelCodes] track by $index\"><td><span editable-select=\"keyPixelCodes\" e-class=\"form-control\" e-name=\"pixelType\" e-form=\"rowform\" e-ng-options=\"type.type as type.name for type in types\">{{keyPixelCodes}}</span></td><td><span editable-text=\"keyPixelValue\" e-class=\"form-control\" e-name=\"pixelValue\" e-form=\"rowform\">{{keyPixelValue}}</span></td><style>\n                    .editable-wrap {\n                      width: 100%;\n                    }\n                  </style><td style=\"word-break: break-all\"><span e-class=\"form-control\" editable-textarea=\"valuePixelValue\" e-name=\"pixelCode\" e-form=\"rowform\">{{valuePixelValue}}</span></td><td style=\"white-space: nowrap\"><form editable-form=\"\" name=\"rowform\" onbeforesave=\"saveCodes($data)\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"pixel.codes[\'\']\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\" translate=\"\">SAVE</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"cancelCodes()\" class=\"btn btn-default\" translate=\"\">CANCEL</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"removeCodes(keyPixelCodes,valuePixelCodes,keyPixelValue,valuePixelValue)\" translate=\"\">DELETE</button></div></td></tr></tbody></table><button type=\"button\" class=\"btn btn-default\" ng-click=\"addCodes()\" translate=\"\">ADD ROW</button></div></div></div><div ba-panel=\"\" ba-panel-title=\"{{\'REDIRECTS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"row\"><table ng-table=\"\" class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=\"width:15%\">Redirect Type</td><td style=\"width:15%\">Redirect Value</td><td style=\"width:60%\">Code</td><td style=\"width:10%\">Edit</td></tr><tbody ng-repeat=\"(keyPixelRedirects, valuePixelRedirects) in pixel.redirects track by $index\"><tr ng-if=\"!isAObject(valuePixelRedirects)\"><td><span editable-select=\"keyPixelRedirects\" e-class=\"form-control\" e-name=\"pixelType\" e-form=\"rowform\" e-ng-options=\"type.type as type.name for type in types\">{{keyPixelRedirects}}</span></td><td></td><td style=\"word-break: break-all;\"><span editable-textarea=\"valuePixelRedirects\" e-class=\"form-control\" e-name=\"pixelRedirect\" e-form=\"rowform\">{{valuePixelRedirects}}</span></td><td style=\"white-space: nowrap\"><form editable-form=\"\" name=\"rowform\" onbeforesave=\"saveRedirects($data)\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\" translate=\"\">SAVE</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"cancelRedirects()\" class=\"btn btn-default\" translate=\"\">CANCEL</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"removeRedirects(keyPixelRedirects,valuePixelRedirects,null,null)\" translate=\"\">DELETE</button></div></td></tr><tr ng-if=\"isAObject(valuePixelRedirects)\" ng-repeat=\"(keyPixelValue, valuePixelValue) in pixel.redirects[keyPixelRedirects] track by $index\"><td><span editable-select=\"keyPixelRedirects\" e-class=\"form-control\" e-name=\"pixelType\" e-form=\"rowform\" e-ng-options=\"type.type as type.name for type in types\">{{keyPixelRedirects}}</span></td><td><span editable-text=\"keyPixelValue\" e-class=\"form-control\" e-name=\"pixelValue\" e-form=\"rowform\">{{keyPixelValue}}</span></td><style>\n                  .editable-wrap {\n                    width: 100%;\n                  }\n                </style><td style=\"word-break: break-all\"><span e-class=\"form-control\" editable-textarea=\"valuePixelValue\" e-name=\"pixelRedirect\" e-form=\"rowform\">{{valuePixelValue}}</span></td><td style=\"white-space: nowrap\"><form editable-form=\"\" name=\"rowform\" onbeforesave=\"saveRedirects($data)\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"pixel.redirects[\'\']\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\" translate=\"\">SAVE</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"cancelRedirects()\" class=\"btn btn-default\" translate=\"\">CANCEL</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"removeRedirects(keyPixelRedirects,valuePixelRedirects,keyPixelValue,valuePixelValue)\" translate=\"\">DELETE</button></div></td></tr></tbody></table><button type=\"button\" class=\"btn btn-default\" ng-click=\"addRedirects()\" translate=\"\">ADD ROW</button></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-if=\"pixel.hash\" ba-panel=\"\" ba-panel-title=\"{{\'TAGS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><a class=\"btn btn-default\" ng-click=\"downloadTags()\">{{\'DOWNLOAD ALL\'|translate}}</a></div><div class=\"row\"><pre>\n<ng-repeat ng-repeat=\"type in types\">// {{type.name}} Tag<ng-if ng-if=\"!type.recommended\"> (optional)</ng-if>:<ng-if ng-if=\"type.description\">\n// {{type.description}}</ng-if>\n  {{generateTag(type.type, pixel.hash, type.params)}}\n\n</ng-repeat>\n// [[ und ]] gehören zum Platzhalter und sind bei der Integration zu entfernen.\n          </pre></div><div ng-repeat=\"type in types\"><div class=\"row\" style=\"margin-top:5px;\"><div class=\"col-md-2\" style=\"margin-top:10px;\"><h4>{{type.name}} Tag<small ng-if=\"!type.recommended\">optional</small></h4></div><div class=\"col-md-1\"><button clipboard=\"\" type=\"button\" class=\"btn btn-default\" style=\"margin-bottom:10px;\" text=\"generateTag(type.type, pixel.hash, type.params)\" on-copied=\"success()\" on-error=\"fail(err)\">{{\'COPY\' | translate}}</button></div></div><pre>{{generateTag(type.type, pixel.hash, type.params)}}</pre><input type=\"text\" class=\"form-control\" value=\"{{generateTag(type.type, pixel.hash, type.params)}}\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/pixels/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CAMPAIGNS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"pixels.detail\">{{\'NEW PIXEL\'|translate}}</a><table class=\"table\" st-pipe=\"getAds\" st-table=\"ads\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"hash\" st-sort-default=\"reverse\" translate=\"\">HASH</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th></tr><tr><th><input st-search=\"download_token\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'HASH\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th></tr></thead><tbody><tr ng-repeat=\"item in ads\"><td class=\"table-id\"><a ui-sref=\"pixels.detail({hash: item.hash})\">#{{item.hash}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/productfeeds/all/ProductFeedsList.html","<div class=\"widgets\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'PRODUCTFEEDS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW PRODUCTFEED\'| translate}}\" ba-panel-new-click=\"routeToNewProductFeed()\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table\" st-persist=\"productFeedsList\" st-pipe=\"getProductFeeds\" st-table=\"productFeeds\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"parser\" translate=\"\">PARSER</th><th st-sort=\"import_status\" translate=\"\">IMPORT STATUS</th><th st-sort=\"import_date\" translate=\"\">IMPORT DATE</th><th translate=\"\">ACTION</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th><input st-search=\"parser\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'PARSER\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in productFeeds\"><td class=\"table-id\">#{{item.id}}</td><td>{{item.name}}</td><td><i class=\"{{(item.active) ? \'fa fa-check\': \'fa fa-ban\'}}\" style=\"{{(item.active) ? \'color:green;\' : \'color:red;\'}}\"></i></td><td>{{item.parser}}</td><td>{{item.import_status}}</td><td>{{item.import_date | date: \'dd.MM.yyyy\': locale}}</td><td><a class=\"btn btn-default adsListProfit\" ui-sref=\"productfeeds.detail({id: item.id})\"><span class=\"glyphicon glyphicon-cog\"></span></a></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div id=\"pager\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td><td></td></tr></tfoot></table></div><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100,200]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/productfeeds/detail/ProductFeedsDetail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"productfeeds.all\">{{\'BACK\'|translate}}</a> <a class=\"btn btn-info\" ng-click=\"saveProductFeed()\" ng-if=\"!productFeed.id\">{{\'CREATE PRODUCTFEED\'|translate}}</a> <a ng-if=\"!detectChanges()\" class=\"btn btn-danger\" ng-click=\"saveProductFeed()\" translate=\"\">SAVE</a></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\"><div class=\"section-block\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"productFeed.name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"parser\" translate=\"\">PARSER</label> <input class=\"form-control\" id=\"parser\" ng-model=\"productFeed.parser\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"import_status\" translate=\"\">IMPORT STATUS</label> <input readonly=\"\" class=\"form-control\" id=\"import_status\" ng-model=\"productFeed.import_status\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"button\" translate=\"\">START IMPORT</label> <a id=\"button\" ng-disabled=\"!(productFeed.import_status !== \'running\' || (productFeed.import_status === \'running\' && compareImportDate()))\" ng-click=\"setImportStatus()\" class=\"form-control btn btn-default\" translate=\"\">START IMPORT</a></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"created\" translate=\"\">IMPORTED</label> <label id=\"created\" class=\"form-control\">{{ \'with_date\'|translate:{date:productFeed.import_date} }}</label></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"externalImages\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"externalImages\" ng-model=\"productFeed.external_images\"> <span translate=\"\">EXTERNAL IMAGES</span></label></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"productFeed.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"medium-panel panel-primary with-scroll\"><json-editor-toggle-mode source=\"productFeed.options\" overwrite-height=\"290\"></json-editor-toggle-mode></div></div></div></div>");
$templateCache.put("app/pages/settings/adchecker/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-title=\"{{\'ADMEDIAS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table\" st-pipe=\"getAdmedias\" st-table=\"admedias\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" translate=\"\">ID</th><th st-sort=\"ad\" translate=\"\">AD</th><th st-sort=\"status\" translate=\"\">STATUS</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"modified\" st-sort-default=\"reverse\" translate=\"\">MODIFIED</th><th st-sort=\"created\" translate=\"\">CREATED</th><th st-sort=\"next_check\" translate=\"\">NEXT CHECK</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"ad\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'AD\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"status\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'STATUS\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"1\">true</option><option value=\"0\">false</option><option value=\"\" translate=\"\">ALL</option></select></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in admedias\"><td class=\"table-id\">{{item.id}}</td><td><a ui-sref=\"ads.detail({id: item.ad})\">#{{item.ad}}</a></td><td><span class=\"label label-warning\" ng-if=\"item.status !==\'NEW\'\">{{item.status}}</span> <span class=\"label label-info\" style=\"background-color:#2dacd1\" ng-if=\"item.status ===\'NEW\'\">{{item.status}}</span></td><td>{{item.active}}</td><td><span>{{ \'with_date\'|translate:{date:item.modified} }}</span></td><td><span>{{ \'with_date\'|translate:{date:item.created} }}</span></td><td><span>{{ \'with_date\'|translate:{date:item.next_check} }}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/events/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'BIDDER RELOAD\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"submit()\"><button type=\"submit\" class=\"btn btn-default\" translate=\"\">REFRESH</button></form></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'IMPORT SALES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><form ng-submit=\"startImportSales()\"><div class=\"form-group\"><label for=\"network\" translate=\"\">NETWORK</label><select id=\"network\" class=\"form-control\" ng-model=\"importSales.networkId\" ng-options=\"network.id as network.name + \' (\'+network.id+\')\' for network in networks\"></select></div><div class=\"form-group\"><label for=\"importDays\" translate=\"\">DAYS</label> <input type=\"number\" class=\"form-control\" id=\"importDays\" ng-model=\"importSales.days\" placeholder=\"30\"></div><button type=\"submit\" class=\"btn btn-default\" translate=\"\">IMPORT</button></form></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/inventories/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'Inventories\'}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW INVENTORY\'| translate}}\" ba-panel-new-click=\"createInventory()\"><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\" style=\"color:#373737; {{\'border-left: 5px solid hsl(\' + (-65 + (65 * this.$nodeScope.depth())) + \',80%, 70%);\'}}\"> <div style=\"display: block; margin-right:10px;\"> <a class=\"pull-left\" ng-if=\"node.kind !== \'placement\'\" style=\"cursor: pointer; margin-right:5px;\" data-nodrag ng-click=\"customToggle(this, true)\"> <span style=\"color: #555555\" class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"> </span> </a> <span class=\"pull-left\" style=\"display: inline-block; min-width: 50px; width: 50px; margin-left:5px;\"> {{node.id}} </span> <span data-nodrag style=\"display: inline-block; margin-left:10px; min-width: 100px; width:50%;\"> <a style=\"cursor:text;\" editable-text=\"node.name\" onaftersave=\"saveNode(this)\" blur=\"cancel\"> {{node.name || \'EMPTY\' | translate}} </a> </span> <div style=\" display: inline-block; position: absolute; right: 20px;\"> <a class=\"pull-right\" data-nodrag ng-click=\"removeInventory(this)\" style=\"cursor: pointer\"> <span style=\"color: #e75656\" class=\"glyphicon glyphicon-remove\"> </span> </a> <div class=\"pull-right\" style=\"display:inline-block; text-align: right; margin-right: 10px;\"> <p style=\" font-size: 11px; color: #888888; width:60px;\"> {{node.kind}} </p> </div> <div class=\"pull-right\" style=\"display: inline-block; text-align: right;\"> <input ng-if=\"node.kind !== \'placement\'\" class=\"form-control\" style=\" font-size: 13px; font-weight: normal; min-width:50px; width: 140px; margin-left: 8px; height: 23px;\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" ng-model=\"searchInput\" ng-change=\"this.$nodeScope.$modelValue.searchInput = findNodes(searchInput, node.id, this)\" data-nodrag> </div> <a ng-if=\"node.kind !== \'placement\'\" title=\"{{\'ADD CHILD\'| translate}}\" class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-click=\"newSubItem(node, this)\" style=\"margin-right: 8px;\"> <span class=\"glyphicon glyphicon-plus\"> </span> </a> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node collapsed=\"!node.expanded\" ng-include=\"\'nodes_renderer.html\'\"> </li> <li ng-if=\"node.total > limit\" ng-click=\"customToggle(this, false)\"> <div class=\"tree-node tree-node-content\" data-nodrag style=\"color: #373737; background-color: #ffffff; text-align: center; font-family: Roboto, sans-serif; font-weight: 500; border: 1px solid #98999a; cursor: pointer; \"> <div style=\"min-width:10px; display:inline-flex; line-height: 20px;cursor: pointer;\"> {{\'LOAD ALL\' | translate}} </div> </div> </li> </ol></script><div class=\"row\"><div class=\"col-md-12\"><div ui-tree=\"treeOptions\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"inventories\"><li ng-repeat=\"node in inventories\" ui-tree-node=\"\" collapsed=\"!node.expanded\" ng-include=\"\'nodes_renderer.html\'\"></li></ol></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/locations/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'LOCATIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table\"><thead><tr><th translate=\"\">NAME</th><th translate=\"\">IP</th><th translate=\"\">ZIP</th><th translate=\"\">ACTION</th></tr></thead><tbody><tr ng-repeat=\"location in locations.all()\"><td>{{location.name}}</td><td>{{location.ips|join}}</td><td>{{location.zip}}</td><td><button class=\"btn btn-sm\" ng-click=\"delete(location)\" translate=\"\">DELETE</button></td></tr></tbody></table></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CREATE LOCATION\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><form class=\"row\" ng-submit=\"submit()\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"inputName\" placeholder=\"{{\'NAME\'|translate}}\" ng-model=\"location.name\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"inputIp\" placeholder=\"{{\'IP\'|translate}}\" ng-model=\"location.ip\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"inputZip\" placeholder=\"{{\'ZIP\'|translate}}\" ng-model=\"location.zip\"></div><button type=\"submit\" class=\"btn btn-default\" translate=\"\">CREATE LOCATION</button></form></div></div></div></div></div>");
$templateCache.put("app/pages/settings/placementgroups/index.html","<style>\n    .loader-wrapper {\n        height: 295px;\n        display: flex;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .pagination-wrapper {\n        height: 50px;\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .pagination-button {\n        display: flex;\n        width: 100px;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .no-result-message {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 75px;\n        font-weight: bold;\n    }\n\n  .loader {\n    margin: 5px 0 0 0;\n    border: 5px solid #eef1f2;\n    border-top: 5px solid #0762e3;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    animation: spin 2s linear infinite;\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n</style><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CREATE PLACEMENTGROUP\'| translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW PLACEMENTGROUP\'| translate}}\" ba-panel-new-click=\"createPlacementGroup()\"><div class=\"row\"><div class=\"col-md-8 col-xs-12 col-sm-12 col-lg-8\"><div style=\"display: inline-block; right: 20px; position: absolute; visibility:hidden\" class=\"loader\"></div><input class=\"form-control\" type=\"text\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" ng-model=\"searchGlobalInput\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"findGlobal(searchGlobalInput, true)\" style=\"width: 100%; padding-right:50px;\"><div ui-tree=\"treeOptions\" id=\"tree-root\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"inventories\"><li ng-if=\"totalResults.total > limit && searchGlobalInput && !allLoaded\" ng-click=\"findGlobal(searchGlobalInput, false)\"><div class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"color: #373737; background-color: #ffffff; margin-right: 0; text-align: center; font-family: Roboto, sans-serif; font-weight: 500; border: 1px solid #98999a; cursor: pointer;\"><div style=\"min-width:10px; display:inline-flex; line-height: 20px;cursor: pointer;\">{{\'LOAD ALL\' | translate}}</div></div></li><li class=\"hover\" ng-repeat=\"node in inventories\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><nodes-renderer></nodes-renderer></li></ol></div></div><div class=\"col-md-4 col-xs-12 col-lg-4 col-sm-12\" ng-if=\"newPlacementGroupInventories\"><div class=\"form-group\"><label for=\"pgName\" translate=\"\">NAME</label> <input id=\"pgName\" class=\"form-control\" ng-model=\"npg.name\"></div><label translate=\"\">ADD INVENTORIES</label>:<div ng-if=\"newPlacementGroupInventories.length > 0\" ui-tree=\"treeOptions\" data-clone-enabled=\"true\" id=\"tree\"><ol ui-tree-nodes=\"\" ng-model=\"newPlacementGroupInventories\"><li ng-repeat=\"node in newPlacementGroupInventories\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><nodes-selected></nodes-selected></li></ol></div><br><button class=\"btn btn-default pull-right\" translate=\"\" ng-click=\"saveNewPlacementGroup()\">SAVE</button></div></div><div style=\"left: 35%; position: relative;width: 50px\"><div style=\"visibility: hidden\" class=\"loader\"></div></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'ALL\' | translate}} {{\'Placementgroups\'}}\" ba-panel-class=\"panel-primary with-scroll\"><input class=\"form-control\" type=\"text\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" ng-model=\"searchAllInput\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"searchAll(searchAllInput)\" style=\"width: 100%; padding-right:50px;\"><div class=\"col-md-12\" ng-if=\"isLoaded && totalPages > 0\" ui-tree=\"treeOptions\" id=\"e\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"allPlacementGroups\"><li ng-repeat=\"node in allPlacementGroups\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><nodes-list></nodes-list></li></ol></div><div class=\"col-md-12\" ng-if=\"!isLoaded\" ui-tree=\"treeOptions\" id=\"loading_spinner\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><div class=\"loader-wrapper\"><div class=\"loader\"></div></div></div><div class=\"col-md-12\" ng-if=\"showLoadingError\" ui-tree=\"treeOptions\" id=\"timeout_error\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\">{{\'TIMEOUT\' | translate}}</div><div class=\"col-md-12 no-result-message\" ng-if=\"isLoaded && totalPages === 0\" ui-tree=\"treeOptions\" id=\"no_result\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\">{{\'NO RESULT FOUND\' | translate}}</div><div class=\"pagination-wrapper\"><button class=\"btn btn-default pagination-button\" ng-disabled=\"currentPage == 0 || !isLoaded\" ng-click=\"paginate(currentPage, -1)\">{{\'PREVIOUS\' | translate}}</button><div ng-if=\"isLoaded && totalPages > 0\">{{\'PAGE\' | translate}} {{currentPage+1}} {{\'OF\' | translate}} {{totalPages}}</div><button class=\"btn btn-default pagination-button\" ng-disabled=\"currentPage >= data.length/totalPages - 1 || !isLoaded\" ng-click=\"paginate(currentPage, 1)\">{{\'NEXT\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/pages/settings/placementgroups/nodes_list.html","<div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"cursor:default !important; color:#373737; {{\'border-left: 5px solid hsl(\' + (130 + (50 * this.$nodeScope.depth())) + \',30%, 70%);\'}}\"><div style=\"display: block;\"><div ng-if=\"node.inventories.length > 0\" style=\"cursor: pointer; display:inline-block;\" data-nodrag=\"\"><a ng-click=\"allPlacementGroupsToggle(this)\"><span class=\"glyphicon\" style=\"color: #555555\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></a></div><div style=\"display:inline-block\" ng-if=\"node.inventories.length === 0 && !node.hasOwnProperty(\'include\')\"><span class=\"glyphicon\" style=\"color: #555555; visibility: hidden\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></div><span style=\"color: green\" class=\"glyphicon glyphicon-ok-circle\" ng-if=\"node.hasOwnProperty(\'include\') && node.include\"></span> <span style=\"color: red\" class=\"glyphicon glyphicon-ban-circle\" ng-if=\"node.hasOwnProperty(\'include\') && !node.include\"></span><div style=\"min-width:5px; display:inline-block; line-height: 20px;\"></div><div class=\"row text-center\" style=\"min-width: 25px; width:75px; display:inline-block; line-height: 20px;\">{{node.id}}</div><div style=\"min-width:10px; display:inline-flex; line-height: 20px;\"></div><div style=\"min-width: 100px; width:28%; display:inline-flex; line-height: 20px;\">{{node.inventory ? node.inventory.name : node.name}}</div><p style=\"font-size: 11px; color: #888888; width:60px; margin-right: 0px; margin-left: 8px; float:right\">{{node.inventory.kind}}</p><div style=\"position: absolute; display: inline-block; right: 20px;\"><span style=\"cursor:pointer; color: #002900\" class=\"glyphicon glyphicon-cog\" ng-if=\"node.inventories\" ng-click=\"editPlacementGroup(node)\"></span></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.inventories\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in node.inventories\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><nodes-list></nodes-list></li></ol>");
$templateCache.put("app/pages/settings/placementgroups/nodes_renderer.html","<div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"cursor:default !important ; color:#373737; {{\'border-left: 5px solid hsl(\' + (-65 + (65 * getDepth(this.$nodeScope.$modelValue))) + \',80%, 70%); margin-right:0;\'}}\"><div style=\"display: block; margin-right:10px;\"><a ng-if=\"node.kind !== \'placement\'\" data-nodrag=\"\" style=\"cursor: pointer\" ng-click=\"customToggle(this, true)\"><span class=\"glyphicon\" style=\"color: #555555\" ng-class=\"{\'glyphicon-chevron-right\': this.$nodeScope.collapsed,\'glyphicon-chevron-down\': !this.$nodeScope.collapsed}\"></span></a><div style=\"min-width:5px; display:inline-block; line-height: 20px;\"></div><div style=\"min-width:10px; display:inline-block; line-height: 20px;\"></div><div ng-if=\"node.kind !== \'placement\'\" style=\"min-width: 100px; width:28%; display:inline-block; line-height: 20px;\">{{node.name}}</div><div ng-if=\"node.kind === \'placement\'\" style=\"min-width: 180px; width:58%; display:inline-block; line-height: 20px;\">{{node.name}}</div><div style=\"width:20px; display:inline-block;\"></div><div style=\"display: inline-block; position: absolute; right: 20px;\"><div style=\"display: inline-block; text-align: right;\"><input ng-if=\"!(!searchGlobalInput && (node.kind === \'placement\')) && (!(searchGlobalInput && (node.kind === \'publisher\' || node.kind === \'network\' || node.kind === \'placement\')))\" class=\"form-control\" style=\"display:inline-block; font-size: 13px; font-weight: normal; min-width:50px; width: 140px; margin-left: 8px; height: 26px;\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" ng-model=\"searchInput\" ng-change=\"this.$nodeScope.$modelValue.searchInput = findNodes(searchInput, node.id, this)\" data-nodrag=\"\"></div><div style=\"display:inline-block; text-align: right;\"><p style=\"font-size: 11px; color: #888888; width:60px;\">{{node.kind}}</p></div><div ng-init=\"node.depth = this.$nodeScope.depth()\" class=\"form-group-xs\" ng-if=\"editMode\" data-nodrag=\"\" style=\"margin-right: 0px; margin-left: 15px; text-align: right; display:inline-block;\"><div class=\"btn-group-xs\"><label ng-click=\"addInventories(node, true)\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{nodeIsIncluded(node) === true ? \'color:green\': \'color:grey\'}}\"></span></label> <label ng-click=\"addInventories(node, false)\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{nodeIsIncluded(node) === false ? \'color:red\' : \'color:grey\'}}\"></span></label></div></div></div></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in node.nodes\" ui-tree-node=\"\" data-collapsed=\"!node.expanded\" ng-show=\"visible(node, searchInput)\"><nodes-renderer></nodes-renderer></li><li ng-if=\"node.total > limit && !searchGlobalInput\" ng-click=\"customToggle(this, false)\"><div class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"color: #373737; margin-right: 0; background-color: #ffffff; text-align: center; font-family: Roboto, sans-serif; font-weight: 500; border: 1px solid #98999a; cursor: pointer;\"><div ng-if=\"!searchGlobalInput\" style=\"min-width:10px; display:inline-flex; line-height: 20px;cursor: pointer;\">{{\'LOAD ALL\' | translate}}</div></div></li></ol>");
$templateCache.put("app/pages/settings/placementgroups/nodes_selected.html","<div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" data-nodrag=\"\" style=\"cursor:default !important; color:#373737; {{\'border-left: 5px solid hsl(\' + (-65 + (65 * (getDepth(node)))) + \',80%, 70%);\'}}\"><div style=\"display: block;\"><a ng-if=\"node.kind !== \'placement\'\" data-nodrag=\"\" style=\"cursor: pointer\" ng-click=\"customToggle(this, true)\"><span class=\"glyphicon\" style=\"color: #555555\" ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></a><div style=\"min-width:3px; display:inline-block; line-height: 20px;\"></div><div style=\"min-width:10px; display:inline-flex; line-height: 20px;\"></div><div style=\"min-width: 100px; width:28%; display:inline-flex; line-height: 20px;\">{{node.name}}</div><div style=\"width:20px; display:inline-flex\"></div><div class=\"form-group-xs\" ng-if=\"node.hasOwnProperty(\'include\') && this.$nodeScope.depth() === 1\" data-nodrag=\"\" style=\"margin-right: 0px; margin-left: 4px; float:right\"><div class=\"btn-group-xs\"><label class=\"{{node.include === true?\'active\':\'\'}}\" ng-click=\"changeInventories(node, true)\"><span class=\"glyphicon glyphicon-ok-circle\" style=\"font-size:15px; cursor: pointer; {{node.include === true ? \'color:green\': \'color:grey\'}}\"></span></label> <label class=\"{{node.include === false?\'active\':\'\'}}\" ng-click=\"changeInventories(node, false)\"><span class=\"glyphicon glyphicon-ban-circle\" style=\"font-size:15px; cursor: pointer; {{node.include === false ? \'color:red\' : \'color:grey\'}}\"></span></label></div></div><p style=\"font-size: 11px; color: #888888; width:60px; margin-right: 0px; margin-left: 8px; float:right\">{{node.kind}}</p></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"node in node.nodes\" ui-tree-node=\"\" collapsed=\"!node.expanded\"><nodes-selected></nodes-selected></li></ol>");
$templateCache.put("app/pages/settings/requestcategories/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'REQUEST CATEGORIES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW REQUESTCATEGORY\'| translate}}\" ba-panel-new-click=\"addEditRequestcategory()\"><recursive-tree nodes=\"requestCategories\" type=\"requestcategories\" show-add=\"true\" show-attributes=\"attributes\" modal=\"Requestcategory\"></recursive-tree></div></div></div></div>");
$templateCache.put("app/pages/settings/templates/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TEMPLATES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div><table class=\"table table-striped\"><thead><tr><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">KIND</th><th translate=\"\">ENGINE</th><th translate=\"\">WIZARD_TYPE</th><th translate=\"\">CODE</th></tr></thead><tbody><tr ng-repeat=\"template in templates\"><td>{{template.id}}</td><td>{{template.name}}</td><td>{{template.kind}}</td><td>{{template.engine}}</td><td class=\"col-md-4\"><div class=\"col-md-8\" style=\"padding-left:0\"><select class=\"form-control\" ng-model=\"template.options.wizardType\" ng-change=\"optionsChanged(template)\"><option ng-repeat=\"value in wizardTypes\" value=\"{{value.value}}\">{{value.text}}</option></select></div><div class=\"col-md-4\" ng-if=\"template.optionsChanged\"><button class=\"btn btn-xs btn-default\" ng-click=\"saveTemplate(template)\" translate=\"\">SAVE</button></div></td><td style=\"width: 50%;padding:6px 0;\"><button class=\"btn btn-xs btn-default\" editable-textarea=\"template.code\" e-rows=\"10\" e-cols=\"70\" onaftersave=\"saveTemplate(template)\" blur=\"cancel\" translate=\"\">EDIT</button></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CREATE TEMPLATE\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><form ng-submit=\"submit()\"><div class=\"row\"><div class=\"col-md-3 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputName\" placeholder=\"{{\'NAME\'|translate}}\" ng-model=\"template.name\"></div><div class=\"col-md-3 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputSize\" placeholder=\"{{\'KIND\'|translate}}\" ng-model=\"template.kind\"></div><div class=\"col-md-3 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputWidth\" placeholder=\"{{\'ENGINE\'|translate}}\" ng-model=\"template.engine\"></div><div class=\"col-md-3 form-group\"><select class=\"form-control\" ng-model=\"template.options\"><option ng-repeat=\"value in wizardTypes\" value=\"{{value.value}}\">{{value.text}}</option></select></div><div class=\"col-md-3 form-group\"><textarea class=\"form-control\" id=\"inputHeight\" placeholder=\"{{\'CODE\'|translate}}\" ng-model=\"template.code\"></textarea></div></div><div class=\"row\"><div class=\"col-md-3\"><button type=\"submit\" class=\"btn btn-default\" translate=\"\">CREATE TEMPLATE</button></div></div></form></div></div></div></div>");
$templateCache.put("app/pages/statistics/actionReport/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" style=\"position:relative;z-index:9999;\"><div ba-panel=\"\" ba-panel-title=\"{{\'CHOOSE FILTERS\' | translate}}\" ba-panel-class=\"panel-primary animated zoomIn\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">INSERTION ORDER</label><ui-select ng-model=\"filters.selectedInsertionOrder\" title=\"Choose Insertion Orders\" ng-change=\"updateFilters(\'insertionorders\')\"><ui-select-match placeholder=\"{{\'SELECT INSERTION ORDERS\'|translate}}\">{{$select.selected.name}} {{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"io in insertionOrders track by $index\" refresh=\"searchInsertionOrders($select.search)\" refresh-delay=\"500\">{{io.name}} ({{io.id}})<div ng-bind=\"$scope.insertionorders\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><label translate=\"\">PRESET</label><select class=\"form-control input-sm\" ng-model=\"filters.selectedPreset\" ng-change=\"updateFilters()\"><option ng-model=\"selectedPreset\" ng-repeat=\"(key,value) in selectedPreset\" value=\"{{value}}\">{{value}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">RESTRICT ADMEDIA</label><ui-select multiple=\"\" class=\"form-control\" ng-disabled=\"!filters.selectedInsertionOrder\" ng-model=\"filters.selectedAdmedias\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Admedias\" ng-change=\"updateFilters(\'admedias\')\"><ui-select-match placeholder=\"{{\'SELECT ADMEDIAS\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"admedia in admedias track by $index\" refresh=\"searchAdmedias($select.search)\" refresh-delay=\"500\">{{admedia.name}} ({{admedia.id}})</ui-select-choices></ui-select><span class=\"help-block sub-little-text\" ng-if=\"!filters.selectedInsertionOrder\" translate=\"\">You need to select insertionorder first.</span></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE FROM</label><div class=\"form-control input-sm\" ng-disabled=\"!filters.activeDateRange\" moment-picker=\"dateRange.from\" change=\"updateFilters()\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.from || \'Select date\' }}</div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE TO</label><div class=\"form-control input-sm\" ng-disabled=\"!filters.activeDateRange\" moment-picker=\"dateRange.to\" change=\"updateFilters()\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.to || \'Select date\' }}</div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">DATEFILTER</label><select class=\"form-control input-sm\" ng-disabled=\"!filters.activeDateRange\" ng-change=\"updateDateFilter(); updateFilters()\" ng-model=\"filters.selectedDate.model\" ng-options=\"filter.name for filter in filters.selectedDate.availableFilters track by filter.id\"></select></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"filters.activeDateRange\" ng-change=\"updateFilters()\"> <span translate=\"\">RESTRICT DATE RANGE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-ci\" ng-click=\"downloadStatistic()\" translate=\"\">DOWNLOAD ACTION STATISTIC</button> <button type=\"button\" class=\"btn btn-ci\" ng-click=\"resetFilter()\" translate=\"\">RESET FILTER</button></div></div></div><div class=\"row\"><div class=\"col-md-12\"><br><pre ng-if=\"url\">{{ url }}</pre></div></div></div></div></div></div>");
$templateCache.put("app/pages/statistics/chart/chart.html","<div id=\"zoomAxisChart\" class=\"admin-chart\" ng-controller=\"ChartController\"></div>");
$templateCache.put("app/pages/statistics/statistics/statistics.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" style=\"position:relative;z-index:9999;\"><div ba-panel=\"\" ba-panel-title=\"{{\'CHOOSE FILTERS\' | translate}}\" ba-panel-class=\"panel-primary animated zoomIn\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">KIND</label><select ng-disabled=\"filters.selectedAds.length>0\" class=\"form-control input-sm\" ng-model=\"filters.kind\" ng-change=\"updateFilters()\"><option value=\"\" translate=\"\">ALL</option><option ng-repeat=\"(key, value) in adKinds\" value=\"{{key}}\">{{key}}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">SUBKIND</label><br><multiselect class=\"input-xlarge multiselect\" enable-filter=\"false\" enable-check-all=\"true\" enable-uncheck-all=\"true\" ng-model=\"filters.subkind\" ng-change=\"updateFilters()\" options=\"sk for sk in adKinds[filters.kind]\" multiple=\"true\"></multiselect></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"sitemedias\">Sitemedia</label><ui-select multiple=\"\" id=\"sitemedias\" ng-model=\"filters.selectedSitemedias\" style=\"min-width: 100px;\" title=\"Choose Sitemedia\" ng-change=\"updateFilters()\"><ui-select-match placeholder=\"{{\'SELECT SITEMEDIA\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"st in sitemedias track by $index\" refresh=\"searchSitemedias($select.search)\" refresh-delay=\"500\">{{st.name}} ({{st.id}})</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">ADVERTISER</label><ui-select multiple=\"\" class=\"form-control\" ng-model=\"filters.selectedAdvertiser\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Advertiser\" ng-change=\"updateFilters()\"><ui-select-match placeholder=\"{{\'SELECT ADVERTISER\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"io in advertiser track by $index\" refresh=\"searchAdvertiser($select.search)\" refresh-delay=\"500\">{{io.name}} ({{io.id}})</ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">INSERTION ORDER</label><ui-select multiple=\"\" class=\"form-control\" ng-model=\"filters.selectedInsertionOrders\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Insertion Orders\" ng-change=\"updateFilters()\"><ui-select-match placeholder=\"{{\'SELECT INSERTION ORDERS\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"io in insertionOrders track by $index\" refresh=\"searchInsertionOrders($select.search)\" refresh-delay=\"500\">{{io.name}} ({{io.id}})</ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"\">OMIT AD</label><ui-select multiple=\"\" class=\"form-control\" ng-model=\"filters.selectedOmitAds\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Ads\" ng-change=\"updateFilters()\"><ui-select-match placeholder=\"{{\'SELECT ADS\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"ad in ads track by $index\" refresh=\"searchAds($select.search)\" refresh-delay=\"500\">{{ad.name}} ({{ad.id}})</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">AD</label><ui-select multiple=\"\" class=\"form-control\" ng-model=\"filters.selectedAds\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Ads\" ng-change=\"updateFilters(\'ads\')\"><ui-select-match placeholder=\"{{\'SELECT ADS\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"ad in ads track by $index\" refresh=\"searchAds($select.search)\" refresh-delay=\"500\">{{ad.name}} ({{ad.id}})</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">ADMEDIA</label><ui-select multiple=\"\" class=\"form-control\" ng-disabled=\"!filters.selectedAds.length\" ng-model=\"filters.selectedAdmedias\" close-on-select=\"false\" style=\"min-width: 100px;\" title=\"Choose Admedias\" ng-change=\"updateFilters()\"><ui-select-match placeholder=\"{{\'SELECT ADMEDIAS\'|translate}}\">{{$item.name}} ({{$item.id}})</ui-select-match><ui-select-choices repeat=\"admedia in admedias track by $index\" refresh=\"searchAdmedias($select.search)\" refresh-delay=\"500\">{{admedia.name}} ({{admedia.id}})</ui-select-choices></ui-select><span class=\"help-block sub-little-text\" ng-if=\"!filters.selectedAds.length\" translate=\"\">You need to select ads first.</span></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE FROM</label><div class=\"form-control input-sm\" moment-picker=\"dateRange.from\" change=\"updateFilters()\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.from || \'Select date\' }}</div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">CHOOSE DATE TO</label><div class=\"form-control input-sm\" moment-picker=\"dateRange.to\" change=\"updateFilters()\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ dateRange.to || \'Select date\' }}</div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label translate=\"\">DATEFILTER</label><select class=\"form-control input-sm\" ng-change=\"updateDateFilter(); updateFilters()\" ng-model=\"filters.selectedDate.model\" ng-options=\"filter.name for filter in filters.selectedDate.availableFilters track by filter.id\"></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">CHOOSE COLUMNS TO BE DISPLAYED</label><multiselect class=\"input-xlarge multiselect\" enable-filter=\"false\" enable-check-all=\"true\" enable-uncheck-all=\"true\" ng-model=\"filters.selectedColumns\" options=\"c for c in columns\" multiple=\"true\"></multiselect></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-ci\" ng-click=\"getStatistics(createStatistic)\" translate=\"\">GET STATISTIC</button> <button ng-if=\"statistics && statistics.length !== 0\" type=\"button\" class=\"btn btn-ci\" ng-click=\"reset()\" translate=\"\">RESET STATISTIC</button> <button ng-if=\"statistics && statistics.length !== 0\" type=\"button\" class=\"btn btn-ci\" ng-click=\"exportData()\" translate=\"\">EXPORT STATISTIC</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"showChart && chartData.length > 0\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"panel-primary animated zoomIn\" ba-panel-title=\"{{\'CHART\'|translate}}\"><div class=\"row\"><div class=\"col-md-12\"><chart></chart></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"panel-primary animated zoomIn\" ba-panel-title=\"{{\'RESULT\'|translate}}\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"table\" id=\"exportable\" st-safe-src=\"statistics\" st-table=\"statisticsData\"><thead><tr class=\"sortable\"><th ng-if=\"isSelected(firstColumnType)\"><b>{{(firstColumnType === \'DATE\' ? \'DATE\' : \'NAME\') | translate}}</b></th><th st-sort=\"kind\" ng-if=\"isSelected(\'KIND\')\"><b>{{\'KIND\' | translate}}</b></th><th st-sort=\"subkind\" ng-if=\"isSelected(\'SUBKIND\')\"><b>{{\'SUBKIND\' | translate}}</b></th><th st-sort=\"impressions\" ng-if=\"isSelected(\'IMPRESSIONS\')\" st-sort-default=\"reverse\"><b>{{\'IMPRESSIONS\' | translate}}</b></th><th st-sort=\"clicks\" ng-if=\"isSelected(\'CLICKS\')\"><b>{{\'CLICKS\' | translate}}</b></th><th st-sort=\"ctr\" ng-if=\"isSelected(\'CTR\')\"><b>CTR</b></th><th st-sort=\"cpc\" ng-if=\"isSelected(\'CPC\')\"><b>CPC</b></th><th st-sort=\"cpm\" ng-if=\"isSelected(\'CPM\')\"><b>CPM</b></th><th st-sort=\"spent\" ng-if=\"isSelected(\'SPENT\')\"><b>{{\'SPENT\' | translate}}</b></th><th st-sort=\"yield_cpc\" ng-if=\"isSelected(\'YIELD CPC\')\"><b>{{\'YIELD CPC\' | translate}}</b></th><th st-sort=\"yield_cpm\" ng-if=\"isSelected(\'YIELD CPM\')\"><b>{{\'YIELD CPM\' | translate}}</b></th><th st-sort=\"yield\" ng-if=\"isSelected(\'YIELD\')\"><b>{{\'YIELD\' | translate}}</b></th><th st-sort=\"yield_pending\" ng-if=\"isSelected(\'YIELD PENDING\')\"><b>{{\'YIELD PENDING\' | translate}}</b></th><th st-sort=\"yield_confirmed\" ng-if=\"isSelected(\'YIELD CONFIRMED\')\"><b>{{\'YIELD CONFIRMED\' | translate}}</b></th><th st-sort=\"yield_rejected\" ng-if=\"isSelected(\'YIELD REJECTED\')\"><b>{{\'YIELD REJECTED\' | translate}}</b></th><th st-sort=\"sales\" ng-if=\"isSelected(\'SALES\')\"><b>{{\'SALES\' | translate}}</b></th><th st-sort=\"sales_pending\" ng-if=\"isSelected(\'SALES PENDING\')\"><b>{{\'SALES PENDING\' | translate}}</b></th><th st-sort=\"sales_confirmed\" ng-if=\"isSelected(\'SALES CONFIRMED\')\"><b>{{\'SALES CONFIRMED\' | translate}}</b></th><th st-sort=\"sales_rejected\" ng-if=\"isSelected(\'SALES REJECTED\')\"><b>{{\'SALES REJECTED\' | translate}}</b></th><th st-sort=\"profit_cpc\" ng-if=\"isSelected(\'PROFIT CPC\')\"><b>{{\'PROFIT CPC\' | translate}}</b></th><th st-sort=\"profit_cpm\" ng-if=\"isSelected(\'PROFIT CPM\')\"><b>{{\'PROFIT CPM\' | translate}}</b></th><th st-sort=\"profit\" ng-if=\"isSelected(\'PROFIT\')\"><b>{{\'PROFIT\' | translate}}</b></th></tr></thead><tbody><tr ng-if=\"firstColumnType === \'NAME\'\" ng-repeat=\"statisticRow in statisticsData\"><td ng-if=\"isSelected(\'NAME\')\"><a ui-sref=\"ads.detail({id: statisticRow.ad.id})\" ng-if=\"!statisticsType.includes(\'admedia\')\">{{statisticRow.ad.name}}</a><a ui-sref=\"ads.detail({id: statisticRow.ad.id})\" ng-if=\"statisticsType.includes(\'admedia\')\">{{statisticRow.ad.name}} {{statisticRow.admedia.id}} ({{\'SIZE\'|translate}}: {{statisticRow.admedia.size.size}}, {{\'NAME\'| translate}}: {{statisticRow.admedia.size.name}})</a></td><td ng-if=\"isSelected(\'KIND\')\">{{statisticRow.ad.kind}}</td><td ng-if=\"isSelected(\'SUBKIND\')\">{{statisticRow.ad.subkind}}</td><td ng-if=\"isSelected(\'IMPRESSIONS\')\">{{statisticRow.impressions.toLocaleString()}}</td><td ng-if=\"isSelected(\'CLICKS\')\">{{statisticRow.clicks}}</td><td ng-if=\"isSelected(\'CTR\')\">{{(statisticRow.clicks/statisticRow.impressions*100).toFixed(4).toString().replace(\'.\', \',\')}} %</td><td ng-if=\"isSelected(\'CPC\')\">{{(statisticRow.clicks > 0) ? (statisticRow.spent / statisticRow.clicks).toFixed(2).toString().replace(\'.\', \',\') : 0}} &euro;</td><td ng-if=\"isSelected(\'CPM\')\">{{statisticRow.cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'SPENT\')\">{{statisticRow.spent.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CPC\')\">{{statisticRow.yield_cpc.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CPM\')\">{{statisticRow.yield_cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD\')\">{{statisticRow.yield.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD PENDING\')\">{{statisticRow.yield_pending.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CONFIRMED\')\">{{statisticRow.yield_confirmed.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD REJECTED\')\">{{statisticRow.yield_rejected.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'SALES\')\">{{statisticRow.sales.toString()}}</td><td ng-if=\"isSelected(\'SALES PENDING\')\">{{statisticRow.sales_pending}}</td><td ng-if=\"isSelected(\'SALES CONFIRMED\')\">{{statisticRow.sales_confirmed}}</td><td ng-if=\"isSelected(\'SALES REJECTED\')\">{{statisticRow.sales_rejected}}</td><td ng-if=\"isSelected(\'PROFIT CPC\')\">{{statisticRow.profit_cpc.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'PROFIT CPM\')\">{{statisticRow.profit_cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'PROFIT\')\">{{statisticRow.profit.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td></tr><tr ng-if=\"firstColumnType === \'DATE\'\" ng-repeat-start=\"day in statistics\" ng-click=\"day.expanded = !day.expanded\" style=\"cursor: pointer;\"><td ng-if=\"isSelected(\'DATE\') && statisticsType === \'dailyAdSitemediaStatistics\'\">{{day.date | amDateFormat:\'dd, L\'}}</td><td ng-if=\"isSelected(\'DATE\') && statisticsType === \'monthlyAdSitemediaStatistics\'\">{{day.date | amDateFormat:\'MM/YYYY\'}}</td><td ng-if=\"isSelected(\'IMPRESSIONS\')\">{{day.impressions.toLocaleString()}}</td><td ng-if=\"isSelected(\'CLICKS\')\">{{day.clicks}}</td><td ng-if=\"isSelected(\'CTR\')\">{{(day.clicks/day.impressions*100).toFixed(4).toString().replace(\'.\', \',\')}} %</td><td ng-if=\"isSelected(\'CPC\')\">{{(day.spent/day.clicks).toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'CPM\')\">{{day.cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'SPENT\')\">{{day.spent.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CPC\')\">{{day.yield_cpc.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CPM\')\">{{day.yield_cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD\')\">{{day.yield.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD PENDING\')\">{{day.yield_pending.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CONFIRMED\')\">{{day.yield_confirmed.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD REJECTED\')\">{{day.yield_rejected.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'SALES\')\">{{day.sales.toString()}}</td><td ng-if=\"isSelected(\'SALES PENDING\')\">{{day.sales_pending}}</td><td ng-if=\"isSelected(\'SALES CONFIRMED\')\">{{day.sales_confirmed}}</td><td ng-if=\"isSelected(\'SALES REJECTED\')\">{{day.sales_rejected}}</td><td ng-if=\"isSelected(\'PROFIT CPC\')\">{{day.profit_cpc.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'PROFIT CPM\')\">{{day.profit_cpm.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'PROFIT\')\">{{day.profit.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td></tr><tr ng-repeat-end=\"\" ng-if=\"day.expanded\"><td>Details:</td><td colspan=\"9\" style=\"padding: 12px;\"><table class=\"table table-striped table-bordered\" st-table=\"day.items\"><thead class=\"sortable\"><tr><th>Sitemedia</th><th st-sort=\"name\">{{statisticsType ===\'dailyAdmediaSitemediaStatistics\' ? \'Admedia\' : \'Ad\'}}</th><th st-sort=\"impressions\" ng-if=\"isSelected(\'IMPRESSIONS\')\" translate=\"\">IMPRESSIONS</th><th st-sort=\"clicks\" ng-if=\"isSelected(\'CLICKS\')\" translate=\"\">CLICKS</th><th st-sort=\"clicks/impressions\" ng-if=\"isSelected(\'CTR\')\">CTR</th><th st-sort=\"cpc\" ng-if=\"isSelected(\'CPC\')\">CPC</th><th st-sort=\"cpm\" ng-if=\"isSelected(\'CPM\')\">CPM</th><th st-sort=\"spent\" ng-if=\"isSelected(\'SPENT\')\" translate=\"\">SPENT</th><th st-sort=\"yield_cpc\" ng-if=\"isSelected(\'YIELD CPC\')\" translate=\"\">YIELD CPC</th><th st-sort=\"yield_cpm\" ng-if=\"isSelected(\'YIELD CPM\')\" translate=\"\">YIELD CPM</th><th st-sort=\"yield\" ng-if=\"isSelected(\'YIELD\')\" translate=\"\">YIELD</th><th st-sort=\"yield_pending\" ng-if=\"isSelected(\'YIELD PENDING\')\">{{\'YIELD PENDING\' | translate}}</th><th st-sort=\"yield_confirmed\" ng-if=\"isSelected(\'YIELD CONFIRMED\')\">{{\'YIELD CONFIRMED\' | translate}}</th><th st-sort=\"yield_rejected\" ng-if=\"isSelected(\'YIELD REJECTED\')\">{{\'YIELD REJECTED\' | translate}}</th><th st-sort=\"sales\" ng-if=\"isSelected(\'SALES\')\" translate=\"\">SALES</th><th st-sort=\"sales_pending\" ng-if=\"isSelected(\'SALES PENDING\')\">{{\'SALES PENDING\' | translate}}</th><th st-sort=\"sales_confirmed\" ng-if=\"isSelected(\'SALES CONFIRMED\')\">{{\'SALES CONFIRMED\' | translate}}</th><th st-sort=\"sales_rejected\" ng-if=\"isSelected(\'SALES REJECTED\')\">{{\'SALES REJECTED\' | translate}}</th><th st-sort=\"profit_cpc\" ng-if=\"isSelected(\'PROFIT CPC\')\" translate=\"\">PROFIT CPC</th><th st-sort=\"profit_cpm\" ng-if=\"isSelected(\'PROFIT CPM\')\" translate=\"\">PROFIT CPM</th><th st-sort=\"profit\" ng-if=\"isSelected(\'PROFIT\')\" translate=\"\">PROFIT</th></tr></thead><tbody><tr ng-repeat=\"item in day.items\"><td>{{item.sitemedia.name}}</td><td><a ng-if=\"statisticsType === \'dailyAdSitemediaStatistics\'\" ui-sref=\"ads.detail({id: item.ad.id})\">{{item.ad.name}}</a>{{statisticsType === \'dailyAdmediaSitemediaStatistics\' ? item.admedia.id + (\'SIZE\'|translate)+\': \' + item.admedia.size.size+ \', \' + (\'NAME\'|translate)+\': \'+item.admedia.size.name : \'\'}}</td><td ng-if=\"isSelected(\'IMPRESSIONS\')\">{{item.impressions.toLocaleString()}}</td><td ng-if=\"isSelected(\'CLICKS\')\">{{item.clicks.toLocaleString()}}</td><td ng-if=\"isSelected(\'CTR\')\">{{(item.clicks/item.impressions*100).toFixed(4).toString().replace(\'.\', \',\')}} %</td><td ng-if=\"isSelected(\'CPC\')\">{{(item.clicks > 0) ? (item.spent / item.clicks).toFixed(2).toString().replace(\'.\', \',\') : 0 }} €</td><td ng-if=\"isSelected(\'CPM\')\">{{item.cpm.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'SPENT\')\">{{item.spent.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CPC\')\">{{item.yield_cpc.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'YIELD CPM\')\">{{item.yield_cpm.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'YIELD\')\">{{item.yield.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'YIELD PENDING\')\">{{item.yield_pending.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD CONFIRMED\')\">{{item.yield_confirmed.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'YIELD REJECTED\')\">{{item.yield_rejected.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</td><td ng-if=\"isSelected(\'SALES\')\">{{item.sales.toString()}}</td><td ng-if=\"isSelected(\'SALES PENDING\')\">{{item.sales_pending}}</td><td ng-if=\"isSelected(\'SALES CONFIRMED\')\">{{item.sales_confirmed}}</td><td ng-if=\"isSelected(\'SALES REJECTED\')\">{{item.sales_rejected}}</td><td ng-if=\"isSelected(\'PROFIT CPC\')\">{{item.profit_cpc.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'PROFIT CPM\')\">{{item.profit_cpm.toFixed(2).toString().replace(\'.\', \',\')}} €</td><td ng-if=\"isSelected(\'PROFIT\')\">{{item.profit.toFixed(2).toString().replace(\'.\', \',\')}} €</td></tr></tbody></table></td></tr></tbody><tfoot><tr ng-if=\"statistics && statistics.length !== 0\"><td ng-if=\"isSelected(firstColumnType)\" class=\"text-center\"><b>{{\'SUM\' | translate}}</b></td><td ng-if=\"isSelected(\'KIND\')\"></td><td ng-if=\"isSelected(\'SUBKIND\')\"></td><td ng-if=\"isSelected(\'IMPRESSIONS\')\"><b>{{sum.impressions.toLocaleString()}}</b></td><td ng-if=\"isSelected(\'CLICKS\')\"><b>{{sum.clicks.toLocaleString()}}</b></td><td ng-if=\"isSelected(\'CTR\')\"><b>{{(sum.clicks/sum.impressions*100).toFixed(4).toString().replace(\'.\', \',\')}} %</b></td><td ng-if=\"isSelected(\'CPC\')\"><b>{{(sum.spent/sum.clicks).toFixed(2).toString().replace(\'.\', \',\')}} €</b></td><td ng-if=\"isSelected(\'CPM\')\"><b>{{(sum.spent/sum.impressions*1000).toFixed(2).toString().replace(\'.\', \',\')}} €</b></td><td ng-if=\"isSelected(\'SPENT\')\"><b>{{sum.spent.toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'YIELD CPC\')\"><b>{{(sum.yield/sum.clicks).toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'YIELD CPM\')\"><b>{{(sum.yield/sum.impressions*1000).toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'YIELD\')\"><b>{{sum.yield.toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'YIELD PENDING\')\"><b>{{sum.yieldPending.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</b></td><td ng-if=\"isSelected(\'YIELD CONFIRMED\')\"><b>{{sum.yieldConfirmed.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</b></td><td ng-if=\"isSelected(\'YIELD REJECTED\')\"><b>{{sum.yieldRejected.toFixed(2).toString().replace(\'.\', \',\')}} &euro;</b></td><td ng-if=\"isSelected(\'SALES\')\"><b>{{sum.sales.toString()}}</b></td><td ng-if=\"isSelected(\'SALES PENDING\')\"><b>{{sum.salesPending}}</b></td><td ng-if=\"isSelected(\'SALES CONFIRMED\')\"><b>{{sum.salesConfirmed}}</b></td><td ng-if=\"isSelected(\'SALES REJECTED\')\"><b>{{sum.salesRejected}}</b></td><td ng-if=\"isSelected(\'PROFIT CPC\')\"><b>{{(sum.profit/sum.clicks).toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'PROFIT CPM\')\"><b>{{(sum.profit/sum.impressions*1000).toFixed(2).toString().replace(\'.\',\',\')}} €</b></td><td ng-if=\"isSelected(\'PROFIT\')\"><b>{{sum.profit.toFixed(2).toString().replace(\'.\',\',\')}} €</b></td></tr></tfoot></table></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/targetings/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TARGETINGS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW TARGETING\'|translate}}\" ba-panel-new-click=\"routeToNewTargeting()\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-pipe=\"getTargetings\" st-table=\"targetings\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"smartTarget\" st-sort-default=\"reverse\" translate=\"\">TARGET</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"permanent\" translate=\"\">FROM</th><th translate=\"\">TO</th><th translate=\"\"># ZIPS</th><th st-sort=\"createdBy\" translate=\"\">CREATED BY</th></tr><tr><th><input st-search=\"smartTarget\" placeholder=\"{{\'SEARCH FOR\' | translate}} {{\'SMART TARGET\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th colspan=\"2\"><select st-search=\"permanent\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">permanent</option></select></th><th></th><th><select st-search=\"createdBy\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"{{identity.id}}\">{{identity.lastname+\", \"+identity.firstname}}</option></select></th></tr></thead><tbody><tr ng-repeat=\"item in targetings\"><td class=\"table-id\"><a ui-sref=\"targetings.detail({id: item._id})\"><span ng-if=\"user.publisher_id!=2\">{{item.smartTarget}}</span> <span ng-if=\"user.publisher_id==2\">{{item.smartTarget}}.v{{item.version}}</span></a></td><td>{{item.name}}</td><td>{{item.active}}</td><td><span ng-if=\"item.permanent\">Permanent</span> <span ng-if=\"!item.permanent\">{{ \'with_date\'|translate:{date:item.from} }}</span></td><td><span ng-if=\"!item.permanent\">{{ \'with_date\'|translate:{date:item.to} }}</span></td><td><span>{{item.targeting.geo.zips.length}}</span></td><td><span>{{item.createdBy.lastname}}, {{item.createdBy.firstname}} - {{item.createdBy.email}}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/targetings/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"targetings.all\">{{\'BACK\'|translate}}</a> <button ng-if=\"!targeting.locked\" class=\"btn btn-info\" ng-click=\"save()\">{{\'SAVE\'|translate}}</button> <button ng-if=\"!targeting.locked && targeting._id\" class=\"btn btn-danger\" ng-click=\"remove()\">{{\'REMOVE\'|translate}}</button><div class=\"alert bg-info\" ng-if=\"targeting.locked\" translate=\"\">This Targeting can not be edited or deleted, it is locked, please contact regio@contactimpact.de for changes.</div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel-primary\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"targeting.name\"></div><div class=\"form-group\" ng-if=\"user.publisher_id!=2\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"{{\'Hint: Leave this empty and it is auto generated for you. Do not use special characters like &!? in the token, keep them as short as possible. Use dfx_* for all REGIO Campaigns. Use dfv_* for REGIO Prerolls.\'|translate}}\"><label for=\"smartTarget\" translate=\"\">SMART TARGET</label> <input type=\"text\" class=\"form-control\" id=\"smartTarget\" ng-model=\"targeting.smartTarget\"></div><div class=\"form-group\" ng-if=\"user.publisher_id==2\"><label translate=\"\">TARGET</label> <input class=\"form-control\" ng-if=\"targeting.smartTarget\" value=\"{{targeting.smartTarget}}.v{{targeting.version}}\"> <input class=\"form-control\" ng-if=\"!targeting.smartTarget\" value=\"{{\'UNSAVED\'|translate}}\"></div><div class=\"form-group\"><label>{{\'DURATION\'|translate}}:</label><div class=\"row\"><div class=\"col-md-4\" ng-if=\"!targeting.permanent\"><div class=\"form-control input-sm\" moment-picker=\"daterange.from\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ daterange.from || \'Select date\' }}</div></div><div class=\"col-md-4\" ng-if=\"!targeting.permanent\"><div class=\"form-control input-sm\" moment-picker=\"daterange.to\" locale=\"{{moment.locale()}}\" format=\"LL\">{{ daterange.to || \'Select date\' }}</div></div><div class=\"col-md-4\"><label class=\"custom-checkbox\"><input type=\"checkbox\" name=\"input-settings-permanent\" ng-model=\"targeting.permanent\"> <span>{{\'PERMANENT\'|translate}}</span></label></div></div></div><div class=\"form-group\"><label>{{\'TARGETING\'|translate}}:</label><div class=\"row\"><div class=\"col-md-12\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" name=\"input-settings-options-includerecentzips\" ng-model=\"targeting.options.includeRecentZips\"> <span>{{\'INCLUDE RECENT LOCATION\'|translate}}</span></label></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'INFORMATION\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><table class=\"table\"><tr><td>{{\'CREATED BY\' | translate}}:</td><td>{{targeting.createdBy.lastname}}, {{targeting.createdBy.firstname}} - {{targeting.createdBy.email}}</td></tr><tr><td>{{\'UPDATED BY\'|translate}}:</td><td>{{targeting.updatedBy.lastname}}, {{targeting.updatedBy.firstname}} - {{targeting.updatedBy.email}}</td></tr><tr><td>{{\'UPDATED AT\'|translate}}:</td><td>{{ \'with_date\'|translate:{date:targeting.updatedAt} }}</td></tr><tr ng-if=\"user.publisher_id==2\"><td>{{\'SEGMENT INFO\' | translate}}:</td><td><pre style=\"white-space: pre-wrap;\">{{targeting.options|json:2}}</pre></td></tr></table></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'GEOGRAPHY\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"input-geography-precision\">{{\'PRECISION\'|translate}}:</label><ion-slider id=\"input-geography-precision\" type=\"single\" grid=\"true\" min=\"1\" max=\"5\" from=\"input.precision\" disable=\"precisionDisabled\" on-change=\"changePrecision\"></ion-slider></div><div class=\"form-group\"><label for=\"input-geography-distance\">{{\'DISTANCE\'|translate}}:</label><ion-slider id=\"input-geography-distance\" type=\"single\" grid=\"true\" min=\"0\" max=\"100\" postfix=\"km\" from=\"input.distance\" disable=\"distanceDisabled\" on-change=\"changeDistance\"></ion-slider></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"input-zips\">{{\'ZIPS\'|translate}}:</label> <textarea class=\"form-control\" id=\"input-zips\" ng-model=\"input.raw\" ng-change=\"changed(input.raw)\" rows=\"9\"></textarea> <span class=\"help-block sub-little-text\" translate=\"\">You put one ZIP per line and also use 93000-94000 or comma separeated ZIPs per line.</span></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'RESULTING TARGETING\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\" ng-repeat=\"(type, zips) in targeting.targeting.geo\"><h2>{{type}} ({{zips.length}})</h2><textarea class=\"form-control\" rows=\"20\">{{zips | join}}</textarea></div></div></div></div></div></div>");
$templateCache.put("app/pages/todos/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TODOS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-persist=\"todosList\" st-pipe=\"getTodos\" st-table=\"todos\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"status\" translate=\"\">STATUS</th><th st-sort=\"editing_user_id\" translate=\"\">EDITING USER</th><th st-sort=\"notifier\" translate=\"\">NOTIFIER</th><th st-sort=\"comment\" translate=\"\">COMMENT</th><th st-sort=\"todotypename\" translate=\"\">NAME</th><th st-sort=\"service_name\" translate=\"\">SERVICE</th><th st-stort=\"created\" translate=\"\">CREATED</th><th translate=\"\">ACTION</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\" translate=\"\">TRUE</option><option value=\"false\" translate=\"\">FALSE</option></select></th><th><select st-search=\"status\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"OPEN\" translate=\"\">OPEN</option><option value=\"PROGRESS\" translate=\"\">PROGRESS</option><option value=\"DONE\" translate=\"\">DONE</option><option value=\"CLOSED\" translate=\"\">CLOSED</option></select></th><th><select st-search=\"editing_user_id\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"{{user.id}}\" translate=\"\">ME</option></select></th><th><input st-search=\"notifier\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NOTIFIER\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"comment\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'COMMENT\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in todos\"><td class=\"table-id\"><a ui-sref=\"todos.detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.active}}</td><td>{{item.status}}</td><td>{{item.editing_user_id}}</td><td>{{item.notifier}}</td><td>{{trimString(item.comment, 15)}}</td><td>{{trimString(item.todotype.name, 30)}}</td><td>{{trimString(item.todotype.service_name, 10)}}</td><td><span>{{ formatDateTime(item.created) }}</span></td><td><div class=\"btn-group\" role=\"group\" style=\"display:flex;\"><a class=\"btn btn-default\" ui-sref=\"todos.detail({id: item.id})\"><span class=\"glyphicon glyphicon-cog\"></span></a> <button ng-if=\"item.link_service\" ng-show=\"item.link_service\" class=\"btn btn-info\" ui-sref=\"{{item.link_service}}\">{{\'GOTO\' | translate}}{{formatLinkName(item)}}</button></div></td></tr></tbody><tfoot><tr><td></td><td></td><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/todos/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"todos.all\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-warning\" ng-click=\"changeStatus(status.progress)\" ng-show=\"todo.status === \'OPEN\'\">{{\'BECOME EDITOR\'|translate}}</button> <button class=\"btn btn-success\" ng-click=\"changeStatus(status.done)\" ng-show=\"todo.status === \'PROGRESS\' && todo.editing_user_id === user.id\">{{\'FINISH TODO\'|translate}}</button> <button class=\"btn btn-info\" ng-if=\"todo.link_service\" ng-show=\"todo.link_service\" ui-sref=\"{{todo.link_service}}\">{{\'GOTO\' | translate}}{{formatLinkName(item)}}</button></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TODO\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\"><div class=\"section-block\"><h1 class=\"pull-left\">{{todo.todotype.name}}</h1><span class=\"label label-info pull-right\">{{todo.notifier}}</span><p>{{todo.todotype.description}}</p><div class=\"form-group\"><label for=\"status\" translate=\"\">STATUS</label><div disabled=\"\" class=\"form-control\" id=\"status\">{{todo.status}}</div></div><div class=\"form-group\"><label for=\"editingUser\" translate=\"\">EDITING USER</label><div disabled=\"\" class=\"form-control\" id=\"editingUser\">{{ todo.user.firstname + \' \' + todo.user.lastname}}</div></div><div class=\"form-group\"><label for=\"comment\" translate=\"\">COMMENT</label> <textarea type=\"text\" class=\"form-control\" id=\"comment\" ng-model=\"todo.comment\"></textarea></div><div class=\"form-group\"><button ng-if=\"todo.id\" type=\"button\" ng-click=\"saveChanges()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/users/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'USERS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"users.detail\">{{\'NEW USER\'|translate}}</a><table class=\"table\" st-pipe=\"getAds\" st-table=\"ads\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"username\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"isVerified\" translate=\"\">VERIFIED</th><th st-sort=\"roles\" translate=\"\">ROLES</th><th translate=\"\">ACTION</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"username\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'USERNAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in ads\"><td class=\"table-id\"><a ui-sref=\"users.detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.username}}</td><td>{{item.active}} <button class=\"btn btn-xs btn-danger\" ng-click=\"toggle(item)\" translate=\"\">TOGGLE</button></td><td>{{item.isVerified}}</td><td>{{item.roles}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=\"resetPassword(item)\" translate=\"\">RESET PASSWORD</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/users/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"users.list\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createUser()\" ng-show=\"!user.id\">{{\'CREATE USER\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"firstname\" translate=\"\">FIRSTNAME</label> <input class=\"form-control\" id=\"firstname\" type=\"text\" ng-model=\"user.firstname\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"lastname\" translate=\"\">LASTNAME</label> <input class=\"form-control\" id=\"lastname\" type=\"text\" ng-model=\"user.lastname\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"username\" translate=\"\">USERNAME</label> <input class=\"form-control\" id=\"username\" type=\"text\" ng-model=\"user.username\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"input-roles\" translate=\"\">ROLES</label> <input class=\"form-control\" id=\"input-roles\" type=\"text\" ng-model=\"user.roles\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"email\" translate=\"\">EMAIL</label> <input class=\"form-control\" id=\"email\" type=\"text\" ng-model=\"user.email\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"publisherId\">Publisher ID</label><select id=\"publisherId\" class=\"form-control\" ng-model=\"user.publisher_id\" ng-options=\"publisher.id as publisher.name + \' (\'+publisher.id+\')\' for publisher in publishers\"></select></div></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"user.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"user.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'PERMISSIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><json-editor-toggle-mode source=\"user.permissions\" overwrite-height=\"200\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"user.id\" type=\"button\" ng-click=\"savePermissions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-md-offset-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'GROUPS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><json-editor-toggle-mode source=\"user.groups\" overwrite-height=\"200\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"user.id\" type=\"button\" ng-click=\"saveGroups()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/tools/beautify/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'UGLY HTML/JS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control\" id=\"input-html\" ng-model=\"code.unbeautified\" rows=\"5\"></textarea></div></div></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'NICE HTML/JS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control\" id=\"input-html\" ng-model=\"code.beautified\" rows=\"20\"></textarea></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/tools/taggen/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'CREATE TAG\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><form class=\"row form-inline\" ng-submit=\"parseHash()\"><div class=\"col-sm-10 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputHash\" placeholder=\"{{\'HASH\'|translate}}\" ng-model=\"tag.hash\"></div><button type=\"submit\" class=\"btn btn-default\" translate=\"\">DECODE HASH</button></form><div class=\"row\"><div class=\"col-lg-12\">&nbsp;</div></div><form class=\"row form-inline\" ng-submit=\"generateHash()\"><div class=\"col-sm-2 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputSitemedia\" placeholder=\"{{\'SITEMEDIA\'|translate}}\" ng-model=\"tag.ids[0]\"></div><div class=\"col-sm-2 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputAd\" placeholder=\"{{\'AD\'|translate}}\" ng-model=\"tag.ids[1]\"></div><div class=\"col-sm-2 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputSize\" placeholder=\"{{\'SIZE\'|translate}}\" ng-model=\"tag.ids[2]\"></div><div class=\"col-sm-2 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputPresentation\" placeholder=\"{{\'PRESENTATION\'|translate}}\" ng-model=\"tag.ids[3]\"></div><div class=\"col-sm-2 form-group\"><input type=\"text\" class=\"form-control\" id=\"inputAdmedia\" placeholder=\"{{\'ADMEDIA\'|translate}}\" ng-model=\"tag.ids[4]\"></div><button type=\"submit\" class=\"btn btn-default\" translate=\"\">ENCODE IDs</button></form></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'RESULTING TAGS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control\" id=\"input-html\" ng-model=\"tag.out\" rows=\"40\"></textarea></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/tools/upload/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"alert alert-info black\">You can upload jpg, jpeg, gif, png images and .zip archives, .zip will be extracted and uploaded to a folder.</div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'UPLOAD\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-lg-12\"><div ng-dropzone=\"\" class=\"dropzone\" options=\"dzOptions\" callbacks=\"dzCallbacks\" methods=\"dzMethods\"></div></div></div></div><div ba-panel=\"\" ba-panel-title=\"{{\'UPLOADS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><table class=\"table\"><thead><tr><th translate=\"\">Name</th><th translate=\"\">URL</th><th translate=\"\">Size</th><th translate=\"\">Parts</th></tr></thead><tbody><tr ng-repeat=\"upload in uploaded\" class=\"editable-tr-wrap\"><td><span>{{upload.name}}</span></td><td><input class=\"form-control\" value=\"{{upload.cdnPath}}\"><a class=\"btn btn-xs btn-primary\" clipboard=\"\" text=\"upload.cdnPath\">Copy</a></td><td><span>{{upload.size}}</span></td><td><textarea class=\"form-control\">{{upload.files}}</textarea></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/settings/adsizes/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.adsizes\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createAdMediaSize()\" ng-show=\"!adMediaSize.id\">{{\'CREATE ADMEDIASIZE\'|translate}}</button> <button class=\"btn btn-danger\" ng-click=\"deleteAdMediaSize()\" ng-show=\"adMediaSize.id\">{{\'DELETE\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"adMediaSize.name\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"name\" translate=\"\">SIZE</label> <input class=\"form-control\" id=\"size\" type=\"text\" ng-model=\"adMediaSize.size\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">WIDTH</label> <input class=\"form-control\" id=\"width\" type=\"text\" ng-model=\"adMediaSize.width\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">HEIGHT</label> <input class=\"form-control\" id=\"height\" type=\"text\" ng-model=\"adMediaSize.height\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"adMediaSize.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><json-editor-toggle-mode source=\"adMediaSize.options\" overwrite-height=\"200\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"adMediaSize.id\" type=\"button\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/adsizes/all/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'ADMEDIASIZES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><a class=\"btn btn-primary\" ui-sref=\"settings.adsizes-detail\">{{\'NEW ADMEDIASIZE\'|translate}}</a><table class=\"table table-striped\"><thead><tr><th st-sort-default=\"reverse\" translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">SIZE</th><th>{{\'WIDTH\'|translate}} x {{\'HEIGHT\'|translate}}</th><th translate=\"\">OPTIONS</th></tr></thead><tbody><tr ng-repeat=\"size in admediasizes\"><td><a ui-sref=\"settings.adsizes-detail({id: size.id})\">#{{size.id}}</a></td><td>{{size.name}}</td><td>{{size.size}}</td><td>{{size.width}} x {{size.height}}</td><td>{{trimOptionsObject(size.options)}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/inventories/createInventory/createInventory.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{\'ADD INVENTORY\'| translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" id=\"name\" class=\"form-control\" ng-model=\"inventory.name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"kind\" translate=\"\">KIND</label><select ng-disabled=\"isChild === true\" id=\"kind\" class=\"form-control\" ng-model=\"inventory.kind\"><option ng-repeat=\"inventoryKind in inventoryKinds\">{{inventoryKind}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"externalId\">External ID</label> <input type=\"text\" id=\"externalId\" class=\"form-control\" ng-model=\"inventory.external_id\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"parentId\">Parent ID</label> <input ng-disabled=\"isChild === true\" type=\"text\" id=\"parentId\" class=\"form-control\" ng-model=\"inventory.parent_id\"></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveInventory(inventory)\" translate=\"\">{{\'CREATE INVENTORY\'}}</button></div></div>");
$templateCache.put("app/pages/settings/groups/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.groups\">{{\'BACK\'|translate}}</a></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"group.name\"></div></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"group.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"group.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button> <button class=\"btn btn-info\" ng-click=\"createGroup()\" ng-show=\"!group.id\">{{\'CREATE GROUP\'|translate}}</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'PERMISSIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><json-editor-toggle-mode source=\"group.permissions\" overwrite-height=\"200\"></json-editor-toggle-mode></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/matchers/all/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-15\"><div ba-panel=\"\" ba-panel-title=\"{{\'MATCHERS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><a class=\"btn btn-primary\" ui-sref=\"settings.matchers-detail\">{{\'NEW MATCHER\'|translate}}</a><table class=\"table\" st-pipe=\"getMatchers\" st-table=\"matchers\"><thead><tr><th translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">MATCH</th><th translate=\"\">ACTION</th><th translate=\"\">EVENTS</th></tr><tr><th class=\"col-md-1\"><input st-search=\"_id\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th><td><button class=\"btn btn-sm\" ng-click=\"deleteParas()\" translate=\"\">RESET</button></td></tr></thead><tbody><tr ng-repeat=\"matcher in matchers\"><td><a ui-sref=\"settings.matchers-detail({id: matcher._id})\">{{matcher._id}}</a></td><td>{{matcher.name}}</td><td>{{matcher.match}}</td><td>{{matcher.action}}</td><td>{{matcher.events}}</td><td><button class=\"btn btn-sm\" ng-click=\"delete(matcher)\" translate=\"\">DELETE</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\"></td><td></td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"numPages && pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in pageSize\"></select></label></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/groups/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'GROUPS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.groups-detail\">{{\'NEW GROUP\'|translate}}</a><table class=\"table\" st-pipe=\"getGroups\" st-table=\"groups\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"username\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th></tr><tr><th><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"username\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'USERNAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th></tr></thead><tbody><tr ng-repeat=\"item in groups\"><td class=\"table-id\"><a ui-sref=\"settings.groups-detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/matchers/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.matchers\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createMatcher()\" ng-show=\"!matcher._id\">{{\'CREATE MATCHER\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"matcher.name\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"matcher._id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'EVENTS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"matcher.events\"></json-editor-toggle-mode></div><div class=\"form-group\"><button type=\"button\" ng-if=\"matcher._id\" ng-click=\"saveEvents()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'MATCH\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"matcher.match\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"matcher._id\" type=\"button\" ng-click=\"saveMatch()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'ACTION\'|translate}}\"><div class=\"form-group\"><div ng-jsoneditor=\"\" ng-model=\"matcher.action\" options=\"{mode: \'tree\'}\" style=\"height: 475px;\"></div></div><div class=\"form-group\"><button ng-if=\"matcher._id\" type=\"button\" ng-click=\"saveAction()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/pages/settings/networks/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'NETWORKS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.networks-detail\">{{\'NEW NETWORK\'|translate}}</a><form class=\"form form-inline pull-right\"><input class=\"form-control\" type=\"text\" name=\"days\" ng-model=\"days\"> <a class=\"btn btn-primary\" ng-click=\"importSales(days)\">{{\'IMPORT ALL\'|translate}}</a></form><table class=\"table\" st-pipe=\"getNetworks\" st-table=\"networks\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"network\" translate=\"\">NETWORK</th><th st-sort=\"active\" translate=\"\">ACTIVE</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"network\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NETWORK\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in networks\"><td class=\"table-id\"><a ui-sref=\"settings.networks-detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.network}}</td><td>{{item.active}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/networks/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.networks\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createNetwork()\" ng-show=\"!network.id\">{{\'CREATE NETWORK\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"network.name\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"network\" translate=\"\">NETWORK</label> <input class=\"form-control\" id=\"network\" type=\"text\" ng-model=\"network.network\"></div></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"network.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"import_status\" translate=\"\">IMPORT STATUS</label> <input readonly=\"\" class=\"form-control\" id=\"import_status\" ng-model=\"network.import_status\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"created\" translate=\"\">IMPORTED</label> <label readonly=\"\" class=\"form-control\" id=\"created\">{{ \'with_date\'|translate:{date:network.import_date} }}</label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"network.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"network.options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button type=\"button\" ng-if=\"network.id\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'CREDENTIALS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"network.credentials\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"network.id\" type=\"button\" ng-click=\"saveCredentials()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'PRODUCTS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"network.products\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"network.id\" type=\"button\" ng-click=\"saveProducts()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/pages/settings/publishers/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'PUBLISHERS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.publishers-detail\">{{\'NEW PUBLISHER\'|translate}}</a><table class=\"table\" st-pipe=\"getPublishers\" st-table=\"publishers\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in publishers\"><td class=\"table-id\"><a ui-sref=\"settings.publishers-detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/publishers/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.publishers\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createPublisher()\" ng-show=\"!publisher.id\">{{\'CREATE PUBLISHER\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"publisher.name\"></div></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"publisher.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"publisher.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"section-block\"><div class=\"form-group\"><json-editor-toggle-mode source=\"publisher.options\" overwrite-height=\"200\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"publisher.id\" type=\"button\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/requestcategories/addEditRequestcategory/addEditRequestcategory.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color:black;\">{{requestCategory.id ? \'EDIT REQUESTCATEGORY\' : \'ADD REQUESTCATEGORY\'| translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-5 col-md-offset-1\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input id=\"name\" type=\"text\" class=\"form-control input-sm\" ng-model=\"requestCategory.name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"parent\">Parent</label> <input readonly=\"\" id=\"parent\" type=\"text\" class=\"form-control input-sm\" ng-model=\"requestCategory.parent\"></div></div></div><div class=\"row\"><div class=\"col-md-5 col-md-offset-1\"><div class=\"form-group\"><label for=\"tag\">Tag</label> <input id=\"tag\" class=\"form-control input-sm\" ng-model=\"requestCategory.tag\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"decay\">Decay</label> <input id=\"decay\" class=\"form-control input-sm\" ng-model=\"requestCategory.decay\"></div></div></div><div class=\"row\"><div class=\"col-md-5 col-md-offset-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"requestCategory.active\"> <span translate=\"\">ACTIVE</span></label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"form-group\"><label id=\"average\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"requestCategory.average\"> <span>Average</span></label></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"saveRequestCategory(requestCategory)\" translate=\"\">{{requestCategory.id ? \'SAVE\' : \'ADD REQUESTCATEGORY\'}}</button></div></div>");
$templateCache.put("app/pages/settings/sitemedias/all/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-15\"><div ba-panel=\"\" ba-panel-title=\"{{\'SITEMEDIAS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><a class=\"btn btn-primary\" ui-sref=\"settings.sitemedias-detail\">{{\'NEW SITEMEDIAS\'|translate}}</a><table class=\"table\" st-pipe=\"getSitemedias\" st-table=\"sitemedias\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\" translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">ACTIVE</th><th translate=\"\">MEDIA</th><th translate=\"\">SITE</th><th translate=\"\">CPM</th><th translate=\"\">SHARE</th><th translate=\"\">OPTIONS</th><th translate=\"\">KIND</th><th translate=\"\">DOWNLOADTOKEN</th></tr><tr><th class=\"col-md-2\"><input st-search=\"id\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th class=\"col-md-2\"><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th><input st-search=\"media\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'MEDIA\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"site\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'SITE\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"cpm\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'CPM\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"share\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'SHARE\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th><input st-search=\"kind\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'KIND\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"download_token\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'DOWNLOADTOKEN\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><td><button class=\"btn btn-sm\" ng-click=\"deleteParas()\" translate=\"\">RESET</button></td></tr></thead><tbody><tr ng-repeat=\"sitemedia in sitemedias\"><td><a ui-sref=\"settings.sitemedias-detail({id: sitemedia.id})\">{{sitemedia.id}}</a></td><td>{{sitemedia.name}}</td><td>{{sitemedia.active}}</td><td>{{sitemedia.media}}</td><td><a ui-sref=\"settings.sites-detail({id: sitemedia.site})\">{{sitemedia.site}}</a></td><td>{{sitemedia.cpm}}</td><td>{{sitemedia.share}}</td><td>{{sitemedia.options}}</td><td>{{sitemedia.kind}}</td><td>{{sitemedia.download_token|| \'EMPTY\' | translate}}</td><td><button class=\"btn btn-sm\" ng-click=\"delete(sitemedia)\" translate=\"\">DELETE</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\"></td><td></td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"numPages && pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in pageSize\"></select></label></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/sitemedias/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.sitemedias\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createSitemedia()\" ng-show=\"!sitemedia.id\">{{\'CREATE SITEMEDIA\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"sitemedia.name\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"media\" translate=\"\">MEDIA</label> <input type=\"text\" class=\"form-control\" id=\"media\" ng-model=\"sitemedia.media\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"site\" translate=\"\">SITE</label> <input type=\"text\" class=\"form-control\" id=\"site\" ng-model=\"sitemedia.site\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"cpm\" translate=\"\">CPM</label> <input type=\"text\" class=\"form-control\" id=\"cpm\" ng-model=\"sitemedia.cpm\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"share\" translate=\"\">SHARE</label> <input type=\"text\" class=\"form-control\" id=\"share\" ng-model=\"sitemedia.share\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">KIND</label><select class=\"form-control input-sm\" ng-model=\"sitemedia.kind\" ng-options=\"key as key for (key, value) in adKinds\"></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"downloadtoken\" translate=\"\">DOWNLOADTOKEN</label> <input type=\"text\" class=\"form-control\" id=\"downloadtoken\" ng-model=\"sitemedia.download_token\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"sitemedia.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"sitemedia.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"sitemedia.options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button type=\"button\" ng-if=\"sitemedia.id\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/pages/settings/sites/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-15\"><div ba-panel=\"\" ba-panel-title=\"{{\'SITES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><a class=\"btn btn-primary\" ui-sref=\"settings.sites-detail\">{{\'NEW SITE\'|translate}}</a><table class=\"table\" st-pipe=\"getSites\" st-table=\"sites\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\" translate=\"\">ID</th><th translate=\"\">NAME</th><th translate=\"\">AUTO ACCEPT ADVERTISER</th><th translate=\"\">ACTIVE</th><th translate=\"\">CPM</th><th translate=\"\">SHARE</th><th translate=\"\">OPTIONS</th><th translate=\"\">KIND</th><th translate=\"\">EVENTS</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"auto\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th></th><th></th><th></th><th><input st-search=\"kind\" st-delay=\"1000\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'KIND\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><td><button class=\"btn btn-sm\" ng-click=\"deleteParas()\" translate=\"\">RESET</button></td></tr></thead><tbody><tr ng-repeat=\"site in sites\"><td><a ui-sref=\"settings.sites-detail({id: site.id})\">{{site.id}}</a></td><td>{{site.name || \'EMPTY\' | translate}}</td><td>{{site[\"auto_accept_advertiser\"] || \'EMPTY\' | translate}}</td><td>{{site.active || \'EMPTY\' | translate }}</td><td>{{site.cpm || \'EMPTY\' | translate}}</td><td>{{site.share || \'EMPTY\' | translate}}</td><td>{{site.options || \'EMPTY\' | translate}}</td><td>{{site.kind || \'EMPTY\' | translate}}</td><td><button class=\"btn btn-sm\" ng-click=\"delete(site)\" translate=\"\">DELETE</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\"></td><td></td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"numPages && pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in pageSize\"></select></label></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/sites/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.sites\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createSite()\" ng-show=\"!site.id\">{{\'CREATE SITE\'|translate}}</button> <a class=\"btn btn-primary\" ng-if=\"site.id\" ng-href=\"#/settings/sitemedias?site={{site.id}}\">{{\'SHOW SITEMEDIAS\'|translate}}</a></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"site.name\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">CPM</label> <input class=\"form-control\" id=\"cpm\" type=\"text\" ng-model=\"site.cpm\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">SHARE</label> <input class=\"form-control\" id=\"share\" type=\"text\" ng-model=\"site.share\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"name\" translate=\"\">KIND</label> <input class=\"form-control\" id=\"kind\" type=\"text\" ng-model=\"site.kind\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"\">PUBLISHER</label><select class=\"form-control input-sm\" ng-options=\"publisher.id as publisher.name for publisher in publishers\" ng-model=\"site.publisher\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label id=\"auto\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"site[\'auto_accept_advertiser\']\"> <span translate=\"\">AUTO ACCEPT ADVERTISER</span></label></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"site.active\"> <span translate=\"\">ACTIVE</span></label></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"site.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"site.options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button type=\"button\" ng-if=\"site.id\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/pages/settings/todoTypes/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TODOTYPES\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.todoTypes-detail\">{{\'NEW TODOTYPE\'|translate}}</a><table class=\"table table-hover\" st-pipe=\"getTodoTypes\" st-table=\"networks\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"reverse\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th st-sort=\"service\" translate=\"\">SERVICE</th><th st-sort=\"description\" translate=\"\">DESCRIPTION</th><th st-sort=\"templatetext\" translate=\"\">TEMPLATE TEXT</th><th translate=\"\">TRIGGERFN</th><th translate=\"\">TRIGGER OPTIONS</th><th translate=\"\">OPTIONS</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"1\">true</option><option value=\"0\">false</option></select></th><th><input st-search=\"service\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'SERVICE\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"templatetext\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'TEMPLATE TEXT\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"description\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'DESCRIPTION\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in todoTypes\"><td class=\"table-id\"><a ui-sref=\"settings.todoTypes-detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.active}}</td><td>{{item.service_name}}</td><td>{{item.template_text}}</td><td>{{item.description}}</td><td>{{trimString(item.trigger_fn, 15)}}</td><td>{{trimOptionsObject(item.trigger_options, 15)}}</td><td>{{trimOptionsObject(item.options, 15)}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td><td></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/todoTypes/detail/index.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.todoTypes\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createTodoType()\" ng-show=\"!todoType.id\">{{\'CREATE TODOTYPE\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"DETAILS\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input class=\"form-control\" id=\"name\" type=\"text\" ng-model=\"todoType.name\"></div></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"todoType.active\"> <span translate=\"\">ACTIVE</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"serviceName\" translate=\"\">SERVICE NAME</label> <input class=\"form-control\" id=\"serviceName\" type=\"text\" ng-model=\"todoType.service_name\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"import_status\" translate=\"\">DESCRIPTION</label> <input class=\"form-control\" id=\"import_status\" ng-model=\"todoType.description\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"templatetext\" translate=\"\">TEMPLATE TEXT</label> <input class=\"form-control\" id=\"templatetext\" ng-model=\"todoType.template_text\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"triggerfn\" translate=\"\">TRIGGERFN</label><div class=\"btn-group\" role=\"group\" style=\"display:flex;\"><input readonly=\"\" class=\"form-control\" id=\"triggerfn\" ng-model=\"todoType.trigger_fn\"> <button ng-if=\"!todoType.showAce\" class=\"btn btn-default\" ng-click=\"showCode(todoType)\"><span class=\"glyphicon glyphicon-cog\"></span> <span translate=\"\">CODE</span></button></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"kind\" translate=\"\">KIND</label> <input class=\"form-control\" id=\"kind\" ng-model=\"todoType.kind\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button ng-if=\"todoType.id\" type=\"button\" class=\"btn btn-default\" ng-click=\"save()\" translate=\"\">SAVE</button></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'TRIGGER OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"todoType.trigger_options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"todoType.id\" type=\"button\" ng-click=\"saveTriggerOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"todoType.options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"todoType.id\" type=\"button\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div><div><div class=\"col-md-12\" ng-if=\"todoType.showAce\"><div ba-panel=\"\" ba-panel-title=\"{{\'TRIGGERFN\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"outer\"><div class=\"row\"><div class=\"sp toolbar tab-pane\" id=\"htmPane\"><div class=\"toolbar\"><button class=\"btn btn-default btn-sm\" title=\"Save only code\" ng-click=\"saveTodoTypeCode(todoType)\"><span class=\"glyphicon glyphicon-floppy-disk\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Undo action\" ng-click=\"undoAction(todoType)\"><span class=\"fa fa-undo\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Redo action\" ng-click=\"redoAction(todoType)\"><span class=\"fa fa-undo fa-flip-horizontal\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Close codeview\" ng-click=\"showCode(todoType)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div class=\"editor-container\" style=\"resize:vertical; overflow:auto;\"><div ng-if=\"todoType.showAce\" class=\"editor\" ui-ace=\"aceOption\" id=\"{{todoType.id}}\" ng-model=\"todoType.trigger_fn\"></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/tasks/manage/detail/detail.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'OPTIONS\' | translate}}\" ba-panel-class=\"panel-primary with-scroll\"><a class=\"btn btn-primary\" ui-sref=\"settings.tasks\">{{\'BACK\'|translate}}</a> <button class=\"btn btn-info\" ng-click=\"createTask()\" ng-show=\"!task.id\">{{\'CREATE TASKS\'|translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"{{\'CONFIG\'|translate}}\" ba-panel-class=\"panel panel-primary with-scroll\"><div class=\"section-block\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"parenttask\" translate=\"\">PARENT TASK</label><div class=\"input-group\"><ui-select id=\"parenttask\" ng-model=\"filters.selectedParentTask\" on-select=\"setParentTask()\" title=\"Choose Parent Task\"><ui-select-match placeholder=\"{{\'SELECT PARENT TASK\'|translate}}\">{{filters.selectedParentTask.name}}</ui-select-match><ui-select-choices repeat=\"io in possibleParentTask track by $index\" refresh=\"searchParentTasks($select.search)\" refresh-delay=\"500\">({{io.id}}) {{io.name}}</ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"filters.selectedParentTask\"><a class=\"btn btn-default\" ng-href=\"#/settings/tasks/detail/{{filters.selectedParentTask.id}}\" target=\"_blank\" translate=\"\">GO TO PARENT TASK</a></span></div></div></div></div><div class=\"form-group\"><label for=\"name\" translate=\"\">NAME</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"task.name\"></div><div class=\"form-group\"><label for=\"crontab\" translate=\"\">CRONTAB</label> <input type=\"text\" class=\"form-control\" id=\"crontab\" ng-model=\"task.crontab\"></div><div class=\"form-group\"><label for=\"kind\" translate=\"\">KIND</label> <input type=\"text\" class=\"form-control\" id=\"kind\" ng-model=\"task.kind\"></div><div class=\"form-group\"><label for=\"created\" translate=\"\">CREATED</label> <label id=\"created\" class=\"form-control\">{{ \'with_date\'|translate:{date:task.created} }}</label></div><div class=\"form-group\"><label id=\"active\" class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" ng-model=\"task.active\" ng-init=\"checked=false\"> <span translate=\"\">ACTIVE</span></label></div><button ng-show=\"task.id\" type=\"button\" ng-click=\"saveConfig()\" class=\"btn btn-default\" translate=\"\">SAVE CONFIG</button></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"panel-primary horizontal-tabs tabs-panel\"><uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"{{\'OPTIONS\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"task.options\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"todoType.id\" type=\"button\" ng-click=\"saveTriggerOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab><uib-tab heading=\"{{\'ACTION\'|translate}}\"><div class=\"form-group\"><json-editor-toggle-mode source=\"task.action\"></json-editor-toggle-mode></div><div class=\"form-group\"><button ng-if=\"todoType.id\" type=\"button\" ng-click=\"saveOptions()\" class=\"btn btn-default\" translate=\"\">SAVE CHANGES</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/pages/settings/tasks/run/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'RUN TASKS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-persist=\"runTasksList\" st-pipe=\"getRunTasks\" st-table=\"runTasks\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\" translate=\"\">ID</th><th st-sort=\"task_id\" translate=\"\">TASK ID</th><th st-sort=\"status\" translate=\"\">STATUS</th><th st-sort=\"success\" translate=\"\">SUCCESS</th><th st-sort=\"created\" translate=\"\">CREATED</th></tr><tr><th class=\"col-md-2\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th class=\"col-md-2\"><input st-search=\"task_id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'TASK ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"status\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'STATUS\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"success\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th><span style=\"display: inline-block; min-width: 150px;\"><label translate=\"\">CHOOSE DATE FROM</label> <input st-search=\"fromDate\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'FROM DATE\' | translate}}\" class=\"input-sm form-control search-input\" type=\"date\"></span> <span style=\"padding-right: 10px\"></span> <span style=\"display: inline-block; min-width: 150px;\"><label translate=\"\">CHOOSE DATE TO</label> <input st-search=\"toDate\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'TO DATE\' | translate}}\" class=\"input-sm form-control search-input\" type=\"date\"></span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in runTasks\"><td class=\"table-id\">{{item.id}}</td><td><a ui-sref=\"settings.tasks-detail({id: item.task_id})\" ng-if=\"item.task_id\">#{{item.task_id}}</a></td><td>{{item.status}}</td><td>{{item.success}}</td><td><span>{{ \'with_date\'|translate:{date:item.created} }}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");
$templateCache.put("app/pages/settings/tasks/manage/all/list.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"{{\'TASKS\'|translate}}\" ba-panel-class=\"panel-primary with-scroll\" ba-panel-new-title=\"{{\'NEW TASK\'| translate}}\" ba-panel-new-click=\"routeToNewTask()\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-persist=\"tasksList\" st-pipe=\"getTasks\" st-table=\"tasks\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\" translate=\"\">ID</th><th st-sort=\"name\" translate=\"\">NAME</th><th st-sort=\"crontab\" translate=\"\">CRONTAB</th><th st-sort=\"kind\" translate=\"\">KIND</th><th st-sort=\"active\" translate=\"\">ACTIVE</th><th translate=\"\">CREATED</th></tr><tr><th class=\"col-md-1\"><input st-search=\"id\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'ID\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"name\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'NAME\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"crontab\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'CRONTAB\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"kind\" placeholder=\"{{\'SEARCH_FOR\' | translate}} {{\'KIND\' | translate}}\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select st-search=\"active\" class=\"input-sm form-control\"><option value=\"\" translate=\"\">ALL</option><option value=\"true\">True</option><option value=\"false\">False</option></select></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in tasks\"><td class=\"table-id\"><a ui-sref=\"settings.tasks-detail({id: item.id})\">#{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.crontab}}</td><td>{{item.kind}}</td><td>{{item.active}}</td><td><span>{{ \'with_date\'|translate:{date:item.created} }}</span></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" ng-show=\"isLoading\">{{\'LOADING\' | translate}} ...</td><td colspan=\"6\" class=\"text-center\" ng-show=\"!isLoading\"><script type=\"text/ng-template\" id=\"custompaging.html\"><nav ng-if=\"pages.length >= 2\"> <ul class=\"pagination\"> <li><a ng-click=\"selectPage(1)\">&lt;&lt;</a> </li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a> </li><li><a><page-select></page-select></a> </li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a> </li><li><a ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li> </ul> </nav></script><div id=\"pagerId\" st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\" st-template=\"custompaging.html\"></div></td><td></td></tr></tfoot></table><div class=\"form-group select-page-size-wrap\"><label>{{\'ROWS ON PAGE\'|translate}}<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,25,50,100]\"></select></label></div></div></div></div></div></div>");}]);